var $51bb400a14a72998$exports = {};
!function(n) {
    "use strict";
    function r(n, r, e) {
        return e.a = n, e.f = r, e;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(e) {
                return n(r, e);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(e) {
                return function(t) {
                    return n(r, e, t);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(u) {
                        return n(r, e, t, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return n(r, e, t, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return n(r, e, t, u, a, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return n(r, e, t, u, a, i, c);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, e) {
        return 2 === n.a ? n.f(r, e) : n(r)(e);
    }
    function A3(n, r, e, t) {
        return 3 === n.a ? n.f(r, e, t) : n(r)(e)(t);
    }
    function A4(n, r, e, t, u) {
        return 4 === n.a ? n.f(r, e, t, u) : n(r)(e)(t)(u);
    }
    function A5(n, r, e, t, u, a) {
        return 5 === n.a ? n.f(r, e, t, u, a) : n(r)(e)(t)(u)(a);
    }
    function A6(n, r, e, t, u, a, i) {
        return 6 === n.a ? n.f(r, e, t, u, a, i) : n(r)(e)(t)(u)(a)(i);
    }
    function A7(n, r, e, t, u, a, i, c) {
        return 7 === n.a ? n.f(r, e, t, u, a, i, c) : n(r)(e)(t)(u)(a)(i)(c);
    }
    function e(n, r) {
        for(var e, u = [], a = t(n, r, 0, u); a && (e = u.pop()); a = t(e.a, e.b, 0, u));
        return a;
    }
    function t(n, r, e, u) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && w(5), !1;
        if (e > 100) return u.push(i(n, r)), !0;
        for(var a in 0 > n.$ && (n = Hr(n), r = Hr(r)), n)if (!t(n[a], r[a], e + 1, u)) return !1;
        return !0;
    }
    function u(n, r, e) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (e = u(n.a, r.a)) || (e = u(n.b, r.b)) ? e : u(n.c, r.c);
        for(; n.b && r.b && !(e = u(n.a, r.a)); n = n.b, r = r.b);
        return e || (n.b ? 1 : r.b ? -1 : 0);
    }
    var a = F2(function(n, r) {
        var e = u(n, r);
        return 0 > e ? Er : e ? Nr : Cr;
    });
    function i(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function c(n, r, e) {
        return {
            a: n,
            b: r,
            c: e
        };
    }
    function o(n) {
        return n;
    }
    function f(n, r) {
        var e = {};
        for(var t in n)e[t] = n[t];
        for(var t in r)e[t] = r[t];
        return e;
    }
    function s(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var e = l(n.a, r);
        n = n.b;
        for(var t = e; n.b; n = n.b)t = t.b = l(n.a, r);
        return e;
    }
    var d = {
        $: 0
    };
    function l(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var v = F2(l);
    function b(n) {
        for(var r = d, e = n.length; e--;)r = l(n[e], r);
        return r;
    }
    function $(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var m = F3(function(n, r, e) {
        for(var t = []; r.b && e.b; r = r.b, e = e.b)t.push(A2(n, r.a, e.a));
        return b(t);
    }), h = F2(function(n, r) {
        return b($(r).sort(function(r, e) {
            return u(n(r), n(e));
        }));
    }), p = F2(function(n, r) {
        return b($(r).sort(function(r, e) {
            var t = A2(n, r, e);
            return t === Cr ? 0 : t === Er ? -1 : 1;
        }));
    }), g = F3(function(n, r, e) {
        for(var t = Array(n), u = 0; n > u; u++)t[u] = e(r + u);
        return t;
    }), T = F2(function(n, r) {
        for(var e = Array(n), t = 0; n > t && r.b; t++)e[t] = r.a, r = r.b;
        return e.length = t, i(e, r);
    });
    function w(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    var k = F2(function(n, r) {
        return n + r;
    }), y = Math.ceil, S = Math.floor, _ = Math.round, X = Math.log, A = F2(function(n, r) {
        return r.split(n);
    }), j = F2(function(n, r) {
        return r.join(n);
    }), V = F3(function(n, r, e) {
        return e.slice(n, r);
    }), C = F2(function(n, r) {
        for(var e = r.length; e--;){
            var t = r[e], u = r.charCodeAt(e);
            if (56320 > u || u > 57343 || (t = r[--e] + t), !n(o(t))) return !1;
        }
        return !0;
    }), N = F2(function(n, r) {
        return r.indexOf(n) > -1;
    }), E = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), L = F2(function(n, r) {
        var e = n.length;
        if (1 > e) return d;
        for(var t = 0, u = []; (t = r.indexOf(n, t)) > -1;)u.push(t), t += e;
        return b(u);
    });
    function D(n) {
        return {
            $: 2,
            b: n
        };
    }
    var H = D(function(n) {
        return "number" != typeof n ? W("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? zr(n) : !isFinite(n) || n % 1 ? W("an INT", n) : zr(n);
    }), q = (D(function(n) {
        return "boolean" == typeof n ? zr(n) : W("a BOOL", n);
    }), D(function(n) {
        return "number" == typeof n ? zr(n) : W("a FLOAT", n);
    })), M = D(function(n) {
        return zr(n);
    }), O = D(function(n) {
        return "string" == typeof n ? zr(n) : n instanceof String ? zr(n + "") : W("a STRING", n);
    }), I = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function z(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var P = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), R = F2(function(n, r) {
        return z(n, [
            r
        ]);
    }), x = F3(function(n, r, e) {
        return z(n, [
            r,
            e
        ]);
    }), U = F5(function(n, r, e, t, u) {
        return z(n, [
            r,
            e,
            t,
            u
        ]);
    }), K = F2(function(n, r) {
        try {
            return B(n, JSON.parse(r));
        } catch (n) {
            return qr(A2(Mr, "This is not valid JSON! " + n.message, r));
        }
    }), Y = F2(function(n, r) {
        return B(n, r);
    });
    function B(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? zr(n.c) : W("null", r);
            case 3:
                return G(r) ? J(n.b, r, b) : W("a LIST", r);
            case 4:
                return G(r) ? J(n.b, r, F) : W("an ARRAY", r);
            case 6:
                var e = n.d;
                if ("object" != typeof r || null === r || !(e in r)) return W("an OBJECT with a field named `" + e + "`", r);
                var t = B(n.b, r[e]);
                return Ee(t) ? t : qr(A2(Or, e, t.a));
            case 7:
                var u = n.e;
                return G(r) ? r.length > u ? (t = B(n.b, r[u]), Ee(t) ? t : qr(A2(Ir, u, t.a))) : W("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : W("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || G(r)) return W("an OBJECT", r);
                var a = d;
                for(var c in r)if (r.hasOwnProperty(c)) {
                    if (t = B(n.b, r[c]), !Ee(t)) return qr(A2(Or, c, t.a));
                    a = l(i(c, t.a), a);
                }
                return zr(ce(a));
            case 9:
                for(var o = n.f, f = n.g, s = 0; f.length > s; s++){
                    if (t = B(f[s], r), !Ee(t)) return t;
                    o = o(t.a);
                }
                return zr(o);
            case 10:
                return t = B(n.b, r), Ee(t) ? B(n.h(t.a), r) : t;
            case 11:
                for(var v = d, $ = n.g; $.b; $ = $.b){
                    if (t = B($.a, r), Ee(t)) return t;
                    v = l(t.a, v);
                }
                return qr(Pr(ce(v)));
            case 1:
                return qr(A2(Mr, n.a, r));
            case 0:
                return zr(n.a);
        }
    }
    function J(n, r, e) {
        for(var t = r.length, u = Array(t), a = 0; t > a; a++){
            var i = B(n, r[a]);
            if (!Ee(i)) return qr(A2(Ir, a, i.a));
            u[a] = i.a;
        }
        return zr(e(u));
    }
    function G(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function F(n) {
        return A2(Ne, n.length, function(r) {
            return n[r];
        });
    }
    function W(n, r) {
        return qr(A2(Mr, "Expecting " + n, r));
    }
    function Z(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return Z(n.b, r.b);
            case 6:
                return n.d === r.d && Z(n.b, r.b);
            case 7:
                return n.e === r.e && Z(n.b, r.b);
            case 9:
                return n.f === r.f && Q(n.g, r.g);
            case 10:
                return n.h === r.h && Z(n.b, r.b);
            case 11:
                return Q(n.g, r.g);
        }
    }
    function Q(n, r) {
        var e = n.length;
        if (e !== r.length) return !1;
        for(var t = 0; e > t; t++)if (!Z(n[t], r[t])) return !1;
        return !0;
    }
    var nn = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function rn(n) {
        return n;
    }
    function en(n) {
        return n;
    }
    var tn = F3(function(n, r, e) {
        return e[n] = r, e;
    });
    function un(n) {
        return {
            $: 0,
            a: n
        };
    }
    function an(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var cn = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), on = 0;
    function fn(n) {
        var r = {
            $: 0,
            e: on++,
            f: n,
            g: null,
            h: []
        };
        return $n(r), r;
    }
    function sn(n) {
        return an(function(r) {
            r(un(fn(n)));
        });
    }
    function dn(n, r) {
        n.h.push(r), $n(n);
    }
    var ln = F2(function(n, r) {
        return an(function(e) {
            dn(n, r), e(un(0));
        });
    }), vn = !1, bn = [];
    function $n(n) {
        if (bn.push(n), !vn) {
            for(vn = !0; n = bn.shift();)mn(n);
            vn = !1;
        }
    }
    function mn(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, $n(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var hn = {};
    function pn(n, r, e, t, u) {
        return {
            b: n,
            c: r,
            d: e,
            e: t,
            f: u
        };
    }
    function gn(n, r) {
        var e = {
            g: r,
            h: void 0
        }, t = n.c, u = n.d, a = n.e, i = n.f;
        function c(n) {
            return A2(cn, c, {
                $: 5,
                b: function(r) {
                    var c = r.a;
                    return 0 === r.$ ? A3(u, e, c, n) : a && i ? A4(t, e, c.i, c.j, n) : A3(t, e, a ? c.i : c.j, n);
                }
            });
        }
        return e.h = fn(A2(cn, c, n.b));
    }
    var Tn = F2(function(n, r) {
        return an(function(e) {
            n.g(r), e(un(0));
        });
    }), wn = F2(function(n, r) {
        return A2(ln, n.h, {
            $: 0,
            a: r
        });
    });
    function kn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    var yn = F2(function(n, r) {
        return {
            $: 3,
            n: n,
            o: r
        };
    }), Sn = [], _n = !1;
    function Xn(n, r, e) {
        if (Sn.push({
            p: n,
            q: r,
            r: e
        }), !_n) {
            _n = !0;
            for(var t; t = Sn.shift();)An(t.p, t.q, t.r);
            _n = !1;
        }
    }
    function An(n, r, e) {
        var t = {};
        for(var u in jn(!0, r, t, null), jn(!1, e, t, null), n)dn(n[u], {
            $: "fx",
            a: t[u] || {
                i: d,
                j: d
            }
        });
    }
    function jn(n, r, e, t) {
        switch(r.$){
            case 1:
                var u = r.k, a = function(n, r, e, t) {
                    function u(n) {
                        for(var r = e; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? hn[r].e : hn[r].f, u, t);
                }(n, u, t, r.l);
                return void (e[u] = function(n, r, e) {
                    return e = e || {
                        i: d,
                        j: d
                    }, n ? e.i = l(r, e.i) : e.j = l(r, e.j), e;
                }(n, a, e[u]));
            case 2:
                for(var i = r.m; i.b; i = i.b)jn(n, i.a, e, t);
                return;
            case 3:
                return void jn(n, r.o, e, {
                    s: r.n,
                    t: t
                });
        }
    }
    function Vn(n) {
        hn[n] && w(3);
    }
    function Cn(n, r) {
        return Vn(n), hn[n] = {
            e: Nn,
            u: r,
            a: En
        }, kn(n);
    }
    var Nn = F2(function(n, r) {
        return r;
    });
    function En(n) {
        var r = [], e = hn[n].u, t = an(function(n) {
            var r = setTimeout(function() {
                n(un(0));
            }, 0);
            return function() {
                clearTimeout(r);
            };
        });
        return hn[n].b = t, hn[n].c = F3(function(n, u) {
            for(; u.b; u = u.b)for(var a = r, i = en(e(u.a)), c = 0; a.length > c; c++)a[c](i);
            return t;
        }), {
            subscribe: function(n) {
                r.push(n);
            },
            unsubscribe: function(n) {
                var e = (r = r.slice()).indexOf(n);
                0 > e || r.splice(e, 1);
            }
        };
    }
    var Ln, Dn = F2(function(n, r) {
        return function(e) {
            return n(r(e));
        };
    });
    var Hn = "undefined" != typeof document ? document : {};
    function qn(n, r) {
        n.appendChild(r);
    }
    function Mn(n) {
        return {
            $: 0,
            a: n
        };
    }
    var On = F2(function(n, r) {
        return F2(function(e, t) {
            for(var u = [], a = 0; t.b; t = t.b){
                var i = t.a;
                a += i.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 1,
                c: r,
                d: Jn(e),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0);
    F2(function(n, r) {
        return F2(function(e, t) {
            for(var u = [], a = 0; t.b; t = t.b){
                var i = t.a;
                a += i.b.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 2,
                c: r,
                d: Jn(e),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0);
    var In, zn = F2(function(n, r) {
        return {
            $: 4,
            j: n,
            k: r,
            b: 1 + (r.b || 0)
        };
    }), Pn = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), Rn = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), xn = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    }), Un = /^script$/i, Kn = /^(on|formAction$)/i, Yn = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i, Bn = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function Jn(n) {
        for(var r = {}; n.b; n = n.b){
            var e = n.a, t = e.$, u = e.n, a = e.o;
            if ("a2" !== t) {
                var i = r[t] || (r[t] = {});
                "a3" === t && "class" === u ? Gn(i, u, a) : i[u] = a;
            } else "className" === u ? Gn(r, u, en(a)) : r[u] = en(a);
        }
        return r;
    }
    function Gn(n, r, e) {
        var t = n[r];
        n[r] = t ? t + " " + e : e;
    }
    function Fn(n, r) {
        var e = n.$;
        if (5 === e) return Fn(n.k || (n.k = n.m()), r);
        if (0 === e) return Hn.createTextNode(n.a);
        if (4 === e) {
            for(var t = n.k, u = n.j; 4 === t.$;)"object" != typeof u ? u = [
                u,
                t.j
            ] : u.push(t.j), t = t.k;
            var a = {
                j: u,
                p: r
            };
            return (i = Fn(t, a)).elm_event_node_ref = a, i;
        }
        if (3 === e) return Wn(i = n.h(n.g), r, n.d), i;
        var i = n.f ? Hn.createElementNS(n.f, n.c) : Hn.createElement(n.c);
        Ln && "a" == n.c && i.addEventListener("click", Ln(i)), Wn(i, r, n.d);
        for(var c = n.e, o = 0; c.length > o; o++)qn(i, Fn(1 === e ? c[o] : c[o].b, r));
        return i;
    }
    function Wn(n, r, e) {
        for(var t in e){
            var u = e[t];
            "a1" === t ? Zn(n, u) : "a0" === t ? rr(n, r, u) : "a3" === t ? Qn(n, u) : "a4" === t ? nr(n, u) : ("value" !== t && "checked" !== t || n[t] !== u) && (n[t] = u);
        }
    }
    function Zn(n, r) {
        var e = n.style;
        for(var t in r)e[t] = r[t];
    }
    function Qn(n, r) {
        for(var e in r){
            var t = r[e];
            void 0 !== t ? n.setAttribute(e, t) : n.removeAttribute(e);
        }
    }
    function nr(n, r) {
        for(var e in r){
            var t = r[e], u = t.f, a = t.o;
            void 0 !== a ? n.setAttributeNS(u, e, a) : n.removeAttributeNS(u, e);
        }
    }
    function rr(n, r, e) {
        var t = n.elmFs || (n.elmFs = {});
        for(var u in e){
            var a = e[u], i = t[u];
            if (a) {
                if (i) {
                    if (i.q.$ === a.$) {
                        i.q = a;
                        continue;
                    }
                    n.removeEventListener(u, i);
                }
                i = er(r, a), n.addEventListener(u, i, In && {
                    passive: 2 > qe(a)
                }), t[u] = i;
            } else n.removeEventListener(u, i), t[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                In = !0;
            }
        }));
    } catch (n) {}
    function er(n, r) {
        function e(r) {
            var t = e.q, u = B(t.a, r);
            if (Ee(u)) {
                for(var a, i = qe(t), c = u.a, o = i ? 3 > i ? c.a : c.c$ : c, f = 1 == i ? c.b : 3 == i && c.bz, s = (f && r.stopPropagation(), (2 == i ? c.b : 3 == i && c.bs) && r.preventDefault(), n); a = s.j;){
                    if ("function" == typeof a) o = a(o);
                    else for(var d = a.length; d--;)o = a[d](o);
                    s = s.p;
                }
                s(o, f);
            }
        }
        return e.q = r, e;
    }
    function tr(n, r) {
        return n.$ == r.$ && Z(n.a, r.a);
    }
    function ur(n, r, e, t) {
        var u = {
            $: r,
            r: e,
            s: t,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function ar(n, r, e, t) {
        if (n !== r) {
            var u = n.$, a = r.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void ur(e, 0, t, r);
                r = function(n) {
                    for(var r = n.e, e = r.length, t = Array(e), u = 0; e > u; u++)t[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: t,
                        f: n.f,
                        b: n.b
                    };
                }(r), a = 1;
            }
            switch(a){
                case 5:
                    for(var i = n.l, c = r.l, o = i.length, f = o === c.length; f && o--;)f = i[o] === c[o];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return ar(n.k, r.k, s, 0), void (s.length > 0 && ur(e, 1, t, s));
                case 4:
                    for(var d = n.j, l = r.j, v = !1, b = n.k; 4 === b.$;)v = !0, "object" != typeof d ? d = [
                        d,
                        b.j
                    ] : d.push(b.j), b = b.k;
                    for(var $ = r.k; 4 === $.$;)v = !0, "object" != typeof l ? l = [
                        l,
                        $.j
                    ] : l.push($.j), $ = $.k;
                    return v && d.length !== l.length ? void ur(e, 0, t, r) : ((v ? function(n, r) {
                        for(var e = 0; n.length > e; e++)if (n[e] !== r[e]) return !1;
                        return !0;
                    }(d, l) : d === l) || ur(e, 2, t, l), void ar(b, $, e, t + 1));
                case 0:
                    return void (n.a !== r.a && ur(e, 3, t, r.a));
                case 1:
                    return void ir(n, r, e, t, or);
                case 2:
                    return void ir(n, r, e, t, fr);
                case 3:
                    if (n.h !== r.h) return void ur(e, 0, t, r);
                    var m = cr(n.d, r.d);
                    m && ur(e, 4, t, m);
                    var h = r.i(n.g, r.g);
                    return void (h && ur(e, 5, t, h));
            }
        }
    }
    function ir(n, r, e, t, u) {
        if (n.c === r.c && n.f === r.f) {
            var a = cr(n.d, r.d);
            a && ur(e, 4, t, a), u(n, r, e, t);
        } else ur(e, 0, t, r);
    }
    function cr(n, r, e) {
        var t;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var a = n[u], i = r[u];
                a === i && "value" !== u && "checked" !== u || "a0" === e && tr(a, i) || ((t = t || {})[u] = i);
            } else (t = t || {})[u] = e ? "a1" === e ? "" : "a0" === e || "a3" === e ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var c = cr(n[u], r[u] || {}, u);
            c && ((t = t || {})[u] = c);
        }
        for(var o in r)o in n || ((t = t || {})[o] = r[o]);
        return t;
    }
    function or(n, r, e, t) {
        var u = n.e, a = r.e, i = u.length, c = a.length;
        i > c ? ur(e, 6, t, {
            v: c,
            i: i - c
        }) : c > i && ur(e, 7, t, {
            v: i,
            e: a
        });
        for(var o = c > i ? i : c, f = 0; o > f; f++){
            var s = u[f];
            ar(s, a[f], e, ++t), t += s.b || 0;
        }
    }
    function fr(n, r, e, t) {
        for(var u = [], a = {}, i = [], c = n.e, o = r.e, f = c.length, s = o.length, d = 0, l = 0, v = t; f > d && s > l;){
            var b = (X = c[d]).a, $ = (A = o[l]).a, m = X.b, h = A.b, p = void 0, g = void 0;
            if (b !== $) {
                var T = c[d + 1], w = o[l + 1];
                if (T) {
                    var k = T.a, y = T.b;
                    g = $ === k;
                }
                if (w) {
                    var S = w.a, _ = w.b;
                    p = b === S;
                }
                if (p && g) ar(m, _, u, ++v), dr(a, u, b, h, l, i), v += m.b || 0, lr(a, u, b, y, ++v), v += y.b || 0, d += 2, l += 2;
                else if (p) v++, dr(a, u, $, h, l, i), ar(m, _, u, v), v += m.b || 0, d += 1, l += 2;
                else if (g) lr(a, u, b, m, ++v), v += m.b || 0, ar(y, h, u, ++v), v += y.b || 0, d += 2, l += 1;
                else {
                    if (!T || k !== S) break;
                    lr(a, u, b, m, ++v), dr(a, u, $, h, l, i), v += m.b || 0, ar(y, _, u, ++v), v += y.b || 0, d += 2, l += 2;
                }
            } else ar(m, h, u, ++v), v += m.b || 0, d++, l++;
        }
        for(; f > d;){
            var X;
            v++, lr(a, u, (X = c[d]).a, m = X.b, v), v += m.b || 0, d++;
        }
        for(; s > l;){
            var A, j = j || [];
            dr(a, u, (A = o[l]).a, A.b, void 0, j), l++;
        }
        (u.length > 0 || i.length > 0 || j) && ur(e, 8, t, {
            w: u,
            x: i,
            y: j
        });
    }
    var sr = "_elmW6BL";
    function dr(n, r, e, t, u, a) {
        var i = n[e];
        if (!i) return a.push({
            r: u,
            A: i = {
                c: 0,
                z: t,
                r: u,
                s: void 0
            }
        }), void (n[e] = i);
        if (1 === i.c) {
            a.push({
                r: u,
                A: i
            }), i.c = 2;
            var c = [];
            return ar(i.z, t, c, i.r), i.r = u, void (i.s.s = {
                w: c,
                A: i
            });
        }
        dr(n, r, e + sr, t, u, a);
    }
    function lr(n, r, e, t, u) {
        var a = n[e];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var i = [];
                return ar(t, a.z, i, u), void ur(r, 9, u, {
                    w: i,
                    A: a
                });
            }
            lr(n, r, e + sr, t, u);
        } else {
            var c = ur(r, 9, u, void 0);
            n[e] = {
                c: 1,
                z: t,
                r: u,
                s: c
            };
        }
    }
    function vr(n, r, e, t) {
        br(n, r, e, 0, 0, r.b, t);
    }
    function br(n, r, e, t, u, a, i) {
        for(var c = e[t], o = c.r; o === u;){
            var f = c.$;
            if (1 === f) vr(n, r.k, c.s, i);
            else if (8 === f) c.t = n, c.u = i, (s = c.s.w).length > 0 && br(n, r, s, 0, u, a, i);
            else if (9 === f) {
                c.t = n, c.u = i;
                var s, d = c.s;
                d && (d.A.s = n, (s = d.w).length > 0 && br(n, r, s, 0, u, a, i));
            } else c.t = n, c.u = i;
            if (!(c = e[++t]) || (o = c.r) > a) return t;
        }
        var l = r.$;
        if (4 === l) {
            for(var v = r.k; 4 === v.$;)v = v.k;
            return br(n, v, e, t, u + 1, a, n.elm_event_node_ref);
        }
        for(var b = r.e, $ = n.childNodes, m = 0; b.length > m; m++){
            u++;
            var h = 1 === l ? b[m] : b[m].b, p = u + (h.b || 0);
            if (!(u > o || o > p || (c = e[t = br($[m], h, e, t, u, p, i)]) && (o = c.r) <= a)) return t;
            u = p;
        }
        return t;
    }
    function $r(n, r) {
        for(var e = 0; r.length > e; e++){
            var t = r[e], u = t.t, a = mr(u, t);
            u === n && (n = a);
        }
        return n;
    }
    function mr(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, e) {
                    var t = n.parentNode, u = Fn(r, e);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), t && u !== n && t.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return Wn(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return $r(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var e = r.s, t = 0; e.i > t; t++)n.removeChild(n.childNodes[e.v]);
                return n;
            case 7:
                for(var u = (e = r.s).e, a = n.childNodes[t = e.v]; u.length > t; t++)n.insertBefore(Fn(u[t], r.u), a);
                return n;
            case 9:
                if (!(e = r.s)) return n.parentNode.removeChild(n), n;
                var i = e.A;
                return void 0 !== i.r && n.parentNode.removeChild(n), i.s = $r(n, e.w), n;
            case 8:
                return function(n, r) {
                    var e = r.s, t = function(n, r) {
                        if (n) {
                            for(var e = Hn.createDocumentFragment(), t = 0; n.length > t; t++){
                                var u = n[t].A;
                                qn(e, 2 === u.c ? u.s : Fn(u.z, r.u));
                            }
                            return e;
                        }
                    }(e.y, r);
                    n = $r(n, e.w);
                    for(var u = e.x, a = 0; u.length > a; a++){
                        var i = u[a], c = i.A, o = 2 === c.c ? c.s : Fn(c.z, r.u);
                        n.insertBefore(o, n.childNodes[i.r]);
                    }
                    return t && qn(n, t), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                w(10);
        }
    }
    function hr(n) {
        if (3 === n.nodeType) return Mn(n.textContent);
        if (1 !== n.nodeType) return Mn("");
        for(var r = d, e = n.attributes, t = e.length; t--;){
            var u = e[t];
            r = l(A2(xn, u.name, u.value), r);
        }
        var a = n.tagName.toLowerCase(), i = d, c = n.childNodes;
        for(t = c.length; t--;)i = l(hr(c[t]), i);
        return A3(On, a, r, i);
    }
    var pr = F4(function(n, r, e, t) {
        return function(n, r, e, t, u, a) {
            var i = A2(Y, n, r ? r.flags : void 0);
            Ee(i) || w(2);
            var c = {}, o = e(i.a), f = o.a, s = a(l, f), d = function(n, r) {
                var e;
                for(var t in hn){
                    var u = hn[t];
                    u.a && ((e = e || {})[t] = u.a(t, r)), n[t] = gn(u, r);
                }
                return e;
            }(c, l);
            function l(n, r) {
                var e = A2(t, n, f);
                s(f = e.a, r), Xn(c, e.b, u(f));
            }
            return Xn(c, o.b, u(f)), d ? {
                ports: d
            } : {};
        }(r, t, n.cW, n.dG, n.dz, function(r, e) {
            var t = n.bx && n.bx(r), u = n.dI, a = Hn.title, i = Hn.body, c = hr(i);
            return function(n, r) {
                r(n);
                var e = 0;
                function t() {
                    e = 1 === e ? 0 : (gr(t), r(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (r(n), 2 === e && (e = 1)) : (0 === e && gr(t), e = 2);
                };
            }(e, function(n) {
                Ln = t;
                var e = u(n), o = On("body")(d)(e.cD), f = function(n, r) {
                    var e = [];
                    return ar(n, r, e, 0), e;
                }(c, o);
                i = function(n, r, e, t) {
                    return 0 === e.length ? n : (vr(n, r, e, t), $r(n, e));
                }(i, c, f, r), c = o, Ln = 0, a !== e.cn && (Hn.title = a = e.cn);
            });
        });
    }), gr = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    function Tr() {
        return Ze(Hn.location.href).a || w(1);
    }
    var wr = F2(function(n, r) {
        return A2(lt, Qe, an(function() {
            history.pushState({}, "", r), n();
        }));
    }), kr = ("undefined" != typeof document && document, "undefined" != typeof window ? window : {
        addEventListener: function() {},
        removeEventListener: function() {}
    }), yr = F3(function(n, r, e) {
        return an(function(t) {
            function u(n) {
                t(r(e.c.a(n)));
            }
            var a = new XMLHttpRequest;
            a.addEventListener("error", function() {
                u(Pu);
            }), a.addEventListener("timeout", function() {
                u(Uu);
            }), a.addEventListener("load", function() {
                u(function(n, r) {
                    return A2(r.status >= 200 && 300 > r.status ? zu : Ou, function(n) {
                        return {
                            f: n.responseURL,
                            dw: n.status,
                            dx: n.statusText,
                            i: Sr(n.getAllResponseHeaders())
                        };
                    }(r), n(r.response));
                }(e.c.b, a));
            }), Ku(e.n) && function(n, r, e) {
                r.upload.addEventListener("progress", function(t) {
                    r.c || fn(A2(Yu, n, i(e, xu({
                        dq: t.loaded,
                        a4: t.total
                    }))));
                }), r.addEventListener("progress", function(t) {
                    r.c || fn(A2(Yu, n, i(e, Ru({
                        di: t.loaded,
                        a4: t.lengthComputable ? xr(t.total) : Ur
                    }))));
                });
            }(n, a, e.n.a);
            try {
                a.open(e.k, e.f, !0);
            } catch (n) {
                return u(Iu(e.f));
            }
            return function(n, r) {
                for(var e = r.i; e.b; e = e.b)n.setRequestHeader(e.a.a, e.a.b);
                n.timeout = r.m.a || 0, n.responseType = r.c.d, n.withCredentials = r.cz;
            }(a, e), e.cD.a && a.setRequestHeader("Content-Type", e.cD.a), a.send(e.cD.b), function() {
                a.c = !0, a.abort();
            };
        });
    });
    function Sr(n) {
        if (!n) return uu;
        for(var r = uu, e = n.split("\r\n"), t = e.length; t--;){
            var u = e[t], a = u.indexOf(": ");
            if (a > 0) {
                var i = u.substring(0, a), c = u.substring(a + 2);
                r = A3(eu, i, function(n) {
                    return xr(Ku(n) ? c + ", " + n.a : c);
                }, r);
            }
        }
        return r;
    }
    var _r = F3(function(n, r, e) {
        return {
            $: 0,
            d: n,
            b: r,
            a: e
        };
    }), Xr = F2(function(n, r) {
        return {
            $: 0,
            d: r.d,
            b: r.b,
            a: function(e) {
                return n(r.a(e));
            }
        };
    });
    function Ar(n) {
        return new DataView(n);
    }
    var jr, Vr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    });
    D(function(n) {
        return "undefined" != typeof File && n instanceof File ? zr(n) : W("a FILE", n);
    });
    var Cr = 1, Nr = 2, Er = 0, Lr = v, Dr = F3(function(n, r, e) {
        for(;;){
            if (-2 === e.$) return r;
            var t = e.d, u = n, a = A3(n, e.b, e.c, A3(Dr, n, r, e.e));
            n = u, r = a, e = t;
        }
    }), Hr = function(n) {
        return A3(Dr, F3(function(n, r, e) {
            return A2(Lr, i(n, r), e);
        }), d, n);
    }, qr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Mr = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Or = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Ir = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), zr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Pr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Rr = k, xr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ur = {
        $: 1
    }, Kr = C, Yr = nn, Br = function(n) {
        return n + "";
    }, Jr = F2(function(n, r) {
        return A2(j, n, $(r));
    }), Gr = F2(function(n, r) {
        return b(A2(A, n, r));
    }), Fr = function(n) {
        return A2(Jr, "\n    ", A2(Gr, "\n", n));
    }, Wr = F3(function(n, r, e) {
        for(;;){
            if (!e.b) return r;
            var t = e.b, u = n, a = A2(n, e.a, r);
            n = u, r = a, e = t;
        }
    }), Zr = function(n) {
        return A3(Wr, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, Qr = m, ne = F3(function(n, r, e) {
        for(;;){
            if (u(n, r) >= 1) return e;
            var t = n, a = r - 1, i = A2(Lr, r, e);
            n = t, r = a, e = i;
        }
    }), re = F2(function(n, r) {
        return A3(ne, n, r, d);
    }), ee = F2(function(n, r) {
        return A3(Qr, n, A2(re, 0, Zr(r) - 1), r);
    }), te = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, ue = function(n) {
        var r = te(n);
        return r >= 97 && 122 >= r;
    }, ae = function(n) {
        var r = te(n);
        return 90 >= r && r >= 65;
    }, ie = function(n) {
        return ue(n) || ae(n) || function(n) {
            var r = te(n);
            return 57 >= r && r >= 48;
        }(n);
    }, ce = function(n) {
        return A3(Wr, Lr, d, n);
    }, oe = F2(function(n, r) {
        return "\n\n(" + Br(n + 1) + ") " + Fr(fe(r));
    }), fe = function(n) {
        return A2(se, n, d);
    }, se = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                var e = n.a, t = n.b, u = function() {
                    var n, r, t = (r = (n = e).charCodeAt(0), isNaN(r) ? Ur : xr(55296 > r || r > 56319 ? i(n[0], n.slice(1)) : i(n[0] + n[1], n.slice(2))));
                    if (1 === t.$) return !1;
                    var u, a = t.a, c = a.b;
                    return (ue(u = a.a) || ae(u)) && A2(Kr, ie, c);
                }();
                n = t, r = A2(Lr, u ? "." + e : "['" + e + "']", r);
                continue n;
            case 1:
                t = n.b;
                var a = "[" + Br(n.a) + "]";
                n = t, r = A2(Lr, a, r);
                continue n;
            case 2:
                var c = n.a;
                if (c.b) {
                    if (c.b.b) {
                        var o = function() {
                            return r.b ? "The Json.Decode.oneOf at json" + A2(Jr, "", ce(r)) : "Json.Decode.oneOf";
                        }() + " failed in the following " + Br(Zr(c)) + " ways:";
                        return A2(Jr, "\n\n", A2(Lr, o, A2(ee, oe, c)));
                    }
                    n = t = c.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + function() {
                    return r.b ? " at json" + A2(Jr, "", ce(r)) : "!";
                }();
            default:
                var f = n.a, s = n.b;
                return (o = function() {
                    return r.b ? "Problem with the value at json" + A2(Jr, "", ce(r)) + ":\n\n    " : "Problem with the given value:\n\n";
                }()) + (Fr(A2(Yr, 4, s)) + "\n\n") + f;
        }
    }), de = 32, le = F4(function(n, r, e, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: e,
            d: t
        };
    }), ve = [], be = y, $e = F2(function(n, r) {
        return X(r) / X(n);
    }), me = be(A2($e, 2, de)), he = A4(le, 0, me, ve, ve), pe = g, ge = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Te = F2(function(n, r) {
        return r(n);
    }), we = S, ke = function(n) {
        return n.length;
    }, ye = F2(function(n, r) {
        return u(n, r) > 0 ? n : r;
    }), Se = function(n) {
        return {
            $: 0,
            a: n
        };
    }, _e = T, Xe = F2(function(n, r) {
        for(;;){
            var e = A2(_e, de, n), t = e.b, u = A2(Lr, Se(e.a), r);
            if (!t.b) return ce(u);
            n = t, r = u;
        }
    }), Ae = function(n) {
        return n.a;
    }, je = F2(function(n, r) {
        for(;;){
            var e = be(r / de);
            if (1 === e) return A2(_e, de, n).a;
            n = A2(Xe, n, d), r = e;
        }
    }), Ve = F2(function(n, r) {
        if (r.d) {
            var e = r.d * de, t = we(A2($e, de, e - 1)), u = n ? ce(r.l) : r.l, a = A2(je, u, r.d);
            return A4(le, ke(r.j) + e, A2(ye, 5, t * me), a, r.j);
        }
        return A4(le, ke(r.j), me, ve, r.j);
    }), Ce = F5(function(n, r, e, t, u) {
        for(;;){
            if (0 > r) return A2(Ve, !1, {
                l: t,
                d: e / de | 0,
                j: u
            });
            var a = ge(A3(pe, de, r, n));
            r -= de, t = A2(Lr, a, t);
        }
    }), Ne = F2(function(n, r) {
        if (n > 0) {
            var e = n % de;
            return A5(Ce, r, n - e - de, n, d, A3(pe, e, n - e, r));
        }
        return he;
    }), Ee = function(n) {
        return !n.$;
    }, Le = R, De = x, He = function(n) {
        return {
            $: 0,
            a: n
        };
    }, qe = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, Me = function(n) {
        return n;
    }, Oe = F6(function(n, r, e, t, u, a) {
        return {
            bO: a,
            bS: r,
            de: t,
            b5: e,
            b9: n,
            ca: u
        };
    }), Ie = N, ze = function(n) {
        return n.length;
    }, Pe = V, Re = F2(function(n, r) {
        return 1 > n ? r : A3(Pe, n, ze(r), r);
    }), xe = L, Ue = function(n) {
        return "" === n;
    }, Ke = F2(function(n, r) {
        return 1 > n ? "" : A3(Pe, 0, n, r);
    }), Ye = function(n) {
        for(var r = 0, e = n.charCodeAt(0), t = 43 == e || 45 == e ? 1 : 0, u = t; n.length > u; ++u){
            var a = n.charCodeAt(u);
            if (48 > a || a > 57) return Ur;
            r = 10 * r + a - 48;
        }
        return u == t ? Ur : xr(45 == e ? -r : r);
    }, Be = F5(function(n, r, e, t, u) {
        if (Ue(u) || A2(Ie, "@", u)) return Ur;
        var a = A2(xe, ":", u);
        if (a.b) {
            if (a.b.b) return Ur;
            var i = a.a, c = Ye(A2(Re, i + 1, u));
            if (1 === c.$) return Ur;
            var o = c;
            return xr(A6(Oe, n, A2(Ke, i, u), o, r, e, t));
        }
        return xr(A6(Oe, n, u, Ur, r, e, t));
    }), Je = F4(function(n, r, e, t) {
        if (Ue(t)) return Ur;
        var u = A2(xe, "/", t);
        if (u.b) {
            var a = u.a;
            return A5(Be, n, A2(Re, a, t), r, e, A2(Ke, a, t));
        }
        return A5(Be, n, "/", r, e, t);
    }), Ge = F3(function(n, r, e) {
        if (Ue(e)) return Ur;
        var t = A2(xe, "?", e);
        if (t.b) {
            var u = t.a;
            return A4(Je, n, xr(A2(Re, u + 1, e)), r, A2(Ke, u, e));
        }
        return A4(Je, n, Ur, r, e);
    }), Fe = F2(function(n, r) {
        if (Ue(r)) return Ur;
        var e = A2(xe, "#", r);
        if (e.b) {
            var t = e.a;
            return A3(Ge, n, xr(A2(Re, t + 1, r)), A2(Ke, t, r));
        }
        return A3(Ge, n, Ur, r);
    }), We = E, Ze = function(n) {
        return A2(We, "http://", n) ? A2(Fe, 0, A2(Re, 7, n)) : A2(We, "https://", n) ? A2(Fe, 1, A2(Re, 8, n)) : Ur;
    }, Qe = function() {
        for(;;);
    }, nt = un, rt = nt(0), et = F4(function(n, r, e, t) {
        if (t.b) {
            var u = t.a, a = t.b;
            if (a.b) {
                var i = a.a, c = a.b;
                if (c.b) {
                    var o = c.a, f = c.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, u, A2(n, i, A2(n, o, A2(n, f.a, e > 500 ? A3(Wr, n, r, ce(s)) : A4(et, n, r, e + 1, s)))));
                    }
                    return A2(n, u, A2(n, i, A2(n, o, r)));
                }
                return A2(n, u, A2(n, i, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), tt = F3(function(n, r, e) {
        return A4(et, n, r, 0, e);
    }), ut = F2(function(n, r) {
        return A3(tt, F2(function(r, e) {
            return A2(Lr, n(r), e);
        }), d, r);
    }), at = cn, it = F2(function(n, r) {
        return A2(at, function(r) {
            return nt(n(r));
        }, r);
    }), ct = F3(function(n, r, e) {
        return A2(at, function(r) {
            return A2(at, function(e) {
                return nt(A2(n, r, e));
            }, e);
        }, r);
    }), ot = function(n) {
        return A3(tt, ct(Lr), nt(d), n);
    }, ft = Tn, st = F2(function(n, r) {
        var e = r;
        return sn(A2(at, ft(n), e));
    });
    hn.Task = pn(rt, F3(function(n, r) {
        return A2(it, function() {
            return 0;
        }, ot(A2(ut, st(n), r)));
    }), F3(function() {
        return nt(0);
    }), F2(function(n, r) {
        return A2(it, n, r);
    }));
    var dt = kn("Task"), lt = F2(function(n, r) {
        return dt(A2(it, n, r));
    }), vt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, bt = function(n) {
        return {
            $: 3,
            a: n
        };
    }, $t = function(n) {
        return {
            $: 2,
            a: n
        };
    }, mt = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), ht = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), pt = function(n) {
        return {
            $: 8,
            a: n
        };
    }, gt = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Tt = Y, wt = F2(function(n, r) {
        return {
            cC: n,
            S: r
        };
    }), kt = function(n) {
        return {
            $: 11,
            g: n
        };
    }, yt = function(n) {
        return kt(b([
            A2(Le, xr, n),
            He(Ur)
        ]));
    }, St = De(Te), _t = P, Xt = I, At = F2(function(n, r) {
        return A3(tt, Xt, r, n);
    }), jt = function(n) {
        return {
            $: 5,
            c: n
        };
    }, Vt = M, Ct = F3(function(n, r, e) {
        var t = function(n) {
            return kt(b([
                n,
                jt(e)
            ]));
        };
        return A2(_t, function(u) {
            var a = A2(Tt, A2(At, n, Vt), u);
            if (a.$) return He(e);
            var i = a.a, c = A2(Tt, t(r), i);
            return c.$ ? A2(At, n, t(r)) : He(c.a);
        }, Vt);
    }), Nt = F4(function(n, r, e, t) {
        return A2(St, A3(Ct, b([
            n
        ]), r, e), t);
    }), Et = F3(function(n, r, e) {
        return A2(St, A2(Xt, n, r), e);
    }), Lt = O, Dt = Lt, Ht = function(n) {
        return {
            $: 1,
            a: n
        };
    }, qt = A2(_t, function(n) {
        var r = Ze(n);
        return 1 === r.$ ? Ht("Invalid URL") : He(r.a);
    }, Lt), Mt = A4(Nt, "sessionToken", yt(Dt), Ur, A3(Et, "baseUrl", qt, He(wt))), Ot = F5(function(n, r, e, t, u) {
        return {
            W: t,
            Y: e,
            U: r,
            O: u,
            ab: n
        };
    }), It = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(Lr, n.a, It(n.b)) : d;
    }, zt = F2(function(n, r) {
        return xr(1 === r.$ ? b([
            n
        ]) : A2(Lr, n, r.a));
    }), Pt = function(n) {
        try {
            return xr(decodeURIComponent(n));
        } catch (n) {
            return Ur;
        }
    }, Rt = a, xt = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return Ur;
            var e = r.c, t = r.d, u = r.e;
            switch(A2(Rt, n, r.b)){
                case 0:
                    r = t;
                    continue n;
                case 1:
                    return xr(e);
                default:
                    r = u;
                    continue n;
            }
        }
    }), Ut = F5(function(n, r, e, t, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: e,
            d: t,
            e: u
        };
    }), Kt = {
        $: -2
    }, Yt = F5(function(n, r, e, t, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== t.$ || t.a || -1 !== t.d.$ || t.d.a) return A5(Ut, n, r, e, t, u);
            var a = t.d;
            return i = t.e, A5(Ut, 0, t.b, t.c, A5(Ut, 1, a.b, a.c, a.d, a.e), A5(Ut, 1, r, e, i, u));
        }
        var i, c = u.b, o = u.c, f = u.d, s = u.e;
        return -1 !== t.$ || t.a ? A5(Ut, n, c, o, A5(Ut, 0, r, e, t, f), s) : A5(Ut, 0, r, e, A5(Ut, 1, t.b, t.c, t.d, i = t.e), A5(Ut, 1, c, o, f, s));
    }), Bt = F3(function(n, r, e) {
        if (-2 === e.$) return A5(Ut, 0, n, r, Kt, Kt);
        var t = e.a, u = e.b, a = e.c, i = e.d, c = e.e;
        switch(A2(Rt, n, u)){
            case 0:
                return A5(Yt, t, u, a, A3(Bt, n, r, i), c);
            case 1:
                return A5(Ut, t, u, r, i, c);
            default:
                return A5(Yt, t, u, a, i, A3(Bt, n, r, c));
        }
    }), Jt = F3(function(n, r, e) {
        var t = A3(Bt, n, r, e);
        return -1 !== t.$ || t.a ? t : A5(Ut, 1, t.b, t.c, t.d, t.e);
    }), Gt = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, e = n.e;
                return i = e.b, c = e.c, t = e.d, s = e.e, A5(Ut, 1, n.b, n.c, A5(Ut, 0, r.b, r.c, r.d, r.e), A5(Ut, 0, i, c, t, s));
            }
            var t, u = n.d, a = n.e, i = a.b, c = a.c, o = (t = a.d).d, f = t.e, s = a.e;
            return A5(Ut, 0, t.b, t.c, A5(Ut, 1, n.b, n.c, A5(Ut, 0, u.b, u.c, u.d, u.e), o), A5(Ut, 1, i, c, f, s));
        }
        return n;
    }, Ft = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, e = n.e;
                return f = e.b, s = e.c, d = e.d, l = e.e, A5(Ut, 1, t = n.b, u = n.c, A5(Ut, 0, r.b, r.c, r.d, c = r.e), A5(Ut, 0, f, s, d, l));
            }
            var t = n.b, u = n.c, a = n.d, i = a.d, c = a.e, o = n.e, f = o.b, s = o.c, d = o.d, l = o.e;
            return A5(Ut, 0, a.b, a.c, A5(Ut, 1, i.b, i.c, i.d, i.e), A5(Ut, 1, t, u, c, A5(Ut, 0, f, s, d, l)));
        }
        return n;
    }, Wt = F7(function(n, r, e, t, u, a, i) {
        if (-1 !== a.$ || a.a) {
            n: for(;;){
                if (-1 === i.$ && 1 === i.a) {
                    if (-1 === i.d.$) {
                        if (1 === i.d.a) return Ft(r);
                        break n;
                    }
                    return Ft(r);
                }
                break n;
            }
            return r;
        }
        return A5(Ut, e, a.b, a.c, a.d, A5(Ut, 0, t, u, a.e, i));
    }), Zt = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, e = n.b, t = n.c, u = n.d, a = u.d, i = n.e;
            if (1 === u.a) {
                if (-1 !== a.$ || a.a) {
                    var c = Gt(n);
                    if (-1 === c.$) {
                        var o = c.e;
                        return A5(Yt, c.a, c.b, c.c, Zt(c.d), o);
                    }
                    return Kt;
                }
                return A5(Ut, r, e, t, Zt(u), i);
            }
            return A5(Ut, r, e, t, Zt(u), i);
        }
        return Kt;
    }, Qt = F2(function(n, r) {
        if (-2 === r.$) return Kt;
        var e = r.a, t = r.b, a = r.c, i = r.d, c = r.e;
        if (0 > u(n, t)) {
            if (-1 === i.$ && 1 === i.a) {
                var o = i.d;
                if (-1 !== o.$ || o.a) {
                    var f = Gt(r);
                    if (-1 === f.$) {
                        var s = f.e;
                        return A5(Yt, f.a, f.b, f.c, A2(Qt, n, f.d), s);
                    }
                    return Kt;
                }
                return A5(Ut, e, t, a, A2(Qt, n, i), c);
            }
            return A5(Ut, e, t, a, A2(Qt, n, i), c);
        }
        return A2(nu, n, A7(Wt, n, r, e, t, a, i, c));
    }), nu = F2(function(n, r) {
        if (-1 === r.$) {
            var t = r.a, u = r.b, a = r.c, i = r.d, c = r.e;
            if (e(n, u)) {
                var o = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(c);
                return -1 === o.$ ? A5(Yt, t, o.b, o.c, i, Zt(c)) : Kt;
            }
            return A5(Yt, t, u, a, i, A2(Qt, n, c));
        }
        return Kt;
    }), ru = F2(function(n, r) {
        var e = A2(Qt, n, r);
        return -1 !== e.$ || e.a ? e : A5(Ut, 1, e.b, e.c, e.d, e.e);
    }), eu = F3(function(n, r, e) {
        var t = r(A2(xt, n, e));
        return t.$ ? A2(ru, n, e) : A3(Jt, n, t.a, e);
    }), tu = F2(function(n, r) {
        var e = A2(Gr, "=", n);
        if (e.b && e.b.b && !e.b.b.b) {
            var t = e.b.a, u = Pt(e.a);
            if (1 === u.$) return r;
            var a = u.a, i = Pt(t);
            return 1 === i.$ ? r : A3(eu, a, zt(i.a), r);
        }
        return r;
    }), uu = Kt, au = F2(function(n, r) {
        var e;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var r = n.a, e = r.U;
                    if (e.b) {
                        if ("" !== e.a || e.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return xr(r.O);
                    }
                    return xr(r.O);
                }
                return Ur;
            }
        }(n(A5(Ot, d, function(n) {
            var r = A2(Gr, "/", n);
            return It(r.b && "" === r.a ? r.b : r);
        }(r.de), 1 === (e = r.ca).$ ? uu : A3(tt, tu, uu, A2(Gr, "&", e.a)), r.bO, Me)));
    }), iu = {
        $: 4
    }, cu = {
        $: 1
    }, ou = {
        $: 0
    }, fu = function(n) {
        return {
            $: 2,
            a: n
        };
    }, su = function(n) {
        return {
            $: 2,
            a: n
        };
    }, du = {
        $: 1
    }, lu = {
        $: 0
    }, vu = {
        $: 0
    }, bu = {
        $: 3
    }, $u = {
        $: 0
    }, mu = function(n) {
        return {
            $: 2,
            a: n
        };
    }, hu = function(n) {
        return {
            $: 1,
            a: n
        };
    }, pu = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), gu = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Tu = function(n) {
        return {
            $: 3,
            a: n
        };
    }, wu = {
        $: 1
    }, ku = {
        $: 2
    }, yu = {
        $: 0
    }, Su = F2(function(n, r) {
        return A5(Ot, r.ab, r.U, r.Y, r.W, n(r.O));
    }), _u = F2(function(n, r) {
        var e = r;
        return function(r) {
            var t = r.ab, u = r.U, a = r.Y, i = r.W;
            return A2(ut, Su(r.O), e(A5(Ot, t, u, a, i, n)));
        };
    }), Xu = F2(function(n, r) {
        return function(n) {
            var e = n.ab, t = n.U, u = n.Y, a = n.W, i = n.O;
            if (t.b) {
                var c = t.a, o = t.b, f = r(c);
                if (f.$) return d;
                var s = f.a;
                return b([
                    A5(Ot, A2(Lr, c, e), o, u, a, i(s))
                ]);
            }
            return d;
        };
    }), Au = A2(Xu, "MUSICIAN_ID", xr), ju = F2(function(n, r) {
        return r.b ? A3(tt, Lr, r, n) : n;
    }), Vu = F2(function(n, r) {
        return A3(tt, ju, d, A2(ut, n, r));
    }), Cu = function(n) {
        return function(r) {
            return A2(Vu, function(n) {
                return n(r);
            }, n);
        };
    }, Nu = A2(Xu, "PLANNING_ID", xr), Eu = function(n) {
        return function(r) {
            var t = r.ab, u = r.U, a = r.Y, i = r.W, c = r.O;
            if (u.b) {
                var o = u.a, f = u.b;
                return e(o, n) ? b([
                    A5(Ot, A2(Lr, o, t), f, a, i, c)
                ]) : d;
            }
            return d;
        };
    }, Lu = A2(Xu, "SERIE_ID", xr), Du = F2(function(n, r) {
        var e = n, t = r;
        return function(n) {
            return A2(Vu, t, e(n));
        };
    }), Hu = function(n) {
        return b([
            n
        ]);
    }, qu = Cu(b([
        A2(_u, cu, Hu),
        A2(_u, ou, A2(Du, Eu("login"), Eu("callback"))),
        A2(_u, su, A2(Du, Eu("musicians"), Cu(b([
            A2(_u, lu, Hu),
            A2(_u, du, Eu("add")),
            A2(_u, fu, A2(Du, Eu("view"), Au))
        ])))),
        A2(_u, gu, A2(Du, Eu("plannings"), Cu(b([
            A2(_u, vu, Hu),
            A2(_u, pu, A2(Du, Nu, Cu(b([
                A2(_u, yu, Eu("summary")),
                A2(_u, wu, Eu("musicians")),
                A2(_u, ku, Eu("series")),
                A2(_u, Tu, A2(Du, Eu("schedule"), Cu(b([
                    A2(_u, $u, Hu),
                    A2(_u, hu, A2(Du, Eu("series"), Lu)),
                    A2(_u, mu, A2(Du, Eu("musicians"), Au)),
                    A2(_u, bu, Eu("auto"))
                ]))))
            ]))))
        ])))),
        A2(_u, iu, Eu("admin"))
    ])), Mu = function(n) {
        return A2(au, qu, n);
    }, Ou = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Iu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, zu = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Pu = {
        $: 2
    }, Ru = function(n) {
        return {
            $: 1,
            a: n
        };
    }, xu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Uu = {
        $: 1
    }, Ku = function(n) {
        return !n.$;
    }, Yu = wn, Bu = {
        $: 0
    }, Ju = K, Gu = F3(function(n, r, e) {
        return r(n(e));
    }), Fu = F2(function(n, r) {
        return A3(_r, "", Me, A2(Gu, r, n));
    }), Wu = F2(function(n, r) {
        return r.$ ? qr(n(r.a)) : zr(r.a);
    }), Zu = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Qu = function(n) {
        return {
            $: 3,
            a: n
        };
    }, na = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ra = {
        $: 2
    }, ea = {
        $: 1
    }, ta = F2(function(n, r) {
        switch(r.$){
            case 0:
                return qr(na(r.a));
            case 1:
                return qr(ea);
            case 2:
                return qr(ra);
            case 3:
                return qr(Qu(r.a.dw));
            default:
                return A2(Wu, Zu, n(r.b));
        }
    }), ua = F2(function(n, r) {
        return A2(Fu, n, ta(function(n) {
            return A2(Wu, fe, A2(Ju, r, n));
        }));
    }), aa = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ia = function(n) {
        return n.a + "=" + n.b;
    }, ca = F2(function(n, r) {
        return "/" + (A2(Jr, "/", n) + function(n) {
            return n.b ? "?" + A2(Jr, "&", A2(ut, ia, n)) : "";
        }(r));
    }), oa = function(n) {
        return A2(ca, A2(Lr, "api", n), d);
    }, fa = F2(function(n, r) {
        return {
            cL: n,
            dF: r
        };
    }), sa = Lt, da = H, la = A3(Et, "timeZone", A2(Le, Me, da), A3(Et, "email", sa, He(fa))), va = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ba = F2(function(n, r) {
        return {
            cc: n,
            cl: r
        };
    }), $a = nt(A2(ba, uu, d)), ma = function(n) {
        return an(function(r) {
            var e = n.f;
            2 === e.$ && e.c && e.c(), n.f = null, r(un(0));
        });
    }, ha = sn, pa = F3(function(n, r, e) {
        n: for(;;){
            if (r.b) {
                var t = r.a, u = r.b;
                if (t.$) {
                    var a = t.a;
                    return A2(at, function(r) {
                        var t = a.n;
                        return A3(pa, n, u, 1 === t.$ ? e : A3(Jt, t.a, r, e));
                    }, ha(A3(yr, n, ft(n), a)));
                }
                var i = t.a, c = A2(xt, i, e);
                if (1 === c.$) {
                    r = u;
                    continue n;
                }
                return A2(at, function() {
                    return A3(pa, n, u, A2(ru, i, e));
                }, ma(c.a));
            }
            return nt(e);
        }
    }), ga = F4(function(n, r, e, t) {
        return A2(at, function(n) {
            return nt(A2(ba, n, e));
        }, A3(pa, n, r, t.cc));
    }), Ta = F3(function(n, r, e) {
        var t = n(r);
        return t.$ ? e : A2(Lr, t.a, e);
    }), wa = F2(function(n, r) {
        return A3(tt, Ta(n), d, r);
    }), ka = F4(function(n, r, t, u) {
        var a = u.b;
        return e(r, u.a) ? xr(A2(ft, n, a(t))) : Ur;
    }), ya = F3(function(n, r, e) {
        return A2(at, function() {
            return nt(e);
        }, ot(A2(wa, A3(ka, n, r.a, r.b), e.cl)));
    }), Sa = F2(function(n, r) {
        if (r.$) {
            var e = r.a;
            return va({
                cz: e.cz,
                cD: e.cD,
                c: A2(Xr, n, e.c),
                i: e.i,
                k: e.k,
                m: e.m,
                n: e.n,
                f: e.f
            });
        }
        return {
            $: 0,
            a: r.a
        };
    }), _a = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    });
    hn.Http = pn($a, ga, ya, Sa, F2(function(n, r) {
        return A2(_a, r.a, A2(Gu, r.b, n));
    }));
    var Xa, Aa, ja, Va, Ca, Na, Ea, La = kn("Http"), Da = (kn("Http"), function(n) {
        return La(va({
            cz: !1,
            cD: n.cD,
            c: n.c,
            i: n.i,
            k: n.k,
            m: n.m,
            n: n.n,
            f: n.f
        }));
    }), Ha = F2(function(n, r) {
        return Da({
            cD: Bu,
            c: A2(ua, r, la),
            i: b([
                A2(aa, "X-Session-Token", n)
            ]),
            k: "GET",
            m: Ur,
            n: Ur,
            f: oa(b([
                "login",
                "profile"
            ]))
        });
    }), qa = function(n) {
        return {
            $: 2,
            m: n
        };
    }, Ma = qa(d), Oa = i({
        aV: Ur
    }, Ma), Ia = null, za = Cn("requestLoginCallbackProcessingCmd", function() {
        return Ia;
    }), Pa = za(0), Ra = i(0, Pa), xa = yn, Ua = F3(function(n, r, e) {
        var t = e.b;
        return i(n(e.a), r(t));
    }), Ka = F2(function(n, r) {
        var e = r.b;
        return i(n(r.a), e);
    }), Ya = F2(function(n, r) {
        return i(r.a, qa(b([
            r.b,
            n
        ])));
    }), Ba = F2(function(n, r) {
        return i(r, n);
    }), Ja = F3(function(n, r, e) {
        var t = A2(Tt, Mt, n);
        if (1 === t.$) return A2(Ka, function(n) {
            return {
                p: n,
                C: e
            };
        }, A2(Ba, Ma, vt(fe(t.a))));
        var u = t.a, a = Mu(r);
        if (a.$ || a.a.$) {
            var i = u.S;
            return A2(Ka, function(n) {
                return {
                    p: n,
                    C: e
                };
            }, 1 === i.$ ? A3(Ua, ht(u), xa($t), Oa) : A2(Ya, A2(Ha, i.a, pt), A2(Ba, Ma, A2(gt, u, r))));
        }
        return A2(Ka, function(n) {
            return {
                p: n,
                C: e
            };
        }, A3(Ua, mt(u), xa(bt), Ra));
    }), Ga = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Fa = (Xa = "loginReceivedReceiver", Aa = kt(b([
        jt(Ur),
        A2(Le, xr, Lt)
    ])), Vn(Xa), hn[Xa] = {
        f: Dn,
        u: Aa,
        a: function(n, r) {
            var e = d, t = hn[n].u, u = un(null);
            return hn[n].b = u, hn[n].c = F3(function(n, r) {
                return e = r, u;
            }), {
                send: function(n) {
                    var u = A2(Y, t, n);
                    Ee(u) || w(4);
                    for(var a = u.a, i = e; i.b; i = i.b)r(i.a(a));
                }
            };
        }
    }, kn(Xa)), Wa = Fa, Za = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Qa = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ni = function(n) {
        return {
            $: 7,
            a: n
        };
    }, ri = function(n) {
        return {
            $: 4,
            a: n
        };
    }, ei = function(n) {
        return {
            $: 12,
            a: n
        };
    }, ti = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ui = function(n) {
        return {
            $: 6,
            a: n
        };
    }, ai = function(n) {
        return {
            $: 9,
            a: n
        };
    }, ii = function(n) {
        return {
            $: 11,
            a: n
        };
    }, ci = function(n) {
        return {
            $: 3,
            a: n
        };
    }, oi = function(n) {
        return {
            $: 4,
            a: n
        };
    }, fi = function(n) {
        return {
            $: 4,
            a: n
        };
    }, si = {
        $: 1
    }, di = {
        $: 2
    }, li = {
        $: 3
    }, vi = {
        $: 0
    }, bi = function(n) {
        return {
            $: 3,
            a: n
        };
    }, $i = {
        $: 1
    }, mi = function(n) {
        return {
            $: 1,
            a: n
        };
    }, hi = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pi = {
        $: 2
    }, gi = {
        $: 0
    }, Ti = F2(function(n, r) {
        return i(r, n);
    }), wi = F2(function(n, r) {
        return r.$ ? Ur : n(r.a);
    }), ki = F3(function(n, r, e) {
        return n(r(e));
    }), yi = function(n) {
        return 4 === n.$ ? xr(n.a.V) : Ur;
    }, Si = function(n) {
        return 3 === n.$ ? xr(n.a) : Ur;
    }, _i = function(n) {
        return 4 === n.$ ? xr(n.a) : Ur;
    }, Xi = function(n) {
        switch(n.$){
            case 0:
                return Ur;
            case 1:
            case 2:
            case 3:
                return n.a.S;
            default:
                return n.a.aU.S;
        }
    }, Ai = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ji = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Vi = i(0, Ma), Ci = {
        $: 0
    }, Ni = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ei = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Li = function(n) {
        return n.$ ? Ur : xr(n.a);
    }, Di = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Hi = {
        $: 1
    }, qi = function(n) {
        return {
            $: 3,
            b: n
        };
    }, Mi = F2(function(n, r) {
        return {
            cT: n,
            X: r
        };
    }), Oi = Lt, Ii = Lt, zi = A3(Et, "name", Ii, A3(Et, "id", Oi, He(Mi))), Pi = qi(zi), Ri = F2(function(n, r) {
        return Da({
            cD: Bu,
            c: A2(ua, r, Pi),
            i: b([
                A2(aa, "X-Session-Token", n)
            ]),
            k: "GET",
            m: Ur,
            n: Ur,
            f: oa(b([
                "plannings"
            ]))
        });
    }), xi = function(n) {
        var r = ze(n);
        return r > 0 && 200 >= r;
    }, Ui = function(n) {
        return i({
            ay: "",
            a$: xi(""),
            ak: 0,
            aA: Hi,
            S: n
        }, A2(Ri, n, Di));
    }, Ki = F3(function(n, r, e) {
        return 1 === e.$ ? n : r(e.a);
    }), Yi = F2(function(n, r) {
        return f(n, {
            V: r
        });
    }), Bi = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Ji = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Gi = {
        $: 1
    }, Fi = F4(function(n, r, e, t) {
        return {
            cB: e,
            cT: n,
            X: r,
            dh: t
        };
    }), Wi = Lt, Zi = Lt, Qi = Lt, nc = Lt, rc = A3(Et, "pupitre", nc, A3(Et, "avatar", yt(Wi), A3(Et, "name", Qi, A3(Et, "id", Zi, He(Fi))))), ec = F3(function(n, r, e) {
        return Da({
            cD: Bu,
            c: A2(ua, e, rc),
            i: b([
                A2(aa, "X-Session-Token", n)
            ]),
            k: "GET",
            m: Ur,
            n: Ur,
            f: oa(b([
                "musicians",
                r
            ]))
        });
    }), tc = F2(function(n, r) {
        return i({
            aZ: Gi,
            b1: r,
            S: n
        }, A3(ec, n, r, Me));
    }), uc = F2(function(n, r) {
        var e = A2(tc, r.S, n), t = e.b;
        return i(f(r, {
            V: Ji(e.a)
        }), A2(xa, Bi, t));
    }), ac = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ic = function(n) {
        return {
            $: 1,
            a: n
        };
    }, cc = function(n) {
        return 1 === n.$ ? xr(n.a) : Ur;
    }, oc = function(n) {
        return {
            $: 2,
            a: n
        };
    }, fc = function(n) {
        return {
            $: 4,
            a: n
        };
    }, sc = function(n) {
        return {
            $: 3,
            a: n
        };
    }, dc = function(n) {
        return {
            $: 1,
            a: n
        };
    }, lc = function(n) {
        return {
            $: 1,
            a: n
        };
    }, vc = function(n) {
        return {
            $: 3,
            a: n
        };
    }, bc = function(n) {
        return {
            $: 2,
            a: n
        };
    }, $c = function(n) {
        return {
            $: 0,
            a: n
        };
    }, mc = function(n) {
        return 1 === n.$ ? xr(n.a) : Ur;
    }, hc = function(n) {
        return 3 === n.$ ? xr(n.a) : Ur;
    }, pc = function(n) {
        return 2 === n.$ ? xr(n.a) : Ur;
    }, gc = function(n) {
        return n.$ ? Ur : xr(n.a);
    }, Tc = function(n) {
        return {
            $: 0,
            a: n
        };
    }, wc = F4(function(n, r, e, t) {
        return {
            cB: e,
            cT: n,
            X: r,
            dh: t
        };
    }), kc = A3(Et, "pupitre", nc, A3(Et, "avatar", yt(Wi), A3(Et, "name", Qi, A3(Et, "id", Zi, He(wc))))), yc = qi(kc), Sc = F2(function(n, r) {
        return Da({
            cD: Bu,
            c: A2(ua, r, yc),
            i: b([
                A2(aa, "X-Session-Token", n)
            ]),
            k: "GET",
            m: Ur,
            n: Ur,
            f: oa(b([
                "musicians"
            ]))
        });
    }), _c = {
        $: 0
    }, Xc = _c, Ac = F3(function(n, r, e) {
        return i({
            aM: Gi,
            K: Gi,
            a_: Xc,
            al: e,
            H: r,
            M: Gi,
            S: n
        }, A2(Sc, n, Tc));
    }), jc = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Vc = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Cc = F4(function(n, r, e, t) {
        return {
            cT: n,
            aj: e,
            X: r,
            dt: t
        };
    }), Nc = F6(function(n, r, e, t, u, a) {
        return {
            cB: e,
            cT: n,
            X: r,
            az: a,
            aE: u,
            aI: t
        };
    }), Ec = uu, Lc = F2(function(n, r) {
        return A3(Jt, n, 0, r);
    }), Dc = function(n) {
        return A3(Wr, Lc, Ec, n);
    }, Hc = Lt, qc = da, Mc = A3(Et, "onCallSeries", A2(Le, Dc, qi(Hc)), A3(Et, "scheduledSeries", A2(Le, Dc, qi(Hc)), A3(Et, "totalServices", qc, A3(Et, "avatar", yt(Wi), A3(Et, "name", Qi, A3(Et, "id", Zi, He(Nc))))))), Oc = F6(function(n, r, e, t, u, a) {
        return {
            cT: n,
            X: r,
            a0: a,
            dl: e,
            an: u,
            N: t
        };
    }), Ic = da, zc = Lt, Pc = A3(Et, "onCallMusician", yt(Zi), A3(Et, "scheduledMusicians", A2(Le, Dc, qi(Zi)), A3(Et, "services", qc, A3(Et, "requiredMusicians", Ic, A3(Et, "name", zc, A3(Et, "id", Hc, He(Oc))))))), Rc = A3(Et, "series", qi(Pc), A3(Et, "musicians", qi(Mc), A3(Et, "name", Ii, A3(Et, "id", Oi, He(Cc))))), xc = F3(function(n, r, e) {
        return Da({
            cD: Bu,
            c: A2(ua, e, Rc),
            i: b([
                A2(aa, "X-Session-Token", n)
            ]),
            k: "GET",
            m: Ur,
            n: Ur,
            f: oa(b([
                "plannings",
                r
            ]))
        });
    }), Uc = F2(function(n, r) {
        return {
            cy: r,
            dH: n
        };
    }), Kc = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Yc = A3(Et, "serie", Hc, A3(Et, "musician", Zi, He(Kc))), Bc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Jc = A3(Et, "serie", Hc, A3(Et, "musician", Zi, He(Bc))), Gc = A2(_t, function(n) {
        switch(n){
            case "ScheduleMusicianPlanAction":
                return Jc;
            case "PutMusicianOnCall":
                return Yc;
            default:
                return Ht("Unknown tag for TournePlanAction: " + n);
        }
    }, A2(Xt, "tag", Lt)), Fc = da, Wc = A3(Et, "actions", qi(Gc), A3(Et, "version", Fc, He(Uc))), Zc = F3(function(n, r, e) {
        return Da({
            cD: Bu,
            c: A2(ua, e, yt(Wc)),
            i: b([
                A2(aa, "X-Session-Token", n)
            ]),
            k: "GET",
            m: Ur,
            n: Ur,
            f: oa(b([
                "plannings",
                r,
                "auto-plan"
            ]))
        });
    }), Qc = {
        w: Xc
    }, no = F3(function(n, r, e) {
        return i({
            aN: Gi,
            u: Qc,
            H: r,
            aD: e,
            R: Gi,
            S: n,
            aq: Gi
        }, qa(b([
            A3(xc, n, r, Vc),
            A3(Zc, n, r, jc)
        ])));
    }), ro = F2(function(n) {
        return n;
    }), eo = function(n) {
        return {
            $: 0,
            a: n
        };
    }, to = eo({
        X: "",
        dl: 1,
        N: 6
    }), uo = F2(function(n, r) {
        return {
            ad: r,
            be: n
        };
    }), ao = A2(uo, function(n) {
        return n.cT;
    }, F2(function(n, r) {
        return A2(Rt, n.X, r.X);
    })), io = function(n) {
        return A3(Wr, F2(function(n, r) {
            return A3(Jt, n.a, n.b, r);
        }), uu, n);
    }, co = F2(function(n, r) {
        return i(n(r), r);
    }), oo = p, fo = F2(function(n, r) {
        var e = n.ad;
        return {
            o: io(A2(ut, co(n.be), r)),
            T: A2(oo, e, r)
        };
    }), so = fo(ao), lo = function(n) {
        return so(n.dt);
    }, vo = function(n) {
        return {
            $: 3,
            a: n
        };
    }, bo = function(n) {
        return {
            $: 2,
            a: n
        };
    }, $o = {
        $: 0
    }, mo = F3(function(n, r, e) {
        switch(e.$){
            case 0:
                return $o;
            case 1:
                return Gi;
            case 2:
                return bo(r(e.a));
            default:
                return vo(n(e.a));
        }
    }), ho = F3(function(n, r, e) {
        return i({
            q: to,
            H: r,
            dt: A3(mo, ro(0), lo, e),
            S: n,
            J: 0
        }, Ma);
    }), po = F2(function(n, r) {
        return i({
            aj: Gi,
            H: r,
            dt: Gi,
            S: n
        }, A3(xc, n, r, Me));
    }), go = F2(function(n, r) {
        return !A2(xt, n, r).$;
    }), To = F2(function(n, r) {
        return A2(go, n, r.o);
    }), wo = To, ko = F2(function(n, r) {
        return f(r, A2(wo, n, r.K) ? {
            A: mi(n)
        } : {
            A: li
        });
    }), yo = To, So = F2(function(n, r) {
        return f(r, A2(yo, n, r.dt) ? {
            A: hi(n)
        } : {
            A: li
        });
    }), _o = F2(function(n, r) {
        switch(n.$){
            case 3:
                return vo(n.a);
            case 0:
                return $o;
            case 1:
                return Gi;
            default:
                var e = n.a;
                switch(r.$){
                    case 3:
                        return vo(r.a);
                    case 0:
                        return $o;
                    case 1:
                        return Gi;
                    default:
                        return bo((0, r.a)(e));
                }
        }
    }), Xo = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Ao = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), jo = F2(function(n, r) {
        return r.$ ? Ur : xr(n(r.a));
    }), Vo = F2(function(n, r) {
        return A2(wi, function(n) {
            return A2(jo, function(r) {
                return r(n);
            }, r);
        }, n);
    }), Co = F2(function(n, r) {
        return A2(xt, n, r.o);
    }), No = Co, Eo = Co, Lo = h, Do = F2(function(n, r) {
        var e = n.dt, t = n.K, u = function(n) {
            return c(n.$ ? "put-on-call" : "add", n.a.X, n.b.X);
        }, a = function(n) {
            if (n.$) return r = n.a, A2(Vo, A2(Eo, n.b, e), A2(Vo, A2(No, r, t), xr(Xo)));
            var r = n.a;
            return A2(Vo, A2(Eo, n.b, e), A2(Vo, A2(No, r, t), xr(Ao)));
        };
        return {
            bi: A2(jo, function(n) {
                return {
                    cy: A2(Lo, u, A2(wa, a, n.cy)),
                    dH: n.dH
                };
            }, r)
        };
    }), Ho = function(n) {
        return f(n, {
            aN: A2(_o, n.aq, A2(_o, n.R, bo(Do)))
        });
    }, qo = F2(function(n, r) {
        return Ho(f(r, {
            R: bo(n)
        }));
    }), Mo = F2(function(n, r) {
        var e = r.R;
        if (2 === e.$) {
            var t = e.a;
            return (function() {
                switch(n.$){
                    case 0:
                        return qo(A2(So, n.a, t));
                    case 1:
                        return qo(A2(ko, n.a, t));
                    case 2:
                        return qo(f(t, {
                            A: di
                        }));
                    default:
                        return qo(f(t, {
                            A: li
                        }));
                }
            })()(f(r, {
                aD: n
            }));
        }
        return f(r, {
            aD: n
        });
    }), Oo = F2(function(n, r) {
        var e = function() {
            switch(n.$){
                case 0:
                    return A3(Ua, $c, xa(dc), A3(Ki, A2(po, r.S, r.H), Ba(Ma), gc(r.V)));
                case 1:
                    return A3(Ua, lc, xa(oc), A3(Ki, A3(Ac, r.S, r.H, r.al), Ba(Ma), mc(r.V)));
                case 2:
                    return A3(Ua, bc, xa(sc), A3(Ki, A3(ho, r.S, r.H, r.al), Ba(Ma), pc(r.V)));
                default:
                    var e = n.a;
                    return A3(Ua, vc, xa(fc), A3(Ki, A3(no, r.S, r.H, e), A2(ki, Ba(Ma), Mo(e)), hc(r.V)));
            }
        }(), t = e.b;
        return i(f(r, {
            V: e.a
        }), t);
    }), Io = function(n) {
        return {
            $: 0,
            a: n
        };
    }, zo = F3(function(n, r, e) {
        var t = function() {
            switch(e.$){
                case 0:
                    return A3(Ua, $c, xa(dc), A2(po, n, r));
                case 1:
                    return A3(Ua, lc, xa(oc), A3(Ac, n, r, Gi));
                case 2:
                    return A3(Ua, bc, xa(sc), A3(ho, n, r, Gi));
                default:
                    var t = e.a;
                    return A3(Ua, vc, xa(fc), A3(no, n, r, t));
            }
        }(), u = t.b;
        return i({
            V: t.a,
            al: Gi,
            H: r,
            S: n
        }, qa(b([
            A3(xc, n, r, Io),
            u
        ])));
    }), Po = F3(function(n, r, e) {
        return A3(Ua, A2(ki, Yi(e), ic), xa(ac), A3(Ki, A3(zo, e.S, n, r), Oo(r), cc(e.V)));
    }), Ro = {
        $: 0
    }, xo = function(n) {
        return i({
            S: n
        }, Ma);
    }, Uo = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ko = {
        $: 1
    }, Yo = F2(function(n, r) {
        return f(n, {
            p: r
        });
    }), Bo = F4(function(n, r, e, t) {
        var u = t.a, a = t.b, c = e.p;
        switch(c.$){
            case 0:
            case 1:
            case 2:
            case 3:
                return i(e, Ma);
            default:
                return i(f(e, {
                    p: fi(f(c.a, {
                        V: n(u)
                    }))
                }), A2(xa, r, a));
        }
    }), Jo = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), Go = F2(function(n, r) {
        return i(r.a, qa(b([
            n,
            r.b
        ])));
    }), Fo = F2(function(n, r) {
        var e = r.a, t = F2(function(n, r) {
            var t = n(e);
            return 1 === t.$ ? A2(Ba, Ma, A2(Yo, e, vt("Invalid routing request"))) : r(t.a);
        });
        if (1 === n.$) return A4(Bo, Me, Me, e, A2(Ba, Ma, vi));
        switch(n.a.$){
            case 0:
                return A4(Bo, Me, Me, e, A2(Ba, Ma, vi));
            case 1:
                return A2(t, A2(ki, Xi, function(n) {
                    return n.p;
                }), function(n) {
                    return A4(Bo, Qa, ri, e, xo(n));
                });
            case 2:
                var u = n.a.a;
                return A2(t, A2(ki, Xi, function(n) {
                    return n.p;
                }), function(n) {
                    return A4(Bo, ci, ti, e, function(n) {
                        var r = n.a, e = n.b;
                        switch(u.$){
                            case 0:
                                return A2(Go, e, function(n) {
                                    return i(f(n, {
                                        V: Ci
                                    }), Ma);
                                }(r));
                            case 1:
                                return A2(Go, e, function(n) {
                                    var r = Vi.b;
                                    return i(f(n, {
                                        V: Ai(Vi.a)
                                    }), A2(xa, ji, r));
                                }(r));
                            default:
                                return A2(Go, e, A2(uc, u.a, r));
                        }
                    }(A2(Jo, function(n) {
                        return i({
                            V: Ci,
                            aj: Ko,
                            S: n
                        }, A2(Sc, n, Uo));
                    }(n), A2(jo, Ti(Ma), A2(wi, Si, yi(e.p))))));
                });
            case 3:
                return u = n.a.a, A2(t, A2(ki, Xi, function(n) {
                    return n.p;
                }), function(n) {
                    return A4(Bo, oi, ui, e, function(n) {
                        var r = n.a, e = n.b;
                        if (u.$) {
                            var t = u.a, a = u.b, i = function() {
                                switch(a.$){
                                    case 0:
                                        return gi;
                                    case 1:
                                        return $i;
                                    case 2:
                                        return pi;
                                    default:
                                        switch(a.a.$){
                                            case 0:
                                                return bi(li);
                                            case 1:
                                                return bi(hi(a.a.a));
                                            case 2:
                                                return bi(mi(a.a.a));
                                            default:
                                                return bi(di);
                                        }
                                }
                            }();
                            return A2(Go, e, A3(Po, t, i, r));
                        }
                        return A2(Go, e, function(n) {
                            return A3(Ua, A2(ki, Yi(n), Ei), xa(Ni), A3(Ki, Ui(n.S), Ba(Ma), Li(n.V)));
                        }(r));
                    }(A2(Jo, function(n) {
                        return A3(Ua, function(r) {
                            return {
                                V: Ei(r),
                                S: n
                            };
                        }, xa(Ni), Ui(n));
                    }(n), A2(jo, Ti(Ma), A2(wi, _i, yi(e.p))))));
                });
            default:
                return A2(t, A2(ki, Xi, function(n) {
                    return n.p;
                }), function(n) {
                    return A4(Bo, Za, ni, e, function(n) {
                        return i({
                            ai: Ro,
                            S: n
                        }, Ma);
                    }(n));
                });
        }
    }), Wo = F2(function(n, r) {
        var e = r.c, t = n(i(r.a, r.b));
        return i(t.a, qa(b([
            t.b,
            A2(xa, ei, e)
        ])));
    }), Zo = function(n) {
        return A2(lt, Qe, an(function() {
            try {
                kr.location = n;
            } catch (n) {
                Hn.location.reload(!1);
            }
        }));
    }, Qo = function(n) {
        switch(n.$){
            case 0:
                return "The login URL " + n.a + " was invalid.";
            case 1:
                return "Unable to reach the server, try again later...";
            case 2:
                return "Unable to reach the server, check your network connection.";
            case 3:
                return 500 === n.a ? "The server had a problem, try again later..." : "Unknown error (" + Br(n.a) + "). Please try again later...";
            default:
                return n.a;
        }
    }, nf = rn, rf = Cn("persistSessionTokenCmd", nf), ef = rf, tf = wr, uf = function(n) {
        return A3(Wr, F2(function(n, r) {
            return A3(tn, n.a, n.b, r);
        }), {}, n);
    }, af = Cn("requestLoginCmd", Me), cf = function(n) {
        var r, e;
        return af((e = (r = n).b2, uf(b([
            i("redirectUri", nf(r.dj)),
            i("nonce", nf(e))
        ]))));
    }, of = Cn("requestLogoutCmd", function() {
        return Ia;
    }), ff = of(0), sf = function(n) {
        return "/" + A2(Jr, "/", function(n) {
            switch(n.$){
                case 1:
                    return d;
                case 0:
                    return b([
                        "login",
                        "callback"
                    ]);
                case 2:
                    switch(n.a.$){
                        case 0:
                            return b([
                                "musicians"
                            ]);
                        case 1:
                            return b([
                                "musicians",
                                "add"
                            ]);
                        default:
                            return b([
                                "musicians",
                                "view",
                                n.a.a
                            ]);
                    }
                case 3:
                    if (!n.a.$) return b([
                        "plannings"
                    ]);
                    switch(n.a.b.$){
                        case 0:
                            return b([
                                "plannings",
                                n.a.a,
                                "summary"
                            ]);
                        case 1:
                            return b([
                                "plannings",
                                n.a.a,
                                "musicians"
                            ]);
                        case 2:
                            return b([
                                "plannings",
                                n.a.a,
                                "series"
                            ]);
                        default:
                            switch(n.a.b.a.$){
                                case 0:
                                    return b([
                                        "plannings",
                                        n.a.a,
                                        "schedule"
                                    ]);
                                case 1:
                                    var r = n.a;
                                    return b([
                                        "plannings",
                                        r.a,
                                        "schedule",
                                        "series",
                                        r.b.a.a
                                    ]);
                                case 2:
                                    var e = n.a;
                                    return b([
                                        "plannings",
                                        e.a,
                                        "schedule",
                                        "musicians",
                                        e.b.a.a
                                    ]);
                                default:
                                    return b([
                                        "plannings",
                                        n.a.a,
                                        "schedule",
                                        "auto"
                                    ]);
                            }
                    }
                default:
                    return b([
                        "admin"
                    ]);
            }
        }(n));
    }, df = Lt, lf = A3(Et, "nonce", df, He(function(n) {
        return {
            b2: n
        };
    })), vf = function(n) {
        return Da({
            cD: n.cD,
            c: n.c,
            i: d,
            k: "POST",
            m: Ur,
            n: Ur,
            f: n.f
        });
    }, bf = function(n) {
        return vf({
            cD: Bu,
            c: A2(ua, n, lf),
            f: oa(b([
                "login",
                "start"
            ]))
        });
    }, $f = F2(function(n, r) {
        return 1 === n.$ ? r : r + ":" + Br(n.a);
    }), mf = F3(function(n, r, e) {
        return 1 === r.$ ? e : s(e, s(n, r.a));
    }), hf = function(n) {
        return A3(mf, "#", n.bO, A3(mf, "?", n.ca, s(A2($f, n.b5, s(n.b9 ? "https://" : "http://", n.bS)), n.de)));
    }, pf = function(n) {
        return {
            $: 2,
            a: n
        };
    }, gf = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Tf = {
        $: 2
    }, wf = function(n) {
        return {
            $: 3,
            a: n
        };
    }, kf = F2(function(n, r) {
        return A2(lt, r, function(n) {
            return an(function(r) {
                (jr = document.createElement("input")).type = "file", jr.accept = A2(Jr, ",", n), jr.addEventListener("change", function(n) {
                    r(un(n.target.files[0]));
                }), function(n) {
                    if ("function" == typeof MouseEvent) n.dispatchEvent(new MouseEvent("click"));
                    else {
                        var r = document.createEvent("MouseEvents");
                        r.initMouseEvent("click", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), document.body.appendChild(n), n.dispatchEvent(r), document.body.removeChild(n);
                    }
                }(jr);
            });
        }(n));
    }), yf = function(n) {
        return n.name;
    }, Sf = A2(Gu, nt, lt(Me)), _f = function(n) {
        return b([
            n
        ]);
    }, Xf = Vr, Af = F2(function(n, r) {
        return {
            cO: n,
            dd: r
        };
    }), jf = {
        $: 2
    }, Vf = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Cf = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Nf = A2(_t, function(n) {
        switch(n){
            case "imported":
                return A3(Et, "name", Qi, A3(Et, "musician", Zi, He(Vf)));
            case "already-exists":
                return A3(Et, "name", Qi, A3(Et, "musician", Zi, He(Cf)));
            case "failed":
                return He(jf);
            default:
                return Ht("Unknown status for MusicianImportOutcome: " + n);
        }
    }, A2(Xt, "status", Lt)), Ef = A3(Et, "outcome", qi(Nf), A3(Et, "fileName", Lt, He(Af))), Lf = A3(Et, "results", qi(Ef), He(function(n) {
        return {
            dm: n
        };
    })), Df = F3(function(n, r, e) {
        var t;
        return Da({
            cD: (t = A2(ut, Xf("files[]"), r), A2(Vr, "", function(n) {
                for(var r = new FormData; n.b; n = n.b){
                    var e = n.a;
                    r.append(e.a, e.b);
                }
                return r;
            }(t))),
            c: A2(ua, e, Lf),
            i: b([
                A2(aa, "X-Session-Token", n)
            ]),
            k: "POST",
            m: Ur,
            n: Ur,
            f: oa(b([
                "musicians"
            ]))
        });
    }), Hf = F2(function(n, r) {
        switch(n.$){
            case 0:
                return c(r, A2(kf, b([
                    "text/yaml"
                ]), gf), Ma);
            case 1:
                var e = n.a;
                return c(f(r, {
                    ai: (u = yf(e), {
                        $: 1,
                        a: u
                    })
                }), A3(Df, r.S, _f(e), pf), Ma);
            case 2:
                var t = n.a;
                return c(f(r, 1 === t.$ ? {
                    ai: Tf
                } : {
                    ai: wf(A2(Vu, function(n) {
                        return n.dd;
                    }, t.a.dm))
                }), Ma, Ma);
            default:
                return c(r, Ma, Sf(n.a));
        }
        var u;
    }), qf = F2(function(n, r) {
        return c(r, Ma, Sf(n));
    }), Mf = {
        $: 0
    }, Of = F2(function(n, r) {
        return c(r, Ma, Sf(Mf));
    }), If = F2(function(n, r) {
        return i(r, Ma);
    }), zf = {
        $: 2
    }, Pf = F2(function(n, r) {
        return f(n, {
            V: r
        });
    }), Rf = F2(function(n, r) {
        return i(r, Ma);
    }), xf = F2(function(n, r) {
        var e = n;
        return i(f(r, {
            aZ: 1 === e.$ ? vo(0) : bo(e.a)
        }), Ma);
    }), Uf = F2(function(n, r) {
        return c(r.a, r.b, n);
    }), Kf = F2(function(n, r) {
        switch(n.$){
            case 0:
                return c(f(r, 1 === n.a.$ ? {
                    aj: zf
                } : {
                    aj: (a = A2(ut, function(n) {
                        return {
                            cB: n.cB,
                            cT: n.cT,
                            X: n.X,
                            dh: n.dh
                        };
                    }, n.a.a), {
                        $: 0,
                        a: a
                    })
                }), Ma, Ma);
            case 1:
                return c(r, Ma, Sf(n.a));
            case 2:
                var e = n.a;
                return A2(Uf, Ma, A2(Jo, i(r, Ma), A2(jo, A2(Ua, A2(ki, Pf(r), Ai), xa(ji)), A2(jo, Rf(e), 1 === (u = r.V).$ ? xr(u.a) : Ur))));
            default:
                var t = n.a;
                return A2(Uf, Ma, A2(Jo, i(r, Ma), A2(jo, A2(Ua, A2(ki, Pf(r), Ji), xa(Bi)), A2(jo, xf(t), function(n) {
                    return 2 === n.$ ? xr(n.a) : Ur;
                }(r.V)))));
        }
        var u, a;
    }), Yf = F4(function(n, r, e, t) {
        var u = t.b, a = t.c;
        return c(n(t.a), r(u), e(a));
    }), Bf = function(n) {
        return 1 === n.$ ? vo(n.a) : bo(n.a);
    }, Jf = F2(function(n, r) {
        switch(r.$){
            case 0:
                return $o;
            case 1:
                return Gi;
            case 2:
                return bo(r.a);
            default:
                return vo(n(r.a));
        }
    }), Gf = F2(function(n, r) {
        return f(n, {
            V: r
        });
    }), Ff = F2(function(n, r) {
        var e = r.b, t = n(r.a);
        return i(t.a, qa(b([
            e,
            t.b
        ])));
    }), Wf = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Zf = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Qf = F2(function(n, r) {
        return A3(_r, "arraybuffer", Ar, A2(Gu, r, n));
    }), ns = function(n) {
        return A2(Qf, n, ta(function() {
            return zr(0);
        }));
    }, rs = function(n) {
        return A2(Vr, "application/json", A2(Yr, 0, n));
    }, es = rn, ts = es, us = es, as = function(n) {
        var r = n.bn;
        return uf(b([
            i("services", us(n.N)),
            i("onCalls", ts(r))
        ]));
    }, is = F6(function(n, r, e, t, u, a) {
        return Da({
            cD: rs(as({
                bn: u,
                N: t
            })),
            c: ns(a),
            i: b([
                A2(aa, "X-Session-Token", n)
            ]),
            k: "PUT",
            m: Ur,
            n: Ur,
            f: oa(b([
                "plannings",
                r,
                "musicians",
                e
            ]))
        });
    }), cs = {
        o: uu,
        T: d
    }, os = cs, fs = function(n) {
        return -2 === n.o.$;
    }, ss = A2(uo, function(n) {
        return n.cT;
    }, F2(function(n, r) {
        return A2(Rt, n.X, r.X);
    })), ds = function(n) {
        return A3(Dr, F3(function(n, r, e) {
            return A2(Lr, r, e);
        }), d, n);
    }, ls = F3(function(n, r, e) {
        var t = n.ad, u = e, a = (0, n.be)(r), i = A3(Jt, a, r, u.o);
        return {
            o: i,
            T: A2(oo, t, ds(i))
        };
    }), vs = F3(function(n, r, e) {
        var t, u = n.ad, a = e, c = A2(xt, r, a.o);
        return 1 === c.$ ? i(Ur, a) : i(xr(c.a), {
            o: t = A2(ru, r, a.o),
            T: A2(oo, u, ds(t))
        });
    }), bs = F4(function(n, r, e, t) {
        var u = A3(vs, n, r, e), a = u.a, c = u.b;
        return 1 === a.$ ? i(e, t) : i(c, A3(ls, n, a.a, t));
    }), $s = bs(ss), ms = F3(function(n, r, e) {
        var t = function(t) {
            var u = function(n) {
                return fs(n) ? Ur : xr(n);
            }, a = A2(Jo, os, A2(xt, t, e.I)), c = A3(Ua, u, u, A3($s, n, A2(Jo, os, A2(xt, t, r.I)), a)), o = c.a, s = c.b;
            return i(f(r, {
                Z: A2(ru, n, r.Z),
                I: A3(eu, t, ro(o), r.I)
            }), f(e, {
                Z: A3(Jt, n, t, e.Z),
                I: A3(eu, t, ro(s), e.I)
            }));
        };
        return A3(Ki, i(r, e), t, A2(xt, n, r.Z));
    }), hs = F4(function(n, r, e, t) {
        return Da({
            cD: Bu,
            c: ns(t),
            i: b([
                A2(aa, "X-Session-Token", n)
            ]),
            k: "DELETE",
            m: Ur,
            n: Ur,
            f: oa(b([
                "plannings",
                r,
                "musicians",
                e
            ]))
        });
    }), ps = F2(function(n, r) {
        var t = n.a, u = t.a, a = n.b;
        if (e(t.b, a)) return i(r, Ma);
        var c = i(r.M, r.K);
        if (2 === c.a.$ && 2 === c.b.$) {
            var o = c.a.a, s = c.b.a;
            if (1 === a) {
                var d = A3(ms, u, o, s), l = d.a;
                return i(f(r, {
                    K: bo(d.b),
                    M: bo(l)
                }), A4(hs, r.S, r.H, u, Zf));
            }
            var v = A3(ms, u, s, o);
            return l = v.b, i(f(r, {
                K: bo(v.a),
                M: bo(l)
            }), A6(is, r.S, r.H, u, 0, 0, Wf));
        }
        return i(r, Ma);
    }), gs = function(n) {
        return n.$ ? Ur : xr({
            cJ: n.a,
            cM: n.b
        });
    }, Ts = Cn("onDragStart", Me), ws = F4(function(n, r, e, t) {
        return {
            $: 2,
            a: n,
            b: r,
            c: e,
            d: t
        };
    }), ks = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ys = F3(function(n, r, t) {
        var u = c(r, t, n);
        n: for(;;)switch(u.a.$){
            case 0:
                return i(ks(f = u.a.a), Ur);
            case 1:
                return i(_c, Ur);
            case 2:
                switch(u.b.$){
                    case 1:
                        return i(A4(ws, f = u.b.a, v = u.a.a, 0, Ur), Ur);
                    case 2:
                        var a = u.b;
                        return i(A4(ws, f = a.a, v = u.a.a, 0, b = a.d), Ur);
                    default:
                        break n;
                }
            case 3:
                if (2 !== u.b.$ || u.c) break n;
                var o = u.b, f = o.a;
                return e(u.a.a, v = o.b) ? i(ks(f), Ur) : i(t, Ur);
            case 4:
                switch(u.b.$){
                    case 1:
                        var s = u.a;
                        return i(A4(ws, f = u.b.a, v = s.a, d = s.b, xr(b = s.c)), Ur);
                    case 2:
                        var d, l = u.a, v = l.a, b = l.c, $ = u.b;
                        return f = $.a, e(d = l.b, $.c) ? i(t, Ur) : i(A4(ws, f, v, d, xr(b)), Ur);
                    default:
                        break n;
                }
            default:
                switch(u.b.$){
                    case 1:
                        var m = u.a;
                        return i(_c, xr(c(f = u.b.a, v = m.a, b = m.b)));
                    case 2:
                        var h = u.a;
                        return i(_c, xr(c(f = u.b.a, v = h.a, b = h.b)));
                    default:
                        break n;
                }
        }
        return i(t, Ur);
    }), Ss = ys(!1), _s = F2(function(n, r) {
        for(;;){
            if (!r.b) return Ur;
            var e = r.a, t = r.b;
            if (n(e)) return xr(e);
            r = t;
        }
    }), Xs = function(n) {
        return 1 !== n.$;
    }, As = F3(function(n, r, e) {
        var t = i(r, e);
        n: for(;;){
            r: for(;;){
                e: for(;;){
                    t: for(;;)switch(t.a.$){
                        case 3:
                            return vo(t.a.a);
                        case 1:
                            if (3 === t.b.$) break n;
                            break r;
                        case 0:
                            switch(t.b.$){
                                case 3:
                                    break n;
                                case 1:
                                    break e;
                                default:
                                    break t;
                            }
                        default:
                            switch(t.b.$){
                                case 3:
                                    break n;
                                case 1:
                                    break e;
                                case 0:
                                    return $o;
                                default:
                                    return bo(A2(n, t.a.a, t.b.a));
                            }
                    }
                    return $o;
                }
                return Gi;
            }
            return Gi;
        }
        return vo(t.b.a);
    }), js = F2(function(n, r) {
        return A3(tt, F2(function(r, e) {
            return A3(eu, n(r), A2(Gu, jo(Lr(r)), A2(Gu, Jo(b([
                r
            ])), xr)), e);
        }), uu, r);
    }), Vs = F2(function(n, r) {
        if (-2 === r.$) return Kt;
        var e = r.b, t = r.d, u = r.e;
        return A5(Ut, r.a, e, A2(n, e, r.c), A2(Vs, n, t), A2(Vs, n, u));
    }), Cs = fo(ss), Ns = function(n) {
        return n.T;
    }, Es = Ns, Ls = function(n) {
        return {
            Z: io(A2(Vu, function(n) {
                var r = n.a;
                return A2(ut, function(n) {
                    return i(n.cT, r);
                }, Es(n.b));
            }, Hr(n))),
            I: n
        };
    }, Ds = function(n) {
        return Ls(A2(Vs, ro(Cs), A2(js, function(n) {
            return n.dh;
        }, n)));
    }, Hs = F2(function(n, r) {
        return A3(tt, F2(function(r, e) {
            return n(r) ? A2(Lr, r, e) : e;
        }), d, r);
    }), qs = F2(function(n, r) {
        return i(r.a, n(r.b));
    }), Ms = function(n) {
        return !n;
    }, Os = F3(function(n, r, e) {
        for(;;){
            if (-2 === e.$) return r;
            var t = e.e, u = n, a = A3(n, e.b, e.c, A3(Os, n, r, e.d));
            n = u, r = a, e = t;
        }
    }), Is = F2(function(n, r) {
        return A3(Os, F3(function(r, e, t) {
            var u = t.a, a = t.b;
            return A2(n, r, e) ? i(A3(Jt, r, e, u), a) : i(u, A3(Jt, r, e, a));
        }), i(uu, uu), r);
    }), zs = F3(function(n, r, e) {
        var t = n.ad, u = A2(Is, function() {
            return r;
        }, e.o), a = u.a, c = u.b;
        return i({
            o: a,
            T: A2(oo, t, ds(a))
        }, {
            o: c,
            T: A2(oo, t, ds(c))
        });
    }), Ps = zs(ss), Rs = function(n) {
        return n.b;
    }, xs = function(n) {
        return A3(tt, F2(function(n, r) {
            var e = n.b, t = r.b;
            return i(A2(Lr, n.a, r.a), A2(Lr, e, t));
        }), i(d, d), n);
    }, Us = function(n) {
        var r = function(n) {
            var r, t;
            return A2(ki, (r = function(r) {
                return Xs(A2(_s, function(n) {
                    return e(n.cT, r.cT);
                }, n.aj));
            }, t = A2(Gu, Hs(A2(Gu, Rs, A2(Gu, fs, Ms))), A2(Gu, io, Ls)), A2(Gu, function(n) {
                return n.I;
            }, A2(Gu, Hr, A2(Gu, ut(qs(Ps(r))), A2(Gu, ut(function(n) {
                var r = n.a, e = n.b, t = e.b;
                return i(i(r, e.a), i(r, t));
            }), A2(Gu, xs, A2(Ua, t, t))))))), Ds);
        }, t = function(n) {
            switch(n.$){
                case 0:
                    return i($o, $o);
                case 1:
                    return i(Gi, Gi);
                case 2:
                    var r = n.a, e = r.b;
                    return i(bo(r.a), bo(e));
                default:
                    var t = n.a;
                    return i(vo(t), vo(t));
            }
        }(A3(As, r, n.al, n.aM));
        return f(n, {
            K: t.b,
            M: t.a
        });
    }, Ks = F2(function(n, r) {
        switch(n.$){
            case 0:
                var e = n.a;
                return i(Us(f(r, {
                    aM: A2(Jf, ro(0), Bf(e))
                })), Ma);
            case 1:
                var t = n.a, u = A2(Jo, Ma, A2(jo, A2(Gu, function(n) {
                    return n.cM;
                }, Ts), gs(t))), a = A2(Ss, t, r.a_), c = a.a, o = a.b;
                return A4(Ki, Me, A2(ki, Ff, ps), o, i(f(r, {
                    a_: c
                }), u));
            default:
                return i(1 === n.a.$ ? f(r, {
                    K: vo(0),
                    M: vo(0)
                }) : r, Ma);
        }
    }), Ys = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Bs = F4(function(n, r, e, t) {
        return Da({
            cD: Bu,
            c: ns(t),
            i: b([
                A2(aa, "X-Session-Token", n)
            ]),
            k: "POST",
            m: Ur,
            n: Ur,
            f: oa(b([
                "plannings",
                r,
                "auto-plan",
                Br(e),
                "apply"
            ]))
        });
    }), Js = function(n) {
        return Ho(f(n, {
            R: vo(0)
        }));
    }, Gs = A2(uo, function(n) {
        return n.cT;
    }, F2(function(n, r) {
        return A2(Rt, n.X, r.X);
    })), Fs = fo(Gs), Ws = A2(uo, function(n) {
        return n.cT;
    }, F2(function(n, r) {
        return A2(Rt, n.X, r.X);
    })), Zs = fo(Ws), Qs = F2(function(n, r) {
        return Ho(f(r, {
            aq: bo(n)
        }));
    }), nd = function(n) {
        switch(n.$){
            case 0:
            case 1:
            default:
                return Ur;
            case 2:
                return xr(n.a);
        }
    }, rd = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ed = function(n) {
        return {
            $: 3,
            a: n
        };
    }, td = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ud = function(n) {
        return {
            $: 6,
            a: n
        };
    }, ad = function(n) {
        return {
            $: 4,
            a: n
        };
    }, id = function(n) {
        return {
            $: 1,
            a: n
        };
    }, cd = function(n) {
        return {
            $: 5,
            a: n
        };
    }, od = F2(function(n, r) {
        var e = A2(Ss, n, r.w), t = e.a, u = e.b, a = function() {
            n: for(; !u.$;)switch(u.a.a.$){
                case 2:
                    if (3 === u.a.b.$) {
                        var n = u.a.a;
                        return xr(ed({
                            b1: n.a,
                            a3: n.b
                        }));
                    }
                    break n;
                case 1:
                    switch(u.a.b.$){
                        case 0:
                            var r = u.a, e = r.a;
                            return xr(rd({
                                b1: e.a,
                                dv: e.b,
                                dE: r.b.a
                            }));
                        case 1:
                            var t = u.a, a = t.a, i = t.b;
                            return xr(id({
                                c1: a.a,
                                c2: i.b,
                                dr: a.b,
                                ds: i.a
                            }));
                        case 3:
                            var c = u.a.a;
                            return xr(cd({
                                b1: c.a,
                                a3: c.b
                            }));
                        default:
                            break n;
                    }
                default:
                    switch(u.a.b.$){
                        case 2:
                            var o = u.a;
                            return xr(td({
                                b1: o.a.a,
                                a3: o.b.a
                            }));
                        case 0:
                            var f = u.a;
                            return xr(ad({
                                b1: f.a.a,
                                a3: f.b.a
                            }));
                        case 1:
                            var s = u.a, d = s.b;
                            return xr(ud({
                                c4: s.a.a,
                                dk: d.b,
                                a3: d.a
                            }));
                        default:
                            break n;
                    }
            }
            return Ur;
        }();
        return c(f(r, {
            w: t
        }), A2(Jo, Ma, A2(jo, A2(Gu, function(n) {
            return n.cM;
        }, Ts), gs(n))), a);
    }), fd = function(n) {
        return {
            $: 7,
            a: n
        };
    }, sd = function(n) {
        return {
            $: 6,
            a: n
        };
    }, dd = function(n) {
        return {
            $: 8,
            a: n
        };
    }, ld = function(n) {
        return {
            $: 9,
            a: n
        };
    }, vd = F5(function(n, r, e, t, u) {
        return Da({
            cD: Bu,
            c: ns(u),
            i: b([
                A2(aa, "X-Session-Token", n)
            ]),
            k: "DELETE",
            m: Ur,
            n: Ur,
            f: oa(b([
                "plannings",
                r,
                "series",
                e,
                "on-call",
                t
            ]))
        });
    }), bd = nf, $d = F5(function(n, r, e, t, u) {
        return Da({
            cD: rs(bd(t)),
            c: ns(u),
            i: b([
                A2(aa, "X-Session-Token", n)
            ]),
            k: "PUT",
            m: Ur,
            n: Ur,
            f: oa(b([
                "plannings",
                r,
                "series",
                e,
                "on-call"
            ]))
        });
    }), md = F2(function(n, r) {
        return f(r, {
            az: A2(Lc, n.cT, r.az)
        });
    }), hd = F2(function(n, r) {
        return f(r, {
            a0: xr(n)
        });
    }), pd = F2(function(n, r) {
        return A2(ru, n, r);
    }), gd = F2(function(n, r) {
        return f(r, {
            az: A2(pd, n.cT, r.az)
        });
    }), Td = F2(function(n, r) {
        return f(r, {
            aE: A2(Lc, n.cT, r.aE),
            aI: r.aI + n.N
        });
    }), wd = F5(function(n, r, e, t, u) {
        return Da({
            cD: Bu,
            c: ns(u),
            i: b([
                A2(aa, "X-Session-Token", n)
            ]),
            k: "PUT",
            m: Ur,
            n: Ur,
            f: oa(b([
                "plannings",
                r,
                "series",
                e,
                "scheduled",
                t
            ]))
        });
    }), kd = F2(function(n, r) {
        return f(r, {
            an: A2(Lc, n, r.an)
        });
    }), yd = F2(function(n, r) {
        return A2(go, n, r);
    }), Sd = F2(function(n, r) {
        return A2(yd, n, r.an);
    }), _d = F2(function(n, r) {
        return e(r.a0, xr(n)) || A2(Sd, n, r);
    }), Xd = F2(function(n, r) {
        return f(r, {
            aE: A2(pd, n.cT, r.aE),
            aI: r.aI - n.N
        });
    }), Ad = F2(function(n, r) {
        return f(r, {
            an: A2(pd, n, r.an)
        });
    }), jd = F5(function(n, r, e, t, u) {
        return Da({
            cD: Bu,
            c: ns(u),
            i: b([
                A2(aa, "X-Session-Token", n)
            ]),
            k: "DELETE",
            m: Ur,
            n: Ur,
            f: oa(b([
                "plannings",
                r,
                "series",
                e,
                "scheduled",
                t
            ]))
        });
    }), Vd = ls(Gs), Cd = ls(Ws), Nd = F5(function(n, r, e, t, u) {
        var a = A2(Eo, e, u.dt), c = A2(No, r, u.K), o = function(n) {
            var r = n.b, e = n.c;
            return i(f(u, {
                K: A2(Vd, n.a, u.K),
                dt: A2(Cd, r, u.dt)
            }), e);
        };
        return A3(Ki, i(u, n), o, A2(wi, Me, A2(Vo, a, A2(Vo, c, xr(t)))));
    }), Ed = F4(function(n, r, t, u) {
        if (1 === t.$) return i(u, Ma);
        switch(t.a.$){
            case 0:
            case 1:
            default:
                return i(u, Ma);
            case 2:
                return A5(Nd, Ma, a = t.a.a.b1, o = t.a.a.a3, F2(function(t, u) {
                    return e(u.a0, Ur) && !A2(_d, a, u) ? xr(c(A2(md, u, t), A2(hd, a, u), A5($d, n, r, o, a, sd))) : Ur;
                }), u);
            case 3:
                return A5(Nd, Ma, a = t.a.a.b1, o = t.a.a.a3, F2(function(t, u) {
                    return e(u.a0, xr(a)) ? xr(c(A2(gd, u, t), function(n) {
                        return f(n, {
                            a0: Ur
                        });
                    }(u), A5(vd, n, r, o, a, fd))) : Ur;
                }), u);
            case 4:
                return A5(Nd, Ma, a = t.a.a.b1, o = t.a.a.a3, F2(function(e, t) {
                    return A2(_d, a, t) ? Ur : xr(c(A2(Td, t, e), A2(kd, a, t), A5(wd, n, r, o, a, dd)));
                }), u);
            case 5:
                var a, o;
                return A5(Nd, Ma, a = t.a.a.b1, o = t.a.a.a3, F2(function(e, t) {
                    return A2(Sd, a, t) ? xr(c(A2(Xd, t, e), A2(Ad, a, t), A5(jd, n, r, t.cT, a, ld))) : Ur;
                }), u);
        }
    }), Ld = F2(function(n, r) {
        return f(r, {
            A: n
        });
    }), Dd = F5(function(n, r, e, t, u) {
        var a = n(u);
        if (1 === a.$) return i(u, Ma);
        var c = t(a.a), o = c.b;
        return i(A2(r, c.a, u), A2(xa, e, o));
    }), Hd = F2(function(n, r) {
        switch(n.$){
            case 0:
                return i(function(n) {
                    return Ho(f(n, {
                        aq: Gi
                    }));
                }(r), A3(Zc, r.S, r.H, jc));
            case 1:
                return i(r, A4(Bs, r.S, r.H, n.a, Ys));
            case 2:
                return i(1 === (c = n.a).$ ? function(n) {
                    return Ho(f(n, {
                        aq: vo(0)
                    }));
                }(r) : A2(Qs, c.a, r), Ma);
            case 3:
                return i(r, 1 === (c = n.a).$ ? Ma : qa(b([
                    A3(xc, r.S, r.H, Vc),
                    A3(Zc, r.S, r.H, jc)
                ])));
            case 4:
                var e = A2(od, n.a, r.u), t = e.a, u = e.b, a = e.c;
                return A2(Ff, A4(Dd, A2(Gu, function(n) {
                    return n.R;
                }, nd), qo, Me, A3(Ed, r.S, r.H, a)), i(f(r, {
                    u: t
                }), u));
            case 5:
                return i(1 === (c = n.a).$ ? Js(r) : A2(qo, A2(Ld, r.aD, (s = Zs((o = c.a).dt), {
                    K: Fs(o.aj),
                    A: li,
                    dt: s
                })), r), Ma);
            default:
                var c;
                return i(1 === (c = n.a).$ ? Js(r) : r, Ma);
        }
        var o, s;
    }), qd = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), Md = F3(function(n, r, e) {
        return {
            $: 7,
            a: n,
            b: r,
            c: e
        };
    }), Od = F3(function(n, r, e) {
        return {
            $: 1,
            a: n,
            b: r,
            c: e
        };
    }), Id = ls(ao), zd = es, Pd = nf, Rd = function(n) {
        var r = n.aj, e = n.N;
        return uf(b([
            i("name", Pd(n.X)),
            i("musicians", zd(r)),
            i("services", us(e))
        ]));
    }, xd = F3(function(n, r, e) {
        var t = r.df;
        return Da({
            cD: rs(Rd({
                aj: r.aj,
                X: r.X,
                N: r.N
            })),
            c: A2(ua, e, Hc),
            i: b([
                A2(aa, "X-Session-Token", n)
            ]),
            k: "POST",
            m: Ur,
            n: Ur,
            f: oa(b([
                "plannings",
                t,
                "series"
            ]))
        });
    }), Ud = Co, Kd = F2(function(n, r) {
        switch(r.$){
            case 0:
                return $o;
            case 1:
                return Gi;
            case 2:
                return bo(n(r.a));
            default:
                return vo(r.a);
        }
    }), Yd = F5(function(n, r, e, t, u) {
        var a, c, o;
        return Da({
            cD: rs((a = t, c = a.aj, o = a.N, uf(b([
                i("name", A2(Jo, Ia, A2(jo, Pd, a.X))),
                i("musicians", A2(Jo, Ia, A2(jo, zd, c))),
                i("services", A2(Jo, Ia, A2(jo, us, o)))
            ])))),
            c: ns(u),
            i: b([
                A2(aa, "X-Session-Token", n)
            ]),
            k: "PATCH",
            m: Ur,
            n: Ur,
            f: oa(b([
                "plannings",
                r,
                "series",
                e
            ]))
        });
    }), Bd = F2(function(n, r) {
        return r.$ ? A3(Od, r.a, r.b, n(r.c)) : eo(n(r.a));
    }), Jd = function(n) {
        return Bd(function(r) {
            return f(r, {
                X: n
            });
        });
    }, Gd = function(n) {
        return Bd(function(r) {
            return f(r, {
                dl: n
            });
        });
    }, Fd = function(n) {
        return Bd(function(r) {
            return f(r, {
                N: n
            });
        });
    }, Wd = F2(function(n, r) {
        switch(n.$){
            case 0:
                return i(f(r, {
                    q: A2(Jd, n.a, r.q)
                }), Ma);
            case 1:
                return i(f(r, {
                    q: A2(Gd, n.a, r.q)
                }), Ma);
            case 2:
                return i(f(r, {
                    q: A2(Fd, n.a, r.q)
                }), Ma);
            case 3:
                var t = A2(wi, Ud(l = n.a), nd(r.dt));
                return i(f(r, 1 === t.$ ? {
                    q: to
                } : {
                    q: (b = t.a, $ = {
                        X: b.X,
                        dl: b.dl,
                        N: b.N
                    }, A3(Od, b.cT, $, $))
                }), Ma);
            case 4:
                return i(f(r, {
                    q: to
                }), Ma);
            case 5:
                var u = r.q;
                if (u.$) {
                    var a = u.a, c = u.b, o = u.c;
                    return i(f(r, {
                        J: 1
                    }), A5(Yd, r.S, r.H, a, {
                        aj: e(o.dl, c.dl) ? Ur : xr(o.dl),
                        X: e(o.X, c.X) ? Ur : xr(o.X),
                        N: e(o.N, c.N) ? Ur : xr(o.N)
                    }, A2(Md, a, o)));
                }
                var s = u.a;
                return i(f(r, {
                    J: 1
                }), A3(xd, r.S, {
                    aj: s.dl,
                    X: s.X,
                    df: r.H,
                    N: s.N
                }, qd(s)));
            case 6:
                if (1 === n.b.$) return i(f(r, {
                    J: 2
                }), Ma);
                var d = n.a;
                return i(f(r, {
                    q: to,
                    dt: A2(Kd, Id({
                        cT: l = n.b.a,
                        X: d.X,
                        a0: Ur,
                        dl: d.dl,
                        an: Ec,
                        N: d.N
                    }), r.dt),
                    J: 0
                }), Ma);
            default:
                if (1 === n.c.$) return i(f(r, {
                    J: 2
                }), Ma);
                var l, v = n.b;
                return i(f(r, {
                    q: A3(Od, l = n.a, v, v),
                    dt: A2(Kd, Id({
                        cT: l,
                        X: v.X,
                        a0: Ur,
                        dl: v.dl,
                        an: Ec,
                        N: v.N
                    }), r.dt),
                    J: 0
                }), Ma);
        }
        var b, $;
    }), Zd = F2(function(n, r) {
        for(;;){
            if (-2 === r.$) return n;
            var e = r.d;
            n = A2(Zd, n + 1, r.e), r = e;
        }
    }), Qd = function(n) {
        return A2(Zd, 0, n);
    }, nl = F2(function(n, r) {
        if (1 === n.$) return i(r, Ma);
        var e, t = n.a;
        return i(f(r, {
            aj: (e = t.aj.b ? 0 | A3(Wr, Rr, 0, A2(ut, function(n) {
                return n.aI;
            }, t.aj)) / Zr(t.aj) : 0, bo(A2(ut, function(n) {
                var r = n.aI, t = n.aE;
                return {
                    cB: n.cB,
                    ae: r - e,
                    cT: n.cT,
                    X: n.X,
                    az: Qd(n.az),
                    aE: Qd(t),
                    aI: r
                };
            }, t.aj))),
            dt: bo(A2(ut, function(n) {
                var r = n.cT, e = n.X, t = n.dl, u = n.an;
                return {
                    aS: Qd(u) - t,
                    cT: r,
                    X: e,
                    dl: t,
                    an: Qd(u)
                };
            }, t.dt))
        }), Ma);
    }), rl = F2(function(n, r) {
        return Us(f(r, {
            al: n
        }));
    }), el = F2(function(n, r) {
        return f(r, {
            dt: A3(mo, ro(0), lo, n)
        });
    }), tl = F2(function(n, r) {
        switch(n.$){
            case 0:
                var e = n.a, t = A2(Jf, ro(0), Bf(e));
                return i(f(r, {
                    V: function() {
                        var n = r.V;
                        switch(n.$){
                            case 1:
                                return lc(A2(rl, t, n.a));
                            case 2:
                                return bc(A2(el, t, n.a));
                            default:
                                return r.V;
                        }
                    }(),
                    al: t
                }), Ma);
            case 1:
                var u = n.a;
                return A3(Ki, i(r, Ma), A2(Ua, A2(ki, Gf(r), $c), xa(dc)), A2(jo, nl(u), gc(r.V)));
            case 2:
                var a = n.a;
                return A3(Ki, i(r, Ma), A2(Ua, A2(ki, Gf(r), lc), xa(oc)), A2(jo, Ks(a), mc(r.V)));
            case 3:
                var c = n.a;
                return A3(Ki, i(r, Ma), A2(Ua, A2(ki, Gf(r), bc), xa(sc)), A2(jo, Wd(c), pc(r.V)));
            default:
                var o = n.a;
                return A3(Ki, i(r, Ma), A2(Ua, A2(ki, Gf(r), vc), xa(fc)), A2(jo, Hd(o), hc(r.V)));
        }
    }), ul = {
        $: 2
    }, al = function(n) {
        return {
            $: 3,
            a: n
        };
    }, il = nf, cl = F3(function(n, r, e) {
        var t;
        return Da({
            cD: rs((t = r, uf(b([
                i("name", il(t.X))
            ])))),
            c: A2(ua, e, Oi),
            i: b([
                A2(aa, "X-Session-Token", n)
            ]),
            k: "POST",
            m: Ur,
            n: Ur,
            f: oa(b([
                "plannings"
            ]))
        });
    }), ol = F2(function(n, r) {
        switch(n.$){
            case 0:
                return c(f(r, 1 === n.a.$ ? {
                    aA: ul
                } : {
                    aA: (u = n.a.a, {
                        $: 0,
                        a: u
                    })
                }), Ma, Ma);
            case 1:
                var e = n.a;
                return c(f(r, {
                    ay: e,
                    a$: xi(e)
                }), Ma, Ma);
            case 2:
                return c(f(r, {
                    ak: 1
                }), A3(cl, r.S, {
                    X: r.ay
                }, al), Ma);
            default:
                if (1 === n.a.$) return c(f(r, {
                    ak: 2
                }), Ma, Ma);
                var t = n.a.a;
                return c(f(r, {
                    ak: 0
                }), Ma, Sf(function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(gu(A2(pu, t, wu)))));
        }
        var u;
    }), fl = F2(function(n, r) {
        switch(n.$){
            case 0:
                return c(r, Ma, Sf(n.a));
            case 1:
                var e = n.a;
                return A2(Jo, c(r, Ma, Ma), A2(jo, A3(Yf, A2(ki, Yi(r), Ei), xa(Ni), Me), A2(jo, ol(e), Li(r.V))));
            default:
                var t = n.a;
                return A2(Uf, Ma, A2(Jo, i(r, Ma), A2(jo, A2(Ua, A2(ki, Yi(r), ic), xa(ac)), A2(jo, tl(t), cc(r.V)))));
        }
    }), sl = nf, dl = F2(function(n, r) {
        var e, t = function(n) {
            switch(n.$){
                case 0:
                    return qr(na(n.a));
                case 1:
                    return qr(ea);
                case 2:
                    return qr(ra);
                case 3:
                    return qr(Qu((r = n.a).dw));
                default:
                    var r = n.a, e = A2(Ju, la, n.b);
                    if (1 === e.$) return qr(Zu(fe(e.a)));
                    var t = e.a, u = A2(xt, "x-session-token", r.i);
                    return 1 === u.$ ? qr(Zu("Missing session token")) : zr({
                        aC: t,
                        S: u.a
                    });
            }
        };
        return vf({
            cD: rs((e = r, uf(b([
                i("id_token", sl(e.cU))
            ])))),
            c: A2(Fu, n, t),
            f: oa(b([
                "login",
                "validate"
            ]))
        });
    }), ll = F2(function(n, r) {
        return f(r, {
            aV: xr(n)
        });
    }), vl = F2(function(n, r) {
        var e = r.p;
        switch(e.$){
            case 0:
                return i(r, Ma);
            case 1:
                var t = e.a, u = e.b;
                if (8 === n.$) {
                    var a = n.a;
                    if (1 === a.$) return A2(Ka, Yo(r), A3(Ua, ht(t), xa($t), Oa));
                    var c = a.a;
                    return A2(Fo, Mu(u), A2(Ba, Ma, A2(Yo, r, fi({
                        V: si,
                        aU: t,
                        aC: c,
                        cp: Ur
                    }))));
                }
                return i(r, Ma);
            case 2:
                t = e.a;
                var o = e.b;
                n: for(;;)switch(n.$){
                    case 2:
                        var s = A2(Of, p = n.a, o), d = s.a, l = s.b, v = s.c;
                        return A2(Ka, Yo(r), i(A2(ht, t, d), qa(b([
                            A2(xa, $t, l),
                            A2(xa, ei, v)
                        ]))));
                    case 12:
                        if (n.a.$) break n;
                        return i(r, bf(ai));
                    case 9:
                        var $ = n.a;
                        if (1 === $.$) {
                            var m = $.a;
                            return A2(Ka, Yo(r), i(A2(ht, t, A2(ll, Qo(m), o)), Ma));
                        }
                        return i(r, cf({
                            b2: $.a.b2,
                            dj: hf(f(t.cC, {
                                de: sf(ou)
                            }))
                        }));
                    default:
                        break n;
                }
                return i(r, Ma);
            case 3:
                t = e.a;
                var h = e.b;
                switch(n.$){
                    case 3:
                        var p = n.a;
                        return A2(Ka, Yo(r), A3(Ua, mt(t), xa(bt), A2(If, p, h)));
                    case 10:
                        var g = n.a;
                        return 1 === g.$ ? A2(Ka, Yo(r), A2(Ya, A2(tf, r.C, sf(cu)), A3(Ua, A2(ki, ht(t), ll("No id token received")), xa($t), Oa))) : i(r, A2(dl, ii, {
                            cU: g.a
                        }));
                    case 11:
                        var T = n.a;
                        if (1 === T.$) return m = T.a, A2(Ka, Yo(r), A2(Ya, A2(tf, r.C, sf(cu)), A3(Ua, A2(ki, ht(t), ll(Qo(m))), xa($t), Oa)));
                        c = T.a.aC;
                        var w = T.a.S;
                        return A2(Ka, Yo(r), A2(Ya, A2(tf, r.C, sf(cu)), A2(Ya, ef(w), A3(Ua, function(n) {
                            return fi({
                                V: Qa(n),
                                aU: f(t, {
                                    S: xr(w)
                                }),
                                aC: c,
                                cp: Ur
                            });
                        }, xa(ri), xo(w)))));
                    default:
                        return i(r, Ma);
                }
            default:
                var k = e.a, y = i(n, k.V);
                n: for(;;)switch(y.a.$){
                    case 0:
                        var S = y.a.a;
                        return i(r, S.$ ? Zo(S.a) : A2(tf, r.C, hf(u = S.a)));
                    case 1:
                        return A2(Fo, Mu(u = y.a.a), i(r, Ma));
                    case 12:
                        switch(y.a.a.$){
                            case 1:
                                return t = k.aU, A2(Ka, Yo(r), A2(Ya, A2(tf, r.C, sf(cu)), A2(Ya, ff, A3(Ua, ht(f(t, {
                                    S: Ur
                                })), xa($t), Oa))));
                            case 2:
                                return i(r, A2(tf, r.C, sf(y.a.a.a)));
                            default:
                                break n;
                        }
                    case 4:
                        if (2 === y.b.$) {
                            p = y.a.a;
                            var _ = y.b.a;
                            return A2(Wo, A3(Bo, Qa, ri, r), A2(qf, p, _));
                        }
                        break n;
                    case 5:
                        if (3 === y.b.$) {
                            p = y.a.a;
                            var X = y.b.a;
                            return A2(Wo, A3(Bo, ci, ti, r), A2(Kf, p, X));
                        }
                        break n;
                    case 6:
                        if (4 === y.b.$) return p = y.a.a, X = y.b.a, A2(Wo, A3(Bo, oi, ui, r), A2(fl, p, X));
                        break n;
                    case 7:
                        if (5 === y.b.$) return p = y.a.a, X = y.b.a, A2(Wo, A3(Bo, Za, ni, r), A2(Hf, p, X));
                        break n;
                    default:
                        break n;
                }
                return i(r, Ma);
        }
    }), bl = zn, $l = bl, ml = function(n) {
        return {
            $: 3,
            a: n
        };
    }, hl = {
        $: 0
    }, pl = On("a"), gl = On("div"), Tl = F2(function(n, r) {
        return A2(Rn, n, nf(r));
    }), wl = Tl("className"), kl = function(n) {
        return wl("orchestra-admin__" + n);
    }, yl = On("h3"), Sl = function(n) {
        var r, e;
        return r = sf(n), A2(Tl, "href", Yn.test(e = r) ? "" : e);
    }, _l = {
        $: 1
    }, Xl = "orchestra-simple", Al = wl(Xl), jl = function(n) {
        return wl(Xl + "__" + n);
    }, Vl = On("header"), Cl = On("main"), Nl = function(n) {
        return On(function(n) {
            return Un.test(n) ? "p" : n;
        }(n));
    }, El = Nl("wa-avatar"), Ll = On("button"), Dl = "orchestra-profile", Hl = wl(Dl), ql = F2(function(n, r) {
        return A2(Rn, function(n) {
            return "innerHTML" == n || "outerHTML" == n || "formAction" == n ? "data-" + n : n;
        }(n), function(n) {
            return "string" == typeof n && Bn.test(n) ? "" : n;
        }(r));
    }), Ml = ql, Ol = A2(ki, Ml("distance"), es), Il = function(n) {
        return "orchestra-profile-" + n;
    }, zl = A2(ki, Ml("for"), nf), Pl = Tl("id"), Rl = A2(ki, Ml("label"), nf), xl = Pn, Ul = F2(function(n, r) {
        return A2(xl, n, {
            $: 0,
            a: r
        });
    }), Kl = function(n) {
        return A2(Ul, "click", He(n));
    }, Yl = A2(ki, Ml("placement"), nf), Bl = Nl("wa-popover"), Jl = Mn, Gl = Jl, Fl = function(n) {
        return Ll(A2(Lr, wl("orchestra-button"), n));
    }, Wl = F2(function(n, r) {
        var e = n.c_, t = r.cL;
        return A2(gl, b([
            Hl
        ]), b([
            A2(Ll, b([
                Pl(Il("profile")),
                wl(Dl + "__logout")
            ]), b([
                A2(El, b([
                    Rl(t)
                ]), d)
            ])),
            A2(Bl, b([
                zl(Il("profile")),
                Yl("bottom"),
                Ol(0)
            ]), b([
                A2(Fl, b([
                    Kl(e)
                ]), b([
                    Gl("Se d\xe9connecter")
                ]))
            ]))
        ]));
    }), Zl = wl("orchestra-site-name"), Ql = On("h1"), nv = A2(Ql, b([
        Zl
    ]), b([
        Gl("Orchestra")
    ])), rv = function(n) {
        return wl(A2(Jr, " ", A2(ut, Ae, A2(Hs, Rs, n))));
    }, ev = F2(function(n, r) {
        return n ? r : rv(d);
    }), tv = "orchestra-site-navigation", uv = wl(tv), av = function(n) {
        return wl(tv + "__" + n);
    }, iv = On("li"), cv = On("nav"), ov = On("ul"), fv = function(n) {
        var r = n.cZ;
        return A2(cv, b([
            uv
        ]), b([
            A2(ov, b([
                av("site-links")
            ]), A2(ut, function(n) {
                var r = n.aQ, e = n.aW, t = n.a1;
                return A2(iv, b([
                    av("site-link-entry")
                ]), b([
                    A2(pl, b([
                        av("site-link"),
                        A2(ev, e, av("site-link-active")),
                        Sl(t)
                    ]), b([
                        Gl(r)
                    ]))
                ]));
            }, r))
        ]));
    }, sv = function(n) {
        var r = n.bH, e = n.bY, t = n.bP;
        return A2(gl, b([
            Al
        ]), b([
            A2(Vl, b([
                jl("header")
            ]), b([
                nv,
                A2(gl, b([
                    jl("site-navigation")
                ]), b([
                    fv(r.c3)
                ])),
                A2(Wl, {
                    c_: t(_l)
                }, r.aC)
            ])),
            A2(Cl, b([
                jl("main")
            ]), b([
                e
            ]))
        ]));
    }, dv = On("p"), lv = "orchestra-page-simple", vv = wl(lv), bv = "orchestra-page-header", $v = wl(bv), mv = function(n) {
        return wl(bv + "__" + n);
    }, hv = On("h2"), pv = function(n) {
        var r = n.cn, e = n.dA;
        return A2(gl, b([
            $v
        ]), b([
            A2(hv, b([
                mv("title")
            ]), b([
                Gl(r)
            ])),
            A2(dv, b([
                mv("subtitle")
            ]), b([
                Gl(e)
            ]))
        ]));
    }, gv = function(n) {
        var r = n.cR, e = n.V;
        return A2(gl, b([
            vv
        ]), b([
            pv(r),
            A2(gl, b([
                wl(lv + "__content")
            ]), b([
                e
            ]))
        ]));
    }, Tv = F2(function(n, r) {
        return {
            V: sv({
                bH: n,
                bP: ml,
                bY: gv({
                    V: A2(gl, d, b([
                        A2(yl, d, b([
                            Gl("T\xe9l\xe9verser des musiciens")
                        ])),
                        A2(dv, d, b([
                            Gl("Cette section permet de charger un fichier d\xe9crivant des musiciens.")
                        ])),
                        A2(gl, d, function() {
                            var n = A2(Fl, b([
                                Kl(hl)
                            ]), b([
                                Gl("S\xe9lectionner un fichier de musiciens")
                            ])), e = r.ai;
                            switch(e.$){
                                case 0:
                                    return b([
                                        n
                                    ]);
                                case 1:
                                    return b([
                                        Gl("T\xe9l\xe9versement de " + e.a + "...")
                                    ]);
                                case 2:
                                    return b([
                                        Gl("\xc9chec lors du t\xe9l\xe9versement du fichier."),
                                        n
                                    ]);
                                default:
                                    var t = e.a;
                                    if (t.b) {
                                        var u = function(n) {
                                            switch(n.$){
                                                case 0:
                                                    var r = n.a, e = n.b;
                                                    return A2(iv, b([
                                                        kl("musician-imported")
                                                    ]), b([
                                                        Gl("Nouveau musicien ajout\xe9 : "),
                                                        A2(pl, b([
                                                            Sl(su(fu(r)))
                                                        ]), b([
                                                            Gl(e)
                                                        ]))
                                                    ]));
                                                case 1:
                                                    return r = n.a, e = n.b, A2(iv, b([
                                                        kl("musician-already-existing")
                                                    ]), b([
                                                        Gl("Musicen d\xe9j\xe0 existant : "),
                                                        A2(pl, b([
                                                            Sl(su(fu(r)))
                                                        ]), b([
                                                            Gl(e)
                                                        ]))
                                                    ]));
                                                default:
                                                    return A2(iv, b([
                                                        kl("musician-failed-to-be-imported")
                                                    ]), b([
                                                        Gl("\xc9chec du chargement du musicien.")
                                                    ]));
                                            }
                                        };
                                        return b([
                                            A2(ov, d, A2(ut, u, t)),
                                            n
                                        ]);
                                    }
                                    return b([
                                        Gl("T\xe9l\xe9vers\xe9, aucun musicien ajout\xe9."),
                                        n
                                    ]);
                            }
                        }())
                    ])),
                    cR: {
                        dA: "G\xe9rer l'application et ses donn\xe9es",
                        cn: "Administration"
                    }
                })
            }),
            cn: "Administration"
        };
    }), wv = F2(function(n) {
        return {
            V: sv({
                bH: n,
                bP: Me,
                bY: gv({
                    V: A2(gl, d, b([
                        A2(yl, d, b([
                            Gl("Planning en cours")
                        ])),
                        A2(dv, b([
                            wl("orchestra-dashboard__todo")
                        ]), b([
                            Gl("todo")
                        ]))
                    ])),
                    cR: {
                        dA: "Voir le r\xe9sum\xe9  des derni\xe8res s\xe9ries",
                        cn: "Tableau de bord"
                    }
                })
            }),
            cn: "Dashboard"
        };
    }), kv = "orchestra-error", yv = wl(kv), Sv = function(n) {
        return wl(kv + "__" + n);
    }, _v = "orchestra-splash", Xv = wl(_v), Av = function(n) {
        return wl(_v + "__" + n);
    }, jv = function(n) {
        var r = n.bY, e = n.cp;
        return A2(gl, b([
            Xv
        ]), b([
            A2(Cl, b([
                Av("main")
            ]), b([
                r
            ])),
            function() {
                if (1 === e.$) return Gl("");
                var n = e.a;
                return A2(gl, b([
                    Av("toast")
                ]), b([
                    n
                ]));
            }()
        ]));
    }, Vv = "orchestra-loading", Cv = wl(Vv), Nv = {
        V: jv({
            bY: A2(gl, b([
                Cv
            ]), b([
                A2(dv, b([
                    wl(Vv + "__message")
                ]), b([
                    Gl("Chargement de l'application en cours")
                ]))
            ])),
            cp: Ur
        }),
        cn: "Chargement en cours"
    }, Ev = "orchestra-login", Lv = wl(Ev), Dv = function(n) {
        return wl(Ev + "__" + n);
    }, Hv = function(n) {
        var r = n.c6;
        return A2(Ll, b([
            wl("orchestra-google-login"),
            Kl(r)
        ]), b([
            Gl("Se connecter via Google")
        ]));
    }, qv = "orchestra-login-callback", Mv = wl(qv), Ov = function(n) {
        return wl(qv + "__" + n);
    }, Iv = function(n) {
        return {
            $: 1,
            a: n
        };
    }, zv = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Pv = wl("orchestra-musicians-page"), Rv = "orchestra-detailed", xv = wl(Rv), Uv = function(n) {
        return wl(Rv + "__" + n);
    }, Kv = function(n) {
        var r = n.bH, e = n.bY, t = n.cj, u = n.bP;
        return A2(gl, b([
            xv
        ]), b([
            A2(Vl, b([
                Uv("header")
            ]), b([
                nv,
                A2(gl, b([
                    Uv("site-navigation")
                ]), b([
                    fv(r.c3)
                ])),
                A2(Wl, {
                    c_: u(_l)
                }, r.aC)
            ])),
            A2(Cl, b([
                Uv("sidebar")
            ]), b([
                t
            ])),
            A2(Cl, b([
                Uv("main")
            ]), b([
                e
            ]))
        ]));
    }, Yv = wl("orchestra-musicians-add-musician"), Bv = "orchestra-musicians-view-musician", Jv = wl(Bv), Gv = function(n) {
        return wl(Bv + "__" + n);
    }, Fv = Nl("wa-spinner"), Wv = A2(ki, Ml("image"), nf), Zv = F2(function(n, r) {
        var e = r.cB;
        return A2(El, 1 === e.$ ? n : A2(Lr, Wv("/api/musicians/" + r.cT + "/avatar?v=" + e.a), n), d);
    }), Qv = "orchestra-musicians-welcome", nb = wl(Qv), rb = {
        V: A2(gl, b([
            nb
        ]), b([
            A2(dv, b([
                wl(Qv + "__instructions")
            ]), b([
                Gl("Pour commencer, cliquez sur un musicien sur la barre de gauche, ou cliquer sur \u2795 pour ajouter un nouveau musicien.")
            ]))
        ])),
        cn: "Les musiciens"
    }, eb = "orchestra-musicians", tb = wl(eb), ub = function(n) {
        return wl(eb + "__" + n);
    }, ab = function(n) {
        return n.$ ? Sl(n.a) : Kl(n.a);
    }, ib = On("span"), cb = Tl("title"), ob = F2(function(n, r) {
        var e = n.c7, t = n.c8;
        return A2(gl, b([
            tb
        ]), function() {
            switch(r.$){
                case 0:
                    var n = r.a;
                    return b([
                        A2(hv, b([
                            ub("header")
                        ]), b([
                            Gl("Musiciens")
                        ])),
                        A2(pl, b([
                            ub("add-musician"),
                            ab(t),
                            cb("Ajouter un nouveau musicien")
                        ]), b([
                            Gl("\u2795")
                        ])),
                        n.b ? A2(ov, b([
                            ub("list")
                        ]), A2(ut, function(n) {
                            var r = n.cT, t = n.X, u = n.cB, a = n.dh;
                            return A2(iv, b([
                                ub("entry")
                            ]), b([
                                A2(pl, b([
                                    ub("musician"),
                                    ab(e(r))
                                ]), b([
                                    A2(Zv, b([
                                        ub("musician-avatar")
                                    ]), {
                                        cB: u,
                                        cT: r
                                    }),
                                    A2(ib, b([
                                        ub("musician-name")
                                    ]), b([
                                        Gl(t)
                                    ])),
                                    A2(ib, b([
                                        ub("musician-pupitre")
                                    ]), b([
                                        Gl(a)
                                    ]))
                                ]))
                            ]));
                        }, n)) : A2(dv, b([
                            ub("empty-list")
                        ]), b([
                            Gl("Aucun musicien connu")
                        ]))
                    ]);
                case 1:
                    return b([
                        A2(hv, b([
                            ub("header")
                        ]), b([
                            Gl("Musiciens")
                        ])),
                        A2(gl, b([
                            ub("loading-spinner")
                        ]), d)
                    ]);
                default:
                    return b([
                        A2(hv, b([
                            ub("header")
                        ]), b([
                            Gl("Musiciens")
                        ])),
                        A2(Ll, b([
                            ub("add-musician"),
                            ab(t),
                            cb("Ajouter un nouveau musicien")
                        ]), b([
                            Gl("\u2795")
                        ])),
                        A2(dv, b([
                            ub("error-message")
                        ]), b([
                            Gl("Le chargement des musiciens a \xe9chou\xe9. Veuillez r\xe9essayer ult\xe9rieurement.")
                        ]))
                    ]);
            }
        }());
    }), fb = F2(function(n, r) {
        var e = r.aj, t = r.V, u = F2(function(n, r) {
            return {
                V: A2($l, n, r.V),
                cn: r.cn
            };
        }), a = function() {
            switch(t.$){
                case 0:
                    return A2(u, Me, rb);
                case 1:
                    return A2(u, ji, {
                        V: A2(gl, b([
                            Yv
                        ]), b([
                            Gl("todo add musician")
                        ])),
                        cn: "Ajouter un musicien"
                    });
                default:
                    return A2(u, Bi, (n = t.a, {
                        V: A2(gl, b([
                            Jv
                        ]), b([
                            function() {
                                var r = n.aZ;
                                switch(r.$){
                                    case 0:
                                        return Gl("");
                                    case 1:
                                        return A2(gl, b([
                                            Gv("loading-spinner")
                                        ]), b([
                                            A2(Fv, d, d)
                                        ]));
                                    case 2:
                                        var e = r.a;
                                        return A2(gl, b([
                                            Gv("loaded")
                                        ]), b([
                                            A2(Zv, b([
                                                Gv("avatar")
                                            ]), e),
                                            A2(hv, b([
                                                Gv("name")
                                            ]), b([
                                                Gl(e.X)
                                            ])),
                                            A2(gl, b([
                                                Gv("pupitre")
                                            ]), b([
                                                Gl(e.dh)
                                            ]))
                                        ]));
                                    default:
                                        return A2(gl, b([
                                            Gv("failed")
                                        ]), b([
                                            A2(dv, d, b([
                                                Gl("Le musicien n'a pu \xeatre charg\xe9.")
                                            ]))
                                        ]));
                                }
                            }()
                        ])),
                        cn: "Musician"
                    }));
            }
            var n;
        }();
        return {
            V: Kv({
                bH: n,
                bP: Iv,
                bY: A2(gl, b([
                    Pv
                ]), b([
                    a.V
                ])),
                cj: A2(ob, {
                    c7: A2(ki, A2(ki, zv, su), fu),
                    c8: zv(su(du))
                }, e)
            }),
            cn: a.cn
        };
    }), sb = "orchestra-not-found", db = wl(sb), lb = {
        V: jv({
            bY: A2(gl, b([
                db
            ]), b([
                A2(dv, b([
                    wl(sb + "__message")
                ]), b([
                    Gl("La page demand\xe9e n'a pu \xeatre trouv\xe9e.")
                ]))
            ])),
            cp: Ur
        }),
        cn: "Page non trouv\xe9e"
    }, vb = function(n) {
        return {
            $: 0,
            a: n
        };
    }, bb = wl("orchestra-plannings-page"), $b = "orchestra-plannings-view-planning", mb = wl($b), hb = function(n) {
        return wl($b + "__" + n);
    }, pb = function(n) {
        return {
            $: 1,
            a: n
        };
    }, gb = "orchestra-plannings-view-planning-schedulable-musicians", Tb = wl(gb), wb = {
        $: 1
    }, kb = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), yb = F2(function(n, r) {
        return A2(xn, function(n) {
            return Kn.test(n) ? "data-" + n : n;
        }(n), function(n) {
            return Bn.test(n) ? "" : n;
        }(r));
    }), Sb = F2(function(n, r) {
        return A2(xl, n, {
            $: 3,
            a: r
        });
    }), _b = F3(function(n, r, e) {
        var t = r.bz, u = r.bs;
        return A2(Sb, n, A2(Le, function(n) {
            return {
                c$: n,
                bs: u,
                bz: t
            };
        }, e));
    }), Xb = F2(function(n, r) {
        return b([
            A2(yb, "draggable", "true"),
            A3(_b, "dragstart", {
                bs: !1,
                bz: !0
            }, A2(Le, A2(ki, n, kb(r)), Vt)),
            A3(_b, "dragend", {
                bs: !1,
                bz: !0
            }, He(n(wb)))
        ]);
    }), Ab = function(n) {
        return {
            $: 3,
            a: n
        };
    }, jb = F3(function(n, r, e) {
        return {
            $: 4,
            a: n,
            b: r,
            c: e
        };
    }), Vb = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), Cb = q, Nb = _, Eb = A5(U, F4(function(n, r, e, t) {
        return {
            bQ: r,
            cu: n,
            cv: e,
            cw: t
        };
    }), A2(At, b([
        "currentTarget",
        "clientWidth"
    ]), da), A2(At, b([
        "currentTarget",
        "clientHeight"
    ]), da), A2(Le, Nb, A2(At, b([
        "offsetX"
    ]), Cb)), A2(Le, Nb, A2(At, b([
        "offsetY"
    ]), Cb))), Lb = A2(Le, Nb, A2(At, b([
        "timeStamp"
    ]), Cb)), Db = F2(function(n, r) {
        var e;
        return b([
            A3(_b, "dragenter", {
                bs: !0,
                bz: !0
            }, He(n((e = r, {
                $: 2,
                a: e
            })))),
            A3(_b, "dragleave", {
                bs: !0,
                bz: !0
            }, He(n(Ab(r)))),
            A3(_b, "dragover", {
                bs: !0,
                bz: !1
            }, A2(Le, n, A3(De, jb(r), Lb, Eb))),
            A3(_b, "drop", {
                bs: !0,
                bz: !0
            }, A2(Le, A2(ki, n, Vb(r)), Eb))
        ]);
    }), Hb = function(n) {
        return wl(gb + "__" + n);
    }, qb = function(n) {
        var r = n.I;
        return A2(ut, qs(Es), Hr(r));
    }, Mb = F2(function(n, r) {
        return A2(gl, A2(Lr, Hb("musician"), n), b([
            A2(Zv, b([
                Hb("musician-avatar")
            ]), r),
            A2(ib, b([
                Hb("musician-name")
            ]), b([
                Gl(r.X)
            ]))
        ]));
    }), Ob = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Ib = "orchestra-plannings-view-planning-schedule", zb = wl(Ib), Pb = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Rb = F2(function(n, r) {
        return A2(Xb, r, Pb(n));
    }), xb = {
        $: 3
    }, Ub = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Kb = F2(function(n, r) {
        return A2(Db, r, Ub(n));
    }), Yb = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Bb = F3(function(n, r, e) {
        return A2(Db, e, A2(Yb, n, r));
    }), Jb = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Gb = F2(function(n, r) {
        return A2(Db, r, Jb(n));
    }), Fb = function(n) {
        return wl(Ib + "__" + n);
    }, Wb = function(n) {
        var r = n.A;
        return 0 === r.$ ? A2(Eo, r.a, n.dt) : Ur;
    }, Zb = function(n) {
        return 0 === n.$ ? Ur : xr(n.a);
    }, Qb = function(n) {
        return Xs(Zb(n.w));
    }, n$ = F2(function(n, r) {
        return e(Zb(r.w), xr(Pb(n)));
    }), r$ = F2(function(n, r) {
        return e(r.a, n);
    }), e$ = F2(function(n, r) {
        var e = r.w;
        return A3(Ki, !1, r$(n), Zb(e));
    }), t$ = function(n) {
        return 0 !== n.$;
    }, u$ = function(n) {
        return A3(Ki, !1, t$, Zb(n.w));
    }, a$ = function(n) {
        switch(n.$){
            case 0:
            case 1:
                return Ur;
            default:
                return xr(n.b);
        }
    }, i$ = F2(function(n, r) {
        switch(r.$){
            case 0:
            case 1:
            case 2:
                return e(n, r.a);
            default:
                return !1;
        }
    }), c$ = F2(function(n, r) {
        var e = r.w;
        return A2(Jo, !1, A2(jo, i$(n), a$(e)));
    }), o$ = F2(function(n, r) {
        return e(a$(r.w), xr(Ub(n)));
    }), f$ = F3(function(n, r, t) {
        return e(a$(t.w), xr(A2(Yb, n, r)));
    }), s$ = F2(function(n, r) {
        return e(a$(r.w), xr(Jb(n)));
    }), d$ = Ns, l$ = Ns, v$ = function(n) {
        return pl(A2(Lr, wl("orchestra-link-button"), n));
    }, b$ = {
        $: 0
    }, $$ = On("h4"), m$ = function(n) {
        return A2(gl, b([
            Fb("musician-info")
        ]), b([
            A2(Zv, b([
                Fb("musician-info-avatar")
            ]), n),
            A2(yl, b([
                Fb("musician-info-name")
            ]), b([
                Gl(n.X)
            ])),
            Gl("todo")
        ]));
    }, h$ = F3(function(n, r, e) {
        return Br(e) + " " + (e > 1 ? r : n);
    }), p$ = F2(function(n, r) {
        return A2(gl, b([
            Fb("planning-musician")
        ]), b([
            A2(Zv, b([
                Fb("musician-avatar")
            ]), r),
            A2(ib, b([
                Fb("musician-name")
            ]), b([
                Gl(r.X)
            ])),
            A2(ib, b([
                Fb("musician-highlight")
            ]), b([
                function() {
                    var e = A3(h$, "service", "services", r.aI), t = A3(h$, "astreinte", "astreintes", Qd(r.az));
                    switch(n){
                        case 0:
                            return Gl(e);
                        case 1:
                            return Gl(t);
                        default:
                            return Gl(e + " \u25AA\uFE0F " + t);
                    }
                }()
            ]))
        ]));
    }), g$ = Gl(""), T$ = On("dl"), w$ = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), k$ = F3(function(n, r, e) {
        return A2(Xb, e, A2(w$, n, r));
    }), y$ = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), S$ = F3(function(n, r, e) {
        return A2(Xb, e, A2(y$, n, r));
    }), _$ = F2(function(n, r) {
        return n ? r : Gl("");
    }), X$ = F3(function(n, r, t) {
        var u = n.u;
        return A2(gl, b([
            Fb("serie-info")
        ]), b([
            A2(yl, d, b([
                Gl(t.X)
            ])),
            A2(T$, b([
                Fb("serie-info-properties")
            ]), b([
                A2(gl, b([
                    Fb("serie-info-property-services")
                ]), b([
                    A2($$, d, b([
                        Gl("Services")
                    ])),
                    A2(ib, d, b([
                        Gl(Br(t.N))
                    ]))
                ])),
                A2(gl, b([
                    Fb("serie-info-property-on-call-musician")
                ]), b([
                    A2($$, d, b([
                        Gl("Musicien en astreinte")
                    ])),
                    function() {
                        var n = A2(wi, function(n) {
                            return A2(No, n, r);
                        }, t.a0);
                        if (1 === n.$) return A2(gl, A2(Lr, Fb("serie-info-on-call-musician-container"), A2(Lr, Fb("serie-info-on-call-musician-none"), A2(Lr, A2(ev, A2(s$, t.cT, u), Fb("serie-info-musician-on-call-dropping")), A2(Gb, t.cT, Ob)))), b([
                            Gl("Aucun musicien en astreinte.")
                        ]));
                        var e = n.a;
                        return A2(gl, s(b([
                            Fb("serie-info-on-call-musician-container"),
                            A2(ev, A2(s$, t.cT, u), Fb("serie-info-musician-on-call-dropping")),
                            A2(ev, A2(e$, e.cT, u), Fb("serie-info-musician-on-call-highlight"))
                        ]), s(A3(k$, e.cT, t.cT, Ob), A2(Gb, t.cT, Ob))), b([
                            A2(p$, 1, e)
                        ]));
                    }()
                ])),
                A2(gl, b([
                    Fb("serie-info-property-scheduled-musicians")
                ]), b([
                    A2($$, d, b([
                        Gl("Musiciens programm\xe9s"),
                        Gl(" (" + Br(Qd(t.an)) + "/" + Br(t.dl) + ")")
                    ])),
                    A2(ov, b([
                        Fb("serie-info-musicians")
                    ]), A2(ut, function(n) {
                        return A2(iv, s(b([
                            Fb("serie-info-musician"),
                            A2(ev, A3(f$, t.cT, n.cT, u), Fb("serie-info-musician-dropping")),
                            A2(ev, A2(n$, n.cT, u), Fb("serie-info-musician-highlight"))
                        ]), s(A3(Bb, t.cT, n.cT, Ob), A3(S$, n.cT, t.cT, Ob))), b([
                            A2(p$, 0, n)
                        ]));
                    }, A2(Hs, function(n) {
                        return A2(yd, n.cT, t.an);
                    }, d$(r)))),
                    A2(_$, !e(Qd(t.an), t.dl), A2(gl, A2(Lr, Fb("serie-info-droppable"), A2(Lr, A2(ev, Qb(u), Fb("serie-info-drop-enabled")), A2(Lr, A2(ev, A2(o$, t.cT, u), Fb("serie-info-dropping")), A2(Kb, t.cT, Ob)))), b([
                        Gl("D\xe9placer le musicien ici pour l'ajouter \xe0 la s\xe9rie")
                    ])))
                ]))
            ]))
        ]));
    }), A$ = F2(function(n, r) {
        var e = r.X;
        return A2(gl, b([
            Fb("planning-serie")
        ]), b([
            A2(ib, b([
                Fb("serie-name")
            ]), b([
                Gl(e)
            ])),
            n
        ]));
    }), j$ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, V$ = {
        $: 4
    }, C$ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, N$ = {
        $: 5
    }, E$ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, L$ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, D$ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, H$ = "orchestra-plannings-view-planning-series", q$ = wl(H$), M$ = rn, O$ = F2(function(n, r) {
        return A2(Rn, n, M$(r));
    }), I$ = O$("disabled"), z$ = function(n) {
        return wl(H$ + "__" + n);
    }, P$ = Ns, R$ = F2(function(n, r) {
        return 1 === n.$ ? rv(d) : r(n.a);
    }), x$ = wl("orchestra-number-input"), U$ = On("input"), K$ = Tl("max"), Y$ = Tl("min"), B$ = function(n) {
        return i(n, !0);
    }, J$ = F2(function(n, r) {
        return A2(xl, n, {
            $: 1,
            a: r
        });
    }), G$ = A2(At, b([
        "target",
        "value"
    ]), Lt), F$ = function(n) {
        return A2(J$, "input", A2(Le, B$, A2(Le, n, G$)));
    }, W$ = Tl("placeholder"), Z$ = O$("required"), Q$ = Tl("type"), nm = Tl("value"), rm = "orchestra-wrapper-input", em = wl(rm), tm = function(n) {
        return wl(rm + "__" + n);
    }, um = On("label"), am = F3(function(n, r, e) {
        return 1 === n.$ ? e : A2(r, n.a, e);
    }), im = F3(function(n, r, e) {
        var t = n.bg, u = n.bt;
        return A2(gl, b([
            em
        ]), b([
            A3(am, t, F2(function(n, r) {
                return A2(um, b([
                    tm("label"),
                    A2(ev, u, tm("required-label"))
                ]), b([
                    A2(ib, b([
                        tm("text")
                    ]), b([
                        Gl(n)
                    ])),
                    r
                ]));
            }), A2(gl, b([
                tm("wrapper")
            ]), b([
                r(e)
            ])))
        ]));
    }), cm = function(n) {
        return A2(im, n, function(r) {
            return A2(U$, b([
                x$,
                Q$("number"),
                Z$(n.bt),
                nm(A3(Ki, "", Br, r)),
                F$(A2(ki, A2(ki, n.bo, Jo(0)), Ye)),
                A2(R$, n.br, W$),
                A2(R$, n.b_, A2(ki, Y$, Br)),
                A2(R$, n.bZ, A2(ki, K$, Br))
            ]), d);
        });
    }, om = "orchestra-series", fm = wl(om), sm = F3(function(n, r, e) {
        return n.$ ? A2(pl, A2(Lr, Sl(n.a), r), e) : A2(Ll, A2(Lr, Kl(n.a), r), e);
    }), dm = function(n) {
        return wl(om + "__" + n);
    }, lm = F2(function(n, r) {
        var e = n.c9, t = n.cy;
        return A2(gl, b([
            fm
        ]), function() {
            switch(r.$){
                case 0:
                    return b([
                        Gl("")
                    ]);
                case 2:
                    var n = r.a;
                    return b([
                        A2(hv, b([
                            dm("header")
                        ]), b([
                            Gl("S\xe9ries")
                        ])),
                        t,
                        n.b ? A2(ov, b([
                            dm("list")
                        ]), A2(ut, function(n) {
                            var r = n.cT, t = n.X;
                            return A2(iv, b([
                                dm("entry")
                            ]), b([
                                A3(sm, e(r), b([
                                    dm("serie")
                                ]), b([
                                    A2(ib, b([
                                        dm("serie-name")
                                    ]), b([
                                        Gl(t)
                                    ]))
                                ]))
                            ]));
                        }, n)) : A2(dv, b([
                            dm("empty-list")
                        ]), b([
                            Gl("Aucune s\xe9rie connu")
                        ]))
                    ]);
                case 1:
                    return b([
                        A2(hv, b([
                            dm("header")
                        ]), b([
                            Gl("S\xe9ries")
                        ])),
                        A2(gl, b([
                            dm("loading-spinner")
                        ]), d)
                    ]);
                default:
                    return b([
                        A2(hv, b([
                            dm("header")
                        ]), b([
                            Gl("S\xe9ries")
                        ])),
                        t,
                        A2(dv, b([
                            dm("error-message")
                        ]), b([
                            Gl("Le chargement des s\xe9ries a \xe9chou\xe9. Veuillez r\xe9essayer ult\xe9rieurement.")
                        ]))
                    ]);
            }
        }());
    }), vm = wl("orchestra-text-input"), bm = function(n) {
        return A2(im, n, function(r) {
            return A2(U$, b([
                vm,
                Q$("text"),
                Z$(n.bt),
                nm(r),
                F$(n.bo),
                A2(R$, n.br, W$)
            ]), d);
        });
    }, $m = "orchestra-plannings-view-planning-summary", mm = wl($m), hm = function(n) {
        return wl($m + "__" + n);
    }, pm = Gl(""), gm = "orchestra-tab-group", Tm = wl(gm), wm = function(n) {
        return wl(gm + "__" + n);
    }, km = F2(function(n, r) {
        var t = n.dD, u = (0, n.dB)(r), a = u.a, i = u.b, c = function(n) {
            var r = n.a7, t = n.X, u = n.a1;
            return A2(pl, b([
                wm("tab"),
                A2(ev, e(r, a), wm("active-tab")),
                Sl(u)
            ]), b([
                Gl(t)
            ]));
        };
        return A2(gl, b([
            Tm
        ]), b([
            A2(gl, b([
                wm("tabs")
            ]), A2(ut, c, t)),
            A2(gl, b([
                wm("panel")
            ]), b([
                i
            ]))
        ]));
    }), ym = function(n) {
        return {
            V: A2(gl, b([
                mb
            ]), b([
                function() {
                    var r = n.al;
                    switch(r.$){
                        case 0:
                            return Gl("");
                        case 1:
                            return A2(gl, b([
                                hb("loading-spinner")
                            ]), b([
                                A2(Fv, d, d)
                            ]));
                        case 2:
                            var t = r.a;
                            return A2(gl, b([
                                hb("loaded")
                            ]), b([
                                A2(gl, b([
                                    hb("header")
                                ]), b([
                                    A2(hv, b([
                                        hb("planning-name")
                                    ]), b([
                                        Gl(t.X)
                                    ]))
                                ])),
                                A2(km, {
                                    dB: function(n) {
                                        switch(n.$){
                                            case 0:
                                                return i(gi, A2($l, dc, function(n) {
                                                    return A2(gl, b([
                                                        mm
                                                    ]), b([
                                                        A2(gl, b([
                                                            hm("statistics")
                                                        ]), b([
                                                            A2(gl, b([
                                                                hm("musicians-statistics")
                                                            ]), b([
                                                                A2(yl, b([
                                                                    hm("musicians-heading")
                                                                ]), b([
                                                                    Gl("Musiciens")
                                                                ])),
                                                                function() {
                                                                    var r = n.aj;
                                                                    switch(r.$){
                                                                        case 0:
                                                                            return Gl("Les informations des musiciens ne sont pas disponibles.");
                                                                        case 1:
                                                                            return Gl("Chargement des musiciens...");
                                                                        case 2:
                                                                            var e = r.a;
                                                                            return A2(ov, b([
                                                                                hm("musicians-list")
                                                                            ]), A2(ut, function(r) {
                                                                                return A2(iv, d, b([
                                                                                    A2(pl, b([
                                                                                        Sl(gu(A2(pu, n.H, Tu(mu(r.cT))))),
                                                                                        hm("musician")
                                                                                    ]), b([
                                                                                        A2(Zv, b([
                                                                                            hm("musician-avatar")
                                                                                        ]), r),
                                                                                        A2(gl, b([
                                                                                            hm("musician-name")
                                                                                        ]), b([
                                                                                            Gl(r.X)
                                                                                        ])),
                                                                                        A2(ov, b([
                                                                                            hm("musician-statistics")
                                                                                        ]), b([
                                                                                            A2(iv, b([
                                                                                                hm("musician-services")
                                                                                            ]), b([
                                                                                                A2(ib, d, b([
                                                                                                    Gl(A3(h$, "service", "services", r.aI))
                                                                                                ])),
                                                                                                0 > r.ae ? A2(ib, b([
                                                                                                    hm("musician-services-shortage")
                                                                                                ]), b([
                                                                                                    Gl(Br(r.ae))
                                                                                                ])) : r.ae ? A2(ib, b([
                                                                                                    hm("musician-services-excess")
                                                                                                ]), b([
                                                                                                    Gl("+" + Br(r.ae))
                                                                                                ])) : pm
                                                                                            ])),
                                                                                            A2(iv, d, b([
                                                                                                Gl(A3(h$, "s\xe9rie", "s\xe9ries", r.aE)),
                                                                                                Gl(" - "),
                                                                                                Gl(A3(h$, "astreinte", "astreintes", r.az))
                                                                                            ]))
                                                                                        ]))
                                                                                    ]))
                                                                                ]));
                                                                            }, e));
                                                                        default:
                                                                            return Gl("Le chargement des musiciens a \xe9chou\xe9.");
                                                                    }
                                                                }(),
                                                                A2(v$, b([
                                                                    Sl(gu(A2(pu, n.H, wu))),
                                                                    hm("add-musician")
                                                                ]), b([
                                                                    Gl("Ajouter un musicien")
                                                                ]))
                                                            ])),
                                                            A2(gl, b([
                                                                hm("series-statistics")
                                                            ]), b([
                                                                A2(yl, b([
                                                                    hm("series-heading")
                                                                ]), b([
                                                                    Gl("S\xe9ries")
                                                                ])),
                                                                function() {
                                                                    var r = n.dt;
                                                                    switch(r.$){
                                                                        case 0:
                                                                            return Gl("Les informations des s\xe9ries ne sont pas disponibles.");
                                                                        case 1:
                                                                            return Gl("Chargement des s\xe9ries...");
                                                                        case 2:
                                                                            var e = r.a;
                                                                            return A2(ov, b([
                                                                                hm("series-list")
                                                                            ]), A2(ut, function(r) {
                                                                                return A2(iv, d, b([
                                                                                    A2(pl, b([
                                                                                        Sl(gu(A2(pu, n.H, Tu(hu(r.cT))))),
                                                                                        hm("serie")
                                                                                    ]), b([
                                                                                        A2(gl, b([
                                                                                            hm("serie-name")
                                                                                        ]), b([
                                                                                            Gl(r.X)
                                                                                        ])),
                                                                                        A2(gl, b([
                                                                                            hm("serie-musicians")
                                                                                        ]), b([
                                                                                            A2(ib, d, b([
                                                                                                Gl(A3(h$, "musicien", "musiciens", r.an)),
                                                                                                Gl(" / "),
                                                                                                Gl(Br(r.dl))
                                                                                            ])),
                                                                                            r.aS ? A2(ib, b([
                                                                                                hm("serie-musicians-difference")
                                                                                            ]), b([
                                                                                                Gl(Br(r.aS))
                                                                                            ])) : pm
                                                                                        ]))
                                                                                    ]))
                                                                                ]));
                                                                            }, e));
                                                                        default:
                                                                            return Gl("Le chargement des s\xe9ries a \xe9chou\xe9.");
                                                                    }
                                                                }(),
                                                                A2(v$, b([
                                                                    Sl(gu(A2(pu, n.H, ku))),
                                                                    hm("add-serie")
                                                                ]), b([
                                                                    Gl("Ajouter une s\xe9rie")
                                                                ]))
                                                            ]))
                                                        ]))
                                                    ]));
                                                }(n.a)));
                                            case 1:
                                                return i($i, A2($l, oc, function(n) {
                                                    return A2(gl, b([
                                                        Tb
                                                    ]), b([
                                                        A2(gl, b([
                                                            Hb("schedule-instructions")
                                                        ]), b([
                                                            Gl("Glissez les musiciens \xe0 gauche pour les ajouter au planning et \xe0 droite pour les en retirer")
                                                        ])),
                                                        A2(gl, b([
                                                            Hb("scheduled-musicians")
                                                        ]), b([
                                                            A2(gl, d, b([
                                                                Gl("Liste des musiciens programm\xe9s :")
                                                            ])),
                                                            function() {
                                                                var r = n.M;
                                                                switch(r.$){
                                                                    case 0:
                                                                        return Gl("");
                                                                    case 3:
                                                                        return Gl("Les musiciens n'ont pu \xeatre charg\xe9s.");
                                                                    case 1:
                                                                        return A2(Fv, d, d);
                                                                    default:
                                                                        var e = r.a;
                                                                        return A2(ov, A2(Lr, Hb("scheduled-musician-pupitres-list"), A2(Db, pb, 0)), A2(Vu, function(n) {
                                                                            var r = n.a, e = n.b;
                                                                            return b([
                                                                                A2(gl, b([
                                                                                    Hb("musician-pupitre")
                                                                                ]), b([
                                                                                    Gl(r)
                                                                                ])),
                                                                                A2(ov, b([
                                                                                    Hb("scheduled-musician-pupitre")
                                                                                ]), A2(ut, function(n) {
                                                                                    return A2(iv, d, b([
                                                                                        A2(Mb, A2(Xb, pb, i(n.cT, 0)), n)
                                                                                    ]));
                                                                                }, e))
                                                                            ]);
                                                                        }, qb(e)));
                                                                }
                                                            }()
                                                        ])),
                                                        A2(gl, b([
                                                            Hb("available-musicians")
                                                        ]), b([
                                                            A2(gl, d, b([
                                                                Gl("Liste des musiciens disponibles :")
                                                            ])),
                                                            function() {
                                                                var r = n.K;
                                                                switch(r.$){
                                                                    case 0:
                                                                        return Gl("");
                                                                    case 3:
                                                                        return Gl("Les musiciens n'ont pu \xeatre charg\xe9s.");
                                                                    case 1:
                                                                        return A2(Fv, d, d);
                                                                    default:
                                                                        var e = r.a;
                                                                        return A2(ov, A2(Lr, Hb("available-musician-pupitres-list"), A2(Db, pb, 1)), A2(Vu, function(n) {
                                                                            var r = n.a, e = n.b;
                                                                            return b([
                                                                                A2(gl, b([
                                                                                    Hb("musician-pupitre")
                                                                                ]), b([
                                                                                    Gl(r)
                                                                                ])),
                                                                                A2(ov, b([
                                                                                    Hb("available-musician-pupitre")
                                                                                ]), A2(ut, function(n) {
                                                                                    return A2(iv, d, b([
                                                                                        A2(Mb, A2(Xb, pb, i(n.cT, 1)), n)
                                                                                    ]));
                                                                                }, e))
                                                                            ]);
                                                                        }, qb(e)));
                                                                }
                                                            }()
                                                        ]))
                                                    ]));
                                                }(n.a)));
                                            case 2:
                                                return i(pi, A2($l, sc, function(n) {
                                                    var r = function(n) {
                                                        return b([
                                                            A2(bm, {
                                                                bg: xr("Nom de la s\xe9rie"),
                                                                bo: E$,
                                                                br: Ur,
                                                                bt: !0
                                                            }, n.X),
                                                            A2(cm, {
                                                                bg: xr("Musiciens n\xe9cessaires"),
                                                                bZ: Ur,
                                                                b_: xr(0),
                                                                bo: j$,
                                                                br: Ur,
                                                                bt: !0
                                                            }, xr(n.dl)),
                                                            A2(cm, {
                                                                bg: xr("Services"),
                                                                bZ: Ur,
                                                                b_: xr(0),
                                                                bo: L$,
                                                                br: Ur,
                                                                bt: !0
                                                            }, xr(n.N))
                                                        ]);
                                                    }, t = function(n) {
                                                        var r;
                                                        return (r = ze(n.X)) > 0 && 200 >= r;
                                                    };
                                                    return A2(gl, b([
                                                        q$
                                                    ]), b([
                                                        A2(gl, b([
                                                            z$("series-list")
                                                        ]), b([
                                                            A2(lm, {
                                                                cy: A2(Ll, b([
                                                                    z$("add-serie"),
                                                                    Kl(V$),
                                                                    cb("Ajouter une nouvelle s\xe9rie")
                                                                ]), b([
                                                                    Gl("\u2795")
                                                                ])),
                                                                c9: A2(ki, C$, D$)
                                                            }, A2(Kd, P$, n.dt))
                                                        ])),
                                                        A2(gl, b([
                                                            z$("series-info")
                                                        ]), function() {
                                                            var u = n.q;
                                                            if (u.$) {
                                                                var a, i = u.b;
                                                                return s(r(a = u.c), b([
                                                                    A2(Fl, b([
                                                                        Kl(N$),
                                                                        I$(1 === n.J || e(i, a) || !t(a))
                                                                    ]), b([
                                                                        Gl("Mettre \xe0 jour la s\xe9rie")
                                                                    ]))
                                                                ]));
                                                            }
                                                            return s(r(a = u.a), b([
                                                                A2(Fl, b([
                                                                    Kl(N$),
                                                                    I$(1 === n.J || !t(a))
                                                                ]), b([
                                                                    Gl("Cr\xe9er la s\xe9rie")
                                                                ]))
                                                            ]));
                                                        }())
                                                    ]));
                                                }(n.a)));
                                            default:
                                                var r = n.a;
                                                return i(bi(li), A2($l, fc, function(n) {
                                                    return A2(gl, b([
                                                        zb
                                                    ]), function() {
                                                        var r, t, u = n.R;
                                                        switch(u.$){
                                                            case 0:
                                                                return b([
                                                                    Gl("Les donn\xe9es de programmation ne sont pas disponibles.")
                                                                ]);
                                                            case 1:
                                                                return b([
                                                                    Gl("Chargement de la programmation en cours...")
                                                                ]);
                                                            case 3:
                                                                return b([
                                                                    Gl("Les donn\xe9es de programmation n'ont pu \xeatre charg\xe9es.")
                                                                ]);
                                                            default:
                                                                var a = u.a;
                                                                return b([
                                                                    A2(gl, b([
                                                                        Fb("schedule")
                                                                    ]), b([
                                                                        A2(gl, b([
                                                                            Fb("series")
                                                                        ]), b([
                                                                            A2(yl, b([
                                                                                Fb("series-heading")
                                                                            ]), b([
                                                                                Gl("S\xe9ries")
                                                                            ])),
                                                                            A2(v$, b([
                                                                                Sl(gu(A2(pu, n.H, Tu(bu)))),
                                                                                Fb("series-assign-automatically"),
                                                                                cb("Ouvrir la programmation automatique")
                                                                            ]), b([
                                                                                Gl("Auto")
                                                                            ])),
                                                                            (t = function(r) {
                                                                                var t;
                                                                                return A2(iv, d, b([
                                                                                    A2(pl, b([
                                                                                        Sl(gu(A2(pu, n.H, Tu(hu(r.cT))))),
                                                                                        Fb("serie"),
                                                                                        A2(ev, e((t = a.A, 0 === t.$ ? xr(t.a) : Ur), xr(r.cT)), Fb("serie-active")),
                                                                                        A2(ev, A2(c$, r.cT, n.u), Fb("serie-dropping"))
                                                                                    ]), b([
                                                                                        A2(A$, A2(gl, b([
                                                                                            Fb("serie-musicians-container")
                                                                                        ]), b([
                                                                                            function() {
                                                                                                var e = A2(wi, function(n) {
                                                                                                    return A2(No, n, a.K);
                                                                                                }, r.a0);
                                                                                                if (1 === e.$) return A2(gl, A2(Lr, Fb("serie-on-call-musician-placeholder"), A2(Lr, A2(ev, A2(s$, r.cT, n.u), Fb("serie-info-musician-on-call-dropping")), A2(Gb, r.cT, Ob))), d);
                                                                                                var t = e.a;
                                                                                                return A2(gl, d, b([
                                                                                                    A2(Zv, b([
                                                                                                        Fb("serie-musician-avatar"),
                                                                                                        Rl(t.X),
                                                                                                        cb(t.X)
                                                                                                    ]), t)
                                                                                                ]));
                                                                                            }(),
                                                                                            A2(gl, b([
                                                                                                Fb("serie-scheduled-musicians-container")
                                                                                            ]), b([
                                                                                                A2(ov, b([
                                                                                                    Fb("serie-scheduled-musicians")
                                                                                                ]), A2(ut, function(e) {
                                                                                                    return A2(iv, A2(Lr, Fb("serie-scheduled-musician"), A2(Lr, A2(ev, A3(f$, r.cT, e.cT, n.u), Fb("serie-musician-dropping")), A2(Lr, A2(ev, A2(e$, e.cT, n.u), Fb("serie-musician-highlight")), A3(Bb, r.cT, e.cT, Ob)))), b([
                                                                                                        A2(Zv, b([
                                                                                                            Fb("serie-musician-avatar"),
                                                                                                            Rl(e.X),
                                                                                                            cb(e.X)
                                                                                                        ]), e)
                                                                                                    ]));
                                                                                                }, A2(Hs, function(n) {
                                                                                                    return A2(yd, n.cT, r.an);
                                                                                                }, d$(a.K)))),
                                                                                                A2(gl, A2(Lr, Fb("serie-musician-placeholder"), A2(Lr, A2(ev, Qb(n.u), Fb("serie-musician-placeholder-enabled")), A2(Lr, A2(ev, !e(Qd(r.an), r.dl), Fb("serie-musician-placeholder-active")), A2(Lr, A2(ev, A2(o$, r.cT, n.u), Fb("serie-musician-placeholder-dropping")), A2(Kb, r.cT, Ob))))), d)
                                                                                            ]))
                                                                                        ])), r)
                                                                                    ]))
                                                                                ]));
                                                                            }, A2(ov, b([
                                                                                Fb("series-list")
                                                                            ]), A2(ut, t, l$(a.dt))))
                                                                        ])),
                                                                        A2(gl, b([
                                                                            Fb("main-info")
                                                                        ]), _f(function() {
                                                                            var r = a.A;
                                                                            switch(r.$){
                                                                                case 3:
                                                                                    return g$;
                                                                                case 2:
                                                                                    return function(n) {
                                                                                        return A2(gl, b([
                                                                                            Fb("automatic-assignment")
                                                                                        ]), b([
                                                                                            A2(yl, d, b([
                                                                                                Gl("Planification automatique")
                                                                                            ])),
                                                                                            A2(ov, d, b([
                                                                                                A2(iv, d, b([
                                                                                                    Gl("todo Afficher les changements envisag\xe9s et leurs impacts sur les statistiques")
                                                                                                ]))
                                                                                            ])),
                                                                                            A2($$, d, b([
                                                                                                Gl("Actions envisag\xe9es")
                                                                                            ])),
                                                                                            function() {
                                                                                                switch(n.$){
                                                                                                    case 3:
                                                                                                        return A2(gl, d, b([
                                                                                                            Gl("\xc9chec lors de la r\xe9cup\xe9ration du plan de programmation."),
                                                                                                            A2(Fl, b([
                                                                                                                Kl(b$)
                                                                                                            ]), b([
                                                                                                                Gl("Cr\xe9er un nouveau plan de programmation")
                                                                                                            ]))
                                                                                                        ]));
                                                                                                    case 0:
                                                                                                        return A2(gl, d, b([
                                                                                                            Gl("Aucun plan de programmation demand\xe9."),
                                                                                                            A2(Fl, b([
                                                                                                                Kl(b$)
                                                                                                            ]), b([
                                                                                                                Gl("Cr\xe9er un nouveau plan de programmation")
                                                                                                            ]))
                                                                                                        ]));
                                                                                                    case 1:
                                                                                                        return Gl("G\xe9n\xe9ration d'un plan de programmation en cours en cours...");
                                                                                                    default:
                                                                                                        var r = n.a.bi;
                                                                                                        if (1 === r.$) return A2(gl, d, b([
                                                                                                            Gl("Aucun plan de programmation n'a pu \xeatre g\xe9n\xe9r\xe9 avec les informations actuelles."),
                                                                                                            A2(Fl, b([
                                                                                                                Kl(b$)
                                                                                                            ]), b([
                                                                                                                Gl("Cr\xe9er un nouveau plan de programmation")
                                                                                                            ]))
                                                                                                        ]));
                                                                                                        var e = r.a;
                                                                                                        return A2(gl, d, b([
                                                                                                            A2(ov, b([
                                                                                                                Fb("planned-assign-actions")
                                                                                                            ]), A2(ut, function(n) {
                                                                                                                return A2(iv, b([
                                                                                                                    Fb("planned-assign-action")
                                                                                                                ]), b([
                                                                                                                    function() {
                                                                                                                        if (n.$) return r = n.a, e = n.b, A2(gl, b([
                                                                                                                            Fb("assign-action-put-on-call-musician")
                                                                                                                        ]), b([
                                                                                                                            A2(gl, b([
                                                                                                                                Fb("assign-on-call-serie")
                                                                                                                            ]), b([
                                                                                                                                Gl(e.X)
                                                                                                                            ])),
                                                                                                                            A2(Zv, b([
                                                                                                                                Fb("assign-put-on-call-musician-avatar")
                                                                                                                            ]), r)
                                                                                                                        ]));
                                                                                                                        var r = n.a, e = n.b;
                                                                                                                        return A2(gl, b([
                                                                                                                            Fb("assign-action-schedule-musician")
                                                                                                                        ]), b([
                                                                                                                            A2(gl, b([
                                                                                                                                Fb("assign-schedule-serie")
                                                                                                                            ]), b([
                                                                                                                                Gl(e.X)
                                                                                                                            ])),
                                                                                                                            A2(Zv, b([
                                                                                                                                Fb("assign-schedule-musician-avatar")
                                                                                                                            ]), r)
                                                                                                                        ]));
                                                                                                                    }()
                                                                                                                ]));
                                                                                                            }, e.cy)),
                                                                                                            A2(Fl, b([
                                                                                                                Kl(b$)
                                                                                                            ]), b([
                                                                                                                Gl("Cr\xe9er un nouveau plan de programmation")
                                                                                                            ])),
                                                                                                            A2(Fl, b([
                                                                                                                Kl((t = e.dH, {
                                                                                                                    $: 1,
                                                                                                                    a: t
                                                                                                                }))
                                                                                                            ]), b([
                                                                                                                Gl("Appliquer")
                                                                                                            ]))
                                                                                                        ]));
                                                                                                }
                                                                                                var t;
                                                                                            }(),
                                                                                            A2($$, d, b([
                                                                                                Gl("Impacts")
                                                                                            ])),
                                                                                            Gl("TODO")
                                                                                        ]));
                                                                                    }(n.aN);
                                                                                case 1:
                                                                                    var e = r.a;
                                                                                    return A2(Jo, Gl("??"), A2(jo, m$, A2(No, e, a.K)));
                                                                                default:
                                                                                    var t = r.a;
                                                                                    return A2(Jo, Gl("??"), A2(jo, A2(X$, n, a.K), A2(Eo, t, a.dt)));
                                                                            }
                                                                        }())),
                                                                        A2(gl, b([
                                                                            Fb("musicians")
                                                                        ]), b([
                                                                            A2(yl, d, b([
                                                                                Gl("Musiciens")
                                                                            ])),
                                                                            A2(ov, A2(Lr, Fb("musicians-list"), A2(Lr, A2(ev, u$(n.u), Fb("musicians-list-drop-enabled")), (r = Ob, A2(Db, r, xb)))), A2(ut, function(r) {
                                                                                return A2(iv, d, b([
                                                                                    A2(pl, A2(Lr, Sl(gu(A2(pu, n.H, Tu(mu(r.cT))))), A2(Lr, Fb("musician"), A2(Lr, A2(ev, A2(n$, r.cT, n.u), Fb("musician-dragging")), A2(Lr, A2(ev, e(A2(jo, _d(r.cT), Wb(a)), xr(!0)), Fb("musician-already-scheduled")), A2(Rb, r.cT, Ob))))), b([
                                                                                        A2(p$, 2, r)
                                                                                    ]))
                                                                                ]));
                                                                            }, d$(a.K)))
                                                                        ]))
                                                                    ]))
                                                                ]);
                                                        }
                                                    }());
                                                }(r)));
                                        }
                                    },
                                    dD: b([
                                        {
                                            X: "R\xe9sum\xe9",
                                            a1: gu(A2(pu, n.H, yu)),
                                            a7: gi
                                        },
                                        {
                                            X: "Musiciens programm\xe9s",
                                            a1: gu(A2(pu, n.H, wu)),
                                            a7: $i
                                        },
                                        {
                                            X: "S\xe9ries",
                                            a1: gu(A2(pu, n.H, ku)),
                                            a7: pi
                                        },
                                        {
                                            X: "Programmation",
                                            a1: gu(A2(pu, n.H, Tu($u))),
                                            a7: bi(li)
                                        }
                                    ])
                                }, n.V)
                            ]));
                        default:
                            return A2(gl, b([
                                hb("failed")
                            ]), b([
                                A2(dv, d, b([
                                    Gl("Le planning n'a pu \xeatre charg\xe9.")
                                ]))
                            ]));
                    }
                }()
            ])),
            cn: "Planning"
        };
    }, Sm = {
        $: 2
    }, _m = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Xm = "orchestra-plannings-welcome", Am = wl(Xm), jm = function(n) {
        return wl(Xm + "__" + n);
    }, Vm = function(n) {
        return "orchestra-plannings-welcome-" + n;
    }, Cm = "orchestra-plannings", Nm = wl(Cm), Em = function(n) {
        return wl(Cm + "__" + n);
    }, Lm = F2(function(n, r) {
        var e = n.dg, t = n.cy;
        return A2(gl, b([
            Nm
        ]), function() {
            switch(r.$){
                case 0:
                    var n = r.a;
                    return b([
                        A2(hv, b([
                            Em("header")
                        ]), b([
                            Gl("Plannings")
                        ])),
                        A2(gl, b([
                            Em("actions")
                        ]), b([
                            t
                        ])),
                        n.b ? A2(ov, b([
                            Em("list")
                        ]), A2(ut, function(n) {
                            var r = n.cT, t = n.X;
                            return A2(iv, b([
                                Em("entry")
                            ]), b([
                                A2(pl, b([
                                    Em("planning"),
                                    ab(e(r))
                                ]), b([
                                    A2(ib, b([
                                        Em("planning-name")
                                    ]), b([
                                        Gl(t)
                                    ]))
                                ]))
                            ]));
                        }, n)) : A2(dv, b([
                            Em("empty-list")
                        ]), b([
                            Gl("Aucun planning connu")
                        ]))
                    ]);
                case 1:
                    return b([
                        A2(hv, b([
                            Em("header")
                        ]), b([
                            Gl("Plannings")
                        ])),
                        A2(gl, b([
                            Em("loading-spinner")
                        ]), d)
                    ]);
                default:
                    return b([
                        A2(hv, b([
                            Em("header")
                        ]), b([
                            Gl("Plannings")
                        ])),
                        A2(gl, b([
                            Em("actions")
                        ]), b([
                            t
                        ])),
                        A2(dv, b([
                            Em("error-message")
                        ]), b([
                            Gl("Le chargement des plannings a \xe9chou\xe9. Veuillez r\xe9essayer ult\xe9rieurement.")
                        ]))
                    ]);
            }
        }());
    }), Dm = function(n) {
        var r = n.V;
        return A2(gl, b([
            wl("orchestra-section")
        ]), b([
            r
        ]));
    }, Hm = F2(function(n, r) {
        var e = r.V, t = F2(function(n, r) {
            return {
                V: A2($l, n, r.V),
                cn: r.cn
            };
        }), u = e.$ ? A2(t, ac, ym(e.a)) : A2(t, Ni, function(n) {
            var r = n.aA, e = n.ak, t = n.ay, u = n.a$;
            return {
                V: A2(gl, b([
                    Am
                ]), b([
                    pv({
                        dA: "Consulter ou cr\xe9er des plannings",
                        cn: "Plannings"
                    }),
                    Dm({
                        V: A2(gl, b([
                            jm("list")
                        ]), b([
                            A2(Lm, {
                                cy: A2(gl, d, b([
                                    A2(Ll, b([
                                        Pl(Vm("add-planning")),
                                        jm("add-planning"),
                                        cb("Ajouter un nouveau planning")
                                    ]), b([
                                        Gl("\u2795")
                                    ])),
                                    A2(Bl, b([
                                        zl(Vm("add-planning")),
                                        Yl("bottom-end")
                                    ]), b([
                                        A2(gl, b([
                                            jm("add-planning-container")
                                        ]), b([
                                            A2(bm, {
                                                bg: xr("Nom du nouveau planning"),
                                                bo: _m,
                                                br: xr("Nom du planning"),
                                                bt: !0
                                            }, t),
                                            A2(Fl, b([
                                                I$(1 === e || !u),
                                                Kl(Sm)
                                            ]), b([
                                                Gl("Cr\xe9er le planning")
                                            ])),
                                            A2(_$, 2 === e, A2(gl, b([
                                                jm("error")
                                            ]), b([
                                                Gl("La cr\xe9ation du nouveau planning a \xe9chou\xe9. Veuillez r\xe9essayer ult\xe9rieurement.")
                                            ])))
                                        ]))
                                    ]))
                                ])),
                                dg: function(n) {
                                    return zv(gu(A2(pu, n, yu)));
                                }
                            }, r),
                            A2(dv, b([
                                jm("instructions")
                            ]), b([
                                Gl("Cliquez sur un planning pour le consulter, ou cliquer sur \u2795 pour cr\xe9er un nouveau planning.")
                            ]))
                        ]))
                    })
                ])),
                cn: "Les plannings"
            };
        }(e.a));
        return {
            V: sv({
                bH: n,
                bP: vb,
                bY: A2(gl, b([
                    bb
                ]), b([
                    u.V
                ]))
            }),
            cn: u.cn
        };
    }), qm = "orchestra-redirect", Mm = wl(qm), Om = {
        V: jv({
            bY: A2(gl, b([
                Mm
            ]), b([
                A2(dv, b([
                    wl(qm + "__message")
                ]), b([
                    Gl("Redirection en cours, veuillez patientier...")
                ]))
            ])),
            cp: Ur
        }),
        cn: "Redirection"
    };
    ja = {
        Main: {
            init: (Ca = (Va = {
                cW: Ja,
                da: function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                },
                db: function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                },
                dz: function() {
                    return Wa(Ga);
                },
                dG: vl,
                dI: function(n) {
                    var r, t = F2(function(n, r) {
                        var e = r.cn;
                        return {
                            cD: b([
                                A2($l, n, r.V)
                            ]),
                            cn: s(e, " | Orchestra")
                        };
                    }), u = n.p;
                    switch(u.$){
                        case 0:
                            return A2(t, Me, (r = u.a, {
                                V: jv({
                                    bY: A2(gl, b([
                                        yv
                                    ]), b([
                                        A2(gl, b([
                                            Sv("container")
                                        ]), b([
                                            A2(Ql, b([
                                                Sv("title")
                                            ]), b([
                                                Gl("Oh non !")
                                            ])),
                                            A2(dv, d, b([
                                                Gl("Une erreur s'est produite, Orchestra n'est pas en mesure de poursuivre son fonctionnement normale. Veuillez r\xe9essayer de lancer l'application dans quelques instants.")
                                            ]))
                                        ]))
                                    ])),
                                    cp: xr(Gl(r))
                                }),
                                cn: "Erreur"
                            }));
                        case 1:
                            return A2(t, Me, Nv);
                        case 2:
                            return A2(t, $t, function(n) {
                                var r = n.aV;
                                return {
                                    V: jv({
                                        bY: A2(gl, b([
                                            Lv
                                        ]), b([
                                            A2(ov, b([
                                                Dv("sso-options")
                                            ]), b([
                                                A2(iv, d, b([
                                                    Hv({
                                                        c6: 0
                                                    })
                                                ]))
                                            ]))
                                        ])),
                                        cp: A2(jo, Gl, r)
                                    }),
                                    cn: "Identification"
                                };
                            }(u.b));
                        case 3:
                            return A2(t, bt, {
                                V: jv({
                                    bY: A2(gl, b([
                                        Mv
                                    ]), b([
                                        A2(dv, b([
                                            Ov("message")
                                        ]), b([
                                            Gl("Identification en cours...")
                                        ]))
                                    ])),
                                    cp: Ur
                                }),
                                cn: "Identification"
                            });
                        default:
                            var a = u.a.V, i = u.a.aC, c = function(n) {
                                return {
                                    c3: {
                                        cZ: b([
                                            {
                                                aQ: "Tableau de bord",
                                                aW: e(n, xr(cu)),
                                                a1: cu
                                            },
                                            {
                                                aQ: "Plannings",
                                                aW: e(n, xr(gu(vu))),
                                                a1: gu(vu)
                                            },
                                            {
                                                aQ: "Musiciens",
                                                aW: e(n, xr(su(lu))),
                                                a1: su(lu)
                                            },
                                            {
                                                aQ: "Administration",
                                                aW: e(n, xr(iu)),
                                                a1: iu
                                            }
                                        ])
                                    },
                                    aC: i
                                };
                            };
                            switch(a.$){
                                case 0:
                                    return A2(t, Me, lb);
                                case 1:
                                    return A2(t, Me, Om);
                                case 2:
                                    var o = a.a;
                                    return A2(t, ri, A2(wv, c(xr(cu)), o));
                                case 3:
                                    var f = a.a;
                                    return A2(t, ti, A2(fb, c(xr(su(lu))), f));
                                case 4:
                                    var l = a.a;
                                    return A2(t, ui, A2(Hm, c(xr(gu(vu))), l));
                                default:
                                    var v = a.a;
                                    return A2(t, ni, A2(Tv, c(xr(iu)), v));
                            }
                    }
                }
            }).da, Na = Va.db, Ea = function() {
                Ea.a(Ca(Tr()));
            }, pr({
                bx: function(n) {
                    return Ea.a = n, kr.addEventListener("popstate", Ea), 0 > kr.navigator.userAgent.indexOf("Trident") || kr.addEventListener("hashchange", Ea), F2(function(r, e) {
                        if (!(e.ctrlKey || e.metaKey || e.shiftKey || e.button >= 1 || r.target || r.hasAttribute("download"))) {
                            e.preventDefault();
                            var t = r.href, u = Tr(), a = Ze(t).a;
                            n(Na(a && u.b9 === a.b9 && u.bS === a.bS && u.b5.a === a.b5.a ? {
                                $: 0,
                                a: a
                            } : function(n) {
                                return {
                                    $: 1,
                                    a: n
                                };
                            }(t)));
                        }
                    });
                },
                cW: function(n) {
                    return A3(Va.cW, n, Tr(), Ea);
                },
                dI: Va.dI,
                dG: Va.dG,
                dz: Va.dz
            }))(Vt)(0)
        }
    }, n.Elm ? function n(r, e) {
        for(var t in e)t in r ? "init" == t ? w(6) : n(r[t], e[t]) : r[t] = e[t];
    }(n.Elm, ja) : n.Elm = ja;
}($51bb400a14a72998$exports);


function $434810d243e219c9$export$889ea624f2cb2c57({ node: node, baseUrl: baseUrl, sessionToken: sessionToken }) {
    const app = (0, $51bb400a14a72998$exports.Elm).Main.init({
        node: node,
        flags: {
            baseUrl: baseUrl,
            sessionToken: sessionToken
        }
    });
    app.ports.onDragStart.subscribe(function(event) {
        // This is required for Firefox to properly handle drag&drop.
        event.dataTransfer.setData("text", "");
    });
    return {
        persistSessionToken: app.ports.persistSessionTokenCmd,
        requestLogin: app.ports.requestLoginCmd,
        requestLoginCallbackProcessing: app.ports.requestLoginCallbackProcessingCmd,
        requestLogout: app.ports.requestLogoutCmd,
        reportLoginReceived: (id_token)=>{
            app.ports.loginReceivedReceiver.send(id_token);
        }
    };
}


let $e0734e0b78b64dca$var$USER_AGENT;
if (typeof navigator === 'undefined' || !navigator.userAgent?.startsWith?.('Mozilla/5.0 ')) {
    const NAME = 'oauth4webapi';
    const VERSION = 'v3.8.1';
    $e0734e0b78b64dca$var$USER_AGENT = `${NAME}/${VERSION}`;
}
function $e0734e0b78b64dca$var$looseInstanceOf(input, expected) {
    if (input == null) return false;
    try {
        return input instanceof expected || Object.getPrototypeOf(input)[Symbol.toStringTag] === expected.prototype[Symbol.toStringTag];
    } catch  {
        return false;
    }
}
const $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE = 'ERR_INVALID_ARG_VALUE';
const $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE = 'ERR_INVALID_ARG_TYPE';
function $e0734e0b78b64dca$var$CodedTypeError(message, code, cause) {
    const err = new TypeError(message, {
        cause: cause
    });
    Object.assign(err, {
        code: code
    });
    return err;
}
const $e0734e0b78b64dca$export$7df29a6c2173f26b = Symbol();
const $e0734e0b78b64dca$export$b708b81a4ce6a399 = Symbol();
const $e0734e0b78b64dca$export$5f7768254837f408 = Symbol();
const $e0734e0b78b64dca$export$1512182a095696a1 = Symbol();
const $e0734e0b78b64dca$export$3c98c9a00e160706 = Symbol();
const $e0734e0b78b64dca$export$fe968a6742b93a36 = Symbol();
const $e0734e0b78b64dca$export$68a3c8fa6edea323 = Symbol();
const $e0734e0b78b64dca$var$encoder = new TextEncoder();
const $e0734e0b78b64dca$var$decoder = new TextDecoder();
function $e0734e0b78b64dca$var$buf(input) {
    if (typeof input === 'string') return $e0734e0b78b64dca$var$encoder.encode(input);
    return $e0734e0b78b64dca$var$decoder.decode(input);
}
let $e0734e0b78b64dca$var$encodeBase64Url;
if (Uint8Array.prototype.toBase64) $e0734e0b78b64dca$var$encodeBase64Url = (input)=>{
    if (input instanceof ArrayBuffer) input = new Uint8Array(input);
    return input.toBase64({
        alphabet: 'base64url',
        omitPadding: true
    });
};
else {
    const CHUNK_SIZE = 0x8000;
    $e0734e0b78b64dca$var$encodeBase64Url = (input)=>{
        if (input instanceof ArrayBuffer) input = new Uint8Array(input);
        const arr = [];
        for(let i = 0; i < input.byteLength; i += CHUNK_SIZE)arr.push(String.fromCharCode.apply(null, input.subarray(i, i + CHUNK_SIZE)));
        return btoa(arr.join('')).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
    };
}
let $e0734e0b78b64dca$var$decodeBase64Url;
if (Uint8Array.fromBase64) $e0734e0b78b64dca$var$decodeBase64Url = (input)=>{
    try {
        return Uint8Array.fromBase64(input, {
            alphabet: 'base64url'
        });
    } catch (cause) {
        throw $e0734e0b78b64dca$var$CodedTypeError('The input to be decoded is not correctly encoded.', $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE, cause);
    }
};
else $e0734e0b78b64dca$var$decodeBase64Url = (input)=>{
    try {
        const binary = atob(input.replace(/-/g, '+').replace(/_/g, '/').replace(/\s/g, ''));
        const bytes = new Uint8Array(binary.length);
        for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
        return bytes;
    } catch (cause) {
        throw $e0734e0b78b64dca$var$CodedTypeError('The input to be decoded is not correctly encoded.', $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE, cause);
    }
};
function $e0734e0b78b64dca$var$b64u(input) {
    if (typeof input === 'string') return $e0734e0b78b64dca$var$decodeBase64Url(input);
    return $e0734e0b78b64dca$var$encodeBase64Url(input);
}
class $e0734e0b78b64dca$export$ab59e00737fb22e6 extends Error {
    code;
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
        this.code = $e0734e0b78b64dca$export$32f5e317a183f59;
        Error.captureStackTrace?.(this, this.constructor);
    }
}
class $e0734e0b78b64dca$export$aa6a6a0f7f354fbf extends Error {
    code;
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
        if (options?.code) this.code = options?.code;
        Error.captureStackTrace?.(this, this.constructor);
    }
}
function $e0734e0b78b64dca$var$OPE(message, code, cause) {
    return new $e0734e0b78b64dca$export$aa6a6a0f7f354fbf(message, {
        code: code,
        cause: cause
    });
}
async function $e0734e0b78b64dca$var$calculateJwkThumbprint(jwk) {
    let components;
    switch(jwk.kty){
        case 'EC':
            components = {
                crv: jwk.crv,
                kty: jwk.kty,
                x: jwk.x,
                y: jwk.y
            };
            break;
        case 'OKP':
            components = {
                crv: jwk.crv,
                kty: jwk.kty,
                x: jwk.x
            };
            break;
        case 'AKP':
            components = {
                alg: jwk.alg,
                kty: jwk.kty,
                pub: jwk.pub
            };
            break;
        case 'RSA':
            components = {
                e: jwk.e,
                kty: jwk.kty,
                n: jwk.n
            };
            break;
        default:
            throw new $e0734e0b78b64dca$export$ab59e00737fb22e6('unsupported JWK key type', {
                cause: jwk
            });
    }
    return $e0734e0b78b64dca$var$b64u(await crypto.subtle.digest('SHA-256', $e0734e0b78b64dca$var$buf(JSON.stringify(components))));
}
function $e0734e0b78b64dca$var$assertCryptoKey(key, it) {
    if (!(key instanceof CryptoKey)) throw $e0734e0b78b64dca$var$CodedTypeError(`${it} must be a CryptoKey`, $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
}
function $e0734e0b78b64dca$var$assertPrivateKey(key, it) {
    $e0734e0b78b64dca$var$assertCryptoKey(key, it);
    if (key.type !== 'private') throw $e0734e0b78b64dca$var$CodedTypeError(`${it} must be a private CryptoKey`, $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE);
}
function $e0734e0b78b64dca$var$assertPublicKey(key, it) {
    $e0734e0b78b64dca$var$assertCryptoKey(key, it);
    if (key.type !== 'public') throw $e0734e0b78b64dca$var$CodedTypeError(`${it} must be a public CryptoKey`, $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE);
}
function $e0734e0b78b64dca$var$normalizeTyp(value) {
    return value.toLowerCase().replace(/^application\//, '');
}
function $e0734e0b78b64dca$var$isJsonObject(input) {
    if (input === null || typeof input !== 'object' || Array.isArray(input)) return false;
    return true;
}
function $e0734e0b78b64dca$var$prepareHeaders(input) {
    if ($e0734e0b78b64dca$var$looseInstanceOf(input, Headers)) input = Object.fromEntries(input.entries());
    const headers = new Headers(input ?? {});
    if ($e0734e0b78b64dca$var$USER_AGENT && !headers.has('user-agent')) headers.set('user-agent', $e0734e0b78b64dca$var$USER_AGENT);
    if (headers.has('authorization')) throw $e0734e0b78b64dca$var$CodedTypeError('"options.headers" must not include the "authorization" header name', $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE);
    return headers;
}
function $e0734e0b78b64dca$var$signal(url, value) {
    if (value !== undefined) {
        if (typeof value === 'function') value = value(url.href);
        if (!(value instanceof AbortSignal)) throw $e0734e0b78b64dca$var$CodedTypeError('"options.signal" must return or be an instance of AbortSignal', $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
        return value;
    }
    return undefined;
}
function $e0734e0b78b64dca$var$replaceDoubleSlash(pathname) {
    if (pathname.includes('//')) return pathname.replace('//', '/');
    return pathname;
}
function $e0734e0b78b64dca$var$prependWellKnown(url, wellKnown, allowTerminatingSlash = false) {
    if (url.pathname === '/') url.pathname = wellKnown;
    else url.pathname = $e0734e0b78b64dca$var$replaceDoubleSlash(`${wellKnown}/${allowTerminatingSlash ? url.pathname : url.pathname.replace(/(\/)$/, '')}`);
    return url;
}
function $e0734e0b78b64dca$var$appendWellKnown(url, wellKnown) {
    url.pathname = $e0734e0b78b64dca$var$replaceDoubleSlash(`${url.pathname}/${wellKnown}`);
    return url;
}
async function $e0734e0b78b64dca$var$performDiscovery(input, urlName, transform, options) {
    if (!(input instanceof URL)) throw $e0734e0b78b64dca$var$CodedTypeError(`"${urlName}" must be an instance of URL`, $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
    $e0734e0b78b64dca$export$c0232e93d81db550(input, options?.[$e0734e0b78b64dca$export$7df29a6c2173f26b] !== true);
    const url = transform(new URL(input.href));
    const headers = $e0734e0b78b64dca$var$prepareHeaders(options?.headers);
    headers.set('accept', 'application/json');
    return (options?.[$e0734e0b78b64dca$export$1512182a095696a1] || fetch)(url.href, {
        body: undefined,
        headers: Object.fromEntries(headers.entries()),
        method: 'GET',
        redirect: 'manual',
        signal: $e0734e0b78b64dca$var$signal(url, options?.signal)
    });
}
async function $e0734e0b78b64dca$export$addcddb71479c5e9(issuerIdentifier, options) {
    return $e0734e0b78b64dca$var$performDiscovery(issuerIdentifier, 'issuerIdentifier', (url)=>{
        switch(options?.algorithm){
            case undefined:
            case 'oidc':
                $e0734e0b78b64dca$var$appendWellKnown(url, '.well-known/openid-configuration');
                break;
            case 'oauth2':
                $e0734e0b78b64dca$var$prependWellKnown(url, '.well-known/oauth-authorization-server');
                break;
            default:
                throw $e0734e0b78b64dca$var$CodedTypeError('"options.algorithm" must be "oidc" (default), or "oauth2"', $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE);
        }
        return url;
    }, options);
}
function $e0734e0b78b64dca$var$assertNumber(input, allow0, it, code, cause) {
    try {
        if (typeof input !== 'number' || !Number.isFinite(input)) throw $e0734e0b78b64dca$var$CodedTypeError(`${it} must be a number`, $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE, cause);
        if (input > 0) return;
        if (allow0) {
            if (input !== 0) throw $e0734e0b78b64dca$var$CodedTypeError(`${it} must be a non-negative number`, $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE, cause);
            return;
        }
        throw $e0734e0b78b64dca$var$CodedTypeError(`${it} must be a positive number`, $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE, cause);
    } catch (err) {
        if (code) throw $e0734e0b78b64dca$var$OPE(err.message, code, cause);
        throw err;
    }
}
function $e0734e0b78b64dca$var$assertString(input, it, code, cause) {
    try {
        if (typeof input !== 'string') throw $e0734e0b78b64dca$var$CodedTypeError(`${it} must be a string`, $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE, cause);
        if (input.length === 0) throw $e0734e0b78b64dca$var$CodedTypeError(`${it} must not be empty`, $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE, cause);
    } catch (err) {
        if (code) throw $e0734e0b78b64dca$var$OPE(err.message, code, cause);
        throw err;
    }
}
async function $e0734e0b78b64dca$export$21080005ccae27cc(expectedIssuerIdentifier, response) {
    const expected = expectedIssuerIdentifier;
    if (!(expected instanceof URL) && expected !== $e0734e0b78b64dca$export$910be5ca85535298) throw $e0734e0b78b64dca$var$CodedTypeError('"expectedIssuerIdentifier" must be an instance of URL', $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
    if (!$e0734e0b78b64dca$var$looseInstanceOf(response, Response)) throw $e0734e0b78b64dca$var$CodedTypeError('"response" must be an instance of Response', $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
    if (response.status !== 200) throw $e0734e0b78b64dca$var$OPE('"response" is not a conform Authorization Server Metadata response (unexpected HTTP status code)', $e0734e0b78b64dca$export$d685a0ca6b1d1c11, response);
    $e0734e0b78b64dca$var$assertReadableResponse(response);
    const json = await $e0734e0b78b64dca$var$getResponseJsonBody(response);
    $e0734e0b78b64dca$var$assertString(json.issuer, '"response" body "issuer" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    if (expected !== $e0734e0b78b64dca$export$910be5ca85535298 && new URL(json.issuer).href !== expected.href) throw $e0734e0b78b64dca$var$OPE('"response" body "issuer" property does not match the expected value', $e0734e0b78b64dca$export$cbbd45b2b4b65c94, {
        expected: expected.href,
        body: json,
        attribute: 'issuer'
    });
    return json;
}
function $e0734e0b78b64dca$var$assertApplicationJson(response) {
    $e0734e0b78b64dca$var$assertContentType(response, 'application/json');
}
function $e0734e0b78b64dca$var$notJson(response, ...types) {
    let msg = '"response" content-type must be ';
    if (types.length > 2) {
        const last = types.pop();
        msg += `${types.join(', ')}, or ${last}`;
    } else if (types.length === 2) msg += `${types[0]} or ${types[1]}`;
    else msg += types[0];
    return $e0734e0b78b64dca$var$OPE(msg, $e0734e0b78b64dca$export$a846b8736a86183d, response);
}
function $e0734e0b78b64dca$var$assertContentTypes(response, ...types) {
    if (!types.includes($e0734e0b78b64dca$export$1ef77878e4e0b972(response))) throw $e0734e0b78b64dca$var$notJson(response, ...types);
}
function $e0734e0b78b64dca$var$assertContentType(response, contentType) {
    if ($e0734e0b78b64dca$export$1ef77878e4e0b972(response) !== contentType) throw $e0734e0b78b64dca$var$notJson(response, contentType);
}
function $e0734e0b78b64dca$var$randomBytes() {
    return $e0734e0b78b64dca$var$b64u(crypto.getRandomValues(new Uint8Array(32)));
}
function $e0734e0b78b64dca$export$1a3cc162d1920778() {
    return $e0734e0b78b64dca$var$randomBytes();
}
function $e0734e0b78b64dca$export$2cfaa88455cb5a99() {
    return $e0734e0b78b64dca$var$randomBytes();
}
function $e0734e0b78b64dca$export$710c4eec6c0c64b9() {
    return $e0734e0b78b64dca$var$randomBytes();
}
async function $e0734e0b78b64dca$export$bc305e5334785b5d(codeVerifier) {
    $e0734e0b78b64dca$var$assertString(codeVerifier, 'codeVerifier');
    return $e0734e0b78b64dca$var$b64u(await crypto.subtle.digest('SHA-256', $e0734e0b78b64dca$var$buf(codeVerifier)));
}
function $e0734e0b78b64dca$var$getKeyAndKid(input) {
    if (input instanceof CryptoKey) return {
        key: input
    };
    if (!(input?.key instanceof CryptoKey)) return {};
    if (input.kid !== undefined) $e0734e0b78b64dca$var$assertString(input.kid, '"kid"');
    return {
        key: input.key,
        kid: input.kid
    };
}
function $e0734e0b78b64dca$var$psAlg(key) {
    switch(key.algorithm.hash.name){
        case 'SHA-256':
            return 'PS256';
        case 'SHA-384':
            return 'PS384';
        case 'SHA-512':
            return 'PS512';
        default:
            throw new $e0734e0b78b64dca$export$ab59e00737fb22e6('unsupported RsaHashedKeyAlgorithm hash name', {
                cause: key
            });
    }
}
function $e0734e0b78b64dca$var$rsAlg(key) {
    switch(key.algorithm.hash.name){
        case 'SHA-256':
            return 'RS256';
        case 'SHA-384':
            return 'RS384';
        case 'SHA-512':
            return 'RS512';
        default:
            throw new $e0734e0b78b64dca$export$ab59e00737fb22e6('unsupported RsaHashedKeyAlgorithm hash name', {
                cause: key
            });
    }
}
function $e0734e0b78b64dca$var$esAlg(key) {
    switch(key.algorithm.namedCurve){
        case 'P-256':
            return 'ES256';
        case 'P-384':
            return 'ES384';
        case 'P-521':
            return 'ES512';
        default:
            throw new $e0734e0b78b64dca$export$ab59e00737fb22e6('unsupported EcKeyAlgorithm namedCurve', {
                cause: key
            });
    }
}
function $e0734e0b78b64dca$var$keyToJws(key) {
    switch(key.algorithm.name){
        case 'RSA-PSS':
            return $e0734e0b78b64dca$var$psAlg(key);
        case 'RSASSA-PKCS1-v1_5':
            return $e0734e0b78b64dca$var$rsAlg(key);
        case 'ECDSA':
            return $e0734e0b78b64dca$var$esAlg(key);
        case 'Ed25519':
        case 'ML-DSA-44':
        case 'ML-DSA-65':
        case 'ML-DSA-87':
            return key.algorithm.name;
        case 'EdDSA':
            return 'Ed25519';
        default:
            throw new $e0734e0b78b64dca$export$ab59e00737fb22e6('unsupported CryptoKey algorithm name', {
                cause: key
            });
    }
}
function $e0734e0b78b64dca$var$getClockSkew(client) {
    const skew = client?.[$e0734e0b78b64dca$export$b708b81a4ce6a399];
    return typeof skew === 'number' && Number.isFinite(skew) ? skew : 0;
}
function $e0734e0b78b64dca$var$getClockTolerance(client) {
    const tolerance = client?.[$e0734e0b78b64dca$export$5f7768254837f408];
    return typeof tolerance === 'number' && Number.isFinite(tolerance) && Math.sign(tolerance) !== -1 ? tolerance : 30;
}
function $e0734e0b78b64dca$var$epochTime() {
    return Math.floor(Date.now() / 1000);
}
function $e0734e0b78b64dca$var$assertAs(as) {
    if (typeof as !== 'object' || as === null) throw $e0734e0b78b64dca$var$CodedTypeError('"as" must be an object', $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
    $e0734e0b78b64dca$var$assertString(as.issuer, '"as.issuer"');
}
function $e0734e0b78b64dca$var$assertClient(client) {
    if (typeof client !== 'object' || client === null) throw $e0734e0b78b64dca$var$CodedTypeError('"client" must be an object', $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
    $e0734e0b78b64dca$var$assertString(client.client_id, '"client.client_id"');
}
function $e0734e0b78b64dca$var$formUrlEncode(token) {
    return encodeURIComponent(token).replace(/(?:[-_.!~*'()]|%20)/g, (substring)=>{
        switch(substring){
            case '-':
            case '_':
            case '.':
            case '!':
            case '~':
            case '*':
            case "'":
            case '(':
            case ')':
                return `%${substring.charCodeAt(0).toString(16).toUpperCase()}`;
            case '%20':
                return '+';
            default:
                throw new Error();
        }
    });
}
function $e0734e0b78b64dca$export$d0f6cb9d2fa8a5e4(clientSecret) {
    $e0734e0b78b64dca$var$assertString(clientSecret, '"clientSecret"');
    return (_as, client, body, _headers)=>{
        body.set('client_id', client.client_id);
        body.set('client_secret', clientSecret);
    };
}
function $e0734e0b78b64dca$export$fac1ad2e7e73de2f(clientSecret) {
    $e0734e0b78b64dca$var$assertString(clientSecret, '"clientSecret"');
    return (_as, client, _body, headers)=>{
        const username = $e0734e0b78b64dca$var$formUrlEncode(client.client_id);
        const password = $e0734e0b78b64dca$var$formUrlEncode(clientSecret);
        const credentials = btoa(`${username}:${password}`);
        headers.set('authorization', `Basic ${credentials}`);
    };
}
function $e0734e0b78b64dca$var$clientAssertionPayload(as, client) {
    const now = $e0734e0b78b64dca$var$epochTime() + $e0734e0b78b64dca$var$getClockSkew(client);
    return {
        jti: $e0734e0b78b64dca$var$randomBytes(),
        aud: as.issuer,
        exp: now + 60,
        iat: now,
        nbf: now,
        iss: client.client_id,
        sub: client.client_id
    };
}
function $e0734e0b78b64dca$export$205d96266e252745(clientPrivateKey, options) {
    const { key: key, kid: kid } = $e0734e0b78b64dca$var$getKeyAndKid(clientPrivateKey);
    $e0734e0b78b64dca$var$assertPrivateKey(key, '"clientPrivateKey.key"');
    return async (as, client, body, _headers)=>{
        const header = {
            alg: $e0734e0b78b64dca$var$keyToJws(key),
            kid: kid
        };
        const payload = $e0734e0b78b64dca$var$clientAssertionPayload(as, client);
        options?.[$e0734e0b78b64dca$export$3c98c9a00e160706]?.(header, payload);
        body.set('client_id', client.client_id);
        body.set('client_assertion_type', 'urn:ietf:params:oauth:client-assertion-type:jwt-bearer');
        body.set('client_assertion', await $e0734e0b78b64dca$var$signJwt(header, payload, key));
    };
}
function $e0734e0b78b64dca$export$c54fb5a764324620(clientSecret, options) {
    $e0734e0b78b64dca$var$assertString(clientSecret, '"clientSecret"');
    const modify = options?.[$e0734e0b78b64dca$export$3c98c9a00e160706];
    let key;
    return async (as, client, body, _headers)=>{
        key ||= await crypto.subtle.importKey('raw', $e0734e0b78b64dca$var$buf(clientSecret), {
            hash: 'SHA-256',
            name: 'HMAC'
        }, false, [
            'sign'
        ]);
        const header = {
            alg: 'HS256'
        };
        const payload = $e0734e0b78b64dca$var$clientAssertionPayload(as, client);
        modify?.(header, payload);
        const data = `${$e0734e0b78b64dca$var$b64u($e0734e0b78b64dca$var$buf(JSON.stringify(header)))}.${$e0734e0b78b64dca$var$b64u($e0734e0b78b64dca$var$buf(JSON.stringify(payload)))}`;
        const hmac = await crypto.subtle.sign(key.algorithm, key, $e0734e0b78b64dca$var$buf(data));
        body.set('client_id', client.client_id);
        body.set('client_assertion_type', 'urn:ietf:params:oauth:client-assertion-type:jwt-bearer');
        body.set('client_assertion', `${data}.${$e0734e0b78b64dca$var$b64u(new Uint8Array(hmac))}`);
    };
}
function $e0734e0b78b64dca$export$57ca7e07b341709d() {
    return (_as, client, body, _headers)=>{
        body.set('client_id', client.client_id);
    };
}
function $e0734e0b78b64dca$export$a7f4b82fa21adfbd() {
    return $e0734e0b78b64dca$export$57ca7e07b341709d();
}
async function $e0734e0b78b64dca$var$signJwt(header, payload, key) {
    if (!key.usages.includes('sign')) throw $e0734e0b78b64dca$var$CodedTypeError('CryptoKey instances used for signing assertions must include "sign" in their "usages"', $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE);
    const input = `${$e0734e0b78b64dca$var$b64u($e0734e0b78b64dca$var$buf(JSON.stringify(header)))}.${$e0734e0b78b64dca$var$b64u($e0734e0b78b64dca$var$buf(JSON.stringify(payload)))}`;
    const signature = $e0734e0b78b64dca$var$b64u(await crypto.subtle.sign($e0734e0b78b64dca$var$keyToSubtle(key), key, $e0734e0b78b64dca$var$buf(input)));
    return `${input}.${signature}`;
}
async function $e0734e0b78b64dca$export$c57216a8ee03ac8a(as, client, parameters, privateKey, options) {
    $e0734e0b78b64dca$var$assertAs(as);
    $e0734e0b78b64dca$var$assertClient(client);
    parameters = new URLSearchParams(parameters);
    const { key: key, kid: kid } = $e0734e0b78b64dca$var$getKeyAndKid(privateKey);
    $e0734e0b78b64dca$var$assertPrivateKey(key, '"privateKey.key"');
    parameters.set('client_id', client.client_id);
    const now = $e0734e0b78b64dca$var$epochTime() + $e0734e0b78b64dca$var$getClockSkew(client);
    const claims = {
        ...Object.fromEntries(parameters.entries()),
        jti: $e0734e0b78b64dca$var$randomBytes(),
        aud: as.issuer,
        exp: now + 60,
        iat: now,
        nbf: now,
        iss: client.client_id
    };
    let resource;
    if (parameters.has('resource') && (resource = parameters.getAll('resource')) && resource.length > 1) claims.resource = resource;
    {
        let value = parameters.get('max_age');
        if (value !== null) {
            claims.max_age = parseInt(value, 10);
            $e0734e0b78b64dca$var$assertNumber(claims.max_age, true, '"max_age" parameter');
        }
    }
    {
        let value = parameters.get('claims');
        if (value !== null) {
            try {
                claims.claims = JSON.parse(value);
            } catch (cause) {
                throw $e0734e0b78b64dca$var$OPE('failed to parse the "claims" parameter as JSON', $e0734e0b78b64dca$export$2ecaad7eb5cc1f25, cause);
            }
            if (!$e0734e0b78b64dca$var$isJsonObject(claims.claims)) throw $e0734e0b78b64dca$var$CodedTypeError('"claims" parameter must be a JSON with a top level object', $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE);
        }
    }
    {
        let value = parameters.get('authorization_details');
        if (value !== null) {
            try {
                claims.authorization_details = JSON.parse(value);
            } catch (cause) {
                throw $e0734e0b78b64dca$var$OPE('failed to parse the "authorization_details" parameter as JSON', $e0734e0b78b64dca$export$2ecaad7eb5cc1f25, cause);
            }
            if (!Array.isArray(claims.authorization_details)) throw $e0734e0b78b64dca$var$CodedTypeError('"authorization_details" parameter must be a JSON with a top level array', $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE);
        }
    }
    const header = {
        alg: $e0734e0b78b64dca$var$keyToJws(key),
        typ: 'oauth-authz-req+jwt',
        kid: kid
    };
    options?.[$e0734e0b78b64dca$export$3c98c9a00e160706]?.(header, claims);
    return $e0734e0b78b64dca$var$signJwt(header, claims, key);
}
let $e0734e0b78b64dca$var$jwkCache;
async function $e0734e0b78b64dca$var$getSetPublicJwkCache(key, alg) {
    const { kty: kty, e: e, n: n, x: x, y: y, crv: crv, pub: pub } = await crypto.subtle.exportKey('jwk', key);
    const jwk = {
        kty: kty,
        e: e,
        n: n,
        x: x,
        y: y,
        crv: crv,
        pub: pub
    };
    if (kty === 'AKP') jwk.alg = alg;
    $e0734e0b78b64dca$var$jwkCache.set(key, jwk);
    return jwk;
}
async function $e0734e0b78b64dca$var$publicJwk(key, alg) {
    $e0734e0b78b64dca$var$jwkCache ||= new WeakMap();
    return $e0734e0b78b64dca$var$jwkCache.get(key) || $e0734e0b78b64dca$var$getSetPublicJwkCache(key, alg);
}
const $e0734e0b78b64dca$var$URLParse = URL.parse ? (url, base)=>URL.parse(url, base) : (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return null;
    }
};
function $e0734e0b78b64dca$export$c0232e93d81db550(url, enforceHttps) {
    if (enforceHttps && url.protocol !== 'https:') throw $e0734e0b78b64dca$var$OPE('only requests to HTTPS are allowed', $e0734e0b78b64dca$export$6b11590cd6c9e2e5, url);
    if (url.protocol !== 'https:' && url.protocol !== 'http:') throw $e0734e0b78b64dca$var$OPE('only HTTP and HTTPS requests are allowed', $e0734e0b78b64dca$export$e324cc317a4199fc, url);
}
function $e0734e0b78b64dca$var$validateEndpoint(value, endpoint, useMtlsAlias, enforceHttps) {
    let url;
    if (typeof value !== 'string' || !(url = $e0734e0b78b64dca$var$URLParse(value))) throw $e0734e0b78b64dca$var$OPE(`authorization server metadata does not contain a valid ${useMtlsAlias ? `"as.mtls_endpoint_aliases.${endpoint}"` : `"as.${endpoint}"`}`, value === undefined ? $e0734e0b78b64dca$export$3d98cc6c66e92ac6 : $e0734e0b78b64dca$export$2571c083f06d615, {
        attribute: useMtlsAlias ? `mtls_endpoint_aliases.${endpoint}` : endpoint
    });
    $e0734e0b78b64dca$export$c0232e93d81db550(url, enforceHttps);
    return url;
}
function $e0734e0b78b64dca$export$48b88e4e5ecac119(as, endpoint, useMtlsAlias, enforceHttps) {
    if (useMtlsAlias && as.mtls_endpoint_aliases && endpoint in as.mtls_endpoint_aliases) return $e0734e0b78b64dca$var$validateEndpoint(as.mtls_endpoint_aliases[endpoint], endpoint, useMtlsAlias, enforceHttps);
    return $e0734e0b78b64dca$var$validateEndpoint(as[endpoint], endpoint, useMtlsAlias, enforceHttps);
}
async function $e0734e0b78b64dca$export$8aa8f6630ac0dd7f(as, client, clientAuthentication, parameters, options) {
    $e0734e0b78b64dca$var$assertAs(as);
    $e0734e0b78b64dca$var$assertClient(client);
    const url = $e0734e0b78b64dca$export$48b88e4e5ecac119(as, 'pushed_authorization_request_endpoint', client.use_mtls_endpoint_aliases, options?.[$e0734e0b78b64dca$export$7df29a6c2173f26b] !== true);
    const body = new URLSearchParams(parameters);
    body.set('client_id', client.client_id);
    const headers = $e0734e0b78b64dca$var$prepareHeaders(options?.headers);
    headers.set('accept', 'application/json');
    if (options?.DPoP !== undefined) {
        $e0734e0b78b64dca$var$assertDPoP(options.DPoP);
        await options.DPoP.addProof(url, headers, 'POST');
    }
    const response = await $e0734e0b78b64dca$var$authenticatedRequest(as, client, clientAuthentication, url, body, headers, options);
    options?.DPoP?.cacheNonce(response);
    return response;
}
class $e0734e0b78b64dca$var$DPoPHandler {
    #header;
    #privateKey;
    #publicKey;
    #clockSkew;
    #modifyAssertion;
    #map;
    #jkt;
    constructor(client, keyPair, options){
        $e0734e0b78b64dca$var$assertPrivateKey(keyPair?.privateKey, '"DPoP.privateKey"');
        $e0734e0b78b64dca$var$assertPublicKey(keyPair?.publicKey, '"DPoP.publicKey"');
        if (!keyPair.publicKey.extractable) throw $e0734e0b78b64dca$var$CodedTypeError('"DPoP.publicKey.extractable" must be true', $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE);
        this.#modifyAssertion = options?.[$e0734e0b78b64dca$export$3c98c9a00e160706];
        this.#clockSkew = $e0734e0b78b64dca$var$getClockSkew(client);
        this.#privateKey = keyPair.privateKey;
        this.#publicKey = keyPair.publicKey;
        $e0734e0b78b64dca$var$branded.add(this);
    }
    #get(key) {
        this.#map ||= new Map();
        let item = this.#map.get(key);
        if (item) {
            this.#map.delete(key);
            this.#map.set(key, item);
        }
        return item;
    }
    #set(key, val) {
        this.#map ||= new Map();
        this.#map.delete(key);
        if (this.#map.size === 100) this.#map.delete(this.#map.keys().next().value);
        this.#map.set(key, val);
    }
    async calculateThumbprint() {
        if (!this.#jkt) {
            const jwk = await crypto.subtle.exportKey('jwk', this.#publicKey);
            this.#jkt ||= await $e0734e0b78b64dca$var$calculateJwkThumbprint(jwk);
        }
        return this.#jkt;
    }
    async addProof(url, headers, htm, accessToken) {
        const alg = $e0734e0b78b64dca$var$keyToJws(this.#privateKey);
        this.#header ||= {
            alg: alg,
            typ: 'dpop+jwt',
            jwk: await $e0734e0b78b64dca$var$publicJwk(this.#publicKey, alg)
        };
        const nonce = this.#get(url.origin);
        const now = $e0734e0b78b64dca$var$epochTime() + this.#clockSkew;
        const payload = {
            iat: now,
            jti: $e0734e0b78b64dca$var$randomBytes(),
            htm: htm,
            nonce: nonce,
            htu: `${url.origin}${url.pathname}`,
            ath: accessToken ? $e0734e0b78b64dca$var$b64u(await crypto.subtle.digest('SHA-256', $e0734e0b78b64dca$var$buf(accessToken))) : undefined
        };
        this.#modifyAssertion?.(this.#header, payload);
        headers.set('dpop', await $e0734e0b78b64dca$var$signJwt(this.#header, payload, this.#privateKey));
    }
    cacheNonce(response) {
        try {
            const nonce = response.headers.get('dpop-nonce');
            if (nonce) this.#set(new URL(response.url).origin, nonce);
        } catch  {}
    }
}
function $e0734e0b78b64dca$export$283c6a56651b6b3(err) {
    if (err instanceof $e0734e0b78b64dca$export$e8c9940a097b035d) {
        const { 0: challenge, length: length } = err.cause;
        return length === 1 && challenge.scheme === 'dpop' && challenge.parameters.error === 'use_dpop_nonce';
    }
    if (err instanceof $e0734e0b78b64dca$export$10b74a1a57a5fea2) return err.error === 'use_dpop_nonce';
    return false;
}
function $e0734e0b78b64dca$export$dea928b46d13a16a(client, keyPair, options) {
    return new $e0734e0b78b64dca$var$DPoPHandler(client, keyPair, options);
}
class $e0734e0b78b64dca$export$10b74a1a57a5fea2 extends Error {
    cause;
    code;
    error;
    status;
    error_description;
    response;
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
        this.code = $e0734e0b78b64dca$export$7c386099a0178c9e;
        this.cause = options.cause;
        this.error = options.cause.error;
        this.status = options.response.status;
        this.error_description = options.cause.error_description;
        Object.defineProperty(this, 'response', {
            enumerable: false,
            value: options.response
        });
        Error.captureStackTrace?.(this, this.constructor);
    }
}
class $e0734e0b78b64dca$export$9ba4842ad1493b35 extends Error {
    cause;
    code;
    error;
    error_description;
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
        this.code = $e0734e0b78b64dca$export$d28be95474e00f8;
        this.cause = options.cause;
        this.error = options.cause.get('error');
        this.error_description = options.cause.get('error_description') ?? undefined;
        Error.captureStackTrace?.(this, this.constructor);
    }
}
class $e0734e0b78b64dca$export$e8c9940a097b035d extends Error {
    cause;
    code;
    response;
    status;
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
        this.code = $e0734e0b78b64dca$export$828007b5392b716e;
        this.cause = options.cause;
        this.status = options.response.status;
        this.response = options.response;
        Object.defineProperty(this, 'response', {
            enumerable: false
        });
        Error.captureStackTrace?.(this, this.constructor);
    }
}
const $e0734e0b78b64dca$var$tokenMatch = "[a-zA-Z0-9!#$%&\\'\\*\\+\\-\\.\\^_`\\|~]+";
const $e0734e0b78b64dca$var$token68Match = '[a-zA-Z0-9\\-\\._\\~\\+\\/]+[=]{0,2}';
const $e0734e0b78b64dca$var$quotedMatch = '"((?:[^"\\\\]|\\\\.)*)"';
const $e0734e0b78b64dca$var$quotedParamMatcher = '(' + $e0734e0b78b64dca$var$tokenMatch + ')\\s*=\\s*' + $e0734e0b78b64dca$var$quotedMatch;
const $e0734e0b78b64dca$var$paramMatcher = '(' + $e0734e0b78b64dca$var$tokenMatch + ')\\s*=\\s*(' + $e0734e0b78b64dca$var$tokenMatch + ')';
const $e0734e0b78b64dca$var$schemeRE = new RegExp('^[,\\s]*(' + $e0734e0b78b64dca$var$tokenMatch + ')\\s(.*)');
const $e0734e0b78b64dca$var$quotedParamRE = new RegExp('^[,\\s]*' + $e0734e0b78b64dca$var$quotedParamMatcher + '[,\\s]*(.*)');
const $e0734e0b78b64dca$var$unquotedParamRE = new RegExp('^[,\\s]*' + $e0734e0b78b64dca$var$paramMatcher + '[,\\s]*(.*)');
const $e0734e0b78b64dca$var$token68ParamRE = new RegExp('^(' + $e0734e0b78b64dca$var$token68Match + ')(?:$|[,\\s])(.*)');
function $e0734e0b78b64dca$var$parseWwwAuthenticateChallenges(response) {
    if (!$e0734e0b78b64dca$var$looseInstanceOf(response, Response)) throw $e0734e0b78b64dca$var$CodedTypeError('"response" must be an instance of Response', $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
    const header = response.headers.get('www-authenticate');
    if (header === null) return undefined;
    const challenges = [];
    let rest = header;
    while(rest){
        let match = rest.match($e0734e0b78b64dca$var$schemeRE);
        const scheme = match?.['1'].toLowerCase();
        rest = match?.['2'];
        if (!scheme) return undefined;
        const parameters = {};
        let token68;
        while(rest){
            let key;
            let value;
            if (match = rest.match($e0734e0b78b64dca$var$quotedParamRE)) {
                [, key, value, rest] = match;
                if (value.includes('\\')) try {
                    value = JSON.parse(`"${value}"`);
                } catch  {}
                parameters[key.toLowerCase()] = value;
                continue;
            }
            if (match = rest.match($e0734e0b78b64dca$var$unquotedParamRE)) {
                [, key, value, rest] = match;
                parameters[key.toLowerCase()] = value;
                continue;
            }
            if (match = rest.match($e0734e0b78b64dca$var$token68ParamRE)) {
                if (Object.keys(parameters).length) break;
                [, token68, rest] = match;
                break;
            }
            return undefined;
        }
        const challenge = {
            scheme: scheme,
            parameters: parameters
        };
        if (token68) challenge.token68 = token68;
        challenges.push(challenge);
    }
    if (!challenges.length) return undefined;
    return challenges;
}
async function $e0734e0b78b64dca$export$f6b2ca9fe5bf06d7(as, client, response) {
    $e0734e0b78b64dca$var$assertAs(as);
    $e0734e0b78b64dca$var$assertClient(client);
    if (!$e0734e0b78b64dca$var$looseInstanceOf(response, Response)) throw $e0734e0b78b64dca$var$CodedTypeError('"response" must be an instance of Response', $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
    await $e0734e0b78b64dca$var$checkOAuthBodyError(response, 201, 'Pushed Authorization Request Endpoint');
    $e0734e0b78b64dca$var$assertReadableResponse(response);
    const json = await $e0734e0b78b64dca$var$getResponseJsonBody(response);
    $e0734e0b78b64dca$var$assertString(json.request_uri, '"response" body "request_uri" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    let expiresIn = typeof json.expires_in !== 'number' ? parseFloat(json.expires_in) : json.expires_in;
    $e0734e0b78b64dca$var$assertNumber(expiresIn, true, '"response" body "expires_in" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    json.expires_in = expiresIn;
    return json;
}
async function $e0734e0b78b64dca$var$parseOAuthResponseErrorBody(response) {
    if (response.status > 399 && response.status < 500) {
        $e0734e0b78b64dca$var$assertReadableResponse(response);
        $e0734e0b78b64dca$var$assertApplicationJson(response);
        try {
            const json = await response.clone().json();
            if ($e0734e0b78b64dca$var$isJsonObject(json) && typeof json.error === 'string' && json.error.length) return json;
        } catch  {}
    }
    return undefined;
}
async function $e0734e0b78b64dca$var$checkOAuthBodyError(response, expected, label) {
    if (response.status !== expected) {
        $e0734e0b78b64dca$var$checkAuthenticationChallenges(response);
        let err;
        if (err = await $e0734e0b78b64dca$var$parseOAuthResponseErrorBody(response)) {
            await response.body?.cancel();
            throw new $e0734e0b78b64dca$export$10b74a1a57a5fea2('server responded with an error in the response body', {
                cause: err,
                response: response
            });
        }
        throw $e0734e0b78b64dca$var$OPE(`"response" is not a conform ${label} response (unexpected HTTP status code)`, $e0734e0b78b64dca$export$d685a0ca6b1d1c11, response);
    }
}
function $e0734e0b78b64dca$var$assertDPoP(option) {
    if (!$e0734e0b78b64dca$var$branded.has(option)) throw $e0734e0b78b64dca$var$CodedTypeError('"options.DPoP" is not a valid DPoPHandle', $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE);
}
async function $e0734e0b78b64dca$var$resourceRequest(accessToken, method, url, headers, body, options) {
    $e0734e0b78b64dca$var$assertString(accessToken, '"accessToken"');
    if (!(url instanceof URL)) throw $e0734e0b78b64dca$var$CodedTypeError('"url" must be an instance of URL', $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
    $e0734e0b78b64dca$export$c0232e93d81db550(url, options?.[$e0734e0b78b64dca$export$7df29a6c2173f26b] !== true);
    headers = $e0734e0b78b64dca$var$prepareHeaders(headers);
    if (options?.DPoP) {
        $e0734e0b78b64dca$var$assertDPoP(options.DPoP);
        await options.DPoP.addProof(url, headers, method.toUpperCase(), accessToken);
    }
    headers.set('authorization', `${headers.has('dpop') ? 'DPoP' : 'Bearer'} ${accessToken}`);
    const response = await (options?.[$e0734e0b78b64dca$export$1512182a095696a1] || fetch)(url.href, {
        body: body,
        headers: Object.fromEntries(headers.entries()),
        method: method,
        redirect: 'manual',
        signal: $e0734e0b78b64dca$var$signal(url, options?.signal)
    });
    options?.DPoP?.cacheNonce(response);
    return response;
}
async function $e0734e0b78b64dca$export$5156e7f986a031a3(accessToken, method, url, headers, body, options) {
    const response = await $e0734e0b78b64dca$var$resourceRequest(accessToken, method, url, headers, body, options);
    $e0734e0b78b64dca$var$checkAuthenticationChallenges(response);
    return response;
}
async function $e0734e0b78b64dca$export$1e6533dcdca12073(as, client, accessToken, options) {
    $e0734e0b78b64dca$var$assertAs(as);
    $e0734e0b78b64dca$var$assertClient(client);
    const url = $e0734e0b78b64dca$export$48b88e4e5ecac119(as, 'userinfo_endpoint', client.use_mtls_endpoint_aliases, options?.[$e0734e0b78b64dca$export$7df29a6c2173f26b] !== true);
    const headers = $e0734e0b78b64dca$var$prepareHeaders(options?.headers);
    if (client.userinfo_signed_response_alg) headers.set('accept', 'application/jwt');
    else {
        headers.set('accept', 'application/json');
        headers.append('accept', 'application/jwt');
    }
    return $e0734e0b78b64dca$var$resourceRequest(accessToken, 'GET', url, headers, null, {
        ...options,
        [$e0734e0b78b64dca$export$b708b81a4ce6a399]: $e0734e0b78b64dca$var$getClockSkew(client)
    });
}
let $e0734e0b78b64dca$var$jwksMap;
function $e0734e0b78b64dca$var$setJwksCache(as, jwks, uat, cache) {
    $e0734e0b78b64dca$var$jwksMap ||= new WeakMap();
    $e0734e0b78b64dca$var$jwksMap.set(as, {
        jwks: jwks,
        uat: uat,
        get age () {
            return $e0734e0b78b64dca$var$epochTime() - this.uat;
        }
    });
    if (cache) Object.assign(cache, {
        jwks: structuredClone(jwks),
        uat: uat
    });
}
function $e0734e0b78b64dca$var$isFreshJwksCache(input) {
    if (typeof input !== 'object' || input === null) return false;
    if (!('uat' in input) || typeof input.uat !== 'number' || $e0734e0b78b64dca$var$epochTime() - input.uat >= 300) return false;
    if (!('jwks' in input) || !$e0734e0b78b64dca$var$isJsonObject(input.jwks) || !Array.isArray(input.jwks.keys) || !Array.prototype.every.call(input.jwks.keys, $e0734e0b78b64dca$var$isJsonObject)) return false;
    return true;
}
function $e0734e0b78b64dca$var$clearJwksCache(as, cache) {
    $e0734e0b78b64dca$var$jwksMap?.delete(as);
    delete cache?.jwks;
    delete cache?.uat;
}
async function $e0734e0b78b64dca$var$getPublicSigKeyFromIssuerJwksUri(as, options, header) {
    const { alg: alg, kid: kid } = header;
    $e0734e0b78b64dca$var$checkSupportedJwsAlg(header);
    if (!$e0734e0b78b64dca$var$jwksMap?.has(as) && $e0734e0b78b64dca$var$isFreshJwksCache(options?.[$e0734e0b78b64dca$export$68a3c8fa6edea323])) $e0734e0b78b64dca$var$setJwksCache(as, options?.[$e0734e0b78b64dca$export$68a3c8fa6edea323].jwks, options?.[$e0734e0b78b64dca$export$68a3c8fa6edea323].uat);
    let jwks;
    let age;
    if ($e0734e0b78b64dca$var$jwksMap?.has(as)) {
        ({ jwks: jwks, age: age } = $e0734e0b78b64dca$var$jwksMap.get(as));
        if (age >= 300) {
            $e0734e0b78b64dca$var$clearJwksCache(as, options?.[$e0734e0b78b64dca$export$68a3c8fa6edea323]);
            return $e0734e0b78b64dca$var$getPublicSigKeyFromIssuerJwksUri(as, options, header);
        }
    } else {
        jwks = await $e0734e0b78b64dca$var$jwksRequest(as, options).then($e0734e0b78b64dca$var$processJwksResponse);
        age = 0;
        $e0734e0b78b64dca$var$setJwksCache(as, jwks, $e0734e0b78b64dca$var$epochTime(), options?.[$e0734e0b78b64dca$export$68a3c8fa6edea323]);
    }
    let kty;
    switch(alg.slice(0, 2)){
        case 'RS':
        case 'PS':
            kty = 'RSA';
            break;
        case 'ES':
            kty = 'EC';
            break;
        case 'Ed':
            kty = 'OKP';
            break;
        case 'ML':
            kty = 'AKP';
            break;
        default:
            throw new $e0734e0b78b64dca$export$ab59e00737fb22e6('unsupported JWS algorithm', {
                cause: {
                    alg: alg
                }
            });
    }
    const candidates = jwks.keys.filter((jwk)=>{
        if (jwk.kty !== kty) return false;
        if (kid !== undefined && kid !== jwk.kid) return false;
        if (jwk.alg !== undefined && alg !== jwk.alg) return false;
        if (jwk.use !== undefined && jwk.use !== 'sig') return false;
        if (jwk.key_ops?.includes('verify') === false) return false;
        switch(true){
            case alg === 'ES256' && jwk.crv !== 'P-256':
            case alg === 'ES384' && jwk.crv !== 'P-384':
            case alg === 'ES512' && jwk.crv !== 'P-521':
            case alg === 'Ed25519' && jwk.crv !== 'Ed25519':
            case alg === 'EdDSA' && jwk.crv !== 'Ed25519':
                return false;
        }
        return true;
    });
    const { 0: jwk, length: length } = candidates;
    if (!length) {
        if (age >= 60) {
            $e0734e0b78b64dca$var$clearJwksCache(as, options?.[$e0734e0b78b64dca$export$68a3c8fa6edea323]);
            return $e0734e0b78b64dca$var$getPublicSigKeyFromIssuerJwksUri(as, options, header);
        }
        throw $e0734e0b78b64dca$var$OPE('error when selecting a JWT verification key, no applicable keys found', $e0734e0b78b64dca$export$bfbcb4ed1226f649, {
            header: header,
            candidates: candidates,
            jwks_uri: new URL(as.jwks_uri)
        });
    }
    if (length !== 1) throw $e0734e0b78b64dca$var$OPE('error when selecting a JWT verification key, multiple applicable keys found, a "kid" JWT Header Parameter is required', $e0734e0b78b64dca$export$bfbcb4ed1226f649, {
        header: header,
        candidates: candidates,
        jwks_uri: new URL(as.jwks_uri)
    });
    return $e0734e0b78b64dca$var$importJwk(alg, jwk);
}
const $e0734e0b78b64dca$export$7880c8df8f6a0b6 = Symbol();
function $e0734e0b78b64dca$export$1ef77878e4e0b972(input) {
    return input.headers.get('content-type')?.split(';')[0];
}
async function $e0734e0b78b64dca$export$8dbb33ddf3c4a913(as, client, expectedSubject, response, options) {
    $e0734e0b78b64dca$var$assertAs(as);
    $e0734e0b78b64dca$var$assertClient(client);
    if (!$e0734e0b78b64dca$var$looseInstanceOf(response, Response)) throw $e0734e0b78b64dca$var$CodedTypeError('"response" must be an instance of Response', $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
    $e0734e0b78b64dca$var$checkAuthenticationChallenges(response);
    if (response.status !== 200) throw $e0734e0b78b64dca$var$OPE('"response" is not a conform UserInfo Endpoint response (unexpected HTTP status code)', $e0734e0b78b64dca$export$d685a0ca6b1d1c11, response);
    $e0734e0b78b64dca$var$assertReadableResponse(response);
    let json;
    if ($e0734e0b78b64dca$export$1ef77878e4e0b972(response) === 'application/jwt') {
        const { claims: claims, jwt: jwt } = await $e0734e0b78b64dca$var$validateJwt(await response.text(), $e0734e0b78b64dca$var$checkSigningAlgorithm.bind(undefined, client.userinfo_signed_response_alg, as.userinfo_signing_alg_values_supported, undefined), $e0734e0b78b64dca$var$getClockSkew(client), $e0734e0b78b64dca$var$getClockTolerance(client), options?.[$e0734e0b78b64dca$export$fe968a6742b93a36]).then($e0734e0b78b64dca$var$validateOptionalAudience.bind(undefined, client.client_id)).then($e0734e0b78b64dca$var$validateOptionalIssuer.bind(undefined, as));
        $e0734e0b78b64dca$var$jwtRefs.set(response, jwt);
        json = claims;
    } else {
        if (client.userinfo_signed_response_alg) throw $e0734e0b78b64dca$var$OPE('JWT UserInfo Response expected', $e0734e0b78b64dca$export$3045c630ee9482af, response);
        json = await $e0734e0b78b64dca$var$getResponseJsonBody(response);
    }
    $e0734e0b78b64dca$var$assertString(json.sub, '"response" body "sub" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    switch(expectedSubject){
        case $e0734e0b78b64dca$export$7880c8df8f6a0b6:
            break;
        default:
            $e0734e0b78b64dca$var$assertString(expectedSubject, '"expectedSubject"');
            if (json.sub !== expectedSubject) throw $e0734e0b78b64dca$var$OPE('unexpected "response" body "sub" property value', $e0734e0b78b64dca$export$cbbd45b2b4b65c94, {
                expected: expectedSubject,
                body: json,
                attribute: 'sub'
            });
    }
    return json;
}
async function $e0734e0b78b64dca$var$authenticatedRequest(as, client, clientAuthentication, url, body, headers, options) {
    await clientAuthentication(as, client, body, headers);
    headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
    return (options?.[$e0734e0b78b64dca$export$1512182a095696a1] || fetch)(url.href, {
        body: body,
        headers: Object.fromEntries(headers.entries()),
        method: 'POST',
        redirect: 'manual',
        signal: $e0734e0b78b64dca$var$signal(url, options?.signal)
    });
}
async function $e0734e0b78b64dca$var$tokenEndpointRequest(as, client, clientAuthentication, grantType, parameters, options) {
    const url = $e0734e0b78b64dca$export$48b88e4e5ecac119(as, 'token_endpoint', client.use_mtls_endpoint_aliases, options?.[$e0734e0b78b64dca$export$7df29a6c2173f26b] !== true);
    parameters.set('grant_type', grantType);
    const headers = $e0734e0b78b64dca$var$prepareHeaders(options?.headers);
    headers.set('accept', 'application/json');
    if (options?.DPoP !== undefined) {
        $e0734e0b78b64dca$var$assertDPoP(options.DPoP);
        await options.DPoP.addProof(url, headers, 'POST');
    }
    const response = await $e0734e0b78b64dca$var$authenticatedRequest(as, client, clientAuthentication, url, parameters, headers, options);
    options?.DPoP?.cacheNonce(response);
    return response;
}
async function $e0734e0b78b64dca$export$b5bbb508112f49c9(as, client, clientAuthentication, refreshToken, options) {
    $e0734e0b78b64dca$var$assertAs(as);
    $e0734e0b78b64dca$var$assertClient(client);
    $e0734e0b78b64dca$var$assertString(refreshToken, '"refreshToken"');
    const parameters = new URLSearchParams(options?.additionalParameters);
    parameters.set('refresh_token', refreshToken);
    return $e0734e0b78b64dca$var$tokenEndpointRequest(as, client, clientAuthentication, 'refresh_token', parameters, options);
}
const $e0734e0b78b64dca$var$idTokenClaims = new WeakMap();
const $e0734e0b78b64dca$var$jwtRefs = new WeakMap();
function $e0734e0b78b64dca$export$3bd2388378bb9d92(ref) {
    if (!ref.id_token) return undefined;
    const claims = $e0734e0b78b64dca$var$idTokenClaims.get(ref);
    if (!claims) throw $e0734e0b78b64dca$var$CodedTypeError('"ref" was already garbage collected or did not resolve from the proper sources', $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE);
    return claims;
}
async function $e0734e0b78b64dca$export$5e65027d616da1c9(as, ref, options) {
    $e0734e0b78b64dca$var$assertAs(as);
    if (!$e0734e0b78b64dca$var$jwtRefs.has(ref)) throw $e0734e0b78b64dca$var$CodedTypeError('"ref" does not contain a processed JWT Response to verify the signature of', $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE);
    const { 0: protectedHeader, 1: payload, 2: encodedSignature } = $e0734e0b78b64dca$var$jwtRefs.get(ref).split('.');
    const header = JSON.parse($e0734e0b78b64dca$var$buf($e0734e0b78b64dca$var$b64u(protectedHeader)));
    if (header.alg.startsWith('HS')) throw new $e0734e0b78b64dca$export$ab59e00737fb22e6('unsupported JWS algorithm', {
        cause: {
            alg: header.alg
        }
    });
    let key;
    key = await $e0734e0b78b64dca$var$getPublicSigKeyFromIssuerJwksUri(as, options, header);
    await $e0734e0b78b64dca$var$validateJwsSignature(protectedHeader, payload, key, $e0734e0b78b64dca$var$b64u(encodedSignature));
}
async function $e0734e0b78b64dca$var$processGenericAccessTokenResponse(as, client, response, additionalRequiredIdTokenClaims, decryptFn, recognizedTokenTypes) {
    $e0734e0b78b64dca$var$assertAs(as);
    $e0734e0b78b64dca$var$assertClient(client);
    if (!$e0734e0b78b64dca$var$looseInstanceOf(response, Response)) throw $e0734e0b78b64dca$var$CodedTypeError('"response" must be an instance of Response', $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
    await $e0734e0b78b64dca$var$checkOAuthBodyError(response, 200, 'Token Endpoint');
    $e0734e0b78b64dca$var$assertReadableResponse(response);
    const json = await $e0734e0b78b64dca$var$getResponseJsonBody(response);
    $e0734e0b78b64dca$var$assertString(json.access_token, '"response" body "access_token" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    $e0734e0b78b64dca$var$assertString(json.token_type, '"response" body "token_type" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    json.token_type = json.token_type.toLowerCase();
    if (json.expires_in !== undefined) {
        let expiresIn = typeof json.expires_in !== 'number' ? parseFloat(json.expires_in) : json.expires_in;
        $e0734e0b78b64dca$var$assertNumber(expiresIn, true, '"response" body "expires_in" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
            body: json
        });
        json.expires_in = expiresIn;
    }
    if (json.refresh_token !== undefined) $e0734e0b78b64dca$var$assertString(json.refresh_token, '"response" body "refresh_token" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    if (json.scope !== undefined && typeof json.scope !== 'string') throw $e0734e0b78b64dca$var$OPE('"response" body "scope" property must be a string', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    if (json.id_token !== undefined) {
        $e0734e0b78b64dca$var$assertString(json.id_token, '"response" body "id_token" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
            body: json
        });
        const requiredClaims = [
            'aud',
            'exp',
            'iat',
            'iss',
            'sub'
        ];
        if (client.require_auth_time === true) requiredClaims.push('auth_time');
        if (client.default_max_age !== undefined) {
            $e0734e0b78b64dca$var$assertNumber(client.default_max_age, true, '"client.default_max_age"');
            requiredClaims.push('auth_time');
        }
        if (additionalRequiredIdTokenClaims?.length) requiredClaims.push(...additionalRequiredIdTokenClaims);
        const { claims: claims, jwt: jwt } = await $e0734e0b78b64dca$var$validateJwt(json.id_token, $e0734e0b78b64dca$var$checkSigningAlgorithm.bind(undefined, client.id_token_signed_response_alg, as.id_token_signing_alg_values_supported, 'RS256'), $e0734e0b78b64dca$var$getClockSkew(client), $e0734e0b78b64dca$var$getClockTolerance(client), decryptFn).then($e0734e0b78b64dca$var$validatePresence.bind(undefined, requiredClaims)).then($e0734e0b78b64dca$var$validateIssuer.bind(undefined, as)).then($e0734e0b78b64dca$var$validateAudience.bind(undefined, client.client_id));
        if (Array.isArray(claims.aud) && claims.aud.length !== 1) {
            if (claims.azp === undefined) throw $e0734e0b78b64dca$var$OPE('ID Token "aud" (audience) claim includes additional untrusted audiences', $e0734e0b78b64dca$export$755cfb9d9708df13, {
                claims: claims,
                claim: 'aud'
            });
            if (claims.azp !== client.client_id) throw $e0734e0b78b64dca$var$OPE('unexpected ID Token "azp" (authorized party) claim value', $e0734e0b78b64dca$export$755cfb9d9708df13, {
                expected: client.client_id,
                claims: claims,
                claim: 'azp'
            });
        }
        if (claims.auth_time !== undefined) $e0734e0b78b64dca$var$assertNumber(claims.auth_time, true, 'ID Token "auth_time" (authentication time)', $e0734e0b78b64dca$export$a95f69ec43d8404, {
            claims: claims
        });
        $e0734e0b78b64dca$var$jwtRefs.set(response, jwt);
        $e0734e0b78b64dca$var$idTokenClaims.set(json, claims);
    }
    if (recognizedTokenTypes?.[json.token_type] !== undefined) recognizedTokenTypes[json.token_type](response, json);
    else if (json.token_type !== 'dpop' && json.token_type !== 'bearer') throw new $e0734e0b78b64dca$export$ab59e00737fb22e6('unsupported `token_type` value', {
        cause: {
            body: json
        }
    });
    return json;
}
function $e0734e0b78b64dca$var$checkAuthenticationChallenges(response) {
    let challenges;
    if (challenges = $e0734e0b78b64dca$var$parseWwwAuthenticateChallenges(response)) throw new $e0734e0b78b64dca$export$e8c9940a097b035d('server responded with a challenge in the WWW-Authenticate HTTP Header', {
        cause: challenges,
        response: response
    });
}
async function $e0734e0b78b64dca$export$37635a4180b34950(as, client, response, options) {
    return $e0734e0b78b64dca$var$processGenericAccessTokenResponse(as, client, response, undefined, options?.[$e0734e0b78b64dca$export$fe968a6742b93a36], options?.recognizedTokenTypes);
}
function $e0734e0b78b64dca$var$validateOptionalAudience(expected, result) {
    if (result.claims.aud !== undefined) return $e0734e0b78b64dca$var$validateAudience(expected, result);
    return result;
}
function $e0734e0b78b64dca$var$validateAudience(expected, result) {
    if (Array.isArray(result.claims.aud)) {
        if (!result.claims.aud.includes(expected)) throw $e0734e0b78b64dca$var$OPE('unexpected JWT "aud" (audience) claim value', $e0734e0b78b64dca$export$755cfb9d9708df13, {
            expected: expected,
            claims: result.claims,
            claim: 'aud'
        });
    } else if (result.claims.aud !== expected) throw $e0734e0b78b64dca$var$OPE('unexpected JWT "aud" (audience) claim value', $e0734e0b78b64dca$export$755cfb9d9708df13, {
        expected: expected,
        claims: result.claims,
        claim: 'aud'
    });
    return result;
}
function $e0734e0b78b64dca$var$validateOptionalIssuer(as, result) {
    if (result.claims.iss !== undefined) return $e0734e0b78b64dca$var$validateIssuer(as, result);
    return result;
}
function $e0734e0b78b64dca$var$validateIssuer(as, result) {
    const expected = as[$e0734e0b78b64dca$export$40bb94adbb055b3]?.(result) ?? as.issuer;
    if (result.claims.iss !== expected) throw $e0734e0b78b64dca$var$OPE('unexpected JWT "iss" (issuer) claim value', $e0734e0b78b64dca$export$755cfb9d9708df13, {
        expected: expected,
        claims: result.claims,
        claim: 'iss'
    });
    return result;
}
const $e0734e0b78b64dca$var$branded = new WeakSet();
function $e0734e0b78b64dca$var$brand(searchParams) {
    $e0734e0b78b64dca$var$branded.add(searchParams);
    return searchParams;
}
const $e0734e0b78b64dca$export$45246453d97b4076 = Symbol();
async function $e0734e0b78b64dca$export$78262594e8327622(as, client, clientAuthentication, callbackParameters, redirectUri, codeVerifier, options) {
    $e0734e0b78b64dca$var$assertAs(as);
    $e0734e0b78b64dca$var$assertClient(client);
    if (!$e0734e0b78b64dca$var$branded.has(callbackParameters)) throw $e0734e0b78b64dca$var$CodedTypeError('"callbackParameters" must be an instance of URLSearchParams obtained from "validateAuthResponse()", or "validateJwtAuthResponse()', $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE);
    $e0734e0b78b64dca$var$assertString(redirectUri, '"redirectUri"');
    const code = $e0734e0b78b64dca$var$getURLSearchParameter(callbackParameters, 'code');
    if (!code) throw $e0734e0b78b64dca$var$OPE('no authorization code in "callbackParameters"', $e0734e0b78b64dca$export$a95f69ec43d8404);
    const parameters = new URLSearchParams(options?.additionalParameters);
    parameters.set('redirect_uri', redirectUri);
    parameters.set('code', code);
    if (codeVerifier !== $e0734e0b78b64dca$export$45246453d97b4076) {
        $e0734e0b78b64dca$var$assertString(codeVerifier, '"codeVerifier"');
        parameters.set('code_verifier', codeVerifier);
    }
    return $e0734e0b78b64dca$var$tokenEndpointRequest(as, client, clientAuthentication, 'authorization_code', parameters, options);
}
const $e0734e0b78b64dca$var$jwtClaimNames = {
    aud: 'audience',
    c_hash: 'code hash',
    client_id: 'client id',
    exp: 'expiration time',
    iat: 'issued at',
    iss: 'issuer',
    jti: 'jwt id',
    nonce: 'nonce',
    s_hash: 'state hash',
    sub: 'subject',
    ath: 'access token hash',
    htm: 'http method',
    htu: 'http uri',
    cnf: 'confirmation',
    auth_time: 'authentication time'
};
function $e0734e0b78b64dca$var$validatePresence(required, result) {
    for (const claim of required){
        if (result.claims[claim] === undefined) throw $e0734e0b78b64dca$var$OPE(`JWT "${claim}" (${$e0734e0b78b64dca$var$jwtClaimNames[claim]}) claim missing`, $e0734e0b78b64dca$export$a95f69ec43d8404, {
            claims: result.claims
        });
    }
    return result;
}
const $e0734e0b78b64dca$export$2b4a6dea801548f3 = Symbol();
const $e0734e0b78b64dca$export$7ad54358b8d54bb3 = Symbol();
async function $e0734e0b78b64dca$export$2c578c716b290815(as, client, response, options) {
    if (typeof options?.expectedNonce === 'string' || typeof options?.maxAge === 'number' || options?.requireIdToken) return $e0734e0b78b64dca$var$processAuthorizationCodeOpenIDResponse(as, client, response, options.expectedNonce, options.maxAge, options[$e0734e0b78b64dca$export$fe968a6742b93a36], options.recognizedTokenTypes);
    return $e0734e0b78b64dca$var$processAuthorizationCodeOAuth2Response(as, client, response, options?.[$e0734e0b78b64dca$export$fe968a6742b93a36], options?.recognizedTokenTypes);
}
async function $e0734e0b78b64dca$var$processAuthorizationCodeOpenIDResponse(as, client, response, expectedNonce, maxAge, decryptFn, recognizedTokenTypes) {
    const additionalRequiredClaims = [];
    switch(expectedNonce){
        case undefined:
            expectedNonce = $e0734e0b78b64dca$export$2b4a6dea801548f3;
            break;
        case $e0734e0b78b64dca$export$2b4a6dea801548f3:
            break;
        default:
            $e0734e0b78b64dca$var$assertString(expectedNonce, '"expectedNonce" argument');
            additionalRequiredClaims.push('nonce');
    }
    maxAge ??= client.default_max_age;
    switch(maxAge){
        case undefined:
            maxAge = $e0734e0b78b64dca$export$7ad54358b8d54bb3;
            break;
        case $e0734e0b78b64dca$export$7ad54358b8d54bb3:
            break;
        default:
            $e0734e0b78b64dca$var$assertNumber(maxAge, true, '"maxAge" argument');
            additionalRequiredClaims.push('auth_time');
    }
    const result = await $e0734e0b78b64dca$var$processGenericAccessTokenResponse(as, client, response, additionalRequiredClaims, decryptFn, recognizedTokenTypes);
    $e0734e0b78b64dca$var$assertString(result.id_token, '"response" body "id_token" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: result
    });
    const claims = $e0734e0b78b64dca$export$3bd2388378bb9d92(result);
    if (maxAge !== $e0734e0b78b64dca$export$7ad54358b8d54bb3) {
        const now = $e0734e0b78b64dca$var$epochTime() + $e0734e0b78b64dca$var$getClockSkew(client);
        const tolerance = $e0734e0b78b64dca$var$getClockTolerance(client);
        if (claims.auth_time + maxAge < now - tolerance) throw $e0734e0b78b64dca$var$OPE('too much time has elapsed since the last End-User authentication', $e0734e0b78b64dca$export$e256757118ff9e88, {
            claims: claims,
            now: now,
            tolerance: tolerance,
            claim: 'auth_time'
        });
    }
    if (expectedNonce === $e0734e0b78b64dca$export$2b4a6dea801548f3) {
        if (claims.nonce !== undefined) throw $e0734e0b78b64dca$var$OPE('unexpected ID Token "nonce" claim value', $e0734e0b78b64dca$export$755cfb9d9708df13, {
            expected: undefined,
            claims: claims,
            claim: 'nonce'
        });
    } else if (claims.nonce !== expectedNonce) throw $e0734e0b78b64dca$var$OPE('unexpected ID Token "nonce" claim value', $e0734e0b78b64dca$export$755cfb9d9708df13, {
        expected: expectedNonce,
        claims: claims,
        claim: 'nonce'
    });
    return result;
}
async function $e0734e0b78b64dca$var$processAuthorizationCodeOAuth2Response(as, client, response, decryptFn, recognizedTokenTypes) {
    const result = await $e0734e0b78b64dca$var$processGenericAccessTokenResponse(as, client, response, undefined, decryptFn, recognizedTokenTypes);
    const claims = $e0734e0b78b64dca$export$3bd2388378bb9d92(result);
    if (claims) {
        if (client.default_max_age !== undefined) {
            $e0734e0b78b64dca$var$assertNumber(client.default_max_age, true, '"client.default_max_age"');
            const now = $e0734e0b78b64dca$var$epochTime() + $e0734e0b78b64dca$var$getClockSkew(client);
            const tolerance = $e0734e0b78b64dca$var$getClockTolerance(client);
            if (claims.auth_time + client.default_max_age < now - tolerance) throw $e0734e0b78b64dca$var$OPE('too much time has elapsed since the last End-User authentication', $e0734e0b78b64dca$export$e256757118ff9e88, {
                claims: claims,
                now: now,
                tolerance: tolerance,
                claim: 'auth_time'
            });
        }
        if (claims.nonce !== undefined) throw $e0734e0b78b64dca$var$OPE('unexpected ID Token "nonce" claim value', $e0734e0b78b64dca$export$755cfb9d9708df13, {
            expected: undefined,
            claims: claims,
            claim: 'nonce'
        });
    }
    return result;
}
const $e0734e0b78b64dca$export$828007b5392b716e = 'OAUTH_WWW_AUTHENTICATE_CHALLENGE';
const $e0734e0b78b64dca$export$7c386099a0178c9e = 'OAUTH_RESPONSE_BODY_ERROR';
const $e0734e0b78b64dca$export$32f5e317a183f59 = 'OAUTH_UNSUPPORTED_OPERATION';
const $e0734e0b78b64dca$export$d28be95474e00f8 = 'OAUTH_AUTHORIZATION_RESPONSE_ERROR';
const $e0734e0b78b64dca$export$3045c630ee9482af = 'OAUTH_JWT_USERINFO_EXPECTED';
const $e0734e0b78b64dca$export$2ecaad7eb5cc1f25 = 'OAUTH_PARSE_ERROR';
const $e0734e0b78b64dca$export$a95f69ec43d8404 = 'OAUTH_INVALID_RESPONSE';
const $e0734e0b78b64dca$export$c77b2f9ece3946ce = 'OAUTH_INVALID_REQUEST';
const $e0734e0b78b64dca$export$a846b8736a86183d = 'OAUTH_RESPONSE_IS_NOT_JSON';
const $e0734e0b78b64dca$export$d685a0ca6b1d1c11 = 'OAUTH_RESPONSE_IS_NOT_CONFORM';
const $e0734e0b78b64dca$export$6b11590cd6c9e2e5 = 'OAUTH_HTTP_REQUEST_FORBIDDEN';
const $e0734e0b78b64dca$export$e324cc317a4199fc = 'OAUTH_REQUEST_PROTOCOL_FORBIDDEN';
const $e0734e0b78b64dca$export$e256757118ff9e88 = 'OAUTH_JWT_TIMESTAMP_CHECK_FAILED';
const $e0734e0b78b64dca$export$755cfb9d9708df13 = 'OAUTH_JWT_CLAIM_COMPARISON_FAILED';
const $e0734e0b78b64dca$export$cbbd45b2b4b65c94 = 'OAUTH_JSON_ATTRIBUTE_COMPARISON_FAILED';
const $e0734e0b78b64dca$export$bfbcb4ed1226f649 = 'OAUTH_KEY_SELECTION_FAILED';
const $e0734e0b78b64dca$export$3d98cc6c66e92ac6 = 'OAUTH_MISSING_SERVER_METADATA';
const $e0734e0b78b64dca$export$2571c083f06d615 = 'OAUTH_INVALID_SERVER_METADATA';
function $e0734e0b78b64dca$var$checkJwtType(expected, result) {
    if (typeof result.header.typ !== 'string' || $e0734e0b78b64dca$var$normalizeTyp(result.header.typ) !== expected) throw $e0734e0b78b64dca$var$OPE('unexpected JWT "typ" header parameter value', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        header: result.header
    });
    return result;
}
async function $e0734e0b78b64dca$export$180dac7d148d2257(as, client, clientAuthentication, parameters, options) {
    $e0734e0b78b64dca$var$assertAs(as);
    $e0734e0b78b64dca$var$assertClient(client);
    return $e0734e0b78b64dca$var$tokenEndpointRequest(as, client, clientAuthentication, 'client_credentials', new URLSearchParams(parameters), options);
}
async function $e0734e0b78b64dca$export$fbfac642237c603(as, client, clientAuthentication, grantType, parameters, options) {
    $e0734e0b78b64dca$var$assertAs(as);
    $e0734e0b78b64dca$var$assertClient(client);
    $e0734e0b78b64dca$var$assertString(grantType, '"grantType"');
    return $e0734e0b78b64dca$var$tokenEndpointRequest(as, client, clientAuthentication, grantType, new URLSearchParams(parameters), options);
}
async function $e0734e0b78b64dca$export$d889f08c5c5cc0cd(as, client, response, options) {
    return $e0734e0b78b64dca$var$processGenericAccessTokenResponse(as, client, response, undefined, options?.[$e0734e0b78b64dca$export$fe968a6742b93a36], options?.recognizedTokenTypes);
}
async function $e0734e0b78b64dca$export$26635fb30941f4a5(as, client, response, options) {
    return $e0734e0b78b64dca$var$processGenericAccessTokenResponse(as, client, response, undefined, options?.[$e0734e0b78b64dca$export$fe968a6742b93a36], options?.recognizedTokenTypes);
}
async function $e0734e0b78b64dca$export$a903960abbc67225(as, client, clientAuthentication, token, options) {
    $e0734e0b78b64dca$var$assertAs(as);
    $e0734e0b78b64dca$var$assertClient(client);
    $e0734e0b78b64dca$var$assertString(token, '"token"');
    const url = $e0734e0b78b64dca$export$48b88e4e5ecac119(as, 'revocation_endpoint', client.use_mtls_endpoint_aliases, options?.[$e0734e0b78b64dca$export$7df29a6c2173f26b] !== true);
    const body = new URLSearchParams(options?.additionalParameters);
    body.set('token', token);
    const headers = $e0734e0b78b64dca$var$prepareHeaders(options?.headers);
    headers.delete('accept');
    return $e0734e0b78b64dca$var$authenticatedRequest(as, client, clientAuthentication, url, body, headers, options);
}
async function $e0734e0b78b64dca$export$f3d92abf544f771c(response) {
    if (!$e0734e0b78b64dca$var$looseInstanceOf(response, Response)) throw $e0734e0b78b64dca$var$CodedTypeError('"response" must be an instance of Response', $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
    await $e0734e0b78b64dca$var$checkOAuthBodyError(response, 200, 'Revocation Endpoint');
    return undefined;
}
function $e0734e0b78b64dca$var$assertReadableResponse(response) {
    if (response.bodyUsed) throw $e0734e0b78b64dca$var$CodedTypeError('"response" body has been used already', $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE);
}
async function $e0734e0b78b64dca$export$a6015ffb0bad7c98(as, client, clientAuthentication, token, options) {
    $e0734e0b78b64dca$var$assertAs(as);
    $e0734e0b78b64dca$var$assertClient(client);
    $e0734e0b78b64dca$var$assertString(token, '"token"');
    const url = $e0734e0b78b64dca$export$48b88e4e5ecac119(as, 'introspection_endpoint', client.use_mtls_endpoint_aliases, options?.[$e0734e0b78b64dca$export$7df29a6c2173f26b] !== true);
    const body = new URLSearchParams(options?.additionalParameters);
    body.set('token', token);
    const headers = $e0734e0b78b64dca$var$prepareHeaders(options?.headers);
    if (options?.requestJwtResponse ?? client.introspection_signed_response_alg) headers.set('accept', 'application/token-introspection+jwt');
    else headers.set('accept', 'application/json');
    return $e0734e0b78b64dca$var$authenticatedRequest(as, client, clientAuthentication, url, body, headers, options);
}
async function $e0734e0b78b64dca$export$b50837af7a77c5b3(as, client, response, options) {
    $e0734e0b78b64dca$var$assertAs(as);
    $e0734e0b78b64dca$var$assertClient(client);
    if (!$e0734e0b78b64dca$var$looseInstanceOf(response, Response)) throw $e0734e0b78b64dca$var$CodedTypeError('"response" must be an instance of Response', $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
    await $e0734e0b78b64dca$var$checkOAuthBodyError(response, 200, 'Introspection Endpoint');
    let json;
    if ($e0734e0b78b64dca$export$1ef77878e4e0b972(response) === 'application/token-introspection+jwt') {
        $e0734e0b78b64dca$var$assertReadableResponse(response);
        const { claims: claims, jwt: jwt } = await $e0734e0b78b64dca$var$validateJwt(await response.text(), $e0734e0b78b64dca$var$checkSigningAlgorithm.bind(undefined, client.introspection_signed_response_alg, as.introspection_signing_alg_values_supported, 'RS256'), $e0734e0b78b64dca$var$getClockSkew(client), $e0734e0b78b64dca$var$getClockTolerance(client), options?.[$e0734e0b78b64dca$export$fe968a6742b93a36]).then($e0734e0b78b64dca$var$checkJwtType.bind(undefined, 'token-introspection+jwt')).then($e0734e0b78b64dca$var$validatePresence.bind(undefined, [
            'aud',
            'iat',
            'iss'
        ])).then($e0734e0b78b64dca$var$validateIssuer.bind(undefined, as)).then($e0734e0b78b64dca$var$validateAudience.bind(undefined, client.client_id));
        $e0734e0b78b64dca$var$jwtRefs.set(response, jwt);
        if (!$e0734e0b78b64dca$var$isJsonObject(claims.token_introspection)) throw $e0734e0b78b64dca$var$OPE('JWT "token_introspection" claim must be a JSON object', $e0734e0b78b64dca$export$a95f69ec43d8404, {
            claims: claims
        });
        json = claims.token_introspection;
    } else {
        $e0734e0b78b64dca$var$assertReadableResponse(response);
        json = await $e0734e0b78b64dca$var$getResponseJsonBody(response);
    }
    if (typeof json.active !== 'boolean') throw $e0734e0b78b64dca$var$OPE('"response" body "active" property must be a boolean', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    return json;
}
async function $e0734e0b78b64dca$var$jwksRequest(as, options) {
    $e0734e0b78b64dca$var$assertAs(as);
    const url = $e0734e0b78b64dca$export$48b88e4e5ecac119(as, 'jwks_uri', false, options?.[$e0734e0b78b64dca$export$7df29a6c2173f26b] !== true);
    const headers = $e0734e0b78b64dca$var$prepareHeaders(options?.headers);
    headers.set('accept', 'application/json');
    headers.append('accept', 'application/jwk-set+json');
    return (options?.[$e0734e0b78b64dca$export$1512182a095696a1] || fetch)(url.href, {
        body: undefined,
        headers: Object.fromEntries(headers.entries()),
        method: 'GET',
        redirect: 'manual',
        signal: $e0734e0b78b64dca$var$signal(url, options?.signal)
    });
}
async function $e0734e0b78b64dca$var$processJwksResponse(response) {
    if (!$e0734e0b78b64dca$var$looseInstanceOf(response, Response)) throw $e0734e0b78b64dca$var$CodedTypeError('"response" must be an instance of Response', $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
    if (response.status !== 200) throw $e0734e0b78b64dca$var$OPE('"response" is not a conform JSON Web Key Set response (unexpected HTTP status code)', $e0734e0b78b64dca$export$d685a0ca6b1d1c11, response);
    $e0734e0b78b64dca$var$assertReadableResponse(response);
    const json = await $e0734e0b78b64dca$var$getResponseJsonBody(response, (response)=>$e0734e0b78b64dca$var$assertContentTypes(response, 'application/json', 'application/jwk-set+json'));
    if (!Array.isArray(json.keys)) throw $e0734e0b78b64dca$var$OPE('"response" body "keys" property must be an array', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    if (!Array.prototype.every.call(json.keys, $e0734e0b78b64dca$var$isJsonObject)) throw $e0734e0b78b64dca$var$OPE('"response" body "keys" property members must be JWK formatted objects', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    return json;
}
function $e0734e0b78b64dca$var$supported(alg) {
    switch(alg){
        case 'PS256':
        case 'ES256':
        case 'RS256':
        case 'PS384':
        case 'ES384':
        case 'RS384':
        case 'PS512':
        case 'ES512':
        case 'RS512':
        case 'Ed25519':
        case 'EdDSA':
        case 'ML-DSA-44':
        case 'ML-DSA-65':
        case 'ML-DSA-87':
            return true;
        default:
            return false;
    }
}
function $e0734e0b78b64dca$var$checkSupportedJwsAlg(header) {
    if (!$e0734e0b78b64dca$var$supported(header.alg)) throw new $e0734e0b78b64dca$export$ab59e00737fb22e6('unsupported JWS "alg" identifier', {
        cause: {
            alg: header.alg
        }
    });
}
function $e0734e0b78b64dca$var$checkRsaKeyAlgorithm(key) {
    const { algorithm: algorithm } = key;
    if (typeof algorithm.modulusLength !== 'number' || algorithm.modulusLength < 2048) throw new $e0734e0b78b64dca$export$ab59e00737fb22e6(`unsupported ${algorithm.name} modulusLength`, {
        cause: key
    });
}
function $e0734e0b78b64dca$var$ecdsaHashName(key) {
    const { algorithm: algorithm } = key;
    switch(algorithm.namedCurve){
        case 'P-256':
            return 'SHA-256';
        case 'P-384':
            return 'SHA-384';
        case 'P-521':
            return 'SHA-512';
        default:
            throw new $e0734e0b78b64dca$export$ab59e00737fb22e6('unsupported ECDSA namedCurve', {
                cause: key
            });
    }
}
function $e0734e0b78b64dca$var$keyToSubtle(key) {
    switch(key.algorithm.name){
        case 'ECDSA':
            return {
                name: key.algorithm.name,
                hash: $e0734e0b78b64dca$var$ecdsaHashName(key)
            };
        case 'RSA-PSS':
            $e0734e0b78b64dca$var$checkRsaKeyAlgorithm(key);
            switch(key.algorithm.hash.name){
                case 'SHA-256':
                case 'SHA-384':
                case 'SHA-512':
                    return {
                        name: key.algorithm.name,
                        saltLength: parseInt(key.algorithm.hash.name.slice(-3), 10) >> 3
                    };
                default:
                    throw new $e0734e0b78b64dca$export$ab59e00737fb22e6('unsupported RSA-PSS hash name', {
                        cause: key
                    });
            }
        case 'RSASSA-PKCS1-v1_5':
            $e0734e0b78b64dca$var$checkRsaKeyAlgorithm(key);
            return key.algorithm.name;
        case 'ML-DSA-44':
        case 'ML-DSA-65':
        case 'ML-DSA-87':
        case 'Ed25519':
            return key.algorithm.name;
    }
    throw new $e0734e0b78b64dca$export$ab59e00737fb22e6('unsupported CryptoKey algorithm name', {
        cause: key
    });
}
async function $e0734e0b78b64dca$var$validateJwsSignature(protectedHeader, payload, key, signature) {
    const data = $e0734e0b78b64dca$var$buf(`${protectedHeader}.${payload}`);
    const algorithm = $e0734e0b78b64dca$var$keyToSubtle(key);
    const verified = await crypto.subtle.verify(algorithm, key, signature, data);
    if (!verified) throw $e0734e0b78b64dca$var$OPE('JWT signature verification failed', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        key: key,
        data: data,
        signature: signature,
        algorithm: algorithm
    });
}
async function $e0734e0b78b64dca$var$validateJwt(jws, checkAlg, clockSkew, clockTolerance, decryptJwt) {
    let { 0: protectedHeader, 1: payload, length: length } = jws.split('.');
    if (length === 5) {
        if (decryptJwt !== undefined) {
            jws = await decryptJwt(jws);
            ({ 0: protectedHeader, 1: payload, length: length } = jws.split('.'));
        } else throw new $e0734e0b78b64dca$export$ab59e00737fb22e6('JWE decryption is not configured', {
            cause: jws
        });
    }
    if (length !== 3) throw $e0734e0b78b64dca$var$OPE('Invalid JWT', $e0734e0b78b64dca$export$a95f69ec43d8404, jws);
    let header;
    try {
        header = JSON.parse($e0734e0b78b64dca$var$buf($e0734e0b78b64dca$var$b64u(protectedHeader)));
    } catch (cause) {
        throw $e0734e0b78b64dca$var$OPE('failed to parse JWT Header body as base64url encoded JSON', $e0734e0b78b64dca$export$2ecaad7eb5cc1f25, cause);
    }
    if (!$e0734e0b78b64dca$var$isJsonObject(header)) throw $e0734e0b78b64dca$var$OPE('JWT Header must be a top level object', $e0734e0b78b64dca$export$a95f69ec43d8404, jws);
    checkAlg(header);
    if (header.crit !== undefined) throw new $e0734e0b78b64dca$export$ab59e00737fb22e6('no JWT "crit" header parameter extensions are supported', {
        cause: {
            header: header
        }
    });
    let claims;
    try {
        claims = JSON.parse($e0734e0b78b64dca$var$buf($e0734e0b78b64dca$var$b64u(payload)));
    } catch (cause) {
        throw $e0734e0b78b64dca$var$OPE('failed to parse JWT Payload body as base64url encoded JSON', $e0734e0b78b64dca$export$2ecaad7eb5cc1f25, cause);
    }
    if (!$e0734e0b78b64dca$var$isJsonObject(claims)) throw $e0734e0b78b64dca$var$OPE('JWT Payload must be a top level object', $e0734e0b78b64dca$export$a95f69ec43d8404, jws);
    const now = $e0734e0b78b64dca$var$epochTime() + clockSkew;
    if (claims.exp !== undefined) {
        if (typeof claims.exp !== 'number') throw $e0734e0b78b64dca$var$OPE('unexpected JWT "exp" (expiration time) claim type', $e0734e0b78b64dca$export$a95f69ec43d8404, {
            claims: claims
        });
        if (claims.exp <= now - clockTolerance) throw $e0734e0b78b64dca$var$OPE('unexpected JWT "exp" (expiration time) claim value, expiration is past current timestamp', $e0734e0b78b64dca$export$e256757118ff9e88, {
            claims: claims,
            now: now,
            tolerance: clockTolerance,
            claim: 'exp'
        });
    }
    if (claims.iat !== undefined) {
        if (typeof claims.iat !== 'number') throw $e0734e0b78b64dca$var$OPE('unexpected JWT "iat" (issued at) claim type', $e0734e0b78b64dca$export$a95f69ec43d8404, {
            claims: claims
        });
    }
    if (claims.iss !== undefined) {
        if (typeof claims.iss !== 'string') throw $e0734e0b78b64dca$var$OPE('unexpected JWT "iss" (issuer) claim type', $e0734e0b78b64dca$export$a95f69ec43d8404, {
            claims: claims
        });
    }
    if (claims.nbf !== undefined) {
        if (typeof claims.nbf !== 'number') throw $e0734e0b78b64dca$var$OPE('unexpected JWT "nbf" (not before) claim type', $e0734e0b78b64dca$export$a95f69ec43d8404, {
            claims: claims
        });
        if (claims.nbf > now + clockTolerance) throw $e0734e0b78b64dca$var$OPE('unexpected JWT "nbf" (not before) claim value', $e0734e0b78b64dca$export$e256757118ff9e88, {
            claims: claims,
            now: now,
            tolerance: clockTolerance,
            claim: 'nbf'
        });
    }
    if (claims.aud !== undefined) {
        if (typeof claims.aud !== 'string' && !Array.isArray(claims.aud)) throw $e0734e0b78b64dca$var$OPE('unexpected JWT "aud" (audience) claim type', $e0734e0b78b64dca$export$a95f69ec43d8404, {
            claims: claims
        });
    }
    return {
        header: header,
        claims: claims,
        jwt: jws
    };
}
async function $e0734e0b78b64dca$export$d8e5c03b915f0e3f(as, client, parameters, expectedState, options) {
    $e0734e0b78b64dca$var$assertAs(as);
    $e0734e0b78b64dca$var$assertClient(client);
    if (parameters instanceof URL) parameters = parameters.searchParams;
    if (!(parameters instanceof URLSearchParams)) throw $e0734e0b78b64dca$var$CodedTypeError('"parameters" must be an instance of URLSearchParams, or URL', $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
    const response = $e0734e0b78b64dca$var$getURLSearchParameter(parameters, 'response');
    if (!response) throw $e0734e0b78b64dca$var$OPE('"parameters" does not contain a JARM response', $e0734e0b78b64dca$export$a95f69ec43d8404);
    const { claims: claims, header: header, jwt: jwt } = await $e0734e0b78b64dca$var$validateJwt(response, $e0734e0b78b64dca$var$checkSigningAlgorithm.bind(undefined, client.authorization_signed_response_alg, as.authorization_signing_alg_values_supported, 'RS256'), $e0734e0b78b64dca$var$getClockSkew(client), $e0734e0b78b64dca$var$getClockTolerance(client), options?.[$e0734e0b78b64dca$export$fe968a6742b93a36]).then($e0734e0b78b64dca$var$validatePresence.bind(undefined, [
        'aud',
        'exp',
        'iss'
    ])).then($e0734e0b78b64dca$var$validateIssuer.bind(undefined, as)).then($e0734e0b78b64dca$var$validateAudience.bind(undefined, client.client_id));
    const { 0: protectedHeader, 1: payload, 2: encodedSignature } = jwt.split('.');
    const signature = $e0734e0b78b64dca$var$b64u(encodedSignature);
    const key = await $e0734e0b78b64dca$var$getPublicSigKeyFromIssuerJwksUri(as, options, header);
    await $e0734e0b78b64dca$var$validateJwsSignature(protectedHeader, payload, key, signature);
    const result = new URLSearchParams();
    for (const [key, value] of Object.entries(claims))if (typeof value === 'string' && key !== 'aud') result.set(key, value);
    return $e0734e0b78b64dca$export$d683f58fbab347ba(as, client, result, expectedState);
}
async function $e0734e0b78b64dca$var$idTokenHash(data, header, claimName) {
    let algorithm;
    switch(header.alg){
        case 'RS256':
        case 'PS256':
        case 'ES256':
            algorithm = 'SHA-256';
            break;
        case 'RS384':
        case 'PS384':
        case 'ES384':
            algorithm = 'SHA-384';
            break;
        case 'RS512':
        case 'PS512':
        case 'ES512':
        case 'Ed25519':
        case 'EdDSA':
            algorithm = 'SHA-512';
            break;
        case 'ML-DSA-44':
        case 'ML-DSA-65':
        case 'ML-DSA-87':
            algorithm = {
                name: 'cSHAKE256',
                length: 512
            };
            break;
        default:
            throw new $e0734e0b78b64dca$export$ab59e00737fb22e6(`unsupported JWS algorithm for ${claimName} calculation`, {
                cause: {
                    alg: header.alg
                }
            });
    }
    const digest = await crypto.subtle.digest(algorithm, $e0734e0b78b64dca$var$buf(data));
    return $e0734e0b78b64dca$var$b64u(digest.slice(0, digest.byteLength / 2));
}
async function $e0734e0b78b64dca$var$idTokenHashMatches(data, actual, header, claimName) {
    const expected = await $e0734e0b78b64dca$var$idTokenHash(data, header, claimName);
    return actual === expected;
}
async function $e0734e0b78b64dca$export$b9adc54dc449ec30(as, client, parameters, expectedNonce, expectedState, maxAge, options) {
    return $e0734e0b78b64dca$var$validateHybridResponse(as, client, parameters, expectedNonce, expectedState, maxAge, options, true);
}
async function $e0734e0b78b64dca$export$a78ffc30be489eac(as, client, parameters, expectedNonce, expectedState, maxAge, options) {
    return $e0734e0b78b64dca$var$validateHybridResponse(as, client, parameters, expectedNonce, expectedState, maxAge, options, false);
}
async function $e0734e0b78b64dca$var$consumeStream(request) {
    if (request.bodyUsed) throw $e0734e0b78b64dca$var$CodedTypeError('form_post Request instances must contain a readable body', $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE, {
        cause: request
    });
    return request.text();
}
async function $e0734e0b78b64dca$export$647dd3a9c5418c5e(request) {
    if (request.method !== 'POST') throw $e0734e0b78b64dca$var$CodedTypeError('form_post responses are expected to use the POST method', $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE, {
        cause: request
    });
    if ($e0734e0b78b64dca$export$1ef77878e4e0b972(request) !== 'application/x-www-form-urlencoded') throw $e0734e0b78b64dca$var$CodedTypeError('form_post responses are expected to use the application/x-www-form-urlencoded content-type', $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE, {
        cause: request
    });
    return $e0734e0b78b64dca$var$consumeStream(request);
}
async function $e0734e0b78b64dca$var$validateHybridResponse(as, client, parameters, expectedNonce, expectedState, maxAge, options, fapi) {
    $e0734e0b78b64dca$var$assertAs(as);
    $e0734e0b78b64dca$var$assertClient(client);
    if (parameters instanceof URL) {
        if (!parameters.hash.length) throw $e0734e0b78b64dca$var$CodedTypeError('"parameters" as an instance of URL must contain a hash (fragment) with the Authorization Response parameters', $e0734e0b78b64dca$var$ERR_INVALID_ARG_VALUE);
        parameters = new URLSearchParams(parameters.hash.slice(1));
    } else if ($e0734e0b78b64dca$var$looseInstanceOf(parameters, Request)) parameters = new URLSearchParams(await $e0734e0b78b64dca$export$647dd3a9c5418c5e(parameters));
    else if (parameters instanceof URLSearchParams) parameters = new URLSearchParams(parameters);
    else throw $e0734e0b78b64dca$var$CodedTypeError('"parameters" must be an instance of URLSearchParams, URL, or Response', $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
    const id_token = $e0734e0b78b64dca$var$getURLSearchParameter(parameters, 'id_token');
    parameters.delete('id_token');
    switch(expectedState){
        case undefined:
        case $e0734e0b78b64dca$export$91e6f0984de42078:
            break;
        default:
            $e0734e0b78b64dca$var$assertString(expectedState, '"expectedState" argument');
    }
    const result = $e0734e0b78b64dca$export$d683f58fbab347ba({
        ...as,
        authorization_response_iss_parameter_supported: false
    }, client, parameters, expectedState);
    if (!id_token) throw $e0734e0b78b64dca$var$OPE('"parameters" does not contain an ID Token', $e0734e0b78b64dca$export$a95f69ec43d8404);
    const code = $e0734e0b78b64dca$var$getURLSearchParameter(parameters, 'code');
    if (!code) throw $e0734e0b78b64dca$var$OPE('"parameters" does not contain an Authorization Code', $e0734e0b78b64dca$export$a95f69ec43d8404);
    const requiredClaims = [
        'aud',
        'exp',
        'iat',
        'iss',
        'sub',
        'nonce',
        'c_hash'
    ];
    const state = parameters.get('state');
    if (fapi && (typeof expectedState === 'string' || state !== null)) requiredClaims.push('s_hash');
    if (maxAge !== undefined) $e0734e0b78b64dca$var$assertNumber(maxAge, true, '"maxAge" argument');
    else if (client.default_max_age !== undefined) $e0734e0b78b64dca$var$assertNumber(client.default_max_age, true, '"client.default_max_age"');
    maxAge ??= client.default_max_age ?? $e0734e0b78b64dca$export$7ad54358b8d54bb3;
    if (client.require_auth_time || maxAge !== $e0734e0b78b64dca$export$7ad54358b8d54bb3) requiredClaims.push('auth_time');
    const { claims: claims, header: header, jwt: jwt } = await $e0734e0b78b64dca$var$validateJwt(id_token, $e0734e0b78b64dca$var$checkSigningAlgorithm.bind(undefined, client.id_token_signed_response_alg, as.id_token_signing_alg_values_supported, 'RS256'), $e0734e0b78b64dca$var$getClockSkew(client), $e0734e0b78b64dca$var$getClockTolerance(client), options?.[$e0734e0b78b64dca$export$fe968a6742b93a36]).then($e0734e0b78b64dca$var$validatePresence.bind(undefined, requiredClaims)).then($e0734e0b78b64dca$var$validateIssuer.bind(undefined, as)).then($e0734e0b78b64dca$var$validateAudience.bind(undefined, client.client_id));
    const clockSkew = $e0734e0b78b64dca$var$getClockSkew(client);
    const now = $e0734e0b78b64dca$var$epochTime() + clockSkew;
    if (claims.iat < now - 3600) throw $e0734e0b78b64dca$var$OPE('unexpected JWT "iat" (issued at) claim value, it is too far in the past', $e0734e0b78b64dca$export$e256757118ff9e88, {
        now: now,
        claims: claims,
        claim: 'iat'
    });
    $e0734e0b78b64dca$var$assertString(claims.c_hash, 'ID Token "c_hash" (code hash) claim value', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        claims: claims
    });
    if (claims.auth_time !== undefined) $e0734e0b78b64dca$var$assertNumber(claims.auth_time, true, 'ID Token "auth_time" (authentication time)', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        claims: claims
    });
    if (maxAge !== $e0734e0b78b64dca$export$7ad54358b8d54bb3) {
        const now = $e0734e0b78b64dca$var$epochTime() + $e0734e0b78b64dca$var$getClockSkew(client);
        const tolerance = $e0734e0b78b64dca$var$getClockTolerance(client);
        if (claims.auth_time + maxAge < now - tolerance) throw $e0734e0b78b64dca$var$OPE('too much time has elapsed since the last End-User authentication', $e0734e0b78b64dca$export$e256757118ff9e88, {
            claims: claims,
            now: now,
            tolerance: tolerance,
            claim: 'auth_time'
        });
    }
    $e0734e0b78b64dca$var$assertString(expectedNonce, '"expectedNonce" argument');
    if (claims.nonce !== expectedNonce) throw $e0734e0b78b64dca$var$OPE('unexpected ID Token "nonce" claim value', $e0734e0b78b64dca$export$755cfb9d9708df13, {
        expected: expectedNonce,
        claims: claims,
        claim: 'nonce'
    });
    if (Array.isArray(claims.aud) && claims.aud.length !== 1) {
        if (claims.azp === undefined) throw $e0734e0b78b64dca$var$OPE('ID Token "aud" (audience) claim includes additional untrusted audiences', $e0734e0b78b64dca$export$755cfb9d9708df13, {
            claims: claims,
            claim: 'aud'
        });
        if (claims.azp !== client.client_id) throw $e0734e0b78b64dca$var$OPE('unexpected ID Token "azp" (authorized party) claim value', $e0734e0b78b64dca$export$755cfb9d9708df13, {
            expected: client.client_id,
            claims: claims,
            claim: 'azp'
        });
    }
    const { 0: protectedHeader, 1: payload, 2: encodedSignature } = jwt.split('.');
    const signature = $e0734e0b78b64dca$var$b64u(encodedSignature);
    const key = await $e0734e0b78b64dca$var$getPublicSigKeyFromIssuerJwksUri(as, options, header);
    await $e0734e0b78b64dca$var$validateJwsSignature(protectedHeader, payload, key, signature);
    if (await $e0734e0b78b64dca$var$idTokenHashMatches(code, claims.c_hash, header, 'c_hash') !== true) throw $e0734e0b78b64dca$var$OPE('invalid ID Token "c_hash" (code hash) claim value', $e0734e0b78b64dca$export$755cfb9d9708df13, {
        code: code,
        alg: header.alg,
        claim: 'c_hash',
        claims: claims
    });
    if (fapi && state !== null || claims.s_hash !== undefined) {
        $e0734e0b78b64dca$var$assertString(claims.s_hash, 'ID Token "s_hash" (state hash) claim value', $e0734e0b78b64dca$export$a95f69ec43d8404, {
            claims: claims
        });
        $e0734e0b78b64dca$var$assertString(state, '"state" response parameter', $e0734e0b78b64dca$export$a95f69ec43d8404, {
            parameters: parameters
        });
        if (await $e0734e0b78b64dca$var$idTokenHashMatches(state, claims.s_hash, header, 's_hash') !== true) throw $e0734e0b78b64dca$var$OPE('invalid ID Token "s_hash" (state hash) claim value', $e0734e0b78b64dca$export$755cfb9d9708df13, {
            state: state,
            alg: header.alg,
            claim: 's_hash',
            claims: claims
        });
    }
    return result;
}
function $e0734e0b78b64dca$var$checkSigningAlgorithm(client, issuer, fallback, header) {
    if (client !== undefined) {
        if (typeof client === 'string' ? header.alg !== client : !client.includes(header.alg)) throw $e0734e0b78b64dca$var$OPE('unexpected JWT "alg" header parameter', $e0734e0b78b64dca$export$a95f69ec43d8404, {
            header: header,
            expected: client,
            reason: 'client configuration'
        });
        return;
    }
    if (Array.isArray(issuer)) {
        if (!issuer.includes(header.alg)) throw $e0734e0b78b64dca$var$OPE('unexpected JWT "alg" header parameter', $e0734e0b78b64dca$export$a95f69ec43d8404, {
            header: header,
            expected: issuer,
            reason: 'authorization server metadata'
        });
        return;
    }
    if (fallback !== undefined) {
        if (typeof fallback === 'string' ? header.alg !== fallback : typeof fallback === 'function' ? !fallback(header.alg) : !fallback.includes(header.alg)) throw $e0734e0b78b64dca$var$OPE('unexpected JWT "alg" header parameter', $e0734e0b78b64dca$export$a95f69ec43d8404, {
            header: header,
            expected: fallback,
            reason: 'default value'
        });
        return;
    }
    throw $e0734e0b78b64dca$var$OPE('missing client or server configuration to verify used JWT "alg" header parameter', undefined, {
        client: client,
        issuer: issuer,
        fallback: fallback
    });
}
function $e0734e0b78b64dca$var$getURLSearchParameter(parameters, name) {
    const { 0: value, length: length } = parameters.getAll(name);
    if (length > 1) throw $e0734e0b78b64dca$var$OPE(`"${name}" parameter must be provided only once`, $e0734e0b78b64dca$export$a95f69ec43d8404);
    return value;
}
const $e0734e0b78b64dca$export$da05291b784100ea = Symbol();
const $e0734e0b78b64dca$export$91e6f0984de42078 = Symbol();
function $e0734e0b78b64dca$export$d683f58fbab347ba(as, client, parameters, expectedState) {
    $e0734e0b78b64dca$var$assertAs(as);
    $e0734e0b78b64dca$var$assertClient(client);
    if (parameters instanceof URL) parameters = parameters.searchParams;
    if (!(parameters instanceof URLSearchParams)) throw $e0734e0b78b64dca$var$CodedTypeError('"parameters" must be an instance of URLSearchParams, or URL', $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
    if ($e0734e0b78b64dca$var$getURLSearchParameter(parameters, 'response')) throw $e0734e0b78b64dca$var$OPE('"parameters" contains a JARM response, use validateJwtAuthResponse() instead of validateAuthResponse()', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        parameters: parameters
    });
    const iss = $e0734e0b78b64dca$var$getURLSearchParameter(parameters, 'iss');
    const state = $e0734e0b78b64dca$var$getURLSearchParameter(parameters, 'state');
    if (!iss && as.authorization_response_iss_parameter_supported) throw $e0734e0b78b64dca$var$OPE('response parameter "iss" (issuer) missing', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        parameters: parameters
    });
    if (iss && iss !== as.issuer) throw $e0734e0b78b64dca$var$OPE('unexpected "iss" (issuer) response parameter value', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        expected: as.issuer,
        parameters: parameters
    });
    switch(expectedState){
        case undefined:
        case $e0734e0b78b64dca$export$91e6f0984de42078:
            if (state !== undefined) throw $e0734e0b78b64dca$var$OPE('unexpected "state" response parameter encountered', $e0734e0b78b64dca$export$a95f69ec43d8404, {
                expected: undefined,
                parameters: parameters
            });
            break;
        case $e0734e0b78b64dca$export$da05291b784100ea:
            break;
        default:
            $e0734e0b78b64dca$var$assertString(expectedState, '"expectedState" argument');
            if (state !== expectedState) throw $e0734e0b78b64dca$var$OPE(state === undefined ? 'response parameter "state" missing' : 'unexpected "state" response parameter value', $e0734e0b78b64dca$export$a95f69ec43d8404, {
                expected: expectedState,
                parameters: parameters
            });
    }
    const error = $e0734e0b78b64dca$var$getURLSearchParameter(parameters, 'error');
    if (error) throw new $e0734e0b78b64dca$export$9ba4842ad1493b35('authorization response from the server is an error', {
        cause: parameters
    });
    const id_token = $e0734e0b78b64dca$var$getURLSearchParameter(parameters, 'id_token');
    const token = $e0734e0b78b64dca$var$getURLSearchParameter(parameters, 'token');
    if (id_token !== undefined || token !== undefined) throw new $e0734e0b78b64dca$export$ab59e00737fb22e6('implicit and hybrid flows are not supported');
    return $e0734e0b78b64dca$var$brand(new URLSearchParams(parameters));
}
function $e0734e0b78b64dca$var$algToSubtle(alg) {
    switch(alg){
        case 'PS256':
        case 'PS384':
        case 'PS512':
            return {
                name: 'RSA-PSS',
                hash: `SHA-${alg.slice(-3)}`
            };
        case 'RS256':
        case 'RS384':
        case 'RS512':
            return {
                name: 'RSASSA-PKCS1-v1_5',
                hash: `SHA-${alg.slice(-3)}`
            };
        case 'ES256':
        case 'ES384':
            return {
                name: 'ECDSA',
                namedCurve: `P-${alg.slice(-3)}`
            };
        case 'ES512':
            return {
                name: 'ECDSA',
                namedCurve: 'P-521'
            };
        case 'EdDSA':
            return 'Ed25519';
        case 'Ed25519':
        case 'ML-DSA-44':
        case 'ML-DSA-65':
        case 'ML-DSA-87':
            return alg;
        default:
            throw new $e0734e0b78b64dca$export$ab59e00737fb22e6('unsupported JWS algorithm', {
                cause: {
                    alg: alg
                }
            });
    }
}
async function $e0734e0b78b64dca$var$importJwk(alg, jwk) {
    const { ext: ext, key_ops: key_ops, use: use, ...key } = jwk;
    return crypto.subtle.importKey('jwk', key, $e0734e0b78b64dca$var$algToSubtle(alg), true, [
        'verify'
    ]);
}
async function $e0734e0b78b64dca$export$294e577320311324(as, client, clientAuthentication, parameters, options) {
    $e0734e0b78b64dca$var$assertAs(as);
    $e0734e0b78b64dca$var$assertClient(client);
    const url = $e0734e0b78b64dca$export$48b88e4e5ecac119(as, 'device_authorization_endpoint', client.use_mtls_endpoint_aliases, options?.[$e0734e0b78b64dca$export$7df29a6c2173f26b] !== true);
    const body = new URLSearchParams(parameters);
    body.set('client_id', client.client_id);
    const headers = $e0734e0b78b64dca$var$prepareHeaders(options?.headers);
    headers.set('accept', 'application/json');
    return $e0734e0b78b64dca$var$authenticatedRequest(as, client, clientAuthentication, url, body, headers, options);
}
async function $e0734e0b78b64dca$export$15321a02b54ab69c(as, client, response) {
    $e0734e0b78b64dca$var$assertAs(as);
    $e0734e0b78b64dca$var$assertClient(client);
    if (!$e0734e0b78b64dca$var$looseInstanceOf(response, Response)) throw $e0734e0b78b64dca$var$CodedTypeError('"response" must be an instance of Response', $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
    await $e0734e0b78b64dca$var$checkOAuthBodyError(response, 200, 'Device Authorization Endpoint');
    $e0734e0b78b64dca$var$assertReadableResponse(response);
    const json = await $e0734e0b78b64dca$var$getResponseJsonBody(response);
    $e0734e0b78b64dca$var$assertString(json.device_code, '"response" body "device_code" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    $e0734e0b78b64dca$var$assertString(json.user_code, '"response" body "user_code" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    $e0734e0b78b64dca$var$assertString(json.verification_uri, '"response" body "verification_uri" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    let expiresIn = typeof json.expires_in !== 'number' ? parseFloat(json.expires_in) : json.expires_in;
    $e0734e0b78b64dca$var$assertNumber(expiresIn, true, '"response" body "expires_in" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    json.expires_in = expiresIn;
    if (json.verification_uri_complete !== undefined) $e0734e0b78b64dca$var$assertString(json.verification_uri_complete, '"response" body "verification_uri_complete" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    if (json.interval !== undefined) $e0734e0b78b64dca$var$assertNumber(json.interval, false, '"response" body "interval" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    return json;
}
async function $e0734e0b78b64dca$export$ee649bdc49166378(as, client, clientAuthentication, deviceCode, options) {
    $e0734e0b78b64dca$var$assertAs(as);
    $e0734e0b78b64dca$var$assertClient(client);
    $e0734e0b78b64dca$var$assertString(deviceCode, '"deviceCode"');
    const parameters = new URLSearchParams(options?.additionalParameters);
    parameters.set('device_code', deviceCode);
    return $e0734e0b78b64dca$var$tokenEndpointRequest(as, client, clientAuthentication, 'urn:ietf:params:oauth:grant-type:device_code', parameters, options);
}
async function $e0734e0b78b64dca$export$aeb5a01475f96b14(as, client, response, options) {
    return $e0734e0b78b64dca$var$processGenericAccessTokenResponse(as, client, response, undefined, options?.[$e0734e0b78b64dca$export$fe968a6742b93a36], options?.recognizedTokenTypes);
}
async function $e0734e0b78b64dca$export$a949d36eab55b41f(alg, options) {
    $e0734e0b78b64dca$var$assertString(alg, '"alg"');
    const algorithm = $e0734e0b78b64dca$var$algToSubtle(alg);
    if (alg.startsWith('PS') || alg.startsWith('RS')) Object.assign(algorithm, {
        modulusLength: options?.modulusLength ?? 2048,
        publicExponent: new Uint8Array([
            0x01,
            0x00,
            0x01
        ])
    });
    return crypto.subtle.generateKey(algorithm, options?.extractable ?? false, [
        'sign',
        'verify'
    ]);
}
function $e0734e0b78b64dca$var$normalizeHtu(htu) {
    const url = new URL(htu);
    url.search = '';
    url.hash = '';
    return url.href;
}
async function $e0734e0b78b64dca$var$validateDPoP(request, accessToken, accessTokenClaims, options) {
    const headerValue = request.headers.get('dpop');
    if (headerValue === null) throw $e0734e0b78b64dca$var$OPE('operation indicated DPoP use but the request has no DPoP HTTP Header', $e0734e0b78b64dca$export$c77b2f9ece3946ce, {
        headers: request.headers
    });
    if (request.headers.get('authorization')?.toLowerCase().startsWith('dpop ') === false) throw $e0734e0b78b64dca$var$OPE(`operation indicated DPoP use but the request's Authorization HTTP Header scheme is not DPoP`, $e0734e0b78b64dca$export$c77b2f9ece3946ce, {
        headers: request.headers
    });
    if (typeof accessTokenClaims.cnf?.jkt !== 'string') throw $e0734e0b78b64dca$var$OPE('operation indicated DPoP use but the JWT Access Token has no jkt confirmation claim', $e0734e0b78b64dca$export$c77b2f9ece3946ce, {
        claims: accessTokenClaims
    });
    const clockSkew = $e0734e0b78b64dca$var$getClockSkew(options);
    const proof = await $e0734e0b78b64dca$var$validateJwt(headerValue, $e0734e0b78b64dca$var$checkSigningAlgorithm.bind(undefined, options?.signingAlgorithms, undefined, $e0734e0b78b64dca$var$supported), clockSkew, $e0734e0b78b64dca$var$getClockTolerance(options), undefined).then($e0734e0b78b64dca$var$checkJwtType.bind(undefined, 'dpop+jwt')).then($e0734e0b78b64dca$var$validatePresence.bind(undefined, [
        'iat',
        'jti',
        'ath',
        'htm',
        'htu'
    ]));
    const now = $e0734e0b78b64dca$var$epochTime() + clockSkew;
    const diff = Math.abs(now - proof.claims.iat);
    if (diff > 300) throw $e0734e0b78b64dca$var$OPE('DPoP Proof iat is not recent enough', $e0734e0b78b64dca$export$e256757118ff9e88, {
        now: now,
        claims: proof.claims,
        claim: 'iat'
    });
    if (proof.claims.htm !== request.method) throw $e0734e0b78b64dca$var$OPE('DPoP Proof htm mismatch', $e0734e0b78b64dca$export$755cfb9d9708df13, {
        expected: request.method,
        claims: proof.claims,
        claim: 'htm'
    });
    if (typeof proof.claims.htu !== 'string' || $e0734e0b78b64dca$var$normalizeHtu(proof.claims.htu) !== $e0734e0b78b64dca$var$normalizeHtu(request.url)) throw $e0734e0b78b64dca$var$OPE('DPoP Proof htu mismatch', $e0734e0b78b64dca$export$755cfb9d9708df13, {
        expected: $e0734e0b78b64dca$var$normalizeHtu(request.url),
        claims: proof.claims,
        claim: 'htu'
    });
    {
        const expected = $e0734e0b78b64dca$var$b64u(await crypto.subtle.digest('SHA-256', $e0734e0b78b64dca$var$buf(accessToken)));
        if (proof.claims.ath !== expected) throw $e0734e0b78b64dca$var$OPE('DPoP Proof ath mismatch', $e0734e0b78b64dca$export$755cfb9d9708df13, {
            expected: expected,
            claims: proof.claims,
            claim: 'ath'
        });
    }
    {
        const expected = await $e0734e0b78b64dca$var$calculateJwkThumbprint(proof.header.jwk);
        if (accessTokenClaims.cnf.jkt !== expected) throw $e0734e0b78b64dca$var$OPE('JWT Access Token confirmation mismatch', $e0734e0b78b64dca$export$755cfb9d9708df13, {
            expected: expected,
            claims: accessTokenClaims,
            claim: 'cnf.jkt'
        });
    }
    const { 0: protectedHeader, 1: payload, 2: encodedSignature } = headerValue.split('.');
    const signature = $e0734e0b78b64dca$var$b64u(encodedSignature);
    const { jwk: jwk, alg: alg } = proof.header;
    if (!jwk) throw $e0734e0b78b64dca$var$OPE('DPoP Proof is missing the jwk header parameter', $e0734e0b78b64dca$export$c77b2f9ece3946ce, {
        header: proof.header
    });
    const key = await $e0734e0b78b64dca$var$importJwk(alg, jwk);
    if (key.type !== 'public') throw $e0734e0b78b64dca$var$OPE('DPoP Proof jwk header parameter must contain a public key', $e0734e0b78b64dca$export$c77b2f9ece3946ce, {
        header: proof.header
    });
    await $e0734e0b78b64dca$var$validateJwsSignature(protectedHeader, payload, key, signature);
}
async function $e0734e0b78b64dca$export$ead574608b562098(as, request, expectedAudience, options) {
    $e0734e0b78b64dca$var$assertAs(as);
    if (!$e0734e0b78b64dca$var$looseInstanceOf(request, Request)) throw $e0734e0b78b64dca$var$CodedTypeError('"request" must be an instance of Request', $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
    $e0734e0b78b64dca$var$assertString(expectedAudience, '"expectedAudience"');
    const authorization = request.headers.get('authorization');
    if (authorization === null) throw $e0734e0b78b64dca$var$OPE('"request" is missing an Authorization HTTP Header', $e0734e0b78b64dca$export$c77b2f9ece3946ce, {
        headers: request.headers
    });
    let { 0: scheme, 1: accessToken, length: length } = authorization.split(' ');
    scheme = scheme.toLowerCase();
    switch(scheme){
        case 'dpop':
        case 'bearer':
            break;
        default:
            throw new $e0734e0b78b64dca$export$ab59e00737fb22e6('unsupported Authorization HTTP Header scheme', {
                cause: {
                    headers: request.headers
                }
            });
    }
    if (length !== 2) throw $e0734e0b78b64dca$var$OPE('invalid Authorization HTTP Header format', $e0734e0b78b64dca$export$c77b2f9ece3946ce, {
        headers: request.headers
    });
    const requiredClaims = [
        'iss',
        'exp',
        'aud',
        'sub',
        'iat',
        'jti',
        'client_id'
    ];
    if (options?.requireDPoP || scheme === 'dpop' || request.headers.has('dpop')) requiredClaims.push('cnf');
    const { claims: claims, header: header } = await $e0734e0b78b64dca$var$validateJwt(accessToken, $e0734e0b78b64dca$var$checkSigningAlgorithm.bind(undefined, options?.signingAlgorithms, undefined, $e0734e0b78b64dca$var$supported), $e0734e0b78b64dca$var$getClockSkew(options), $e0734e0b78b64dca$var$getClockTolerance(options), undefined).then($e0734e0b78b64dca$var$checkJwtType.bind(undefined, 'at+jwt')).then($e0734e0b78b64dca$var$validatePresence.bind(undefined, requiredClaims)).then($e0734e0b78b64dca$var$validateIssuer.bind(undefined, as)).then($e0734e0b78b64dca$var$validateAudience.bind(undefined, expectedAudience)).catch($e0734e0b78b64dca$var$reassignRSCode);
    for (const claim of [
        'client_id',
        'jti',
        'sub'
    ]){
        if (typeof claims[claim] !== 'string') throw $e0734e0b78b64dca$var$OPE(`unexpected JWT "${claim}" claim type`, $e0734e0b78b64dca$export$c77b2f9ece3946ce, {
            claims: claims
        });
    }
    if ('cnf' in claims) {
        if (!$e0734e0b78b64dca$var$isJsonObject(claims.cnf)) throw $e0734e0b78b64dca$var$OPE('unexpected JWT "cnf" (confirmation) claim value', $e0734e0b78b64dca$export$c77b2f9ece3946ce, {
            claims: claims
        });
        const { 0: cnf, length: length } = Object.keys(claims.cnf);
        if (length) {
            if (length !== 1) throw new $e0734e0b78b64dca$export$ab59e00737fb22e6('multiple confirmation claims are not supported', {
                cause: {
                    claims: claims
                }
            });
            if (cnf !== 'jkt') throw new $e0734e0b78b64dca$export$ab59e00737fb22e6('unsupported JWT Confirmation method', {
                cause: {
                    claims: claims
                }
            });
        }
    }
    const { 0: protectedHeader, 1: payload, 2: encodedSignature } = accessToken.split('.');
    const signature = $e0734e0b78b64dca$var$b64u(encodedSignature);
    const key = await $e0734e0b78b64dca$var$getPublicSigKeyFromIssuerJwksUri(as, options, header);
    await $e0734e0b78b64dca$var$validateJwsSignature(protectedHeader, payload, key, signature);
    if (options?.requireDPoP || scheme === 'dpop' || claims.cnf?.jkt !== undefined || request.headers.has('dpop')) await $e0734e0b78b64dca$var$validateDPoP(request, accessToken, claims, options).catch($e0734e0b78b64dca$var$reassignRSCode);
    return claims;
}
function $e0734e0b78b64dca$var$reassignRSCode(err) {
    if (err instanceof $e0734e0b78b64dca$export$aa6a6a0f7f354fbf && err?.code === $e0734e0b78b64dca$export$c77b2f9ece3946ce) err.code = $e0734e0b78b64dca$export$a95f69ec43d8404;
    throw err;
}
async function $e0734e0b78b64dca$export$ea7d44245d53d41e(as, client, clientAuthentication, parameters, options) {
    $e0734e0b78b64dca$var$assertAs(as);
    $e0734e0b78b64dca$var$assertClient(client);
    const url = $e0734e0b78b64dca$export$48b88e4e5ecac119(as, 'backchannel_authentication_endpoint', client.use_mtls_endpoint_aliases, options?.[$e0734e0b78b64dca$export$7df29a6c2173f26b] !== true);
    const body = new URLSearchParams(parameters);
    body.set('client_id', client.client_id);
    const headers = $e0734e0b78b64dca$var$prepareHeaders(options?.headers);
    headers.set('accept', 'application/json');
    return $e0734e0b78b64dca$var$authenticatedRequest(as, client, clientAuthentication, url, body, headers, options);
}
async function $e0734e0b78b64dca$export$2ded870eef8da757(as, client, response) {
    $e0734e0b78b64dca$var$assertAs(as);
    $e0734e0b78b64dca$var$assertClient(client);
    if (!$e0734e0b78b64dca$var$looseInstanceOf(response, Response)) throw $e0734e0b78b64dca$var$CodedTypeError('"response" must be an instance of Response', $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
    await $e0734e0b78b64dca$var$checkOAuthBodyError(response, 200, 'Backchannel Authentication Endpoint');
    $e0734e0b78b64dca$var$assertReadableResponse(response);
    const json = await $e0734e0b78b64dca$var$getResponseJsonBody(response);
    $e0734e0b78b64dca$var$assertString(json.auth_req_id, '"response" body "auth_req_id" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    let expiresIn = typeof json.expires_in !== 'number' ? parseFloat(json.expires_in) : json.expires_in;
    $e0734e0b78b64dca$var$assertNumber(expiresIn, true, '"response" body "expires_in" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    json.expires_in = expiresIn;
    if (json.interval !== undefined) $e0734e0b78b64dca$var$assertNumber(json.interval, false, '"response" body "interval" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    return json;
}
async function $e0734e0b78b64dca$export$287a788838ab9583(as, client, clientAuthentication, authReqId, options) {
    $e0734e0b78b64dca$var$assertAs(as);
    $e0734e0b78b64dca$var$assertClient(client);
    $e0734e0b78b64dca$var$assertString(authReqId, '"authReqId"');
    const parameters = new URLSearchParams(options?.additionalParameters);
    parameters.set('auth_req_id', authReqId);
    return $e0734e0b78b64dca$var$tokenEndpointRequest(as, client, clientAuthentication, 'urn:openid:params:grant-type:ciba', parameters, options);
}
async function $e0734e0b78b64dca$export$52147d87e73f0b0(as, client, response, options) {
    return $e0734e0b78b64dca$var$processGenericAccessTokenResponse(as, client, response, undefined, options?.[$e0734e0b78b64dca$export$fe968a6742b93a36], options?.recognizedTokenTypes);
}
async function $e0734e0b78b64dca$export$eac8c7b33276e8ed(as, metadata, options) {
    $e0734e0b78b64dca$var$assertAs(as);
    const url = $e0734e0b78b64dca$export$48b88e4e5ecac119(as, 'registration_endpoint', metadata.use_mtls_endpoint_aliases, options?.[$e0734e0b78b64dca$export$7df29a6c2173f26b] !== true);
    const headers = $e0734e0b78b64dca$var$prepareHeaders(options?.headers);
    headers.set('accept', 'application/json');
    headers.set('content-type', 'application/json');
    const method = 'POST';
    if (options?.DPoP) {
        $e0734e0b78b64dca$var$assertDPoP(options.DPoP);
        await options.DPoP.addProof(url, headers, method, options.initialAccessToken);
    }
    if (options?.initialAccessToken) headers.set('authorization', `${headers.has('dpop') ? 'DPoP' : 'Bearer'} ${options.initialAccessToken}`);
    const response = await (options?.[$e0734e0b78b64dca$export$1512182a095696a1] || fetch)(url.href, {
        body: JSON.stringify(metadata),
        headers: Object.fromEntries(headers.entries()),
        method: method,
        redirect: 'manual',
        signal: $e0734e0b78b64dca$var$signal(url, options?.signal)
    });
    options?.DPoP?.cacheNonce(response);
    return response;
}
async function $e0734e0b78b64dca$export$8d16851174446714(response) {
    if (!$e0734e0b78b64dca$var$looseInstanceOf(response, Response)) throw $e0734e0b78b64dca$var$CodedTypeError('"response" must be an instance of Response', $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
    await $e0734e0b78b64dca$var$checkOAuthBodyError(response, 201, 'Dynamic Client Registration Endpoint');
    $e0734e0b78b64dca$var$assertReadableResponse(response);
    const json = await $e0734e0b78b64dca$var$getResponseJsonBody(response);
    $e0734e0b78b64dca$var$assertString(json.client_id, '"response" body "client_id" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    if (json.client_secret !== undefined) $e0734e0b78b64dca$var$assertString(json.client_secret, '"response" body "client_secret" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    if (json.client_secret) $e0734e0b78b64dca$var$assertNumber(json.client_secret_expires_at, true, '"response" body "client_secret_expires_at" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    return json;
}
async function $e0734e0b78b64dca$export$d6e3cf12de55388f(resourceIdentifier, options) {
    return $e0734e0b78b64dca$var$performDiscovery(resourceIdentifier, 'resourceIdentifier', (url)=>{
        $e0734e0b78b64dca$var$prependWellKnown(url, '.well-known/oauth-protected-resource', true);
        return url;
    }, options);
}
async function $e0734e0b78b64dca$export$77afd26e5bb42f6c(expectedResourceIdentifier, response) {
    const expected = expectedResourceIdentifier;
    if (!(expected instanceof URL) && expected !== $e0734e0b78b64dca$export$910be5ca85535298) throw $e0734e0b78b64dca$var$CodedTypeError('"expectedResourceIdentifier" must be an instance of URL', $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
    if (!$e0734e0b78b64dca$var$looseInstanceOf(response, Response)) throw $e0734e0b78b64dca$var$CodedTypeError('"response" must be an instance of Response', $e0734e0b78b64dca$var$ERR_INVALID_ARG_TYPE);
    if (response.status !== 200) throw $e0734e0b78b64dca$var$OPE('"response" is not a conform Resource Server Metadata response (unexpected HTTP status code)', $e0734e0b78b64dca$export$d685a0ca6b1d1c11, response);
    $e0734e0b78b64dca$var$assertReadableResponse(response);
    const json = await $e0734e0b78b64dca$var$getResponseJsonBody(response);
    $e0734e0b78b64dca$var$assertString(json.resource, '"response" body "resource" property', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    if (expected !== $e0734e0b78b64dca$export$910be5ca85535298 && new URL(json.resource).href !== expected.href) throw $e0734e0b78b64dca$var$OPE('"response" body "resource" property does not match the expected value', $e0734e0b78b64dca$export$cbbd45b2b4b65c94, {
        expected: expected.href,
        body: json,
        attribute: 'resource'
    });
    return json;
}
async function $e0734e0b78b64dca$var$getResponseJsonBody(response, check = $e0734e0b78b64dca$var$assertApplicationJson) {
    let json;
    try {
        json = await response.json();
    } catch (cause) {
        check(response);
        throw $e0734e0b78b64dca$var$OPE('failed to parse "response" body as JSON', $e0734e0b78b64dca$export$2ecaad7eb5cc1f25, cause);
    }
    if (!$e0734e0b78b64dca$var$isJsonObject(json)) throw $e0734e0b78b64dca$var$OPE('"response" body must be a top level object', $e0734e0b78b64dca$export$a95f69ec43d8404, {
        body: json
    });
    return json;
}
const $e0734e0b78b64dca$export$8e784e4973df155b = $e0734e0b78b64dca$export$45246453d97b4076;
const $e0734e0b78b64dca$export$910be5ca85535298 = Symbol();
const $e0734e0b78b64dca$export$40bb94adbb055b3 = Symbol();


const $caa972a0b0381267$export$5486af06137bf21a = new TextEncoder();
const $caa972a0b0381267$export$124c96e6ce37090b = new TextDecoder();
const $caa972a0b0381267$var$MAX_INT32 = 2 ** 32;
function $caa972a0b0381267$export$ee1b3e54f0441b22(...buffers) {
    const size = buffers.reduce((acc, { length: length })=>acc + length, 0);
    const buf = new Uint8Array(size);
    let i = 0;
    for (const buffer of buffers){
        buf.set(buffer, i);
        i += buffer.length;
    }
    return buf;
}
function $caa972a0b0381267$var$writeUInt32BE(buf, value, offset) {
    if (value < 0 || value >= $caa972a0b0381267$var$MAX_INT32) throw new RangeError(`value must be >= 0 and <= ${$caa972a0b0381267$var$MAX_INT32 - 1}. Received ${value}`);
    buf.set([
        value >>> 24,
        value >>> 16,
        value >>> 8,
        value & 0xff
    ], offset);
}
function $caa972a0b0381267$export$e7b531e00a18fdd7(value) {
    const high = Math.floor(value / $caa972a0b0381267$var$MAX_INT32);
    const low = value % $caa972a0b0381267$var$MAX_INT32;
    const buf = new Uint8Array(8);
    $caa972a0b0381267$var$writeUInt32BE(buf, high, 0);
    $caa972a0b0381267$var$writeUInt32BE(buf, low, 4);
    return buf;
}
function $caa972a0b0381267$export$74c16dba6c885532(value) {
    const buf = new Uint8Array(4);
    $caa972a0b0381267$var$writeUInt32BE(buf, value);
    return buf;
}


function $9818cdd72f29fa4c$export$8fb536984ec8b4d7(input) {
    if (Uint8Array.prototype.toBase64) return input.toBase64();
    const CHUNK_SIZE = 0x8000;
    const arr = [];
    for(let i = 0; i < input.length; i += CHUNK_SIZE)arr.push(String.fromCharCode.apply(null, input.subarray(i, i + CHUNK_SIZE)));
    return btoa(arr.join(''));
}
function $9818cdd72f29fa4c$export$94fdf11bafc8de6b(encoded) {
    if (Uint8Array.fromBase64) return Uint8Array.fromBase64(encoded);
    const binary = atob(encoded);
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return bytes;
}


function $21428bcf7069d091$export$2f872c0f2117be69(input) {
    if (Uint8Array.fromBase64) return Uint8Array.fromBase64(typeof input === 'string' ? input : (0, $caa972a0b0381267$export$124c96e6ce37090b).decode(input), {
        alphabet: 'base64url'
    });
    let encoded = input;
    if (encoded instanceof Uint8Array) encoded = (0, $caa972a0b0381267$export$124c96e6ce37090b).decode(encoded);
    encoded = encoded.replace(/-/g, '+').replace(/_/g, '/').replace(/\s/g, '');
    try {
        return (0, $9818cdd72f29fa4c$export$94fdf11bafc8de6b)(encoded);
    } catch  {
        throw new TypeError('The input to be decoded is not correctly encoded.');
    }
}
function $21428bcf7069d091$export$c564cdbbe6da493(input) {
    let unencoded = input;
    if (typeof unencoded === 'string') unencoded = (0, $caa972a0b0381267$export$5486af06137bf21a).encode(unencoded);
    if (Uint8Array.prototype.toBase64) return unencoded.toBase64({
        alphabet: 'base64url',
        omitPadding: true
    });
    return (0, $9818cdd72f29fa4c$export$8fb536984ec8b4d7)(unencoded).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}



class $be9270265a128b70$export$f754d6850d76bf87 extends Error {
    static code = 'ERR_JOSE_GENERIC';
    code = 'ERR_JOSE_GENERIC';
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
        Error.captureStackTrace?.(this, this.constructor);
    }
}
class $be9270265a128b70$export$f1e14efb908196e9 extends $be9270265a128b70$export$f754d6850d76bf87 {
    static code = 'ERR_JWT_CLAIM_VALIDATION_FAILED';
    code = 'ERR_JWT_CLAIM_VALIDATION_FAILED';
    claim;
    reason;
    payload;
    constructor(message, payload, claim = 'unspecified', reason = 'unspecified'){
        super(message, {
            cause: {
                claim: claim,
                reason: reason,
                payload: payload
            }
        });
        this.claim = claim;
        this.reason = reason;
        this.payload = payload;
    }
}
class $be9270265a128b70$export$4b386bf852b7863d extends $be9270265a128b70$export$f754d6850d76bf87 {
    static code = 'ERR_JWT_EXPIRED';
    code = 'ERR_JWT_EXPIRED';
    claim;
    reason;
    payload;
    constructor(message, payload, claim = 'unspecified', reason = 'unspecified'){
        super(message, {
            cause: {
                claim: claim,
                reason: reason,
                payload: payload
            }
        });
        this.claim = claim;
        this.reason = reason;
        this.payload = payload;
    }
}
class $be9270265a128b70$export$d51fd7fedeccc338 extends $be9270265a128b70$export$f754d6850d76bf87 {
    static code = 'ERR_JOSE_ALG_NOT_ALLOWED';
    code = 'ERR_JOSE_ALG_NOT_ALLOWED';
}
class $be9270265a128b70$export$19ddbcbf2016ab28 extends $be9270265a128b70$export$f754d6850d76bf87 {
    static code = 'ERR_JOSE_NOT_SUPPORTED';
    code = 'ERR_JOSE_NOT_SUPPORTED';
}
class $be9270265a128b70$export$1a57512ad9773b2a extends $be9270265a128b70$export$f754d6850d76bf87 {
    static code = 'ERR_JWE_DECRYPTION_FAILED';
    code = 'ERR_JWE_DECRYPTION_FAILED';
    constructor(message = 'decryption operation failed', options){
        super(message, options);
    }
}
class $be9270265a128b70$export$19f281f2275f6a15 extends $be9270265a128b70$export$f754d6850d76bf87 {
    static code = 'ERR_JWE_INVALID';
    code = 'ERR_JWE_INVALID';
}
class $be9270265a128b70$export$e838de724af3d116 extends $be9270265a128b70$export$f754d6850d76bf87 {
    static code = 'ERR_JWS_INVALID';
    code = 'ERR_JWS_INVALID';
}
class $be9270265a128b70$export$936b39ada0bbfceb extends $be9270265a128b70$export$f754d6850d76bf87 {
    static code = 'ERR_JWT_INVALID';
    code = 'ERR_JWT_INVALID';
}
class $be9270265a128b70$export$b3992e0f88fb07e3 extends $be9270265a128b70$export$f754d6850d76bf87 {
    static code = 'ERR_JWK_INVALID';
    code = 'ERR_JWK_INVALID';
}
class $be9270265a128b70$export$9b22c2a1e2403b8e extends $be9270265a128b70$export$f754d6850d76bf87 {
    static code = 'ERR_JWKS_INVALID';
    code = 'ERR_JWKS_INVALID';
}
class $be9270265a128b70$export$3d5ed1a538bed04e extends $be9270265a128b70$export$f754d6850d76bf87 {
    static code = 'ERR_JWKS_NO_MATCHING_KEY';
    code = 'ERR_JWKS_NO_MATCHING_KEY';
    constructor(message = 'no applicable key found in the JSON Web Key Set', options){
        super(message, options);
    }
}
class $be9270265a128b70$export$dc036de401a5c284 extends $be9270265a128b70$export$f754d6850d76bf87 {
    [Symbol.asyncIterator];
    static code = 'ERR_JWKS_MULTIPLE_MATCHING_KEYS';
    code = 'ERR_JWKS_MULTIPLE_MATCHING_KEYS';
    constructor(message = 'multiple matching keys found in the JSON Web Key Set', options){
        super(message, options);
    }
}
class $be9270265a128b70$export$3f30acebf25c04e6 extends $be9270265a128b70$export$f754d6850d76bf87 {
    static code = 'ERR_JWKS_TIMEOUT';
    code = 'ERR_JWKS_TIMEOUT';
    constructor(message = 'request timed out', options){
        super(message, options);
    }
}
class $be9270265a128b70$export$c67a0218e7c50378 extends $be9270265a128b70$export$f754d6850d76bf87 {
    static code = 'ERR_JWS_SIGNATURE_VERIFICATION_FAILED';
    code = 'ERR_JWS_SIGNATURE_VERIFICATION_FAILED';
    constructor(message = 'signature verification failed', options){
        super(message, options);
    }
}



function $2f9ce74d750f43eb$export$db433e85ac514a95(alg) {
    switch(alg){
        case 'A128GCM':
        case 'A128GCMKW':
        case 'A192GCM':
        case 'A192GCMKW':
        case 'A256GCM':
        case 'A256GCMKW':
            return 96;
        case 'A128CBC-HS256':
        case 'A192CBC-HS384':
        case 'A256CBC-HS512':
            return 128;
        default:
            throw new (0, $be9270265a128b70$export$19ddbcbf2016ab28)(`Unsupported JWE Algorithm: ${alg}`);
    }
}
var $2f9ce74d750f43eb$export$2e2bcd8739ae039 = (alg)=>crypto.getRandomValues(new Uint8Array($2f9ce74d750f43eb$export$db433e85ac514a95(alg) >> 3));


var $dd2f89fae20dcc49$export$2e2bcd8739ae039 = (enc, iv)=>{
    if (iv.length << 3 !== (0, $2f9ce74d750f43eb$export$db433e85ac514a95)(enc)) throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('Invalid Initialization Vector length');
};



var $0ed8827f97f2be0c$export$2e2bcd8739ae039 = (cek, expected)=>{
    const actual = cek.byteLength << 3;
    if (actual !== expected) throw new (0, $be9270265a128b70$export$19f281f2275f6a15)(`Invalid Content Encryption Key length. Expected ${expected} bits, got ${actual} bits`);
};



function $6b065c055cfb3c64$var$unusable(name, prop = 'algorithm.name') {
    return new TypeError(`CryptoKey does not support this operation, its ${prop} must be ${name}`);
}
function $6b065c055cfb3c64$var$isAlgorithm(algorithm, name) {
    return algorithm.name === name;
}
function $6b065c055cfb3c64$var$getHashLength(hash) {
    return parseInt(hash.name.slice(4), 10);
}
function $6b065c055cfb3c64$var$getNamedCurve(alg) {
    switch(alg){
        case 'ES256':
            return 'P-256';
        case 'ES384':
            return 'P-384';
        case 'ES512':
            return 'P-521';
        default:
            throw new Error('unreachable');
    }
}
function $6b065c055cfb3c64$var$checkUsage(key, usage) {
    if (usage && !key.usages.includes(usage)) throw new TypeError(`CryptoKey does not support this operation, its usages must include ${usage}.`);
}
function $6b065c055cfb3c64$export$39a36029eee6729(key, alg, usage) {
    switch(alg){
        case 'HS256':
        case 'HS384':
        case 'HS512':
            {
                if (!$6b065c055cfb3c64$var$isAlgorithm(key.algorithm, 'HMAC')) throw $6b065c055cfb3c64$var$unusable('HMAC');
                const expected = parseInt(alg.slice(2), 10);
                const actual = $6b065c055cfb3c64$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $6b065c055cfb3c64$var$unusable(`SHA-${expected}`, 'algorithm.hash');
                break;
            }
        case 'RS256':
        case 'RS384':
        case 'RS512':
            {
                if (!$6b065c055cfb3c64$var$isAlgorithm(key.algorithm, 'RSASSA-PKCS1-v1_5')) throw $6b065c055cfb3c64$var$unusable('RSASSA-PKCS1-v1_5');
                const expected = parseInt(alg.slice(2), 10);
                const actual = $6b065c055cfb3c64$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $6b065c055cfb3c64$var$unusable(`SHA-${expected}`, 'algorithm.hash');
                break;
            }
        case 'PS256':
        case 'PS384':
        case 'PS512':
            {
                if (!$6b065c055cfb3c64$var$isAlgorithm(key.algorithm, 'RSA-PSS')) throw $6b065c055cfb3c64$var$unusable('RSA-PSS');
                const expected = parseInt(alg.slice(2), 10);
                const actual = $6b065c055cfb3c64$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $6b065c055cfb3c64$var$unusable(`SHA-${expected}`, 'algorithm.hash');
                break;
            }
        case 'Ed25519':
        case 'EdDSA':
            if (!$6b065c055cfb3c64$var$isAlgorithm(key.algorithm, 'Ed25519')) throw $6b065c055cfb3c64$var$unusable('Ed25519');
            break;
        case 'ML-DSA-44':
        case 'ML-DSA-65':
        case 'ML-DSA-87':
            if (!$6b065c055cfb3c64$var$isAlgorithm(key.algorithm, alg)) throw $6b065c055cfb3c64$var$unusable(alg);
            break;
        case 'ES256':
        case 'ES384':
        case 'ES512':
            {
                if (!$6b065c055cfb3c64$var$isAlgorithm(key.algorithm, 'ECDSA')) throw $6b065c055cfb3c64$var$unusable('ECDSA');
                const expected = $6b065c055cfb3c64$var$getNamedCurve(alg);
                const actual = key.algorithm.namedCurve;
                if (actual !== expected) throw $6b065c055cfb3c64$var$unusable(expected, 'algorithm.namedCurve');
                break;
            }
        default:
            throw new TypeError('CryptoKey does not support this operation');
    }
    $6b065c055cfb3c64$var$checkUsage(key, usage);
}
function $6b065c055cfb3c64$export$41a67f89f6678b35(key, alg, usage) {
    switch(alg){
        case 'A128GCM':
        case 'A192GCM':
        case 'A256GCM':
            {
                if (!$6b065c055cfb3c64$var$isAlgorithm(key.algorithm, 'AES-GCM')) throw $6b065c055cfb3c64$var$unusable('AES-GCM');
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $6b065c055cfb3c64$var$unusable(expected, 'algorithm.length');
                break;
            }
        case 'A128KW':
        case 'A192KW':
        case 'A256KW':
            {
                if (!$6b065c055cfb3c64$var$isAlgorithm(key.algorithm, 'AES-KW')) throw $6b065c055cfb3c64$var$unusable('AES-KW');
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $6b065c055cfb3c64$var$unusable(expected, 'algorithm.length');
                break;
            }
        case 'ECDH':
            switch(key.algorithm.name){
                case 'ECDH':
                case 'X25519':
                    break;
                default:
                    throw $6b065c055cfb3c64$var$unusable('ECDH or X25519');
            }
            break;
        case 'PBES2-HS256+A128KW':
        case 'PBES2-HS384+A192KW':
        case 'PBES2-HS512+A256KW':
            if (!$6b065c055cfb3c64$var$isAlgorithm(key.algorithm, 'PBKDF2')) throw $6b065c055cfb3c64$var$unusable('PBKDF2');
            break;
        case 'RSA-OAEP':
        case 'RSA-OAEP-256':
        case 'RSA-OAEP-384':
        case 'RSA-OAEP-512':
            {
                if (!$6b065c055cfb3c64$var$isAlgorithm(key.algorithm, 'RSA-OAEP')) throw $6b065c055cfb3c64$var$unusable('RSA-OAEP');
                const expected = parseInt(alg.slice(9), 10) || 1;
                const actual = $6b065c055cfb3c64$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $6b065c055cfb3c64$var$unusable(`SHA-${expected}`, 'algorithm.hash');
                break;
            }
        default:
            throw new TypeError('CryptoKey does not support this operation');
    }
    $6b065c055cfb3c64$var$checkUsage(key, usage);
}


function $d00aeb1d1157a477$var$message(msg, actual, ...types) {
    types = types.filter(Boolean);
    if (types.length > 2) {
        const last = types.pop();
        msg += `one of type ${types.join(', ')}, or ${last}.`;
    } else if (types.length === 2) msg += `one of type ${types[0]} or ${types[1]}.`;
    else msg += `of type ${types[0]}.`;
    if (actual == null) msg += ` Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += ` Received function ${actual.name}`;
    else if (typeof actual === 'object' && actual != null) {
        if (actual.constructor?.name) msg += ` Received an instance of ${actual.constructor.name}`;
    }
    return msg;
}
var $d00aeb1d1157a477$export$2e2bcd8739ae039 = (actual, ...types)=>{
    return $d00aeb1d1157a477$var$message('Key must be ', actual, ...types);
};
function $d00aeb1d1157a477$export$e94f758d09bc1828(alg, actual, ...types) {
    return $d00aeb1d1157a477$var$message(`Key for the ${alg} algorithm must be `, actual, ...types);
}


function $a67a99484c2356b1$export$af46c52e955d1475(key) {
    if (!$a67a99484c2356b1$export$600b5603bbac4c6(key)) throw new Error('CryptoKey instance expected');
}
function $a67a99484c2356b1$export$600b5603bbac4c6(key) {
    return key?.[Symbol.toStringTag] === 'CryptoKey';
}
function $a67a99484c2356b1$export$5c7abba3d2afc0b8(key) {
    return key?.[Symbol.toStringTag] === 'KeyObject';
}
var $a67a99484c2356b1$export$2e2bcd8739ae039 = (key)=>{
    return $a67a99484c2356b1$export$600b5603bbac4c6(key) || $a67a99484c2356b1$export$5c7abba3d2afc0b8(key);
};


async function $4f860b272f88a458$var$timingSafeEqual(a, b) {
    if (!(a instanceof Uint8Array)) throw new TypeError('First argument must be a buffer');
    if (!(b instanceof Uint8Array)) throw new TypeError('Second argument must be a buffer');
    const algorithm = {
        name: 'HMAC',
        hash: 'SHA-256'
    };
    const key = await crypto.subtle.generateKey(algorithm, false, [
        'sign'
    ]);
    const aHmac = new Uint8Array(await crypto.subtle.sign(algorithm, key, a));
    const bHmac = new Uint8Array(await crypto.subtle.sign(algorithm, key, b));
    let out = 0;
    let i = -1;
    while(++i < 32)out |= aHmac[i] ^ bHmac[i];
    return out === 0;
}
async function $4f860b272f88a458$var$cbcDecrypt(enc, cek, ciphertext, iv, tag, aad) {
    if (!(cek instanceof Uint8Array)) throw new TypeError((0, $d00aeb1d1157a477$export$2e2bcd8739ae039)(cek, 'Uint8Array'));
    const keySize = parseInt(enc.slice(1, 4), 10);
    const encKey = await crypto.subtle.importKey('raw', cek.subarray(keySize >> 3), 'AES-CBC', false, [
        'decrypt'
    ]);
    const macKey = await crypto.subtle.importKey('raw', cek.subarray(0, keySize >> 3), {
        hash: `SHA-${keySize << 1}`,
        name: 'HMAC'
    }, false, [
        'sign'
    ]);
    const macData = (0, $caa972a0b0381267$export$ee1b3e54f0441b22)(aad, iv, ciphertext, (0, $caa972a0b0381267$export$e7b531e00a18fdd7)(aad.length << 3));
    const expectedTag = new Uint8Array((await crypto.subtle.sign('HMAC', macKey, macData)).slice(0, keySize >> 3));
    let macCheckPassed;
    try {
        macCheckPassed = await $4f860b272f88a458$var$timingSafeEqual(tag, expectedTag);
    } catch  {}
    if (!macCheckPassed) throw new (0, $be9270265a128b70$export$1a57512ad9773b2a)();
    let plaintext;
    try {
        plaintext = new Uint8Array(await crypto.subtle.decrypt({
            iv: iv,
            name: 'AES-CBC'
        }, encKey, ciphertext));
    } catch  {}
    if (!plaintext) throw new (0, $be9270265a128b70$export$1a57512ad9773b2a)();
    return plaintext;
}
async function $4f860b272f88a458$var$gcmDecrypt(enc, cek, ciphertext, iv, tag, aad) {
    let encKey;
    if (cek instanceof Uint8Array) encKey = await crypto.subtle.importKey('raw', cek, 'AES-GCM', false, [
        'decrypt'
    ]);
    else {
        (0, $6b065c055cfb3c64$export$41a67f89f6678b35)(cek, enc, 'decrypt');
        encKey = cek;
    }
    try {
        return new Uint8Array(await crypto.subtle.decrypt({
            additionalData: aad,
            iv: iv,
            name: 'AES-GCM',
            tagLength: 128
        }, encKey, (0, $caa972a0b0381267$export$ee1b3e54f0441b22)(ciphertext, tag)));
    } catch  {
        throw new (0, $be9270265a128b70$export$1a57512ad9773b2a)();
    }
}
var $4f860b272f88a458$export$2e2bcd8739ae039 = async (enc, cek, ciphertext, iv, tag, aad)=>{
    if (!(0, $a67a99484c2356b1$export$600b5603bbac4c6)(cek) && !(cek instanceof Uint8Array)) throw new TypeError((0, $d00aeb1d1157a477$export$2e2bcd8739ae039)(cek, 'CryptoKey', 'KeyObject', 'Uint8Array', 'JSON Web Key'));
    if (!iv) throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('JWE Initialization Vector missing');
    if (!tag) throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('JWE Authentication Tag missing');
    (0, $dd2f89fae20dcc49$export$2e2bcd8739ae039)(enc, iv);
    switch(enc){
        case 'A128CBC-HS256':
        case 'A192CBC-HS384':
        case 'A256CBC-HS512':
            if (cek instanceof Uint8Array) (0, $0ed8827f97f2be0c$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(-3), 10));
            return $4f860b272f88a458$var$cbcDecrypt(enc, cek, ciphertext, iv, tag, aad);
        case 'A128GCM':
        case 'A192GCM':
        case 'A256GCM':
            if (cek instanceof Uint8Array) (0, $0ed8827f97f2be0c$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(1, 4), 10));
            return $4f860b272f88a458$var$gcmDecrypt(enc, cek, ciphertext, iv, tag, aad);
        default:
            throw new (0, $be9270265a128b70$export$19ddbcbf2016ab28)('Unsupported JWE Content Encryption Algorithm');
    }
};



var $58586c0fe8c58c3d$export$2e2bcd8739ae039 = (...headers)=>{
    const sources = headers.filter(Boolean);
    if (sources.length === 0 || sources.length === 1) return true;
    let acc;
    for (const header of sources){
        const parameters = Object.keys(header);
        if (!acc || acc.size === 0) {
            acc = new Set(parameters);
            continue;
        }
        for (const parameter of parameters){
            if (acc.has(parameter)) return false;
            acc.add(parameter);
        }
    }
    return true;
};


function $9ddacb35cc1fdfe6$var$isObjectLike(value) {
    return typeof value === 'object' && value !== null;
}
var $9ddacb35cc1fdfe6$export$2e2bcd8739ae039 = (input)=>{
    if (!$9ddacb35cc1fdfe6$var$isObjectLike(input) || Object.prototype.toString.call(input) !== '[object Object]') return false;
    if (Object.getPrototypeOf(input) === null) return true;
    let proto = input;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(input) === proto;
};



function $b441d0a49353537c$var$checkKeySize(key, alg) {
    if (key.algorithm.length !== parseInt(alg.slice(1, 4), 10)) throw new TypeError(`Invalid key size for alg: ${alg}`);
}
function $b441d0a49353537c$var$getCryptoKey(key, alg, usage) {
    if (key instanceof Uint8Array) return crypto.subtle.importKey('raw', key, 'AES-KW', true, [
        usage
    ]);
    (0, $6b065c055cfb3c64$export$41a67f89f6678b35)(key, alg, usage);
    return key;
}
async function $b441d0a49353537c$export$4997ffc0176396a6(alg, key, cek) {
    const cryptoKey = await $b441d0a49353537c$var$getCryptoKey(key, alg, 'wrapKey');
    $b441d0a49353537c$var$checkKeySize(cryptoKey, alg);
    const cryptoKeyCek = await crypto.subtle.importKey('raw', cek, {
        hash: 'SHA-256',
        name: 'HMAC'
    }, true, [
        'sign'
    ]);
    return new Uint8Array(await crypto.subtle.wrapKey('raw', cryptoKeyCek, cryptoKey, 'AES-KW'));
}
async function $b441d0a49353537c$export$debb760848ca95a(alg, key, encryptedKey) {
    const cryptoKey = await $b441d0a49353537c$var$getCryptoKey(key, alg, 'unwrapKey');
    $b441d0a49353537c$var$checkKeySize(cryptoKey, alg);
    const cryptoKeyCek = await crypto.subtle.unwrapKey('raw', encryptedKey, cryptoKey, 'AES-KW', {
        hash: 'SHA-256',
        name: 'HMAC'
    }, true, [
        'sign'
    ]);
    return new Uint8Array(await crypto.subtle.exportKey('raw', cryptoKeyCek));
}




var $9439542f6495b409$export$2e2bcd8739ae039 = async (algorithm, data)=>{
    const subtleDigest = `SHA-${algorithm.slice(-3)}`;
    return new Uint8Array(await crypto.subtle.digest(subtleDigest, data));
};


function $4563c5c5cba3303e$var$lengthAndInput(input) {
    return (0, $caa972a0b0381267$export$ee1b3e54f0441b22)((0, $caa972a0b0381267$export$74c16dba6c885532)(input.length), input);
}
async function $4563c5c5cba3303e$var$concatKdf(Z, L, OtherInfo) {
    const dkLen = L >> 3;
    const hashLen = 32;
    const reps = Math.ceil(dkLen / hashLen);
    const dk = new Uint8Array(reps * hashLen);
    for(let i = 1; i <= reps; i++){
        const hashInput = new Uint8Array(4 + Z.length + OtherInfo.length);
        hashInput.set((0, $caa972a0b0381267$export$74c16dba6c885532)(i), 0);
        hashInput.set(Z, 4);
        hashInput.set(OtherInfo, 4 + Z.length);
        const hashResult = await (0, $9439542f6495b409$export$2e2bcd8739ae039)('sha256', hashInput);
        dk.set(hashResult, (i - 1) * hashLen);
    }
    return dk.slice(0, dkLen);
}
async function $4563c5c5cba3303e$export$87770b6b245073b5(publicKey, privateKey, algorithm, keyLength, apu = new Uint8Array(0), apv = new Uint8Array(0)) {
    (0, $6b065c055cfb3c64$export$41a67f89f6678b35)(publicKey, 'ECDH');
    (0, $6b065c055cfb3c64$export$41a67f89f6678b35)(privateKey, 'ECDH', 'deriveBits');
    const algorithmID = $4563c5c5cba3303e$var$lengthAndInput((0, $caa972a0b0381267$export$5486af06137bf21a).encode(algorithm));
    const partyUInfo = $4563c5c5cba3303e$var$lengthAndInput(apu);
    const partyVInfo = $4563c5c5cba3303e$var$lengthAndInput(apv);
    const suppPubInfo = (0, $caa972a0b0381267$export$74c16dba6c885532)(keyLength);
    const suppPrivInfo = new Uint8Array(0);
    const otherInfo = (0, $caa972a0b0381267$export$ee1b3e54f0441b22)(algorithmID, partyUInfo, partyVInfo, suppPubInfo, suppPrivInfo);
    const Z = new Uint8Array(await crypto.subtle.deriveBits({
        name: publicKey.algorithm.name,
        public: publicKey
    }, privateKey, $4563c5c5cba3303e$var$getEcdhBitLength(publicKey)));
    return $4563c5c5cba3303e$var$concatKdf(Z, keyLength, otherInfo);
}
function $4563c5c5cba3303e$var$getEcdhBitLength(publicKey) {
    if (publicKey.algorithm.name === 'X25519') return 256;
    return Math.ceil(parseInt(publicKey.algorithm.namedCurve.slice(-3), 10) / 8) << 3;
}
function $4563c5c5cba3303e$export$921a3ec558688115(key) {
    switch(key.algorithm.namedCurve){
        case 'P-256':
        case 'P-384':
        case 'P-521':
            return true;
        default:
            return key.algorithm.name === 'X25519';
    }
}







function $46e21f8205d61b86$var$getCryptoKey(key, alg) {
    if (key instanceof Uint8Array) return crypto.subtle.importKey('raw', key, 'PBKDF2', false, [
        'deriveBits'
    ]);
    (0, $6b065c055cfb3c64$export$41a67f89f6678b35)(key, alg, 'deriveBits');
    return key;
}
const $46e21f8205d61b86$var$concatSalt = (alg, p2sInput)=>(0, $caa972a0b0381267$export$ee1b3e54f0441b22)((0, $caa972a0b0381267$export$5486af06137bf21a).encode(alg), new Uint8Array([
        0
    ]), p2sInput);
async function $46e21f8205d61b86$var$deriveKey(p2s, alg, p2c, key) {
    if (!(p2s instanceof Uint8Array) || p2s.length < 8) throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('PBES2 Salt Input must be 8 or more octets');
    const salt = $46e21f8205d61b86$var$concatSalt(alg, p2s);
    const keylen = parseInt(alg.slice(13, 16), 10);
    const subtleAlg = {
        hash: `SHA-${alg.slice(8, 11)}`,
        iterations: p2c,
        name: 'PBKDF2',
        salt: salt
    };
    const cryptoKey = await $46e21f8205d61b86$var$getCryptoKey(key, alg);
    return new Uint8Array(await crypto.subtle.deriveBits(subtleAlg, cryptoKey, keylen));
}
async function $46e21f8205d61b86$export$4997ffc0176396a6(alg, key, cek, p2c = 2048, p2s = crypto.getRandomValues(new Uint8Array(16))) {
    const derived = await $46e21f8205d61b86$var$deriveKey(p2s, alg, p2c, key);
    const encryptedKey = await $b441d0a49353537c$export$4997ffc0176396a6(alg.slice(-6), derived, cek);
    return {
        encryptedKey: encryptedKey,
        p2c: p2c,
        p2s: (0, $21428bcf7069d091$export$c564cdbbe6da493)(p2s)
    };
}
async function $46e21f8205d61b86$export$debb760848ca95a(alg, key, encryptedKey, p2c, p2s) {
    const derived = await $46e21f8205d61b86$var$deriveKey(p2s, alg, p2c, key);
    return $b441d0a49353537c$export$debb760848ca95a(alg.slice(-6), derived, encryptedKey);
}



var $0766961a49f57150$export$2e2bcd8739ae039 = (alg, key)=>{
    if (alg.startsWith('RS') || alg.startsWith('PS')) {
        const { modulusLength: modulusLength } = key.algorithm;
        if (typeof modulusLength !== 'number' || modulusLength < 2048) throw new TypeError(`${alg} requires key modulusLength to be 2048 bits or larger`);
    }
};



const $7a56394d7a07f0a6$var$subtleAlgorithm = (alg)=>{
    switch(alg){
        case 'RSA-OAEP':
        case 'RSA-OAEP-256':
        case 'RSA-OAEP-384':
        case 'RSA-OAEP-512':
            return 'RSA-OAEP';
        default:
            throw new (0, $be9270265a128b70$export$19ddbcbf2016ab28)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
};
async function $7a56394d7a07f0a6$export$5b0f6292f11d1d18(alg, key, cek) {
    (0, $6b065c055cfb3c64$export$41a67f89f6678b35)(key, alg, 'encrypt');
    (0, $0766961a49f57150$export$2e2bcd8739ae039)(alg, key);
    return new Uint8Array(await crypto.subtle.encrypt($7a56394d7a07f0a6$var$subtleAlgorithm(alg), key, cek));
}
async function $7a56394d7a07f0a6$export$e85a0c9a1067c5d3(alg, key, encryptedKey) {
    (0, $6b065c055cfb3c64$export$41a67f89f6678b35)(key, alg, 'decrypt');
    (0, $0766961a49f57150$export$2e2bcd8739ae039)(alg, key);
    return new Uint8Array(await crypto.subtle.decrypt($7a56394d7a07f0a6$var$subtleAlgorithm(alg), key, encryptedKey));
}





function $e80e3027304c13a0$export$db433e85ac514a95(alg) {
    switch(alg){
        case 'A128GCM':
            return 128;
        case 'A192GCM':
            return 192;
        case 'A256GCM':
        case 'A128CBC-HS256':
            return 256;
        case 'A192CBC-HS384':
            return 384;
        case 'A256CBC-HS512':
            return 512;
        default:
            throw new (0, $be9270265a128b70$export$19ddbcbf2016ab28)(`Unsupported JWE Algorithm: ${alg}`);
    }
}
var $e80e3027304c13a0$export$2e2bcd8739ae039 = (alg)=>crypto.getRandomValues(new Uint8Array($e80e3027304c13a0$export$db433e85ac514a95(alg) >> 3));







const $e0b9fceb84a48c39$var$formatPEM = (b64, descriptor)=>{
    const newlined = (b64.match(/.{1,64}/g) || []).join('\n');
    return `-----BEGIN ${descriptor}-----\n${newlined}\n-----END ${descriptor}-----`;
};
const $e0b9fceb84a48c39$var$genericExport = async (keyType, keyFormat, key)=>{
    if ((0, $a67a99484c2356b1$export$5c7abba3d2afc0b8)(key)) {
        if (key.type !== keyType) throw new TypeError(`key is not a ${keyType} key`);
        return key.export({
            format: 'pem',
            type: keyFormat
        });
    }
    if (!(0, $a67a99484c2356b1$export$600b5603bbac4c6)(key)) throw new TypeError((0, $d00aeb1d1157a477$export$2e2bcd8739ae039)(key, 'CryptoKey', 'KeyObject'));
    if (!key.extractable) throw new TypeError('CryptoKey is not extractable');
    if (key.type !== keyType) throw new TypeError(`key is not a ${keyType} key`);
    return $e0b9fceb84a48c39$var$formatPEM((0, $9818cdd72f29fa4c$export$8fb536984ec8b4d7)(new Uint8Array(await crypto.subtle.exportKey(keyFormat, key))), `${keyType.toUpperCase()} KEY`);
};
const $e0b9fceb84a48c39$export$cfba7e924fe414ca = (key)=>{
    return $e0b9fceb84a48c39$var$genericExport('public', 'spki', key);
};
const $e0b9fceb84a48c39$export$cac76a78a90b914d = (key)=>{
    return $e0b9fceb84a48c39$var$genericExport('private', 'pkcs8', key);
};
const $e0b9fceb84a48c39$var$bytesEqual = (a, b)=>{
    if (a.byteLength !== b.length) return false;
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
};
const $e0b9fceb84a48c39$var$createASN1State = (data)=>({
        data: data,
        pos: 0
    });
const $e0b9fceb84a48c39$var$parseLength = (state)=>{
    const first = state.data[state.pos++];
    if (first & 0x80) {
        const lengthOfLen = first & 0x7f;
        let length = 0;
        for(let i = 0; i < lengthOfLen; i++)length = length << 8 | state.data[state.pos++];
        return length;
    }
    return first;
};
const $e0b9fceb84a48c39$var$skipElement = (state, count = 1)=>{
    if (count <= 0) return;
    state.pos++;
    const length = $e0b9fceb84a48c39$var$parseLength(state);
    state.pos += length;
    if (count > 1) $e0b9fceb84a48c39$var$skipElement(state, count - 1);
};
const $e0b9fceb84a48c39$var$expectTag = (state, expectedTag, errorMessage)=>{
    if (state.data[state.pos++] !== expectedTag) throw new Error(errorMessage);
};
const $e0b9fceb84a48c39$var$getSubarray = (state, length)=>{
    const result = state.data.subarray(state.pos, state.pos + length);
    state.pos += length;
    return result;
};
const $e0b9fceb84a48c39$var$parseAlgorithmOID = (state)=>{
    $e0b9fceb84a48c39$var$expectTag(state, 0x06, 'Expected algorithm OID');
    const oidLen = $e0b9fceb84a48c39$var$parseLength(state);
    return $e0b9fceb84a48c39$var$getSubarray(state, oidLen);
};
function $e0b9fceb84a48c39$var$parsePKCS8Header(state) {
    $e0b9fceb84a48c39$var$expectTag(state, 0x30, 'Invalid PKCS#8 structure');
    $e0b9fceb84a48c39$var$parseLength(state);
    $e0b9fceb84a48c39$var$expectTag(state, 0x02, 'Expected version field');
    const verLen = $e0b9fceb84a48c39$var$parseLength(state);
    state.pos += verLen;
    $e0b9fceb84a48c39$var$expectTag(state, 0x30, 'Expected algorithm identifier');
    const algIdLen = $e0b9fceb84a48c39$var$parseLength(state);
    const algIdStart = state.pos;
    return {
        algIdStart: algIdStart,
        algIdLength: algIdLen
    };
}
function $e0b9fceb84a48c39$var$parseSPKIHeader(state) {
    $e0b9fceb84a48c39$var$expectTag(state, 0x30, 'Invalid SPKI structure');
    $e0b9fceb84a48c39$var$parseLength(state);
    $e0b9fceb84a48c39$var$expectTag(state, 0x30, 'Expected algorithm identifier');
    const algIdLen = $e0b9fceb84a48c39$var$parseLength(state);
    const algIdStart = state.pos;
    return {
        algIdStart: algIdStart,
        algIdLength: algIdLen
    };
}
const $e0b9fceb84a48c39$var$parseECAlgorithmIdentifier = (state)=>{
    const algOid = $e0b9fceb84a48c39$var$parseAlgorithmOID(state);
    if ($e0b9fceb84a48c39$var$bytesEqual(algOid, [
        0x2b,
        0x65,
        0x6e
    ])) return 'X25519';
    if (!$e0b9fceb84a48c39$var$bytesEqual(algOid, [
        0x2a,
        0x86,
        0x48,
        0xce,
        0x3d,
        0x02,
        0x01
    ])) throw new Error('Unsupported key algorithm');
    $e0b9fceb84a48c39$var$expectTag(state, 0x06, 'Expected curve OID');
    const curveOidLen = $e0b9fceb84a48c39$var$parseLength(state);
    const curveOid = $e0b9fceb84a48c39$var$getSubarray(state, curveOidLen);
    for (const { name: name, oid: oid } of [
        {
            name: 'P-256',
            oid: [
                0x2a,
                0x86,
                0x48,
                0xce,
                0x3d,
                0x03,
                0x01,
                0x07
            ]
        },
        {
            name: 'P-384',
            oid: [
                0x2b,
                0x81,
                0x04,
                0x00,
                0x22
            ]
        },
        {
            name: 'P-521',
            oid: [
                0x2b,
                0x81,
                0x04,
                0x00,
                0x23
            ]
        }
    ]){
        if ($e0b9fceb84a48c39$var$bytesEqual(curveOid, oid)) return name;
    }
    throw new Error('Unsupported named curve');
};
const $e0b9fceb84a48c39$var$genericImport = async (keyFormat, keyData, alg, options)=>{
    let algorithm;
    let keyUsages;
    const isPublic = keyFormat === 'spki';
    const getSigUsages = ()=>isPublic ? [
            'verify'
        ] : [
            'sign'
        ];
    const getEncUsages = ()=>isPublic ? [
            'encrypt',
            'wrapKey'
        ] : [
            'decrypt',
            'unwrapKey'
        ];
    switch(alg){
        case 'PS256':
        case 'PS384':
        case 'PS512':
            algorithm = {
                name: 'RSA-PSS',
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = getSigUsages();
            break;
        case 'RS256':
        case 'RS384':
        case 'RS512':
            algorithm = {
                name: 'RSASSA-PKCS1-v1_5',
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = getSigUsages();
            break;
        case 'RSA-OAEP':
        case 'RSA-OAEP-256':
        case 'RSA-OAEP-384':
        case 'RSA-OAEP-512':
            algorithm = {
                name: 'RSA-OAEP',
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`
            };
            keyUsages = getEncUsages();
            break;
        case 'ES256':
        case 'ES384':
        case 'ES512':
            {
                const curveMap = {
                    ES256: 'P-256',
                    ES384: 'P-384',
                    ES512: 'P-521'
                };
                algorithm = {
                    name: 'ECDSA',
                    namedCurve: curveMap[alg]
                };
                keyUsages = getSigUsages();
                break;
            }
        case 'ECDH-ES':
        case 'ECDH-ES+A128KW':
        case 'ECDH-ES+A192KW':
        case 'ECDH-ES+A256KW':
            try {
                const namedCurve = options.getNamedCurve(keyData);
                algorithm = namedCurve === 'X25519' ? {
                    name: 'X25519'
                } : {
                    name: 'ECDH',
                    namedCurve: namedCurve
                };
            } catch (cause) {
                throw new (0, $be9270265a128b70$export$19ddbcbf2016ab28)('Invalid or unsupported key format');
            }
            keyUsages = isPublic ? [] : [
                'deriveBits'
            ];
            break;
        case 'Ed25519':
        case 'EdDSA':
            algorithm = {
                name: 'Ed25519'
            };
            keyUsages = getSigUsages();
            break;
        case 'ML-DSA-44':
        case 'ML-DSA-65':
        case 'ML-DSA-87':
            algorithm = {
                name: alg
            };
            keyUsages = getSigUsages();
            break;
        default:
            throw new (0, $be9270265a128b70$export$19ddbcbf2016ab28)('Invalid or unsupported "alg" (Algorithm) value');
    }
    return crypto.subtle.importKey(keyFormat, keyData, algorithm, options?.extractable ?? (isPublic ? true : false), keyUsages);
};
const $e0b9fceb84a48c39$var$processPEMData = (pem, pattern)=>{
    return (0, $9818cdd72f29fa4c$export$94fdf11bafc8de6b)(pem.replace(pattern, ''));
};
const $e0b9fceb84a48c39$export$224b0a6339c7267f = (pem, alg, options)=>{
    const keyData = $e0b9fceb84a48c39$var$processPEMData(pem, /(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g);
    let opts = options;
    if (alg?.startsWith?.('ECDH-ES')) {
        opts ||= {};
        opts.getNamedCurve = (keyData)=>{
            const state = $e0b9fceb84a48c39$var$createASN1State(keyData);
            $e0b9fceb84a48c39$var$parsePKCS8Header(state);
            return $e0b9fceb84a48c39$var$parseECAlgorithmIdentifier(state);
        };
    }
    return $e0b9fceb84a48c39$var$genericImport('pkcs8', keyData, alg, opts);
};
const $e0b9fceb84a48c39$export$f9a3505cdaa1fb3e = (pem, alg, options)=>{
    const keyData = $e0b9fceb84a48c39$var$processPEMData(pem, /(?:-----(?:BEGIN|END) PUBLIC KEY-----|\s)/g);
    let opts = options;
    if (alg?.startsWith?.('ECDH-ES')) {
        opts ||= {};
        opts.getNamedCurve = (keyData)=>{
            const state = $e0b9fceb84a48c39$var$createASN1State(keyData);
            $e0b9fceb84a48c39$var$parseSPKIHeader(state);
            return $e0b9fceb84a48c39$var$parseECAlgorithmIdentifier(state);
        };
    }
    return $e0b9fceb84a48c39$var$genericImport('spki', keyData, alg, opts);
};
function $e0b9fceb84a48c39$var$spkiFromX509(buf) {
    const state = $e0b9fceb84a48c39$var$createASN1State(buf);
    $e0b9fceb84a48c39$var$expectTag(state, 0x30, 'Invalid certificate structure');
    $e0b9fceb84a48c39$var$parseLength(state);
    $e0b9fceb84a48c39$var$expectTag(state, 0x30, 'Invalid tbsCertificate structure');
    $e0b9fceb84a48c39$var$parseLength(state);
    if (buf[state.pos] === 0xa0) $e0b9fceb84a48c39$var$skipElement(state, 6);
    else $e0b9fceb84a48c39$var$skipElement(state, 5);
    const spkiStart = state.pos;
    $e0b9fceb84a48c39$var$expectTag(state, 0x30, 'Invalid SPKI structure');
    const spkiContentLen = $e0b9fceb84a48c39$var$parseLength(state);
    return buf.subarray(spkiStart, spkiStart + spkiContentLen + (state.pos - spkiStart));
}
function $e0b9fceb84a48c39$var$extractX509SPKI(x509) {
    const derBytes = $e0b9fceb84a48c39$var$processPEMData(x509, /(?:-----(?:BEGIN|END) CERTIFICATE-----|\s)/g);
    return $e0b9fceb84a48c39$var$spkiFromX509(derBytes);
}
const $e0b9fceb84a48c39$export$ed788b6a8533858f = (pem, alg, options)=>{
    let spki;
    try {
        spki = $e0b9fceb84a48c39$var$extractX509SPKI(pem);
    } catch (cause) {
        throw new TypeError('Failed to parse the X.509 certificate', {
            cause: cause
        });
    }
    return $e0b9fceb84a48c39$export$f9a3505cdaa1fb3e($e0b9fceb84a48c39$var$formatPEM((0, $9818cdd72f29fa4c$export$8fb536984ec8b4d7)(spki), 'PUBLIC KEY'), alg, options);
};



function $f99035164274b3be$var$subtleMapping(jwk) {
    let algorithm;
    let keyUsages;
    switch(jwk.kty){
        case 'AKP':
            switch(jwk.alg){
                case 'ML-DSA-44':
                case 'ML-DSA-65':
                case 'ML-DSA-87':
                    algorithm = {
                        name: jwk.alg
                    };
                    keyUsages = jwk.priv ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                default:
                    throw new (0, $be9270265a128b70$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case 'RSA':
            switch(jwk.alg){
                case 'PS256':
                case 'PS384':
                case 'PS512':
                    algorithm = {
                        name: 'RSA-PSS',
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'RS256':
                case 'RS384':
                case 'RS512':
                    algorithm = {
                        name: 'RSASSA-PKCS1-v1_5',
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'RSA-OAEP':
                case 'RSA-OAEP-256':
                case 'RSA-OAEP-384':
                case 'RSA-OAEP-512':
                    algorithm = {
                        name: 'RSA-OAEP',
                        hash: `SHA-${parseInt(jwk.alg.slice(-3), 10) || 1}`
                    };
                    keyUsages = jwk.d ? [
                        'decrypt',
                        'unwrapKey'
                    ] : [
                        'encrypt',
                        'wrapKey'
                    ];
                    break;
                default:
                    throw new (0, $be9270265a128b70$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case 'EC':
            switch(jwk.alg){
                case 'ES256':
                    algorithm = {
                        name: 'ECDSA',
                        namedCurve: 'P-256'
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'ES384':
                    algorithm = {
                        name: 'ECDSA',
                        namedCurve: 'P-384'
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'ES512':
                    algorithm = {
                        name: 'ECDSA',
                        namedCurve: 'P-521'
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'ECDH-ES':
                case 'ECDH-ES+A128KW':
                case 'ECDH-ES+A192KW':
                case 'ECDH-ES+A256KW':
                    algorithm = {
                        name: 'ECDH',
                        namedCurve: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        'deriveBits'
                    ] : [];
                    break;
                default:
                    throw new (0, $be9270265a128b70$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case 'OKP':
            switch(jwk.alg){
                case 'Ed25519':
                case 'EdDSA':
                    algorithm = {
                        name: 'Ed25519'
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'ECDH-ES':
                case 'ECDH-ES+A128KW':
                case 'ECDH-ES+A192KW':
                case 'ECDH-ES+A256KW':
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        'deriveBits'
                    ] : [];
                    break;
                default:
                    throw new (0, $be9270265a128b70$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        default:
            throw new (0, $be9270265a128b70$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
    }
    return {
        algorithm: algorithm,
        keyUsages: keyUsages
    };
}
var $f99035164274b3be$export$2e2bcd8739ae039 = async (jwk)=>{
    if (!jwk.alg) throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
    const { algorithm: algorithm, keyUsages: keyUsages } = $f99035164274b3be$var$subtleMapping(jwk);
    const keyData = {
        ...jwk
    };
    if (keyData.kty !== 'AKP') delete keyData.alg;
    delete keyData.use;
    return crypto.subtle.importKey('jwk', keyData, algorithm, jwk.ext ?? (jwk.d || jwk.priv ? false : true), jwk.key_ops ?? keyUsages);
};




async function $73fcfeb9db20aac4$export$7cdfc961c11d0266(spki, alg, options) {
    if (typeof spki !== 'string' || spki.indexOf('-----BEGIN PUBLIC KEY-----') !== 0) throw new TypeError('"spki" must be SPKI formatted string');
    return (0, $e0b9fceb84a48c39$export$f9a3505cdaa1fb3e)(spki, alg, options);
}
async function $73fcfeb9db20aac4$export$948757ecbbf4a918(x509, alg, options) {
    if (typeof x509 !== 'string' || x509.indexOf('-----BEGIN CERTIFICATE-----') !== 0) throw new TypeError('"x509" must be X.509 formatted string');
    return (0, $e0b9fceb84a48c39$export$ed788b6a8533858f)(x509, alg, options);
}
async function $73fcfeb9db20aac4$export$17f5e7f6d2848df5(pkcs8, alg, options) {
    if (typeof pkcs8 !== 'string' || pkcs8.indexOf('-----BEGIN PRIVATE KEY-----') !== 0) throw new TypeError('"pkcs8" must be PKCS#8 formatted string');
    return (0, $e0b9fceb84a48c39$export$224b0a6339c7267f)(pkcs8, alg, options);
}
async function $73fcfeb9db20aac4$export$2b70d37b4d0b888b(jwk, alg, options) {
    if (!(0, $9ddacb35cc1fdfe6$export$2e2bcd8739ae039)(jwk)) throw new TypeError('JWK must be an object');
    let ext;
    alg ??= jwk.alg;
    ext ??= options?.extractable ?? jwk.ext;
    switch(jwk.kty){
        case 'oct':
            if (typeof jwk.k !== 'string' || !jwk.k) throw new TypeError('missing "k" (Key Value) Parameter value');
            return (0, $21428bcf7069d091$export$2f872c0f2117be69)(jwk.k);
        case 'RSA':
            if ('oth' in jwk && jwk.oth !== undefined) throw new (0, $be9270265a128b70$export$19ddbcbf2016ab28)('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
            return (0, $f99035164274b3be$export$2e2bcd8739ae039)({
                ...jwk,
                alg: alg,
                ext: ext
            });
        case 'AKP':
            if (typeof jwk.alg !== 'string' || !jwk.alg) throw new TypeError('missing "alg" (Algorithm) Parameter value');
            if (alg !== undefined && alg !== jwk.alg) throw new TypeError('JWK alg and alg option value mismatch');
            return (0, $f99035164274b3be$export$2e2bcd8739ae039)({
                ...jwk,
                ext: ext
            });
        case 'EC':
        case 'OKP':
            return (0, $f99035164274b3be$export$2e2bcd8739ae039)({
                ...jwk,
                alg: alg,
                ext: ext
            });
        default:
            throw new (0, $be9270265a128b70$export$19ddbcbf2016ab28)('Unsupported "kty" (Key Type) Parameter value');
    }
}











async function $39a45c88af2f86a2$var$cbcEncrypt(enc, plaintext, cek, iv, aad) {
    if (!(cek instanceof Uint8Array)) throw new TypeError((0, $d00aeb1d1157a477$export$2e2bcd8739ae039)(cek, 'Uint8Array'));
    const keySize = parseInt(enc.slice(1, 4), 10);
    const encKey = await crypto.subtle.importKey('raw', cek.subarray(keySize >> 3), 'AES-CBC', false, [
        'encrypt'
    ]);
    const macKey = await crypto.subtle.importKey('raw', cek.subarray(0, keySize >> 3), {
        hash: `SHA-${keySize << 1}`,
        name: 'HMAC'
    }, false, [
        'sign'
    ]);
    const ciphertext = new Uint8Array(await crypto.subtle.encrypt({
        iv: iv,
        name: 'AES-CBC'
    }, encKey, plaintext));
    const macData = (0, $caa972a0b0381267$export$ee1b3e54f0441b22)(aad, iv, ciphertext, (0, $caa972a0b0381267$export$e7b531e00a18fdd7)(aad.length << 3));
    const tag = new Uint8Array((await crypto.subtle.sign('HMAC', macKey, macData)).slice(0, keySize >> 3));
    return {
        ciphertext: ciphertext,
        tag: tag,
        iv: iv
    };
}
async function $39a45c88af2f86a2$var$gcmEncrypt(enc, plaintext, cek, iv, aad) {
    let encKey;
    if (cek instanceof Uint8Array) encKey = await crypto.subtle.importKey('raw', cek, 'AES-GCM', false, [
        'encrypt'
    ]);
    else {
        (0, $6b065c055cfb3c64$export$41a67f89f6678b35)(cek, enc, 'encrypt');
        encKey = cek;
    }
    const encrypted = new Uint8Array(await crypto.subtle.encrypt({
        additionalData: aad,
        iv: iv,
        name: 'AES-GCM',
        tagLength: 128
    }, encKey, plaintext));
    const tag = encrypted.slice(-16);
    const ciphertext = encrypted.slice(0, -16);
    return {
        ciphertext: ciphertext,
        tag: tag,
        iv: iv
    };
}
var $39a45c88af2f86a2$export$2e2bcd8739ae039 = async (enc, plaintext, cek, iv, aad)=>{
    if (!(0, $a67a99484c2356b1$export$600b5603bbac4c6)(cek) && !(cek instanceof Uint8Array)) throw new TypeError((0, $d00aeb1d1157a477$export$2e2bcd8739ae039)(cek, 'CryptoKey', 'KeyObject', 'Uint8Array', 'JSON Web Key'));
    if (iv) (0, $dd2f89fae20dcc49$export$2e2bcd8739ae039)(enc, iv);
    else iv = (0, $2f9ce74d750f43eb$export$2e2bcd8739ae039)(enc);
    switch(enc){
        case 'A128CBC-HS256':
        case 'A192CBC-HS384':
        case 'A256CBC-HS512':
            if (cek instanceof Uint8Array) (0, $0ed8827f97f2be0c$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(-3), 10));
            return $39a45c88af2f86a2$var$cbcEncrypt(enc, plaintext, cek, iv, aad);
        case 'A128GCM':
        case 'A192GCM':
        case 'A256GCM':
            if (cek instanceof Uint8Array) (0, $0ed8827f97f2be0c$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(1, 4), 10));
            return $39a45c88af2f86a2$var$gcmEncrypt(enc, plaintext, cek, iv, aad);
        default:
            throw new (0, $be9270265a128b70$export$19ddbcbf2016ab28)('Unsupported JWE Content Encryption Algorithm');
    }
};




async function $4a7568bcb288760b$export$4997ffc0176396a6(alg, key, cek, iv) {
    const jweAlgorithm = alg.slice(0, 7);
    const wrapped = await (0, $39a45c88af2f86a2$export$2e2bcd8739ae039)(jweAlgorithm, cek, key, iv, new Uint8Array(0));
    return {
        encryptedKey: wrapped.ciphertext,
        iv: (0, $21428bcf7069d091$export$c564cdbbe6da493)(wrapped.iv),
        tag: (0, $21428bcf7069d091$export$c564cdbbe6da493)(wrapped.tag)
    };
}
async function $4a7568bcb288760b$export$debb760848ca95a(alg, key, encryptedKey, iv, tag) {
    const jweAlgorithm = alg.slice(0, 7);
    return (0, $4f860b272f88a458$export$2e2bcd8739ae039)(jweAlgorithm, key, encryptedKey, iv, tag, new Uint8Array(0));
}



var $3c21ad5ba81d9602$export$2e2bcd8739ae039 = async (alg, key, encryptedKey, joseHeader, options)=>{
    switch(alg){
        case 'dir':
            if (encryptedKey !== undefined) throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('Encountered unexpected JWE Encrypted Key');
            return key;
        case 'ECDH-ES':
            if (encryptedKey !== undefined) throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('Encountered unexpected JWE Encrypted Key');
        case 'ECDH-ES+A128KW':
        case 'ECDH-ES+A192KW':
        case 'ECDH-ES+A256KW':
            {
                if (!(0, $9ddacb35cc1fdfe6$export$2e2bcd8739ae039)(joseHeader.epk)) throw new (0, $be9270265a128b70$export$19f281f2275f6a15)(`JOSE Header "epk" (Ephemeral Public Key) missing or invalid`);
                (0, $a67a99484c2356b1$export$af46c52e955d1475)(key);
                if (!$4563c5c5cba3303e$export$921a3ec558688115(key)) throw new (0, $be9270265a128b70$export$19ddbcbf2016ab28)('ECDH with the provided key is not allowed or not supported by your javascript runtime');
                const epk = await (0, $73fcfeb9db20aac4$export$2b70d37b4d0b888b)(joseHeader.epk, alg);
                (0, $a67a99484c2356b1$export$af46c52e955d1475)(epk);
                let partyUInfo;
                let partyVInfo;
                if (joseHeader.apu !== undefined) {
                    if (typeof joseHeader.apu !== 'string') throw new (0, $be9270265a128b70$export$19f281f2275f6a15)(`JOSE Header "apu" (Agreement PartyUInfo) invalid`);
                    try {
                        partyUInfo = (0, $21428bcf7069d091$export$2f872c0f2117be69)(joseHeader.apu);
                    } catch  {
                        throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('Failed to base64url decode the apu');
                    }
                }
                if (joseHeader.apv !== undefined) {
                    if (typeof joseHeader.apv !== 'string') throw new (0, $be9270265a128b70$export$19f281f2275f6a15)(`JOSE Header "apv" (Agreement PartyVInfo) invalid`);
                    try {
                        partyVInfo = (0, $21428bcf7069d091$export$2f872c0f2117be69)(joseHeader.apv);
                    } catch  {
                        throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('Failed to base64url decode the apv');
                    }
                }
                const sharedSecret = await $4563c5c5cba3303e$export$87770b6b245073b5(epk, key, alg === 'ECDH-ES' ? joseHeader.enc : alg, alg === 'ECDH-ES' ? (0, $e80e3027304c13a0$export$db433e85ac514a95)(joseHeader.enc) : parseInt(alg.slice(-5, -2), 10), partyUInfo, partyVInfo);
                if (alg === 'ECDH-ES') return sharedSecret;
                if (encryptedKey === undefined) throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('JWE Encrypted Key missing');
                return $b441d0a49353537c$export$debb760848ca95a(alg.slice(-6), sharedSecret, encryptedKey);
            }
        case 'RSA-OAEP':
        case 'RSA-OAEP-256':
        case 'RSA-OAEP-384':
        case 'RSA-OAEP-512':
            if (encryptedKey === undefined) throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('JWE Encrypted Key missing');
            (0, $a67a99484c2356b1$export$af46c52e955d1475)(key);
            return $7a56394d7a07f0a6$export$e85a0c9a1067c5d3(alg, key, encryptedKey);
        case 'PBES2-HS256+A128KW':
        case 'PBES2-HS384+A192KW':
        case 'PBES2-HS512+A256KW':
            {
                if (encryptedKey === undefined) throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('JWE Encrypted Key missing');
                if (typeof joseHeader.p2c !== 'number') throw new (0, $be9270265a128b70$export$19f281f2275f6a15)(`JOSE Header "p2c" (PBES2 Count) missing or invalid`);
                const p2cLimit = options?.maxPBES2Count || 10000;
                if (joseHeader.p2c > p2cLimit) throw new (0, $be9270265a128b70$export$19f281f2275f6a15)(`JOSE Header "p2c" (PBES2 Count) out is of acceptable bounds`);
                if (typeof joseHeader.p2s !== 'string') throw new (0, $be9270265a128b70$export$19f281f2275f6a15)(`JOSE Header "p2s" (PBES2 Salt) missing or invalid`);
                let p2s;
                try {
                    p2s = (0, $21428bcf7069d091$export$2f872c0f2117be69)(joseHeader.p2s);
                } catch  {
                    throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('Failed to base64url decode the p2s');
                }
                return $46e21f8205d61b86$export$debb760848ca95a(alg, key, encryptedKey, joseHeader.p2c, p2s);
            }
        case 'A128KW':
        case 'A192KW':
        case 'A256KW':
            if (encryptedKey === undefined) throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('JWE Encrypted Key missing');
            return $b441d0a49353537c$export$debb760848ca95a(alg, key, encryptedKey);
        case 'A128GCMKW':
        case 'A192GCMKW':
        case 'A256GCMKW':
            {
                if (encryptedKey === undefined) throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('JWE Encrypted Key missing');
                if (typeof joseHeader.iv !== 'string') throw new (0, $be9270265a128b70$export$19f281f2275f6a15)(`JOSE Header "iv" (Initialization Vector) missing or invalid`);
                if (typeof joseHeader.tag !== 'string') throw new (0, $be9270265a128b70$export$19f281f2275f6a15)(`JOSE Header "tag" (Authentication Tag) missing or invalid`);
                let iv;
                try {
                    iv = (0, $21428bcf7069d091$export$2f872c0f2117be69)(joseHeader.iv);
                } catch  {
                    throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('Failed to base64url decode the iv');
                }
                let tag;
                try {
                    tag = (0, $21428bcf7069d091$export$2f872c0f2117be69)(joseHeader.tag);
                } catch  {
                    throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('Failed to base64url decode the tag');
                }
                return (0, $4a7568bcb288760b$export$debb760848ca95a)(alg, key, encryptedKey, iv, tag);
            }
        default:
            throw new (0, $be9270265a128b70$export$19ddbcbf2016ab28)('Invalid or unsupported "alg" (JWE Algorithm) header value');
    }
};





var $358c203f53f20b3f$export$2e2bcd8739ae039 = (Err, recognizedDefault, recognizedOption, protectedHeader, joseHeader)=>{
    if (joseHeader.crit !== undefined && protectedHeader?.crit === undefined) throw new Err('"crit" (Critical) Header Parameter MUST be integrity protected');
    if (!protectedHeader || protectedHeader.crit === undefined) return new Set();
    if (!Array.isArray(protectedHeader.crit) || protectedHeader.crit.length === 0 || protectedHeader.crit.some((input)=>typeof input !== 'string' || input.length === 0)) throw new Err('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
    let recognized;
    if (recognizedOption !== undefined) recognized = new Map([
        ...Object.entries(recognizedOption),
        ...recognizedDefault.entries()
    ]);
    else recognized = recognizedDefault;
    for (const parameter of protectedHeader.crit){
        if (!recognized.has(parameter)) throw new (0, $be9270265a128b70$export$19ddbcbf2016ab28)(`Extension Header Parameter "${parameter}" is not recognized`);
        if (joseHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" is missing`);
        if (recognized.get(parameter) && protectedHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" MUST be integrity protected`);
    }
    return new Set(protectedHeader.crit);
};


var $f8e5edd5199fd13a$export$2e2bcd8739ae039 = (option, algorithms)=>{
    if (algorithms !== undefined && (!Array.isArray(algorithms) || algorithms.some((s)=>typeof s !== 'string'))) throw new TypeError(`"${option}" option must be an array of strings`);
    if (!algorithms) return undefined;
    return new Set(algorithms);
};



function $e495adbfa6948a9d$export$9a44c2ef7e3b3dad(key) {
    return (0, $9ddacb35cc1fdfe6$export$2e2bcd8739ae039)(key) && typeof key.kty === 'string';
}
function $e495adbfa6948a9d$export$431699a4f17ba0e(key) {
    return key.kty !== 'oct' && (key.kty === 'AKP' && typeof key.priv === 'string' || typeof key.d === 'string');
}
function $e495adbfa6948a9d$export$b786616db1cddf3(key) {
    return key.kty !== 'oct' && typeof key.d === 'undefined' && typeof key.priv === 'undefined';
}
function $e495adbfa6948a9d$export$f8ecf533504bc7ad(key) {
    return key.kty === 'oct' && typeof key.k === 'string';
}





let $b27d48e4f2889a3b$var$cache;
const $b27d48e4f2889a3b$var$handleJWK = async (key, jwk, alg, freeze = false)=>{
    $b27d48e4f2889a3b$var$cache ||= new WeakMap();
    let cached = $b27d48e4f2889a3b$var$cache.get(key);
    if (cached?.[alg]) return cached[alg];
    const cryptoKey = await (0, $f99035164274b3be$export$2e2bcd8739ae039)({
        ...jwk,
        alg: alg
    });
    if (freeze) Object.freeze(key);
    if (!cached) $b27d48e4f2889a3b$var$cache.set(key, {
        [alg]: cryptoKey
    });
    else cached[alg] = cryptoKey;
    return cryptoKey;
};
const $b27d48e4f2889a3b$var$handleKeyObject = (keyObject, alg)=>{
    $b27d48e4f2889a3b$var$cache ||= new WeakMap();
    let cached = $b27d48e4f2889a3b$var$cache.get(keyObject);
    if (cached?.[alg]) return cached[alg];
    const isPublic = keyObject.type === 'public';
    const extractable = isPublic ? true : false;
    let cryptoKey;
    if (keyObject.asymmetricKeyType === 'x25519') {
        switch(alg){
            case 'ECDH-ES':
            case 'ECDH-ES+A128KW':
            case 'ECDH-ES+A192KW':
            case 'ECDH-ES+A256KW':
                break;
            default:
                throw new TypeError('given KeyObject instance cannot be used for this algorithm');
        }
        cryptoKey = keyObject.toCryptoKey(keyObject.asymmetricKeyType, extractable, isPublic ? [] : [
            'deriveBits'
        ]);
    }
    if (keyObject.asymmetricKeyType === 'ed25519') {
        if (alg !== 'EdDSA' && alg !== 'Ed25519') throw new TypeError('given KeyObject instance cannot be used for this algorithm');
        cryptoKey = keyObject.toCryptoKey(keyObject.asymmetricKeyType, extractable, [
            isPublic ? 'verify' : 'sign'
        ]);
    }
    switch(keyObject.asymmetricKeyType){
        case 'ml-dsa-44':
        case 'ml-dsa-65':
        case 'ml-dsa-87':
            if (alg !== keyObject.asymmetricKeyType.toUpperCase()) throw new TypeError('given KeyObject instance cannot be used for this algorithm');
            cryptoKey = keyObject.toCryptoKey(keyObject.asymmetricKeyType, extractable, [
                isPublic ? 'verify' : 'sign'
            ]);
    }
    if (keyObject.asymmetricKeyType === 'rsa') {
        let hash;
        switch(alg){
            case 'RSA-OAEP':
                hash = 'SHA-1';
                break;
            case 'RS256':
            case 'PS256':
            case 'RSA-OAEP-256':
                hash = 'SHA-256';
                break;
            case 'RS384':
            case 'PS384':
            case 'RSA-OAEP-384':
                hash = 'SHA-384';
                break;
            case 'RS512':
            case 'PS512':
            case 'RSA-OAEP-512':
                hash = 'SHA-512';
                break;
            default:
                throw new TypeError('given KeyObject instance cannot be used for this algorithm');
        }
        if (alg.startsWith('RSA-OAEP')) return keyObject.toCryptoKey({
            name: 'RSA-OAEP',
            hash: hash
        }, extractable, isPublic ? [
            'encrypt'
        ] : [
            'decrypt'
        ]);
        cryptoKey = keyObject.toCryptoKey({
            name: alg.startsWith('PS') ? 'RSA-PSS' : 'RSASSA-PKCS1-v1_5',
            hash: hash
        }, extractable, [
            isPublic ? 'verify' : 'sign'
        ]);
    }
    if (keyObject.asymmetricKeyType === 'ec') {
        const nist = new Map([
            [
                'prime256v1',
                'P-256'
            ],
            [
                'secp384r1',
                'P-384'
            ],
            [
                'secp521r1',
                'P-521'
            ]
        ]);
        const namedCurve = nist.get(keyObject.asymmetricKeyDetails?.namedCurve);
        if (!namedCurve) throw new TypeError('given KeyObject instance cannot be used for this algorithm');
        if (alg === 'ES256' && namedCurve === 'P-256') cryptoKey = keyObject.toCryptoKey({
            name: 'ECDSA',
            namedCurve: namedCurve
        }, extractable, [
            isPublic ? 'verify' : 'sign'
        ]);
        if (alg === 'ES384' && namedCurve === 'P-384') cryptoKey = keyObject.toCryptoKey({
            name: 'ECDSA',
            namedCurve: namedCurve
        }, extractable, [
            isPublic ? 'verify' : 'sign'
        ]);
        if (alg === 'ES512' && namedCurve === 'P-521') cryptoKey = keyObject.toCryptoKey({
            name: 'ECDSA',
            namedCurve: namedCurve
        }, extractable, [
            isPublic ? 'verify' : 'sign'
        ]);
        if (alg.startsWith('ECDH-ES')) cryptoKey = keyObject.toCryptoKey({
            name: 'ECDH',
            namedCurve: namedCurve
        }, extractable, isPublic ? [] : [
            'deriveBits'
        ]);
    }
    if (!cryptoKey) throw new TypeError('given KeyObject instance cannot be used for this algorithm');
    if (!cached) $b27d48e4f2889a3b$var$cache.set(keyObject, {
        [alg]: cryptoKey
    });
    else cached[alg] = cryptoKey;
    return cryptoKey;
};
var $b27d48e4f2889a3b$export$2e2bcd8739ae039 = async (key, alg)=>{
    if (key instanceof Uint8Array) return key;
    if ((0, $a67a99484c2356b1$export$600b5603bbac4c6)(key)) return key;
    if ((0, $a67a99484c2356b1$export$5c7abba3d2afc0b8)(key)) {
        if (key.type === 'secret') return key.export();
        if ('toCryptoKey' in key && typeof key.toCryptoKey === 'function') try {
            return $b27d48e4f2889a3b$var$handleKeyObject(key, alg);
        } catch (err) {
            if (err instanceof TypeError) throw err;
        }
        let jwk = key.export({
            format: 'jwk'
        });
        return $b27d48e4f2889a3b$var$handleJWK(key, jwk, alg);
    }
    if ((0, $e495adbfa6948a9d$export$9a44c2ef7e3b3dad)(key)) {
        if (key.k) return (0, $21428bcf7069d091$export$2f872c0f2117be69)(key.k);
        return $b27d48e4f2889a3b$var$handleJWK(key, key, alg, true);
    }
    throw new Error('unreachable');
};





const $8f293b507bae9525$var$tag = (key)=>key?.[Symbol.toStringTag];
const $8f293b507bae9525$var$jwkMatchesOp = (alg, key, usage)=>{
    if (key.use !== undefined) {
        let expected;
        switch(usage){
            case 'sign':
            case 'verify':
                expected = 'sig';
                break;
            case 'encrypt':
            case 'decrypt':
                expected = 'enc';
                break;
        }
        if (key.use !== expected) throw new TypeError(`Invalid key for this operation, its "use" must be "${expected}" when present`);
    }
    if (key.alg !== undefined && key.alg !== alg) throw new TypeError(`Invalid key for this operation, its "alg" must be "${alg}" when present`);
    if (Array.isArray(key.key_ops)) {
        let expectedKeyOp;
        switch(true){
            case usage === 'sign' || usage === 'verify':
            case alg === 'dir':
            case alg.includes('CBC-HS'):
                expectedKeyOp = usage;
                break;
            case alg.startsWith('PBES2'):
                expectedKeyOp = 'deriveBits';
                break;
            case /^A\d{3}(?:GCM)?(?:KW)?$/.test(alg):
                if (!alg.includes('GCM') && alg.endsWith('KW')) expectedKeyOp = usage === 'encrypt' ? 'wrapKey' : 'unwrapKey';
                else expectedKeyOp = usage;
                break;
            case usage === 'encrypt' && alg.startsWith('RSA'):
                expectedKeyOp = 'wrapKey';
                break;
            case usage === 'decrypt':
                expectedKeyOp = alg.startsWith('RSA') ? 'unwrapKey' : 'deriveBits';
                break;
        }
        if (expectedKeyOp && key.key_ops?.includes?.(expectedKeyOp) === false) throw new TypeError(`Invalid key for this operation, its "key_ops" must include "${expectedKeyOp}" when present`);
    }
    return true;
};
const $8f293b507bae9525$var$symmetricTypeCheck = (alg, key, usage)=>{
    if (key instanceof Uint8Array) return;
    if ($e495adbfa6948a9d$export$9a44c2ef7e3b3dad(key)) {
        if ($e495adbfa6948a9d$export$f8ecf533504bc7ad(key) && $8f293b507bae9525$var$jwkMatchesOp(alg, key, usage)) return;
        throw new TypeError(`JSON Web Key for symmetric algorithms must have JWK "kty" (Key Type) equal to "oct" and the JWK "k" (Key Value) present`);
    }
    if (!(0, $a67a99484c2356b1$export$2e2bcd8739ae039)(key)) throw new TypeError((0, $d00aeb1d1157a477$export$e94f758d09bc1828)(alg, key, 'CryptoKey', 'KeyObject', 'JSON Web Key', 'Uint8Array'));
    if (key.type !== 'secret') throw new TypeError(`${$8f293b507bae9525$var$tag(key)} instances for symmetric algorithms must be of type "secret"`);
};
const $8f293b507bae9525$var$asymmetricTypeCheck = (alg, key, usage)=>{
    if ($e495adbfa6948a9d$export$9a44c2ef7e3b3dad(key)) switch(usage){
        case 'decrypt':
        case 'sign':
            if ($e495adbfa6948a9d$export$431699a4f17ba0e(key) && $8f293b507bae9525$var$jwkMatchesOp(alg, key, usage)) return;
            throw new TypeError(`JSON Web Key for this operation be a private JWK`);
        case 'encrypt':
        case 'verify':
            if ($e495adbfa6948a9d$export$b786616db1cddf3(key) && $8f293b507bae9525$var$jwkMatchesOp(alg, key, usage)) return;
            throw new TypeError(`JSON Web Key for this operation be a public JWK`);
    }
    if (!(0, $a67a99484c2356b1$export$2e2bcd8739ae039)(key)) throw new TypeError((0, $d00aeb1d1157a477$export$e94f758d09bc1828)(alg, key, 'CryptoKey', 'KeyObject', 'JSON Web Key'));
    if (key.type === 'secret') throw new TypeError(`${$8f293b507bae9525$var$tag(key)} instances for asymmetric algorithms must not be of type "secret"`);
    if (key.type === 'public') switch(usage){
        case 'sign':
            throw new TypeError(`${$8f293b507bae9525$var$tag(key)} instances for asymmetric algorithm signing must be of type "private"`);
        case 'decrypt':
            throw new TypeError(`${$8f293b507bae9525$var$tag(key)} instances for asymmetric algorithm decryption must be of type "private"`);
        default:
            break;
    }
    if (key.type === 'private') switch(usage){
        case 'verify':
            throw new TypeError(`${$8f293b507bae9525$var$tag(key)} instances for asymmetric algorithm verifying must be of type "public"`);
        case 'encrypt':
            throw new TypeError(`${$8f293b507bae9525$var$tag(key)} instances for asymmetric algorithm encryption must be of type "public"`);
        default:
            break;
    }
};
var $8f293b507bae9525$export$2e2bcd8739ae039 = (alg, key, usage)=>{
    const symmetric = alg.startsWith('HS') || alg === 'dir' || alg.startsWith('PBES2') || /^A(?:128|192|256)(?:GCM)?(?:KW)?$/.test(alg) || /^A(?:128|192|256)CBC-HS(?:256|384|512)$/.test(alg);
    if (symmetric) $8f293b507bae9525$var$symmetricTypeCheck(alg, key, usage);
    else $8f293b507bae9525$var$asymmetricTypeCheck(alg, key, usage);
};


async function $ef1348b7887d6cb7$export$b75cd12892ae94d2(jwe, key, options) {
    if (!(0, $9ddacb35cc1fdfe6$export$2e2bcd8739ae039)(jwe)) throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('Flattened JWE must be an object');
    if (jwe.protected === undefined && jwe.header === undefined && jwe.unprotected === undefined) throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('JOSE Header missing');
    if (jwe.iv !== undefined && typeof jwe.iv !== 'string') throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('JWE Initialization Vector incorrect type');
    if (typeof jwe.ciphertext !== 'string') throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('JWE Ciphertext missing or incorrect type');
    if (jwe.tag !== undefined && typeof jwe.tag !== 'string') throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('JWE Authentication Tag incorrect type');
    if (jwe.protected !== undefined && typeof jwe.protected !== 'string') throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('JWE Protected Header incorrect type');
    if (jwe.encrypted_key !== undefined && typeof jwe.encrypted_key !== 'string') throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('JWE Encrypted Key incorrect type');
    if (jwe.aad !== undefined && typeof jwe.aad !== 'string') throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('JWE AAD incorrect type');
    if (jwe.header !== undefined && !(0, $9ddacb35cc1fdfe6$export$2e2bcd8739ae039)(jwe.header)) throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('JWE Shared Unprotected Header incorrect type');
    if (jwe.unprotected !== undefined && !(0, $9ddacb35cc1fdfe6$export$2e2bcd8739ae039)(jwe.unprotected)) throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('JWE Per-Recipient Unprotected Header incorrect type');
    let parsedProt;
    if (jwe.protected) try {
        const protectedHeader = (0, $21428bcf7069d091$export$2f872c0f2117be69)(jwe.protected);
        parsedProt = JSON.parse((0, $caa972a0b0381267$export$124c96e6ce37090b).decode(protectedHeader));
    } catch  {
        throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('JWE Protected Header is invalid');
    }
    if (!(0, $58586c0fe8c58c3d$export$2e2bcd8739ae039)(parsedProt, jwe.header, jwe.unprotected)) throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('JWE Protected, JWE Unprotected Header, and JWE Per-Recipient Unprotected Header Parameter names must be disjoint');
    const joseHeader = {
        ...parsedProt,
        ...jwe.header,
        ...jwe.unprotected
    };
    (0, $358c203f53f20b3f$export$2e2bcd8739ae039)((0, $be9270265a128b70$export$19f281f2275f6a15), new Map(), options?.crit, parsedProt, joseHeader);
    if (joseHeader.zip !== undefined) throw new (0, $be9270265a128b70$export$19ddbcbf2016ab28)('JWE "zip" (Compression Algorithm) Header Parameter is not supported.');
    const { alg: alg, enc: enc } = joseHeader;
    if (typeof alg !== 'string' || !alg) throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('missing JWE Algorithm (alg) in JWE Header');
    if (typeof enc !== 'string' || !enc) throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('missing JWE Encryption Algorithm (enc) in JWE Header');
    const keyManagementAlgorithms = options && (0, $f8e5edd5199fd13a$export$2e2bcd8739ae039)('keyManagementAlgorithms', options.keyManagementAlgorithms);
    const contentEncryptionAlgorithms = options && (0, $f8e5edd5199fd13a$export$2e2bcd8739ae039)('contentEncryptionAlgorithms', options.contentEncryptionAlgorithms);
    if (keyManagementAlgorithms && !keyManagementAlgorithms.has(alg) || !keyManagementAlgorithms && alg.startsWith('PBES2')) throw new (0, $be9270265a128b70$export$d51fd7fedeccc338)('"alg" (Algorithm) Header Parameter value not allowed');
    if (contentEncryptionAlgorithms && !contentEncryptionAlgorithms.has(enc)) throw new (0, $be9270265a128b70$export$d51fd7fedeccc338)('"enc" (Encryption Algorithm) Header Parameter value not allowed');
    let encryptedKey;
    if (jwe.encrypted_key !== undefined) try {
        encryptedKey = (0, $21428bcf7069d091$export$2f872c0f2117be69)(jwe.encrypted_key);
    } catch  {
        throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('Failed to base64url decode the encrypted_key');
    }
    let resolvedKey = false;
    if (typeof key === 'function') {
        key = await key(parsedProt, jwe);
        resolvedKey = true;
    }
    (0, $8f293b507bae9525$export$2e2bcd8739ae039)(alg === 'dir' ? enc : alg, key, 'decrypt');
    const k = await (0, $b27d48e4f2889a3b$export$2e2bcd8739ae039)(key, alg);
    let cek;
    try {
        cek = await (0, $3c21ad5ba81d9602$export$2e2bcd8739ae039)(alg, k, encryptedKey, joseHeader, options);
    } catch (err) {
        if (err instanceof TypeError || err instanceof (0, $be9270265a128b70$export$19f281f2275f6a15) || err instanceof (0, $be9270265a128b70$export$19ddbcbf2016ab28)) throw err;
        cek = (0, $e80e3027304c13a0$export$2e2bcd8739ae039)(enc);
    }
    let iv;
    let tag;
    if (jwe.iv !== undefined) try {
        iv = (0, $21428bcf7069d091$export$2f872c0f2117be69)(jwe.iv);
    } catch  {
        throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('Failed to base64url decode the iv');
    }
    if (jwe.tag !== undefined) try {
        tag = (0, $21428bcf7069d091$export$2f872c0f2117be69)(jwe.tag);
    } catch  {
        throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('Failed to base64url decode the tag');
    }
    const protectedHeader = (0, $caa972a0b0381267$export$5486af06137bf21a).encode(jwe.protected ?? '');
    let additionalData;
    if (jwe.aad !== undefined) additionalData = (0, $caa972a0b0381267$export$ee1b3e54f0441b22)(protectedHeader, (0, $caa972a0b0381267$export$5486af06137bf21a).encode('.'), (0, $caa972a0b0381267$export$5486af06137bf21a).encode(jwe.aad));
    else additionalData = protectedHeader;
    let ciphertext;
    try {
        ciphertext = (0, $21428bcf7069d091$export$2f872c0f2117be69)(jwe.ciphertext);
    } catch  {
        throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('Failed to base64url decode the ciphertext');
    }
    const plaintext = await (0, $4f860b272f88a458$export$2e2bcd8739ae039)(enc, cek, ciphertext, iv, tag, additionalData);
    const result = {
        plaintext: plaintext
    };
    if (jwe.protected !== undefined) result.protectedHeader = parsedProt;
    if (jwe.aad !== undefined) try {
        result.additionalAuthenticatedData = (0, $21428bcf7069d091$export$2f872c0f2117be69)(jwe.aad);
    } catch  {
        throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('Failed to base64url decode the aad');
    }
    if (jwe.unprotected !== undefined) result.sharedUnprotectedHeader = jwe.unprotected;
    if (jwe.header !== undefined) result.unprotectedHeader = jwe.header;
    if (resolvedKey) return {
        ...result,
        key: k
    };
    return result;
}




async function $77ae55cdcb579f17$export$c9a8efe6bfd872ce(jwe, key, options) {
    if (jwe instanceof Uint8Array) jwe = (0, $caa972a0b0381267$export$124c96e6ce37090b).decode(jwe);
    if (typeof jwe !== 'string') throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('Compact JWE must be a string or Uint8Array');
    const { 0: protectedHeader, 1: encryptedKey, 2: iv, 3: ciphertext, 4: tag, length: length } = jwe.split('.');
    if (length !== 5) throw new (0, $be9270265a128b70$export$19f281f2275f6a15)('Invalid Compact JWE');
    const decrypted = await (0, $ef1348b7887d6cb7$export$b75cd12892ae94d2)({
        ciphertext: ciphertext,
        iv: iv || undefined,
        protected: protectedHeader,
        tag: tag || undefined,
        encrypted_key: encryptedKey || undefined
    }, key, options);
    const result = {
        plaintext: decrypted.plaintext,
        protectedHeader: decrypted.protectedHeader
    };
    if (typeof key === 'function') return {
        ...result,
        key: decrypted.key
    };
    return result;
}



let $ae2e0da65795c7c6$var$headers;
let $ae2e0da65795c7c6$var$USER_AGENT;
if (typeof navigator === 'undefined' || !navigator.userAgent?.startsWith?.('Mozilla/5.0 ')) {
    const NAME = 'openid-client';
    const VERSION = 'v6.7.1';
    $ae2e0da65795c7c6$var$USER_AGENT = `${NAME}/${VERSION}`;
    $ae2e0da65795c7c6$var$headers = {
        'user-agent': $ae2e0da65795c7c6$var$USER_AGENT
    };
}
const $ae2e0da65795c7c6$var$int = (config)=>{
    return $ae2e0da65795c7c6$var$props.get(config);
};
let $ae2e0da65795c7c6$var$props;
let $ae2e0da65795c7c6$var$tbi;
function $ae2e0da65795c7c6$export$d0f6cb9d2fa8a5e4(clientSecret) {
    if (clientSecret !== undefined) return $e0734e0b78b64dca$export$d0f6cb9d2fa8a5e4(clientSecret);
    $ae2e0da65795c7c6$var$tbi ||= new WeakMap();
    return (as, client, body, headers)=>{
        let auth;
        if (!(auth = $ae2e0da65795c7c6$var$tbi.get(client))) {
            $ae2e0da65795c7c6$var$assertString(client.client_secret, '"metadata.client_secret"');
            auth = $e0734e0b78b64dca$export$d0f6cb9d2fa8a5e4(client.client_secret);
            $ae2e0da65795c7c6$var$tbi.set(client, auth);
        }
        return auth(as, client, body, headers);
    };
}
function $ae2e0da65795c7c6$var$assertString(input, it) {
    if (typeof input !== 'string') throw $ae2e0da65795c7c6$var$CodedTypeError(`${it} must be a string`, $ae2e0da65795c7c6$var$ERR_INVALID_ARG_TYPE);
    if (input.length === 0) throw $ae2e0da65795c7c6$var$CodedTypeError(`${it} must not be empty`, $ae2e0da65795c7c6$var$ERR_INVALID_ARG_VALUE);
}
function $ae2e0da65795c7c6$export$fac1ad2e7e73de2f(clientSecret) {
    if (clientSecret !== undefined) return $e0734e0b78b64dca$export$fac1ad2e7e73de2f(clientSecret);
    $ae2e0da65795c7c6$var$tbi ||= new WeakMap();
    return (as, client, body, headers)=>{
        let auth;
        if (!(auth = $ae2e0da65795c7c6$var$tbi.get(client))) {
            $ae2e0da65795c7c6$var$assertString(client.client_secret, '"metadata.client_secret"');
            auth = $e0734e0b78b64dca$export$fac1ad2e7e73de2f(client.client_secret);
            $ae2e0da65795c7c6$var$tbi.set(client, auth);
        }
        return auth(as, client, body, headers);
    };
}
function $ae2e0da65795c7c6$export$c54fb5a764324620(clientSecret, options) {
    if (clientSecret !== undefined) return $e0734e0b78b64dca$export$c54fb5a764324620(clientSecret, options);
    $ae2e0da65795c7c6$var$tbi ||= new WeakMap();
    return (as, client, body, headers)=>{
        let auth;
        if (!(auth = $ae2e0da65795c7c6$var$tbi.get(client))) {
            $ae2e0da65795c7c6$var$assertString(client.client_secret, '"metadata.client_secret"');
            auth = $e0734e0b78b64dca$export$c54fb5a764324620(client.client_secret, options);
            $ae2e0da65795c7c6$var$tbi.set(client, auth);
        }
        return auth(as, client, body, headers);
    };
}
function $ae2e0da65795c7c6$export$57ca7e07b341709d() {
    return $e0734e0b78b64dca$export$57ca7e07b341709d();
}
function $ae2e0da65795c7c6$export$205d96266e252745(clientPrivateKey, options) {
    return $e0734e0b78b64dca$export$205d96266e252745(clientPrivateKey, options);
}
function $ae2e0da65795c7c6$export$a7f4b82fa21adfbd() {
    return $e0734e0b78b64dca$export$a7f4b82fa21adfbd();
}
const $ae2e0da65795c7c6$export$da05291b784100ea = $e0734e0b78b64dca$export$da05291b784100ea;
const $ae2e0da65795c7c6$export$7880c8df8f6a0b6 = $e0734e0b78b64dca$export$7880c8df8f6a0b6;
const $ae2e0da65795c7c6$export$1512182a095696a1 = $e0734e0b78b64dca$export$1512182a095696a1;
const $ae2e0da65795c7c6$export$3c98c9a00e160706 = $e0734e0b78b64dca$export$3c98c9a00e160706;
const $ae2e0da65795c7c6$export$b708b81a4ce6a399 = $e0734e0b78b64dca$export$b708b81a4ce6a399;
const $ae2e0da65795c7c6$export$5f7768254837f408 = $e0734e0b78b64dca$export$5f7768254837f408;
const $ae2e0da65795c7c6$var$ERR_INVALID_ARG_VALUE = 'ERR_INVALID_ARG_VALUE';
const $ae2e0da65795c7c6$var$ERR_INVALID_ARG_TYPE = 'ERR_INVALID_ARG_TYPE';
function $ae2e0da65795c7c6$var$CodedTypeError(message, code, cause) {
    const err = new TypeError(message, {
        cause: cause
    });
    Object.assign(err, {
        code: code
    });
    return err;
}
function $ae2e0da65795c7c6$export$bc305e5334785b5d(codeVerifier) {
    return $e0734e0b78b64dca$export$bc305e5334785b5d(codeVerifier);
}
function $ae2e0da65795c7c6$export$8f2fe77a10ebd55a() {
    return $e0734e0b78b64dca$export$1a3cc162d1920778();
}
function $ae2e0da65795c7c6$export$bb6141066c9e8c4d() {
    return $e0734e0b78b64dca$export$710c4eec6c0c64b9();
}
function $ae2e0da65795c7c6$export$ef959a27a958b03b() {
    return $e0734e0b78b64dca$export$2cfaa88455cb5a99();
}
class $ae2e0da65795c7c6$export$bb8c263ad32caa8 extends Error {
    code;
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
        this.code = options?.code;
        Error.captureStackTrace?.(this, this.constructor);
    }
}
const $ae2e0da65795c7c6$var$decoder = new TextDecoder();
function $ae2e0da65795c7c6$var$e(msg, cause, code) {
    return new $ae2e0da65795c7c6$export$bb8c263ad32caa8(msg, {
        cause: cause,
        code: code
    });
}
function $ae2e0da65795c7c6$var$errorHandler(err) {
    if (err instanceof TypeError || err instanceof $ae2e0da65795c7c6$export$bb8c263ad32caa8 || err instanceof $e0734e0b78b64dca$export$10b74a1a57a5fea2 || err instanceof $e0734e0b78b64dca$export$9ba4842ad1493b35 || err instanceof $e0734e0b78b64dca$export$e8c9940a097b035d) throw err;
    if (err instanceof $e0734e0b78b64dca$export$aa6a6a0f7f354fbf) switch(err.code){
        case $e0734e0b78b64dca$export$6b11590cd6c9e2e5:
            throw $ae2e0da65795c7c6$var$e('only requests to HTTPS are allowed', err, err.code);
        case $e0734e0b78b64dca$export$e324cc317a4199fc:
            throw $ae2e0da65795c7c6$var$e('only requests to HTTP or HTTPS are allowed', err, err.code);
        case $e0734e0b78b64dca$export$d685a0ca6b1d1c11:
            throw $ae2e0da65795c7c6$var$e('unexpected HTTP response status code', err.cause, err.code);
        case $e0734e0b78b64dca$export$a846b8736a86183d:
            throw $ae2e0da65795c7c6$var$e('unexpected response content-type', err.cause, err.code);
        case $e0734e0b78b64dca$export$2ecaad7eb5cc1f25:
            throw $ae2e0da65795c7c6$var$e('parsing error occured', err, err.code);
        case $e0734e0b78b64dca$export$a95f69ec43d8404:
            throw $ae2e0da65795c7c6$var$e('invalid response encountered', err, err.code);
        case $e0734e0b78b64dca$export$755cfb9d9708df13:
            throw $ae2e0da65795c7c6$var$e('unexpected JWT claim value encountered', err, err.code);
        case $e0734e0b78b64dca$export$cbbd45b2b4b65c94:
            throw $ae2e0da65795c7c6$var$e('unexpected JSON attribute value encountered', err, err.code);
        case $e0734e0b78b64dca$export$e256757118ff9e88:
            throw $ae2e0da65795c7c6$var$e('JWT timestamp claim value failed validation', err, err.code);
        default:
            throw $ae2e0da65795c7c6$var$e(err.message, err, err.code);
    }
    if (err instanceof $e0734e0b78b64dca$export$ab59e00737fb22e6) throw $ae2e0da65795c7c6$var$e('unsupported operation', err, err.code);
    if (err instanceof DOMException) switch(err.name){
        case 'OperationError':
            throw $ae2e0da65795c7c6$var$e('runtime operation error', err, $e0734e0b78b64dca$export$32f5e317a183f59);
        case 'NotSupportedError':
            throw $ae2e0da65795c7c6$var$e('runtime unsupported operation', err, $e0734e0b78b64dca$export$32f5e317a183f59);
        case 'TimeoutError':
            throw $ae2e0da65795c7c6$var$e('operation timed out', err, 'OAUTH_TIMEOUT');
        case 'AbortError':
            throw $ae2e0da65795c7c6$var$e('operation aborted', err, 'OAUTH_ABORT');
    }
    throw new $ae2e0da65795c7c6$export$bb8c263ad32caa8('something went wrong', {
        cause: err
    });
}
function $ae2e0da65795c7c6$export$abea2d7b98553bf5(alg, options) {
    return $e0734e0b78b64dca$export$a949d36eab55b41f(alg ?? 'ES256', {
        extractable: options?.extractable
    }).catch($ae2e0da65795c7c6$var$errorHandler);
}
function $ae2e0da65795c7c6$var$handleEntraId(server, as, options) {
    if (server.origin === 'https://login.microsoftonline.com' && (!options?.algorithm || options.algorithm === 'oidc')) {
        as[$ae2e0da65795c7c6$var$kEntraId] = true;
        return true;
    }
    return false;
}
function $ae2e0da65795c7c6$var$handleB2Clogin(server, options) {
    if (server.hostname.endsWith('.b2clogin.com') && (!options?.algorithm || options.algorithm === 'oidc')) return true;
    return false;
}
async function $ae2e0da65795c7c6$export$b2ed21e4bb4868ed(server, metadata, clientAuthentication, options) {
    let as;
    if (options?.flag === $ae2e0da65795c7c6$var$retry) as = options.as;
    else as = await $ae2e0da65795c7c6$var$performDiscovery(server, options);
    const clockSkew = metadata[$e0734e0b78b64dca$export$b708b81a4ce6a399] ?? 0;
    const clockTolerance = metadata[$e0734e0b78b64dca$export$5f7768254837f408] ?? 30;
    metadata = structuredClone(metadata);
    const timeout = options?.timeout ?? 30;
    const signal = AbortSignal.timeout(timeout * 1000);
    let registered;
    try {
        registered = await $e0734e0b78b64dca$export$eac8c7b33276e8ed(as, metadata, {
            initialAccessToken: options?.initialAccessToken,
            DPoP: options?.DPoP,
            headers: new Headers($ae2e0da65795c7c6$var$headers),
            [$e0734e0b78b64dca$export$1512182a095696a1]: options?.[$ae2e0da65795c7c6$export$1512182a095696a1],
            [$e0734e0b78b64dca$export$7df29a6c2173f26b]: options?.execute?.includes($ae2e0da65795c7c6$export$7df29a6c2173f26b),
            signal: signal
        }).then($e0734e0b78b64dca$export$8d16851174446714);
    } catch (err) {
        if ($ae2e0da65795c7c6$var$retryable(err, options)) return $ae2e0da65795c7c6$export$b2ed21e4bb4868ed(server, metadata, clientAuthentication, {
            ...options,
            flag: $ae2e0da65795c7c6$var$retry,
            as: as
        });
        $ae2e0da65795c7c6$var$errorHandler(err);
    }
    registered[$e0734e0b78b64dca$export$b708b81a4ce6a399] = clockSkew;
    registered[$e0734e0b78b64dca$export$5f7768254837f408] = clockTolerance;
    const instance = new $ae2e0da65795c7c6$export$fa89be98fe0936f2(as, registered.client_id, registered, clientAuthentication);
    let internals = $ae2e0da65795c7c6$var$int(instance);
    if (options?.[$ae2e0da65795c7c6$export$1512182a095696a1]) internals.fetch = options[$ae2e0da65795c7c6$export$1512182a095696a1];
    if (options?.timeout) internals.timeout = options.timeout;
    if (options?.execute) for (const extension of options.execute)extension(instance);
    return instance;
}
async function $ae2e0da65795c7c6$export$2456e7437e919cd0(server, clientId, metadata, clientAuthentication, options) {
    const as = await $ae2e0da65795c7c6$var$performDiscovery(server, options);
    const instance = new $ae2e0da65795c7c6$export$fa89be98fe0936f2(as, clientId, metadata, clientAuthentication);
    let internals = $ae2e0da65795c7c6$var$int(instance);
    if (options?.[$ae2e0da65795c7c6$export$1512182a095696a1]) internals.fetch = options[$ae2e0da65795c7c6$export$1512182a095696a1];
    if (options?.timeout) internals.timeout = options.timeout;
    if (options?.execute) for (const extension of options.execute)extension(instance);
    return instance;
}
async function $ae2e0da65795c7c6$var$performDiscovery(server, options) {
    if (!(server instanceof URL)) throw $ae2e0da65795c7c6$var$CodedTypeError('"server" must be an instance of URL', $ae2e0da65795c7c6$var$ERR_INVALID_ARG_TYPE);
    const resolve = !server.href.includes('/.well-known/');
    const timeout = options?.timeout ?? 30;
    const signal = AbortSignal.timeout(timeout * 1000);
    const as = await (resolve ? $e0734e0b78b64dca$export$addcddb71479c5e9(server, {
        algorithm: options?.algorithm,
        [$e0734e0b78b64dca$export$1512182a095696a1]: options?.[$ae2e0da65795c7c6$export$1512182a095696a1],
        [$e0734e0b78b64dca$export$7df29a6c2173f26b]: options?.execute?.includes($ae2e0da65795c7c6$export$7df29a6c2173f26b),
        signal: signal,
        headers: new Headers($ae2e0da65795c7c6$var$headers)
    }) : (options?.[$ae2e0da65795c7c6$export$1512182a095696a1] || fetch)((()=>{
        $e0734e0b78b64dca$export$c0232e93d81db550(server, options?.execute?.includes($ae2e0da65795c7c6$export$7df29a6c2173f26b) ? false : true);
        return server.href;
    })(), {
        headers: Object.fromEntries(new Headers({
            accept: 'application/json',
            ...$ae2e0da65795c7c6$var$headers
        }).entries()),
        body: undefined,
        method: 'GET',
        redirect: 'manual',
        signal: signal
    })).then((response)=>$e0734e0b78b64dca$export$21080005ccae27cc($e0734e0b78b64dca$export$910be5ca85535298, response)).catch($ae2e0da65795c7c6$var$errorHandler);
    if (resolve && new URL(as.issuer).href !== server.href) $ae2e0da65795c7c6$var$handleEntraId(server, as, options) || $ae2e0da65795c7c6$var$handleB2Clogin(server, options) || (()=>{
        throw new $ae2e0da65795c7c6$export$bb8c263ad32caa8('discovered metadata issuer does not match the expected issuer', {
            code: $e0734e0b78b64dca$export$cbbd45b2b4b65c94,
            cause: {
                expected: server.href,
                body: as,
                attribute: 'issuer'
            }
        });
    })();
    return as;
}
function $ae2e0da65795c7c6$var$isRsaOaep(input) {
    return input.name === 'RSA-OAEP';
}
function $ae2e0da65795c7c6$var$isEcdh(input) {
    return input.name === 'ECDH';
}
const $ae2e0da65795c7c6$var$ecdhEs = 'ECDH-ES';
const $ae2e0da65795c7c6$var$ecdhEsA128Kw = 'ECDH-ES+A128KW';
const $ae2e0da65795c7c6$var$ecdhEsA192Kw = 'ECDH-ES+A192KW';
const $ae2e0da65795c7c6$var$ecdhEsA256Kw = 'ECDH-ES+A256KW';
function $ae2e0da65795c7c6$var$checkEcdhAlg(algs, alg, pk) {
    switch(alg){
        case undefined:
            algs.add($ae2e0da65795c7c6$var$ecdhEs);
            algs.add($ae2e0da65795c7c6$var$ecdhEsA128Kw);
            algs.add($ae2e0da65795c7c6$var$ecdhEsA192Kw);
            algs.add($ae2e0da65795c7c6$var$ecdhEsA256Kw);
            break;
        case $ae2e0da65795c7c6$var$ecdhEs:
        case $ae2e0da65795c7c6$var$ecdhEsA128Kw:
        case $ae2e0da65795c7c6$var$ecdhEsA192Kw:
        case $ae2e0da65795c7c6$var$ecdhEsA256Kw:
            algs.add(alg);
            break;
        default:
            throw $ae2e0da65795c7c6$var$CodedTypeError('invalid key alg', $ae2e0da65795c7c6$var$ERR_INVALID_ARG_VALUE, {
                pk: pk
            });
    }
}
function $ae2e0da65795c7c6$export$81049353cd4ef5ca(config, contentEncryptionAlgorithms = [
    'A128GCM',
    'A192GCM',
    'A256GCM',
    'A128CBC-HS256',
    'A192CBC-HS384',
    'A256CBC-HS512'
], ...keys) {
    if ($ae2e0da65795c7c6$var$int(config).decrypt !== undefined) throw new TypeError('enableDecryptingResponses can only be called on a given Configuration instance once');
    if (keys.length === 0) throw $ae2e0da65795c7c6$var$CodedTypeError('no keys were provided', $ae2e0da65795c7c6$var$ERR_INVALID_ARG_VALUE);
    const algs = new Set();
    const normalized = [];
    for (const pk of keys){
        let key;
        if ('key' in pk) {
            key = {
                key: pk.key
            };
            if (typeof pk.alg === 'string') key.alg = pk.alg;
            if (typeof pk.kid === 'string') key.kid = pk.kid;
        } else key = {
            key: pk
        };
        if (key.key.type !== 'private') throw $ae2e0da65795c7c6$var$CodedTypeError('only private keys must be provided', $ae2e0da65795c7c6$var$ERR_INVALID_ARG_VALUE);
        if ($ae2e0da65795c7c6$var$isRsaOaep(key.key.algorithm)) switch(key.key.algorithm.hash.name){
            case 'SHA-1':
            case 'SHA-256':
            case 'SHA-384':
            case 'SHA-512':
                {
                    let alg = 'RSA-OAEP';
                    let sha;
                    if (sha = parseInt(key.key.algorithm.hash.name.slice(-3), 10)) alg = `${alg}-${sha}`;
                    key.alg ||= alg;
                    if (alg !== key.alg) throw $ae2e0da65795c7c6$var$CodedTypeError('invalid key alg', $ae2e0da65795c7c6$var$ERR_INVALID_ARG_VALUE, {
                        pk: pk
                    });
                    algs.add(key.alg);
                    break;
                }
            default:
                throw $ae2e0da65795c7c6$var$CodedTypeError('only SHA-512, SHA-384, SHA-256, and SHA-1 RSA-OAEP keys are supported', $ae2e0da65795c7c6$var$ERR_INVALID_ARG_VALUE);
        }
        else if ($ae2e0da65795c7c6$var$isEcdh(key.key.algorithm)) {
            if (key.key.algorithm.namedCurve !== 'P-256') throw $ae2e0da65795c7c6$var$CodedTypeError('Only P-256 ECDH keys are supported', $ae2e0da65795c7c6$var$ERR_INVALID_ARG_VALUE);
            $ae2e0da65795c7c6$var$checkEcdhAlg(algs, key.alg, pk);
        } else if (key.key.algorithm.name === 'X25519') $ae2e0da65795c7c6$var$checkEcdhAlg(algs, key.alg, pk);
        else throw $ae2e0da65795c7c6$var$CodedTypeError('only RSA-OAEP, ECDH, or X25519 keys are supported', $ae2e0da65795c7c6$var$ERR_INVALID_ARG_VALUE);
        normalized.push(key);
    }
    $ae2e0da65795c7c6$var$int(config).decrypt = async (jwe)=>$ae2e0da65795c7c6$var$decrypt(normalized, jwe, contentEncryptionAlgorithms, [
            ...algs
        ]).catch($ae2e0da65795c7c6$var$errorHandler);
}
function $ae2e0da65795c7c6$var$checkCryptoKey(key, alg, epk) {
    if (alg.startsWith('RSA-OAEP')) return true;
    if (alg.startsWith('ECDH-ES')) {
        if (key.algorithm.name !== 'ECDH' && key.algorithm.name !== 'X25519') return false;
        if (key.algorithm.name === 'ECDH') return epk?.crv === key.algorithm.namedCurve;
        if (key.algorithm.name === 'X25519') return epk?.crv === 'X25519';
    }
    return false;
}
function $ae2e0da65795c7c6$var$selectCryptoKeyForDecryption(keys, alg, kid, epk) {
    const { 0: key, length: length } = keys.filter((key)=>{
        if (kid !== key.kid) return false;
        if (key.alg && alg !== key.alg) return false;
        return $ae2e0da65795c7c6$var$checkCryptoKey(key.key, alg, epk);
    });
    if (!key) throw $ae2e0da65795c7c6$var$e('no applicable decryption key selected', undefined, 'OAUTH_DECRYPTION_FAILED');
    if (length !== 1) throw $ae2e0da65795c7c6$var$e('multiple applicable decryption keys selected', undefined, 'OAUTH_DECRYPTION_FAILED');
    return key.key;
}
async function $ae2e0da65795c7c6$var$decrypt(keys, jwe, contentEncryptionAlgorithms, keyManagementAlgorithms) {
    return $ae2e0da65795c7c6$var$decoder.decode((await (0, $77ae55cdcb579f17$export$c9a8efe6bfd872ce)(jwe, (header)=>{
        const { kid: kid, alg: alg, epk: epk } = header;
        return $ae2e0da65795c7c6$var$selectCryptoKeyForDecryption(keys, alg, kid, epk);
    }, {
        keyManagementAlgorithms: keyManagementAlgorithms,
        contentEncryptionAlgorithms: contentEncryptionAlgorithms
    }).catch((err)=>{
        if (err instanceof (0, $be9270265a128b70$export$f754d6850d76bf87)) throw $ae2e0da65795c7c6$var$e('decryption failed', err, 'OAUTH_DECRYPTION_FAILED');
        $ae2e0da65795c7c6$var$errorHandler(err);
    })).plaintext);
}
function $ae2e0da65795c7c6$var$getServerHelpers(metadata) {
    return {
        supportsPKCE: {
            __proto__: null,
            value (method = 'S256') {
                return metadata.code_challenge_methods_supported?.includes(method) === true;
            }
        }
    };
}
function $ae2e0da65795c7c6$var$addServerHelpers(metadata) {
    Object.defineProperties(metadata, $ae2e0da65795c7c6$var$getServerHelpers(metadata));
}
const $ae2e0da65795c7c6$var$kEntraId = Symbol();
class $ae2e0da65795c7c6$export$fa89be98fe0936f2 {
    constructor(server, clientId, metadata, clientAuthentication){
        if (typeof clientId !== 'string' || !clientId.length) throw $ae2e0da65795c7c6$var$CodedTypeError('"clientId" must be a non-empty string', $ae2e0da65795c7c6$var$ERR_INVALID_ARG_TYPE);
        if (typeof metadata === 'string') metadata = {
            client_secret: metadata
        };
        if (metadata?.client_id !== undefined && clientId !== metadata.client_id) throw $ae2e0da65795c7c6$var$CodedTypeError('"clientId" and "metadata.client_id" must be the same', $ae2e0da65795c7c6$var$ERR_INVALID_ARG_VALUE);
        const client = {
            ...structuredClone(metadata),
            client_id: clientId
        };
        client[$e0734e0b78b64dca$export$b708b81a4ce6a399] = metadata?.[$e0734e0b78b64dca$export$b708b81a4ce6a399] ?? 0;
        client[$e0734e0b78b64dca$export$5f7768254837f408] = metadata?.[$e0734e0b78b64dca$export$5f7768254837f408] ?? 30;
        let auth;
        if (clientAuthentication) auth = clientAuthentication;
        else if (typeof client.client_secret === 'string' && client.client_secret.length) auth = $ae2e0da65795c7c6$export$d0f6cb9d2fa8a5e4(client.client_secret);
        else auth = $ae2e0da65795c7c6$export$57ca7e07b341709d();
        let c = Object.freeze(client);
        const clone = structuredClone(server);
        if ($ae2e0da65795c7c6$var$kEntraId in server) clone[$e0734e0b78b64dca$export$40bb94adbb055b3] = ({ claims: { tid: tid } })=>server.issuer.replace('{tenantid}', tid);
        let as = Object.freeze(clone);
        $ae2e0da65795c7c6$var$props ||= new WeakMap();
        $ae2e0da65795c7c6$var$props.set(this, {
            __proto__: null,
            as: as,
            c: c,
            auth: auth,
            tlsOnly: true,
            jwksCache: {}
        });
    }
    serverMetadata() {
        const metadata = structuredClone($ae2e0da65795c7c6$var$int(this).as);
        $ae2e0da65795c7c6$var$addServerHelpers(metadata);
        return metadata;
    }
    clientMetadata() {
        const metadata = structuredClone($ae2e0da65795c7c6$var$int(this).c);
        return metadata;
    }
    get timeout() {
        return $ae2e0da65795c7c6$var$int(this).timeout;
    }
    set timeout(value) {
        $ae2e0da65795c7c6$var$int(this).timeout = value;
    }
    get [$ae2e0da65795c7c6$export$1512182a095696a1]() {
        return $ae2e0da65795c7c6$var$int(this).fetch;
    }
    set [$ae2e0da65795c7c6$export$1512182a095696a1](value) {
        $ae2e0da65795c7c6$var$int(this).fetch = value;
    }
}
Object.freeze($ae2e0da65795c7c6$export$fa89be98fe0936f2.prototype);
function $ae2e0da65795c7c6$var$getHelpers(response) {
    let exp = undefined;
    if (response.expires_in !== undefined) {
        const now = new Date();
        now.setSeconds(now.getSeconds() + response.expires_in);
        exp = now.getTime();
    }
    return {
        expiresIn: {
            __proto__: null,
            value () {
                if (exp) {
                    const now = Date.now();
                    if (exp > now) return Math.floor((exp - now) / 1000);
                    return 0;
                }
                return undefined;
            }
        },
        claims: {
            __proto__: null,
            value () {
                try {
                    return $e0734e0b78b64dca$export$3bd2388378bb9d92(this);
                } catch  {
                    return undefined;
                }
            }
        }
    };
}
function $ae2e0da65795c7c6$var$addHelpers(response) {
    Object.defineProperties(response, $ae2e0da65795c7c6$var$getHelpers(response));
}
function $ae2e0da65795c7c6$export$539422a218c26f64(config, keyPair, options) {
    $ae2e0da65795c7c6$var$checkConfig(config);
    return $e0734e0b78b64dca$export$dea928b46d13a16a($ae2e0da65795c7c6$var$int(config).c, keyPair, options);
}
function $ae2e0da65795c7c6$var$wait(interval) {
    return new Promise((resolve)=>{
        setTimeout(resolve, interval * 1000);
    });
}
async function $ae2e0da65795c7c6$export$5b56fd6ee49a481c(config, deviceAuthorizationResponse, parameters, options) {
    $ae2e0da65795c7c6$var$checkConfig(config);
    parameters = new URLSearchParams(parameters);
    let interval = deviceAuthorizationResponse.interval ?? 5;
    const pollingSignal = options?.signal ?? AbortSignal.timeout(deviceAuthorizationResponse.expires_in * 1000);
    try {
        pollingSignal.throwIfAborted();
    } catch (err) {
        $ae2e0da65795c7c6$var$errorHandler(err);
    }
    await $ae2e0da65795c7c6$var$wait(interval);
    const { as: as, c: c, auth: auth, fetch: fetch1, tlsOnly: tlsOnly, nonRepudiation: nonRepudiation, timeout: timeout, decrypt: decrypt } = $ae2e0da65795c7c6$var$int(config);
    const response = await $e0734e0b78b64dca$export$ee649bdc49166378(as, c, auth, deviceAuthorizationResponse.device_code, {
        [$e0734e0b78b64dca$export$1512182a095696a1]: fetch1,
        [$e0734e0b78b64dca$export$7df29a6c2173f26b]: !tlsOnly,
        additionalParameters: parameters,
        DPoP: options?.DPoP,
        headers: new Headers($ae2e0da65795c7c6$var$headers),
        signal: pollingSignal.aborted ? pollingSignal : $ae2e0da65795c7c6$var$signal(timeout)
    }).catch($ae2e0da65795c7c6$var$errorHandler);
    const p = $e0734e0b78b64dca$export$aeb5a01475f96b14(as, c, response, {
        [$e0734e0b78b64dca$export$fe968a6742b93a36]: decrypt
    });
    let result;
    try {
        result = await p;
    } catch (err) {
        if ($ae2e0da65795c7c6$var$retryable(err, options)) return $ae2e0da65795c7c6$export$5b56fd6ee49a481c(config, {
            ...deviceAuthorizationResponse,
            interval: interval
        }, parameters, {
            ...options,
            signal: pollingSignal,
            flag: $ae2e0da65795c7c6$var$retry
        });
        if (err instanceof $e0734e0b78b64dca$export$10b74a1a57a5fea2) switch(err.error){
            case 'slow_down':
                interval += 5;
            case 'authorization_pending':
                return $ae2e0da65795c7c6$export$5b56fd6ee49a481c(config, {
                    ...deviceAuthorizationResponse,
                    interval: interval
                }, parameters, {
                    ...options,
                    signal: pollingSignal,
                    flag: undefined
                });
        }
        $ae2e0da65795c7c6$var$errorHandler(err);
    }
    result.id_token && await nonRepudiation?.(response);
    $ae2e0da65795c7c6$var$addHelpers(result);
    return result;
}
async function $ae2e0da65795c7c6$export$ab563bc9b14e151c(config, parameters) {
    $ae2e0da65795c7c6$var$checkConfig(config);
    const { as: as, c: c, auth: auth, fetch: fetch1, tlsOnly: tlsOnly, timeout: timeout } = $ae2e0da65795c7c6$var$int(config);
    return $e0734e0b78b64dca$export$294e577320311324(as, c, auth, parameters, {
        [$e0734e0b78b64dca$export$1512182a095696a1]: fetch1,
        [$e0734e0b78b64dca$export$7df29a6c2173f26b]: !tlsOnly,
        headers: new Headers($ae2e0da65795c7c6$var$headers),
        signal: $ae2e0da65795c7c6$var$signal(timeout)
    }).then((response)=>$e0734e0b78b64dca$export$15321a02b54ab69c(as, c, response)).catch($ae2e0da65795c7c6$var$errorHandler);
}
async function $ae2e0da65795c7c6$export$55ff6e78e85cde78(config, parameters) {
    $ae2e0da65795c7c6$var$checkConfig(config);
    const { as: as, c: c, auth: auth, fetch: fetch1, tlsOnly: tlsOnly, timeout: timeout } = $ae2e0da65795c7c6$var$int(config);
    return $e0734e0b78b64dca$export$ea7d44245d53d41e(as, c, auth, parameters, {
        [$e0734e0b78b64dca$export$1512182a095696a1]: fetch1,
        [$e0734e0b78b64dca$export$7df29a6c2173f26b]: !tlsOnly,
        headers: new Headers($ae2e0da65795c7c6$var$headers),
        signal: $ae2e0da65795c7c6$var$signal(timeout)
    }).then((response)=>$e0734e0b78b64dca$export$2ded870eef8da757(as, c, response)).catch($ae2e0da65795c7c6$var$errorHandler);
}
async function $ae2e0da65795c7c6$export$dd1dccf35030b65e(config, backchannelAuthenticationResponse, parameters, options) {
    $ae2e0da65795c7c6$var$checkConfig(config);
    parameters = new URLSearchParams(parameters);
    let interval = backchannelAuthenticationResponse.interval ?? 5;
    const pollingSignal = options?.signal ?? AbortSignal.timeout(backchannelAuthenticationResponse.expires_in * 1000);
    try {
        pollingSignal.throwIfAborted();
    } catch (err) {
        $ae2e0da65795c7c6$var$errorHandler(err);
    }
    await $ae2e0da65795c7c6$var$wait(interval);
    const { as: as, c: c, auth: auth, fetch: fetch1, tlsOnly: tlsOnly, nonRepudiation: nonRepudiation, timeout: timeout, decrypt: decrypt } = $ae2e0da65795c7c6$var$int(config);
    const response = await $e0734e0b78b64dca$export$287a788838ab9583(as, c, auth, backchannelAuthenticationResponse.auth_req_id, {
        [$e0734e0b78b64dca$export$1512182a095696a1]: fetch1,
        [$e0734e0b78b64dca$export$7df29a6c2173f26b]: !tlsOnly,
        additionalParameters: parameters,
        DPoP: options?.DPoP,
        headers: new Headers($ae2e0da65795c7c6$var$headers),
        signal: pollingSignal.aborted ? pollingSignal : $ae2e0da65795c7c6$var$signal(timeout)
    }).catch($ae2e0da65795c7c6$var$errorHandler);
    const p = $e0734e0b78b64dca$export$52147d87e73f0b0(as, c, response, {
        [$e0734e0b78b64dca$export$fe968a6742b93a36]: decrypt
    });
    let result;
    try {
        result = await p;
    } catch (err) {
        if ($ae2e0da65795c7c6$var$retryable(err, options)) return $ae2e0da65795c7c6$export$dd1dccf35030b65e(config, {
            ...backchannelAuthenticationResponse,
            interval: interval
        }, parameters, {
            ...options,
            signal: pollingSignal,
            flag: $ae2e0da65795c7c6$var$retry
        });
        if (err instanceof $e0734e0b78b64dca$export$10b74a1a57a5fea2) switch(err.error){
            case 'slow_down':
                interval += 5;
            case 'authorization_pending':
                return $ae2e0da65795c7c6$export$dd1dccf35030b65e(config, {
                    ...backchannelAuthenticationResponse,
                    interval: interval
                }, parameters, {
                    ...options,
                    signal: pollingSignal,
                    flag: undefined
                });
        }
        $ae2e0da65795c7c6$var$errorHandler(err);
    }
    result.id_token && await nonRepudiation?.(response);
    $ae2e0da65795c7c6$var$addHelpers(result);
    return result;
}
function $ae2e0da65795c7c6$export$7df29a6c2173f26b(config) {
    $ae2e0da65795c7c6$var$int(config).tlsOnly = false;
}
function $ae2e0da65795c7c6$export$db9838bbb139195(config, jwksCache) {
    $ae2e0da65795c7c6$var$int(config).jwksCache = structuredClone(jwksCache);
}
function $ae2e0da65795c7c6$export$164ee8126dcf3b3(config) {
    const cache = $ae2e0da65795c7c6$var$int(config).jwksCache;
    if (cache.uat) return cache;
    return undefined;
}
function $ae2e0da65795c7c6$export$d32afbca34feaf89(config) {
    $ae2e0da65795c7c6$var$checkConfig(config);
    $ae2e0da65795c7c6$var$int(config).nonRepudiation = (response)=>{
        const { as: as, fetch: fetch1, tlsOnly: tlsOnly, timeout: timeout, jwksCache: jwksCache } = $ae2e0da65795c7c6$var$int(config);
        return $e0734e0b78b64dca$export$5e65027d616da1c9(as, response, {
            [$e0734e0b78b64dca$export$1512182a095696a1]: fetch1,
            [$e0734e0b78b64dca$export$7df29a6c2173f26b]: !tlsOnly,
            headers: new Headers($ae2e0da65795c7c6$var$headers),
            signal: $ae2e0da65795c7c6$var$signal(timeout),
            [$e0734e0b78b64dca$export$68a3c8fa6edea323]: jwksCache
        }).catch($ae2e0da65795c7c6$var$errorHandler);
    };
}
function $ae2e0da65795c7c6$export$5035b18c251704ac(config) {
    $ae2e0da65795c7c6$var$checkConfig(config);
    const { hybrid: hybrid, implicit: implicit } = $ae2e0da65795c7c6$var$int(config);
    if (hybrid || implicit) throw $ae2e0da65795c7c6$var$e('JARM cannot be combined with a hybrid or implicit response types', undefined, $e0734e0b78b64dca$export$32f5e317a183f59);
    $ae2e0da65795c7c6$var$int(config).jarm = (authorizationResponse, expectedState)=>$ae2e0da65795c7c6$var$validateJARMResponse(config, authorizationResponse, expectedState);
}
function $ae2e0da65795c7c6$export$7b23364be6415d27(config) {
    if (!$ae2e0da65795c7c6$var$int(config).hybrid) throw $ae2e0da65795c7c6$var$e('"code id_token" response type must be configured to be used first', undefined, $e0734e0b78b64dca$export$32f5e317a183f59);
    $ae2e0da65795c7c6$var$int(config).hybrid = (authorizationResponse, expectedNonce, expectedState, maxAge)=>$ae2e0da65795c7c6$var$validateCodeIdTokenResponse(config, authorizationResponse, expectedNonce, expectedState, maxAge, true);
}
async function $ae2e0da65795c7c6$export$f84b300f42ee5046(config, currentUrl, expectedNonce, checks) {
    $ae2e0da65795c7c6$var$checkConfig(config);
    if (!(currentUrl instanceof URL) && !$ae2e0da65795c7c6$var$webInstanceOf(currentUrl, 'Request')) throw $ae2e0da65795c7c6$var$CodedTypeError('"currentUrl" must be an instance of URL, or Request', $ae2e0da65795c7c6$var$ERR_INVALID_ARG_TYPE);
    if (typeof expectedNonce !== 'string') throw $ae2e0da65795c7c6$var$CodedTypeError('"expectedNonce" must be a string', $ae2e0da65795c7c6$var$ERR_INVALID_ARG_TYPE);
    const { as: as, c: c, fetch: fetch1, tlsOnly: tlsOnly, timeout: timeout, decrypt: decrypt, implicit: implicit, jwksCache: jwksCache } = $ae2e0da65795c7c6$var$int(config);
    if (!implicit) throw new TypeError('implicitAuthentication() cannot be used by clients using flows other than response_type=id_token');
    let params;
    if (!(currentUrl instanceof URL)) {
        const request = currentUrl;
        switch(request.method){
            case 'GET':
                params = new URLSearchParams(new URL(request.url).hash.slice(1));
                break;
            case 'POST':
                params = new URLSearchParams(await $e0734e0b78b64dca$export$647dd3a9c5418c5e(request));
                break;
            default:
                throw $ae2e0da65795c7c6$var$CodedTypeError('unexpected Request HTTP method', $ae2e0da65795c7c6$var$ERR_INVALID_ARG_VALUE);
        }
    } else params = new URLSearchParams(currentUrl.hash.slice(1));
    try {
        {
            const decoy = new URLSearchParams(params);
            decoy.delete('id_token');
            $e0734e0b78b64dca$export$d683f58fbab347ba({
                ...as,
                authorization_response_iss_parameter_supported: undefined
            }, c, decoy, checks?.expectedState);
        }
        {
            const decoy = new Response(JSON.stringify({
                access_token: 'decoy',
                token_type: 'bearer',
                id_token: params.get('id_token')
            }), {
                headers: new Headers({
                    'content-type': 'application/json'
                })
            });
            const ref = await $e0734e0b78b64dca$export$2c578c716b290815(as, c, decoy, {
                expectedNonce: expectedNonce,
                maxAge: checks?.maxAge,
                [$e0734e0b78b64dca$export$fe968a6742b93a36]: decrypt
            });
            await $e0734e0b78b64dca$export$5e65027d616da1c9(as, decoy, {
                [$e0734e0b78b64dca$export$1512182a095696a1]: fetch1,
                [$e0734e0b78b64dca$export$7df29a6c2173f26b]: !tlsOnly,
                headers: new Headers($ae2e0da65795c7c6$var$headers),
                signal: $ae2e0da65795c7c6$var$signal(timeout),
                [$e0734e0b78b64dca$export$68a3c8fa6edea323]: jwksCache
            });
            return $e0734e0b78b64dca$export$3bd2388378bb9d92(ref);
        }
    } catch (err) {
        $ae2e0da65795c7c6$var$errorHandler(err);
    }
}
function $ae2e0da65795c7c6$export$5bb2914163e0f9cc(config) {
    $ae2e0da65795c7c6$var$checkConfig(config);
    const { jarm: jarm, implicit: implicit } = $ae2e0da65795c7c6$var$int(config);
    if (jarm || implicit) throw $ae2e0da65795c7c6$var$e('"code id_token" response type cannot be combined with JARM or implicit response type', undefined, $e0734e0b78b64dca$export$32f5e317a183f59);
    $ae2e0da65795c7c6$var$int(config).hybrid = (authorizationResponse, expectedNonce, expectedState, maxAge)=>$ae2e0da65795c7c6$var$validateCodeIdTokenResponse(config, authorizationResponse, expectedNonce, expectedState, maxAge, false);
}
function $ae2e0da65795c7c6$export$3b0dfb16e7526641(config) {
    $ae2e0da65795c7c6$var$checkConfig(config);
    const { jarm: jarm, hybrid: hybrid } = $ae2e0da65795c7c6$var$int(config);
    if (jarm || hybrid) throw $ae2e0da65795c7c6$var$e('"id_token" response type cannot be combined with JARM or hybrid response type', undefined, $e0734e0b78b64dca$export$32f5e317a183f59);
    $ae2e0da65795c7c6$var$int(config).implicit = true;
}
function $ae2e0da65795c7c6$var$stripParams(url) {
    url = new URL(url);
    url.search = '';
    url.hash = '';
    return url.href;
}
function $ae2e0da65795c7c6$var$webInstanceOf(input, toStringTag) {
    try {
        return Object.getPrototypeOf(input)[Symbol.toStringTag] === toStringTag;
    } catch  {
        return false;
    }
}
async function $ae2e0da65795c7c6$export$7b3b73487f398bc(config, currentUrl, checks, tokenEndpointParameters, options) {
    $ae2e0da65795c7c6$var$checkConfig(config);
    if (options?.flag !== $ae2e0da65795c7c6$var$retry && !(currentUrl instanceof URL) && !$ae2e0da65795c7c6$var$webInstanceOf(currentUrl, 'Request')) throw $ae2e0da65795c7c6$var$CodedTypeError('"currentUrl" must be an instance of URL, or Request', $ae2e0da65795c7c6$var$ERR_INVALID_ARG_TYPE);
    let authResponse;
    let redirectUri;
    const { as: as, c: c, auth: auth, fetch: fetch1, tlsOnly: tlsOnly, jarm: jarm, hybrid: hybrid, nonRepudiation: nonRepudiation, timeout: timeout, decrypt: decrypt, implicit: implicit } = $ae2e0da65795c7c6$var$int(config);
    if (options?.flag === $ae2e0da65795c7c6$var$retry) {
        authResponse = options.authResponse;
        redirectUri = options.redirectUri;
    } else {
        if (!(currentUrl instanceof URL)) {
            const request = currentUrl;
            currentUrl = new URL(currentUrl.url);
            switch(request.method){
                case 'GET':
                    break;
                case 'POST':
                    const params = new URLSearchParams(await $e0734e0b78b64dca$export$647dd3a9c5418c5e(request));
                    if (hybrid) currentUrl.hash = params.toString();
                    else for (const [k, v] of params.entries())currentUrl.searchParams.append(k, v);
                    break;
                default:
                    throw $ae2e0da65795c7c6$var$CodedTypeError('unexpected Request HTTP method', $ae2e0da65795c7c6$var$ERR_INVALID_ARG_VALUE);
            }
        }
        redirectUri = $ae2e0da65795c7c6$var$stripParams(currentUrl);
        switch(true){
            case !!jarm:
                authResponse = await jarm(currentUrl, checks?.expectedState);
                break;
            case !!hybrid:
                authResponse = await hybrid(currentUrl, checks?.expectedNonce, checks?.expectedState, checks?.maxAge);
                break;
            case !!implicit:
                throw new TypeError('authorizationCodeGrant() cannot be used by response_type=id_token clients');
            default:
                try {
                    authResponse = $e0734e0b78b64dca$export$d683f58fbab347ba(as, c, currentUrl.searchParams, checks?.expectedState);
                } catch (err) {
                    $ae2e0da65795c7c6$var$errorHandler(err);
                }
        }
    }
    const response = await $e0734e0b78b64dca$export$78262594e8327622(as, c, auth, authResponse, redirectUri, checks?.pkceCodeVerifier || $e0734e0b78b64dca$export$45246453d97b4076, {
        additionalParameters: tokenEndpointParameters,
        [$e0734e0b78b64dca$export$1512182a095696a1]: fetch1,
        [$e0734e0b78b64dca$export$7df29a6c2173f26b]: !tlsOnly,
        DPoP: options?.DPoP,
        headers: new Headers($ae2e0da65795c7c6$var$headers),
        signal: $ae2e0da65795c7c6$var$signal(timeout)
    }).catch($ae2e0da65795c7c6$var$errorHandler);
    if (typeof checks?.expectedNonce === 'string' || typeof checks?.maxAge === 'number') checks.idTokenExpected = true;
    const p = $e0734e0b78b64dca$export$2c578c716b290815(as, c, response, {
        expectedNonce: checks?.expectedNonce,
        maxAge: checks?.maxAge,
        requireIdToken: checks?.idTokenExpected,
        [$e0734e0b78b64dca$export$fe968a6742b93a36]: decrypt
    });
    let result;
    try {
        result = await p;
    } catch (err) {
        if ($ae2e0da65795c7c6$var$retryable(err, options)) return $ae2e0da65795c7c6$export$7b3b73487f398bc(config, undefined, checks, tokenEndpointParameters, {
            ...options,
            flag: $ae2e0da65795c7c6$var$retry,
            authResponse: authResponse,
            redirectUri: redirectUri
        });
        $ae2e0da65795c7c6$var$errorHandler(err);
    }
    result.id_token && await nonRepudiation?.(response);
    $ae2e0da65795c7c6$var$addHelpers(result);
    return result;
}
async function $ae2e0da65795c7c6$var$validateJARMResponse(config, authorizationResponse, expectedState) {
    const { as: as, c: c, fetch: fetch1, tlsOnly: tlsOnly, timeout: timeout, decrypt: decrypt, jwksCache: jwksCache } = $ae2e0da65795c7c6$var$int(config);
    return $e0734e0b78b64dca$export$d8e5c03b915f0e3f(as, c, authorizationResponse, expectedState, {
        [$e0734e0b78b64dca$export$1512182a095696a1]: fetch1,
        [$e0734e0b78b64dca$export$7df29a6c2173f26b]: !tlsOnly,
        headers: new Headers($ae2e0da65795c7c6$var$headers),
        signal: $ae2e0da65795c7c6$var$signal(timeout),
        [$e0734e0b78b64dca$export$fe968a6742b93a36]: decrypt,
        [$e0734e0b78b64dca$export$68a3c8fa6edea323]: jwksCache
    }).catch($ae2e0da65795c7c6$var$errorHandler);
}
async function $ae2e0da65795c7c6$var$validateCodeIdTokenResponse(config, authorizationResponse, expectedNonce, expectedState, maxAge, fapi) {
    if (typeof expectedNonce !== 'string') throw $ae2e0da65795c7c6$var$CodedTypeError('"expectedNonce" must be a string', $ae2e0da65795c7c6$var$ERR_INVALID_ARG_TYPE);
    if (expectedState !== undefined && typeof expectedState !== 'string') throw $ae2e0da65795c7c6$var$CodedTypeError('"expectedState" must be a string', $ae2e0da65795c7c6$var$ERR_INVALID_ARG_TYPE);
    const { as: as, c: c, fetch: fetch1, tlsOnly: tlsOnly, timeout: timeout, decrypt: decrypt, jwksCache: jwksCache } = $ae2e0da65795c7c6$var$int(config);
    return (fapi ? $e0734e0b78b64dca$export$b9adc54dc449ec30 : $e0734e0b78b64dca$export$a78ffc30be489eac)(as, c, authorizationResponse, expectedNonce, expectedState, maxAge, {
        [$e0734e0b78b64dca$export$1512182a095696a1]: fetch1,
        [$e0734e0b78b64dca$export$7df29a6c2173f26b]: !tlsOnly,
        headers: new Headers($ae2e0da65795c7c6$var$headers),
        signal: $ae2e0da65795c7c6$var$signal(timeout),
        [$e0734e0b78b64dca$export$fe968a6742b93a36]: decrypt,
        [$e0734e0b78b64dca$export$68a3c8fa6edea323]: jwksCache
    }).catch($ae2e0da65795c7c6$var$errorHandler);
}
async function $ae2e0da65795c7c6$export$6d5010d9a99de13b(config, refreshToken, parameters, options) {
    $ae2e0da65795c7c6$var$checkConfig(config);
    parameters = new URLSearchParams(parameters);
    const { as: as, c: c, auth: auth, fetch: fetch1, tlsOnly: tlsOnly, nonRepudiation: nonRepudiation, timeout: timeout, decrypt: decrypt } = $ae2e0da65795c7c6$var$int(config);
    const response = await $e0734e0b78b64dca$export$b5bbb508112f49c9(as, c, auth, refreshToken, {
        [$e0734e0b78b64dca$export$1512182a095696a1]: fetch1,
        [$e0734e0b78b64dca$export$7df29a6c2173f26b]: !tlsOnly,
        additionalParameters: parameters,
        DPoP: options?.DPoP,
        headers: new Headers($ae2e0da65795c7c6$var$headers),
        signal: $ae2e0da65795c7c6$var$signal(timeout)
    }).catch($ae2e0da65795c7c6$var$errorHandler);
    const p = $e0734e0b78b64dca$export$37635a4180b34950(as, c, response, {
        [$e0734e0b78b64dca$export$fe968a6742b93a36]: decrypt
    });
    let result;
    try {
        result = await p;
    } catch (err) {
        if ($ae2e0da65795c7c6$var$retryable(err, options)) return $ae2e0da65795c7c6$export$6d5010d9a99de13b(config, refreshToken, parameters, {
            ...options,
            flag: $ae2e0da65795c7c6$var$retry
        });
        $ae2e0da65795c7c6$var$errorHandler(err);
    }
    result.id_token && await nonRepudiation?.(response);
    $ae2e0da65795c7c6$var$addHelpers(result);
    return result;
}
async function $ae2e0da65795c7c6$export$e0d4b285ff4f15ae(config, parameters, options) {
    $ae2e0da65795c7c6$var$checkConfig(config);
    parameters = new URLSearchParams(parameters);
    const { as: as, c: c, auth: auth, fetch: fetch1, tlsOnly: tlsOnly, timeout: timeout } = $ae2e0da65795c7c6$var$int(config);
    const response = await $e0734e0b78b64dca$export$180dac7d148d2257(as, c, auth, parameters, {
        [$e0734e0b78b64dca$export$1512182a095696a1]: fetch1,
        [$e0734e0b78b64dca$export$7df29a6c2173f26b]: !tlsOnly,
        DPoP: options?.DPoP,
        headers: new Headers($ae2e0da65795c7c6$var$headers),
        signal: $ae2e0da65795c7c6$var$signal(timeout)
    }).catch($ae2e0da65795c7c6$var$errorHandler);
    const p = $e0734e0b78b64dca$export$26635fb30941f4a5(as, c, response);
    let result;
    try {
        result = await p;
    } catch (err) {
        if ($ae2e0da65795c7c6$var$retryable(err, options)) return $ae2e0da65795c7c6$export$e0d4b285ff4f15ae(config, parameters, {
            ...options,
            flag: $ae2e0da65795c7c6$var$retry
        });
        $ae2e0da65795c7c6$var$errorHandler(err);
    }
    $ae2e0da65795c7c6$var$addHelpers(result);
    return result;
}
function $ae2e0da65795c7c6$export$2c13ae2a3bd35235(config, parameters) {
    $ae2e0da65795c7c6$var$checkConfig(config);
    const { as: as, c: c, tlsOnly: tlsOnly, hybrid: hybrid, jarm: jarm, implicit: implicit } = $ae2e0da65795c7c6$var$int(config);
    const authorizationEndpoint = $e0734e0b78b64dca$export$48b88e4e5ecac119(as, 'authorization_endpoint', false, tlsOnly);
    parameters = new URLSearchParams(parameters);
    if (!parameters.has('client_id')) parameters.set('client_id', c.client_id);
    if (!parameters.has('request_uri') && !parameters.has('request')) {
        if (!parameters.has('response_type')) parameters.set('response_type', hybrid ? 'code id_token' : implicit ? 'id_token' : 'code');
        if (implicit && !parameters.has('nonce')) throw $ae2e0da65795c7c6$var$CodedTypeError('response_type=id_token clients must provide a nonce parameter in their authorization request parameters', $ae2e0da65795c7c6$var$ERR_INVALID_ARG_VALUE);
        if (jarm) parameters.set('response_mode', 'jwt');
    }
    for (const [k, v] of parameters.entries())authorizationEndpoint.searchParams.append(k, v);
    return authorizationEndpoint;
}
async function $ae2e0da65795c7c6$export$ee9e847dbcc7f80e(config, parameters, signingKey, options) {
    $ae2e0da65795c7c6$var$checkConfig(config);
    const authorizationEndpoint = $ae2e0da65795c7c6$export$2c13ae2a3bd35235(config, parameters);
    parameters = authorizationEndpoint.searchParams;
    if (!signingKey) throw $ae2e0da65795c7c6$var$CodedTypeError('"signingKey" must be provided', $ae2e0da65795c7c6$var$ERR_INVALID_ARG_VALUE);
    const { as: as, c: c } = $ae2e0da65795c7c6$var$int(config);
    const request = await $e0734e0b78b64dca$export$c57216a8ee03ac8a(as, c, parameters, signingKey, options).catch($ae2e0da65795c7c6$var$errorHandler);
    return $ae2e0da65795c7c6$export$2c13ae2a3bd35235(config, {
        request: request
    });
}
async function $ae2e0da65795c7c6$export$9377b450b0ba016a(config, parameters, options) {
    $ae2e0da65795c7c6$var$checkConfig(config);
    const authorizationEndpoint = $ae2e0da65795c7c6$export$2c13ae2a3bd35235(config, parameters);
    const { as: as, c: c, auth: auth, fetch: fetch1, tlsOnly: tlsOnly, timeout: timeout } = $ae2e0da65795c7c6$var$int(config);
    const response = await $e0734e0b78b64dca$export$8aa8f6630ac0dd7f(as, c, auth, authorizationEndpoint.searchParams, {
        [$e0734e0b78b64dca$export$1512182a095696a1]: fetch1,
        [$e0734e0b78b64dca$export$7df29a6c2173f26b]: !tlsOnly,
        DPoP: options?.DPoP,
        headers: new Headers($ae2e0da65795c7c6$var$headers),
        signal: $ae2e0da65795c7c6$var$signal(timeout)
    }).catch($ae2e0da65795c7c6$var$errorHandler);
    const p = $e0734e0b78b64dca$export$f6b2ca9fe5bf06d7(as, c, response);
    let result;
    try {
        result = await p;
    } catch (err) {
        if ($ae2e0da65795c7c6$var$retryable(err, options)) return $ae2e0da65795c7c6$export$9377b450b0ba016a(config, parameters, {
            ...options,
            flag: $ae2e0da65795c7c6$var$retry
        });
        $ae2e0da65795c7c6$var$errorHandler(err);
    }
    return $ae2e0da65795c7c6$export$2c13ae2a3bd35235(config, {
        request_uri: result.request_uri
    });
}
function $ae2e0da65795c7c6$export$75d04138d8d32581(config, parameters) {
    $ae2e0da65795c7c6$var$checkConfig(config);
    const { as: as, c: c, tlsOnly: tlsOnly } = $ae2e0da65795c7c6$var$int(config);
    const endSessionEndpoint = $e0734e0b78b64dca$export$48b88e4e5ecac119(as, 'end_session_endpoint', false, tlsOnly);
    parameters = new URLSearchParams(parameters);
    if (!parameters.has('client_id')) parameters.set('client_id', c.client_id);
    for (const [k, v] of parameters.entries())endSessionEndpoint.searchParams.append(k, v);
    return endSessionEndpoint;
}
function $ae2e0da65795c7c6$var$checkConfig(input) {
    if (!(input instanceof $ae2e0da65795c7c6$export$fa89be98fe0936f2)) throw $ae2e0da65795c7c6$var$CodedTypeError('"config" must be an instance of Configuration', $ae2e0da65795c7c6$var$ERR_INVALID_ARG_TYPE);
    if (Object.getPrototypeOf(input) !== $ae2e0da65795c7c6$export$fa89be98fe0936f2.prototype) throw $ae2e0da65795c7c6$var$CodedTypeError('subclassing Configuration is not allowed', $ae2e0da65795c7c6$var$ERR_INVALID_ARG_VALUE);
}
function $ae2e0da65795c7c6$var$signal(timeout) {
    return timeout ? AbortSignal.timeout(timeout * 1000) : undefined;
}
async function $ae2e0da65795c7c6$export$eee09f98e5b044aa(config, accessToken, expectedSubject, options) {
    $ae2e0da65795c7c6$var$checkConfig(config);
    const { as: as, c: c, fetch: fetch1, tlsOnly: tlsOnly, nonRepudiation: nonRepudiation, timeout: timeout, decrypt: decrypt } = $ae2e0da65795c7c6$var$int(config);
    const response = await $e0734e0b78b64dca$export$1e6533dcdca12073(as, c, accessToken, {
        [$e0734e0b78b64dca$export$1512182a095696a1]: fetch1,
        [$e0734e0b78b64dca$export$7df29a6c2173f26b]: !tlsOnly,
        DPoP: options?.DPoP,
        headers: new Headers($ae2e0da65795c7c6$var$headers),
        signal: $ae2e0da65795c7c6$var$signal(timeout)
    }).catch($ae2e0da65795c7c6$var$errorHandler);
    let exec = $e0734e0b78b64dca$export$8dbb33ddf3c4a913(as, c, expectedSubject, response, {
        [$e0734e0b78b64dca$export$fe968a6742b93a36]: decrypt
    });
    let result;
    try {
        result = await exec;
    } catch (err) {
        if ($ae2e0da65795c7c6$var$retryable(err, options)) return $ae2e0da65795c7c6$export$eee09f98e5b044aa(config, accessToken, expectedSubject, {
            ...options,
            flag: $ae2e0da65795c7c6$var$retry
        });
        $ae2e0da65795c7c6$var$errorHandler(err);
    }
    $e0734e0b78b64dca$export$1ef77878e4e0b972(response) === 'application/jwt' && await nonRepudiation?.(response);
    return result;
}
function $ae2e0da65795c7c6$var$retryable(err, options) {
    if (options?.DPoP && options.flag !== $ae2e0da65795c7c6$var$retry) return $e0734e0b78b64dca$export$283c6a56651b6b3(err);
    return false;
}
async function $ae2e0da65795c7c6$export$c48ece40b372cd77(config, token, parameters) {
    $ae2e0da65795c7c6$var$checkConfig(config);
    const { as: as, c: c, auth: auth, fetch: fetch1, tlsOnly: tlsOnly, nonRepudiation: nonRepudiation, timeout: timeout, decrypt: decrypt } = $ae2e0da65795c7c6$var$int(config);
    const response = await $e0734e0b78b64dca$export$a6015ffb0bad7c98(as, c, auth, token, {
        [$e0734e0b78b64dca$export$1512182a095696a1]: fetch1,
        [$e0734e0b78b64dca$export$7df29a6c2173f26b]: !tlsOnly,
        additionalParameters: new URLSearchParams(parameters),
        headers: new Headers($ae2e0da65795c7c6$var$headers),
        signal: $ae2e0da65795c7c6$var$signal(timeout)
    }).catch($ae2e0da65795c7c6$var$errorHandler);
    const result = await $e0734e0b78b64dca$export$b50837af7a77c5b3(as, c, response, {
        [$e0734e0b78b64dca$export$fe968a6742b93a36]: decrypt
    }).catch($ae2e0da65795c7c6$var$errorHandler);
    $e0734e0b78b64dca$export$1ef77878e4e0b972(response) === 'application/token-introspection+jwt' && await nonRepudiation?.(response);
    return result;
}
const $ae2e0da65795c7c6$var$retry = Symbol();
async function $ae2e0da65795c7c6$export$75573df07f6071f6(config, grantType, parameters, options) {
    $ae2e0da65795c7c6$var$checkConfig(config);
    const { as: as, c: c, auth: auth, fetch: fetch1, tlsOnly: tlsOnly, timeout: timeout, decrypt: decrypt } = $ae2e0da65795c7c6$var$int(config);
    const result = await $e0734e0b78b64dca$export$fbfac642237c603(as, c, auth, grantType, new URLSearchParams(parameters), {
        [$e0734e0b78b64dca$export$1512182a095696a1]: fetch1,
        [$e0734e0b78b64dca$export$7df29a6c2173f26b]: !tlsOnly,
        DPoP: options?.DPoP,
        headers: new Headers($ae2e0da65795c7c6$var$headers),
        signal: $ae2e0da65795c7c6$var$signal(timeout)
    }).then((response)=>{
        let recognizedTokenTypes;
        if (grantType === 'urn:ietf:params:oauth:grant-type:token-exchange') recognizedTokenTypes = {
            n_a: ()=>{}
        };
        return $e0734e0b78b64dca$export$d889f08c5c5cc0cd(as, c, response, {
            [$e0734e0b78b64dca$export$fe968a6742b93a36]: decrypt,
            recognizedTokenTypes: recognizedTokenTypes
        });
    }).catch($ae2e0da65795c7c6$var$errorHandler);
    $ae2e0da65795c7c6$var$addHelpers(result);
    return result;
}
async function $ae2e0da65795c7c6$export$797fec1d52b59112(config, token, parameters) {
    $ae2e0da65795c7c6$var$checkConfig(config);
    const { as: as, c: c, auth: auth, fetch: fetch1, tlsOnly: tlsOnly, timeout: timeout } = $ae2e0da65795c7c6$var$int(config);
    return $e0734e0b78b64dca$export$a903960abbc67225(as, c, auth, token, {
        [$e0734e0b78b64dca$export$1512182a095696a1]: fetch1,
        [$e0734e0b78b64dca$export$7df29a6c2173f26b]: !tlsOnly,
        additionalParameters: new URLSearchParams(parameters),
        headers: new Headers($ae2e0da65795c7c6$var$headers),
        signal: $ae2e0da65795c7c6$var$signal(timeout)
    }).then($e0734e0b78b64dca$export$f3d92abf544f771c).catch($ae2e0da65795c7c6$var$errorHandler);
}
async function $ae2e0da65795c7c6$export$9709d3e179a1e024(config, accessToken, url, method, body, headers, options) {
    $ae2e0da65795c7c6$var$checkConfig(config);
    headers ||= new Headers();
    if (!headers.has('user-agent')) headers.set('user-agent', $ae2e0da65795c7c6$var$USER_AGENT);
    const { fetch: fetch1, tlsOnly: tlsOnly, timeout: timeout } = $ae2e0da65795c7c6$var$int(config);
    const exec = $e0734e0b78b64dca$export$5156e7f986a031a3(accessToken, method, url, headers, body, {
        [$e0734e0b78b64dca$export$1512182a095696a1]: fetch1,
        [$e0734e0b78b64dca$export$7df29a6c2173f26b]: !tlsOnly,
        DPoP: options?.DPoP,
        signal: $ae2e0da65795c7c6$var$signal(timeout)
    });
    let result;
    try {
        result = await exec;
    } catch (err) {
        if ($ae2e0da65795c7c6$var$retryable(err, options)) return $ae2e0da65795c7c6$export$9709d3e179a1e024(config, accessToken, url, method, body, headers, {
            ...options,
            flag: $ae2e0da65795c7c6$var$retry
        });
        $ae2e0da65795c7c6$var$errorHandler(err);
    }
    return result;
}


async function $8e3c12a99884957c$export$18298bb220d85216({ server: server, clientId: clientId }) {
    const config = await $ae2e0da65795c7c6$export$2456e7437e919cd0(new URL(server), clientId);
    const { authorization_endpoint: authorization_endpoint } = config.serverMetadata();
    return {
        authorizationUrl: authorization_endpoint.toString(),
        clientId: clientId
    };
}
async function $8e3c12a99884957c$export$596d806903d1f59e(env, { nonce: nonce, redirectUri: redirectUri }) {
    const { authorizationUrl: authorizationUrl, clientId: clientId } = await env;
    const url = new URL(authorizationUrl);
    url.searchParams.append("response_type", "id_token");
    url.searchParams.append("client_id", clientId);
    url.searchParams.append("redirect_uri", redirectUri);
    url.searchParams.append("scope", "openid email");
    url.searchParams.append("nonce", nonce);
    window.location = url.href;
}
async function $8e3c12a99884957c$export$875757f72547b5f3() {
    const params = new URLSearchParams(window.location.hash.substring(1));
    return params.get("id_token");
}


var $b19a5f61ff992ce5$exports = {};
$b19a5f61ff992ce5$exports = JSON.parse("{\"authn\":{\"clientId\":\"667992969669-i73bl8o70p1lo8ookp9p0hd602il88lj.apps.googleusercontent.com\"}}");



// src/events/load.ts
var $0b694c174441a21f$export$93d315c41534ba24 = class extends Event {
    constructor(){
        super("wa-load", {
            bubbles: true,
            cancelable: false,
            composed: true
        });
    }
};


// src/utilities/base-path.ts
var $09e9e9e9b5a766a6$var$basePath = "";
var $09e9e9e9b5a766a6$var$kitCode = "";
function $09e9e9e9b5a766a6$export$784ad41d332938c6(path) {
    $09e9e9e9b5a766a6$var$basePath = path;
}
function $09e9e9e9b5a766a6$export$9099264ed9b1c55a(subpath = "") {
    if (!$09e9e9e9b5a766a6$var$basePath) {
        const el = document.querySelector("[data-webawesome]");
        if (el?.hasAttribute("data-webawesome")) {
            const rootRelativeUrl = new URL(el.getAttribute("data-webawesome") ?? "", window.location.href).pathname;
            $09e9e9e9b5a766a6$export$784ad41d332938c6(rootRelativeUrl);
        } else {
            const scripts = [
                ...document.getElementsByTagName("script")
            ];
            const waScript = scripts.find((script)=>script.src.endsWith("webawesome.js") || script.src.endsWith("webawesome.loader.js") || script.src.endsWith("webawesome.ssr-loader.js"));
            if (waScript) {
                const path = String(waScript.getAttribute("src"));
                $09e9e9e9b5a766a6$export$784ad41d332938c6(path.split("/").slice(0, -1).join("/"));
            }
        }
    }
    return $09e9e9e9b5a766a6$var$basePath.replace(/\/$/, "") + (subpath ? `/${subpath.replace(/^\//, "")}` : ``);
}
function $09e9e9e9b5a766a6$export$518755054aae088d(code) {
    $09e9e9e9b5a766a6$var$kitCode = code;
}
function $09e9e9e9b5a766a6$export$652d2e1450c9e1cb() {
    if (!$09e9e9e9b5a766a6$var$kitCode) {
        const el = document.querySelector("[data-fa-kit-code]");
        if (el) $09e9e9e9b5a766a6$export$518755054aae088d(el.getAttribute("data-fa-kit-code") || "");
    }
    return $09e9e9e9b5a766a6$var$kitCode;
}
// src/components/icon/library.default.ts
function $09e9e9e9b5a766a6$var$getIconUrl(name, family, variant) {
    const kitCode2 = $09e9e9e9b5a766a6$export$652d2e1450c9e1cb();
    const isPro = kitCode2.length > 0;
    let folder = "solid";
    if (family === "classic") {
        if (variant === "thin") folder = "thin";
        if (variant === "light") folder = "light";
        if (variant === "regular") folder = "regular";
        if (variant === "solid") folder = "solid";
    }
    if (family === "sharp") {
        if (variant === "thin") folder = "sharp-thin";
        if (variant === "light") folder = "sharp-light";
        if (variant === "regular") folder = "sharp-regular";
        if (variant === "solid") folder = "sharp-solid";
    }
    if (family === "duotone") {
        if (variant === "thin") folder = "duotone-thin";
        if (variant === "light") folder = "duotone-light";
        if (variant === "regular") folder = "duotone-regular";
        if (variant === "solid") folder = "duotone";
    }
    if (family === "sharp-duotone") {
        if (variant === "thin") folder = "sharp-duotone-thin";
        if (variant === "light") folder = "sharp-duotone-light";
        if (variant === "regular") folder = "sharp-duotone-regular";
        if (variant === "solid") folder = "sharp-duotone-solid";
    }
    if (family === "brands") folder = "brands";
    return isPro ? `https://ka-p.fontawesome.com/releases/v6.7.2/svgs/${folder}/${name}.svg?token=${encodeURIComponent(kitCode2)}` : `https://ka-f.fontawesome.com/releases/v6.7.2/svgs/${folder}/${name}.svg`;
}
var $09e9e9e9b5a766a6$var$library = {
    name: "default",
    resolver: (name, family = "classic", variant = "solid")=>{
        return $09e9e9e9b5a766a6$var$getIconUrl(name, family, variant);
    }
};
var $09e9e9e9b5a766a6$export$761783e099ce3526 = $09e9e9e9b5a766a6$var$library;


// src/components/icon/library.system.ts
function $3f619a0a4adb2564$var$dataUri(svg) {
    return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}
var $3f619a0a4adb2564$export$df03f54e09e486fa = {
    //
    // Solid variant
    //
    solid: {
        check: `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>`,
        "chevron-down": `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>`,
        "chevron-left": `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="10" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>`,
        "chevron-right": `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="10" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>`,
        circle: `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"/></svg>`,
        eyedropper: `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><path d="M341.6 29.2L240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6v42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480h42.4c21.2 0 41.6-8.4 56.6-23.4L309.4 335.9l-45.3-45.3L143.4 411.3c-3 3-7.1 4.7-11.3 4.7H96V379.9c0-4.2 1.7-8.3 4.7-11.3L221.4 247.9l-45.3-45.3L55.4 323.3z"/></svg>`,
        "grip-vertical": `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="10" viewBox="0 0 320 512"><path d="M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z"/></svg>`,
        indeterminate: `<svg part="indeterminate-icon" class="icon" viewBox="0 0 16 16"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"><g stroke="currentColor" stroke-width="2"><g transform="translate(2.285714, 6.857143)"><path d="M10.2857143,1.14285714 L1.14285714,1.14285714"></path></g></g></g></svg>`,
        minus: `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512"><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg>`,
        pause: `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="10" viewBox="0 0 320 512"><path d="M48 64C21.5 64 0 85.5 0 112V400c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H240z"/></svg>`,
        play: `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="12" viewBox="0 0 384 512"><path d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"/></svg>`,
        star: `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="18" viewBox="0 0 576 512"><path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"/></svg>`,
        user: `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512"><path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"/></svg>`,
        xmark: `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="12" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>`
    },
    //
    // Regular variant
    //
    regular: {
        "circle-question": `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/></svg>`,
        "circle-xmark": `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.--><path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"/></svg>`,
        copy: `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512"><path d="M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16l140.1 0L400 115.9V320c0 8.8-7.2 16-16 16zM192 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V416H272v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H96V128H64z"/></svg>`,
        eye: `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="18" viewBox="0 0 576 512"><path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"/></svg>`,
        "eye-slash": `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="20" viewBox="0 0 640 512"><path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm51.3 163.3l-41.9-33C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5zm-88-69.3L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8z"/></svg>`,
        star: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"/></svg>'
    }
};
var $3f619a0a4adb2564$var$systemLibrary = {
    name: "system",
    resolver: (name, _family = "classic", variant = "solid")=>{
        let collection = $3f619a0a4adb2564$export$df03f54e09e486fa[variant];
        let svg = collection[name] ?? $3f619a0a4adb2564$export$df03f54e09e486fa.regular[name] ?? $3f619a0a4adb2564$export$df03f54e09e486fa.regular["circle-question"];
        if (svg) return $3f619a0a4adb2564$var$dataUri(svg);
        return "";
    }
};
var $3f619a0a4adb2564$export$3139252f9828970f = $3f619a0a4adb2564$var$systemLibrary;


// src/components/icon/library.ts
var $47014c79790cb258$var$defaultIconFamily = "classic";
var $47014c79790cb258$var$registry = [
    (0, $09e9e9e9b5a766a6$export$761783e099ce3526),
    (0, $3f619a0a4adb2564$export$3139252f9828970f)
];
var $47014c79790cb258$var$watchedIcons = [];
function $47014c79790cb258$export$da63f424a7208010(icon) {
    $47014c79790cb258$var$watchedIcons.push(icon);
}
function $47014c79790cb258$export$9e46b25ecab82f0b(icon) {
    $47014c79790cb258$var$watchedIcons = $47014c79790cb258$var$watchedIcons.filter((el)=>el !== icon);
}
function $47014c79790cb258$export$be026de5111f322b(name) {
    return $47014c79790cb258$var$registry.find((lib)=>lib.name === name);
}
function $47014c79790cb258$export$a482e04ad60c9b11(name, options) {
    $47014c79790cb258$export$8faa256e94012669(name);
    $47014c79790cb258$var$registry.push({
        name: name,
        resolver: options.resolver,
        mutator: options.mutator,
        spriteSheet: options.spriteSheet
    });
    $47014c79790cb258$var$watchedIcons.forEach((icon)=>{
        if (icon.library === name) icon.setIcon();
    });
}
function $47014c79790cb258$export$8faa256e94012669(name) {
    $47014c79790cb258$var$registry = $47014c79790cb258$var$registry.filter((lib)=>lib.name !== name);
}
function $47014c79790cb258$export$f4ed8c13705d022e(family) {
    $47014c79790cb258$var$defaultIconFamily = family;
    $47014c79790cb258$var$watchedIcons.forEach((icon)=>icon.setIcon());
}
function $47014c79790cb258$export$8c069b61c9cfc554() {
    return $47014c79790cb258$var$defaultIconFamily;
}


// src/internal/watch.ts
function $613ce7b9f4894054$export$3db5d71bdb2d5499(propertyName, options) {
    const resolvedOptions = {
        waitUntilFirstUpdate: false,
        ...options
    };
    return (proto, decoratedFnName)=>{
        const { update: update } = proto;
        const watchedProperties = Array.isArray(propertyName) ? propertyName : [
            propertyName
        ];
        proto.update = function(changedProps) {
            watchedProperties.forEach((property)=>{
                const key = property;
                if (changedProps.has(key)) {
                    const oldValue = changedProps.get(key);
                    const newValue = this[key];
                    if (oldValue !== newValue) {
                        if (!resolvedOptions.waitUntilFirstUpdate || this.hasUpdated) this[decoratedFnName](oldValue, newValue);
                    }
                }
            });
            update.call(this, changedProps);
        };
    };
}


var $15471b8b0c071016$var$__defProp = Object.defineProperty;
var $15471b8b0c071016$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $15471b8b0c071016$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $15471b8b0c071016$export$85c93885f16e8446 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $15471b8b0c071016$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $15471b8b0c071016$var$__defProp(target, key, result);
    return result;
};
var $15471b8b0c071016$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $15471b8b0c071016$var$__typeError("Cannot " + msg);
var $15471b8b0c071016$export$18a094aefa070634 = (obj, member, getter)=>($15471b8b0c071016$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $15471b8b0c071016$export$addf369becd23283 = (obj, member, value)=>member.has(obj) ? $15471b8b0c071016$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $15471b8b0c071016$export$42432efe6614d3b4 = (obj, member, value, setter)=>($15471b8b0c071016$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);


/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $fc3e06c5d1c8927b$var$t = globalThis, $fc3e06c5d1c8927b$export$b4d10f6001c083c2 = $fc3e06c5d1c8927b$var$t.ShadowRoot && (void 0 === $fc3e06c5d1c8927b$var$t.ShadyCSS || $fc3e06c5d1c8927b$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $fc3e06c5d1c8927b$var$s = Symbol(), $fc3e06c5d1c8927b$var$o = new WeakMap;
class $fc3e06c5d1c8927b$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $fc3e06c5d1c8927b$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($fc3e06c5d1c8927b$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $fc3e06c5d1c8927b$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $fc3e06c5d1c8927b$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $fc3e06c5d1c8927b$export$8d80f9cac07cdb3 = (t)=>new $fc3e06c5d1c8927b$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $fc3e06c5d1c8927b$var$s), $fc3e06c5d1c8927b$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $fc3e06c5d1c8927b$export$505d1e8739bad805(o, t, $fc3e06c5d1c8927b$var$s);
}, $fc3e06c5d1c8927b$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($fc3e06c5d1c8927b$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $fc3e06c5d1c8927b$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $fc3e06c5d1c8927b$export$ee69dfd951e24778 = $fc3e06c5d1c8927b$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $fc3e06c5d1c8927b$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $220e83d71314010a$var$i, defineProperty: $220e83d71314010a$var$e, getOwnPropertyDescriptor: $220e83d71314010a$var$h, getOwnPropertyNames: $220e83d71314010a$var$r, getOwnPropertySymbols: $220e83d71314010a$var$o, getPrototypeOf: $220e83d71314010a$var$n } = Object, $220e83d71314010a$var$a = globalThis, $220e83d71314010a$var$c = $220e83d71314010a$var$a.trustedTypes, $220e83d71314010a$var$l = $220e83d71314010a$var$c ? $220e83d71314010a$var$c.emptyScript : "", $220e83d71314010a$var$p = $220e83d71314010a$var$a.reactiveElementPolyfillSupport, $220e83d71314010a$var$d = (t, s)=>t, $220e83d71314010a$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $220e83d71314010a$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $220e83d71314010a$export$53a6892c50694894 = (t, s)=>!$220e83d71314010a$var$i(t, s), $220e83d71314010a$var$b = {
    attribute: !0,
    type: String,
    converter: $220e83d71314010a$export$7312b35fbf521afb,
    reflect: !1,
    useDefault: !1,
    hasChanged: $220e83d71314010a$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $220e83d71314010a$var$a.litPropertyMetadata ??= new WeakMap;
class $220e83d71314010a$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $220e83d71314010a$var$b) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((s = Object.create(s)).wrapped = !0), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), h = this.getPropertyDescriptor(t, i, s);
            void 0 !== h && $220e83d71314010a$var$e(this.prototype, t, h);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: r } = $220e83d71314010a$var$h(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get: e,
            set (s) {
                const h = e?.call(this);
                r?.call(this, s), this.requestUpdate(t, h, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $220e83d71314010a$var$b;
    }
    static _$Ei() {
        if (this.hasOwnProperty($220e83d71314010a$var$d("elementProperties"))) return;
        const t = $220e83d71314010a$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($220e83d71314010a$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($220e83d71314010a$var$d("properties"))) {
            const t = this.properties, s = [
                ...$220e83d71314010a$var$r(t),
                ...$220e83d71314010a$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $fc3e06c5d1c8927b$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $fc3e06c5d1c8927b$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $fc3e06c5d1c8927b$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$ET(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const h = (void 0 !== i.converter?.toAttribute ? i.converter : $220e83d71314010a$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == h ? this.removeAttribute(e) : this.setAttribute(e, h), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $220e83d71314010a$export$7312b35fbf521afb;
            this._$Em = e;
            const r = h.fromAttribute(s, t.type);
            this[e] = r ?? this._$Ej?.get(e) ?? r, this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            const e = this.constructor, h = this[t];
            if (i ??= e.getPropertyOptions(t), !((i.hasChanged ?? $220e83d71314010a$export$53a6892c50694894)(h, s) || i.useDefault && i.reflect && h === this._$Ej?.get(t) && !this.hasAttribute(e._$Eu(t, i)))) return;
            this.C(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$EP());
    }
    C(t, s, { useDefault: i, reflect: e, wrapped: h }, r) {
        i && !(this._$Ej ??= new Map).has(t) && (this._$Ej.set(t, r ?? s ?? this[t]), !0 !== h || void 0 !== r) || (this._$AL.has(t) || (this.hasUpdated || i || (s = void 0), this._$AL.set(t, s)), !0 === e && this._$Em !== t && (this._$Eq ??= new Set).add(t));
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t){
                const { wrapped: t } = i, e = this[s];
                !0 !== t || this._$AL.has(s) || void 0 === e || this.C(s, void 0, i, e);
            }
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EM();
        } catch (s) {
            throw t = !1, this._$EM(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EM() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Eq &&= this._$Eq.forEach((t)=>this._$ET(t, this[t])), this._$EM();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$220e83d71314010a$export$c7c07a37856565d.elementStyles = [], $220e83d71314010a$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $220e83d71314010a$export$c7c07a37856565d[$220e83d71314010a$var$d("elementProperties")] = new Map, $220e83d71314010a$export$c7c07a37856565d[$220e83d71314010a$var$d("finalized")] = new Map, $220e83d71314010a$var$p?.({
    ReactiveElement: $220e83d71314010a$export$c7c07a37856565d
}), ($220e83d71314010a$var$a.reactiveElementVersions ??= []).push("2.1.1");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $55d4f6cb7ddbea62$var$t = globalThis, $55d4f6cb7ddbea62$var$i = $55d4f6cb7ddbea62$var$t.trustedTypes, $55d4f6cb7ddbea62$var$s = $55d4f6cb7ddbea62$var$i ? $55d4f6cb7ddbea62$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $55d4f6cb7ddbea62$var$e = "$lit$", $55d4f6cb7ddbea62$var$h = `lit$${Math.random().toFixed(9).slice(2)}$`, $55d4f6cb7ddbea62$var$o = "?" + $55d4f6cb7ddbea62$var$h, $55d4f6cb7ddbea62$var$n = `<${$55d4f6cb7ddbea62$var$o}>`, $55d4f6cb7ddbea62$var$r = document, $55d4f6cb7ddbea62$var$l = ()=>$55d4f6cb7ddbea62$var$r.createComment(""), $55d4f6cb7ddbea62$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $55d4f6cb7ddbea62$var$a = Array.isArray, $55d4f6cb7ddbea62$var$u = (t)=>$55d4f6cb7ddbea62$var$a(t) || "function" == typeof t?.[Symbol.iterator], $55d4f6cb7ddbea62$var$d = "[ \t\n\f\r]", $55d4f6cb7ddbea62$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $55d4f6cb7ddbea62$var$v = /-->/g, $55d4f6cb7ddbea62$var$_ = />/g, $55d4f6cb7ddbea62$var$m = RegExp(`>|${$55d4f6cb7ddbea62$var$d}(?:([^\\s"'>=/]+)(${$55d4f6cb7ddbea62$var$d}*=${$55d4f6cb7ddbea62$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $55d4f6cb7ddbea62$var$p = /'/g, $55d4f6cb7ddbea62$var$g = /"/g, $55d4f6cb7ddbea62$var$$ = /^(?:script|style|textarea|title)$/i, $55d4f6cb7ddbea62$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $55d4f6cb7ddbea62$export$c0bb0b647f701bb5 = $55d4f6cb7ddbea62$var$y(1), $55d4f6cb7ddbea62$export$7ed1367e7fa1ad68 = $55d4f6cb7ddbea62$var$y(2), $55d4f6cb7ddbea62$export$47d5b44d225be5b4 = $55d4f6cb7ddbea62$var$y(3), $55d4f6cb7ddbea62$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $55d4f6cb7ddbea62$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $55d4f6cb7ddbea62$var$A = new WeakMap, $55d4f6cb7ddbea62$var$C = $55d4f6cb7ddbea62$var$r.createTreeWalker($55d4f6cb7ddbea62$var$r, 129);
function $55d4f6cb7ddbea62$var$P(t, i) {
    if (!$55d4f6cb7ddbea62$var$a(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $55d4f6cb7ddbea62$var$s ? $55d4f6cb7ddbea62$var$s.createHTML(i) : i;
}
const $55d4f6cb7ddbea62$var$V = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $55d4f6cb7ddbea62$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $55d4f6cb7ddbea62$var$f ? "!--" === u[1] ? c = $55d4f6cb7ddbea62$var$v : void 0 !== u[1] ? c = $55d4f6cb7ddbea62$var$_ : void 0 !== u[2] ? ($55d4f6cb7ddbea62$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $55d4f6cb7ddbea62$var$m) : void 0 !== u[3] && (c = $55d4f6cb7ddbea62$var$m) : c === $55d4f6cb7ddbea62$var$m ? ">" === u[0] ? (c = r ?? $55d4f6cb7ddbea62$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $55d4f6cb7ddbea62$var$m : '"' === u[3] ? $55d4f6cb7ddbea62$var$g : $55d4f6cb7ddbea62$var$p) : c === $55d4f6cb7ddbea62$var$g || c === $55d4f6cb7ddbea62$var$p ? c = $55d4f6cb7ddbea62$var$m : c === $55d4f6cb7ddbea62$var$v || c === $55d4f6cb7ddbea62$var$_ ? c = $55d4f6cb7ddbea62$var$f : (c = $55d4f6cb7ddbea62$var$m, r = void 0);
        const x = c === $55d4f6cb7ddbea62$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $55d4f6cb7ddbea62$var$f ? s + $55d4f6cb7ddbea62$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $55d4f6cb7ddbea62$var$e + s.slice(d) + $55d4f6cb7ddbea62$var$h + x) : s + $55d4f6cb7ddbea62$var$h + (-2 === d ? i : x);
    }
    return [
        $55d4f6cb7ddbea62$var$P(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        o
    ];
};
class $55d4f6cb7ddbea62$var$N {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $55d4f6cb7ddbea62$var$V(t, s);
        if (this.el = $55d4f6cb7ddbea62$var$N.createElement(f, n), $55d4f6cb7ddbea62$var$C.currentNode = this.el.content, 2 === s || 3 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $55d4f6cb7ddbea62$var$C.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($55d4f6cb7ddbea62$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($55d4f6cb7ddbea62$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $55d4f6cb7ddbea62$var$H : "?" === e[1] ? $55d4f6cb7ddbea62$var$I : "@" === e[1] ? $55d4f6cb7ddbea62$var$L : $55d4f6cb7ddbea62$var$k
                    }), r.removeAttribute(t);
                } else t.startsWith($55d4f6cb7ddbea62$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($55d4f6cb7ddbea62$var$$.test(r.tagName)) {
                    const t = r.textContent.split($55d4f6cb7ddbea62$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $55d4f6cb7ddbea62$var$i ? $55d4f6cb7ddbea62$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $55d4f6cb7ddbea62$var$l()), $55d4f6cb7ddbea62$var$C.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $55d4f6cb7ddbea62$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $55d4f6cb7ddbea62$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($55d4f6cb7ddbea62$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $55d4f6cb7ddbea62$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $55d4f6cb7ddbea62$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $55d4f6cb7ddbea62$var$S(t, i, s = t, e) {
    if (i === $55d4f6cb7ddbea62$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $55d4f6cb7ddbea62$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $55d4f6cb7ddbea62$var$S(t, h._$AS(t, i.values), h, e)), i;
}
class $55d4f6cb7ddbea62$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $55d4f6cb7ddbea62$var$r).importNode(i, !0);
        $55d4f6cb7ddbea62$var$C.currentNode = e;
        let h = $55d4f6cb7ddbea62$var$C.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $55d4f6cb7ddbea62$var$R(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $55d4f6cb7ddbea62$var$z(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $55d4f6cb7ddbea62$var$C.nextNode(), o++);
        }
        return $55d4f6cb7ddbea62$var$C.currentNode = $55d4f6cb7ddbea62$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $55d4f6cb7ddbea62$var$R {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $55d4f6cb7ddbea62$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $55d4f6cb7ddbea62$var$S(this, t, i), $55d4f6cb7ddbea62$var$c(t) ? t === $55d4f6cb7ddbea62$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $55d4f6cb7ddbea62$export$45b790e32b2810ee && this._$AR(), this._$AH = $55d4f6cb7ddbea62$export$45b790e32b2810ee) : t !== this._$AH && t !== $55d4f6cb7ddbea62$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $55d4f6cb7ddbea62$var$u(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $55d4f6cb7ddbea62$export$45b790e32b2810ee && $55d4f6cb7ddbea62$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.T($55d4f6cb7ddbea62$var$r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $55d4f6cb7ddbea62$var$N.createElement($55d4f6cb7ddbea62$var$P(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $55d4f6cb7ddbea62$var$M(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $55d4f6cb7ddbea62$var$A.get(t.strings);
        return void 0 === i && $55d4f6cb7ddbea62$var$A.set(t.strings, i = new $55d4f6cb7ddbea62$var$N(t)), i;
    }
    k(t) {
        $55d4f6cb7ddbea62$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $55d4f6cb7ddbea62$var$R(this.O($55d4f6cb7ddbea62$var$l()), this.O($55d4f6cb7ddbea62$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $55d4f6cb7ddbea62$var$k {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $55d4f6cb7ddbea62$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $55d4f6cb7ddbea62$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $55d4f6cb7ddbea62$var$S(this, t, i, 0), o = !$55d4f6cb7ddbea62$var$c(t) || t !== this._$AH && t !== $55d4f6cb7ddbea62$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $55d4f6cb7ddbea62$var$S(this, e[s + n], i, n), r === $55d4f6cb7ddbea62$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$55d4f6cb7ddbea62$var$c(r) || r !== this._$AH[n], r === $55d4f6cb7ddbea62$export$45b790e32b2810ee ? t = $55d4f6cb7ddbea62$export$45b790e32b2810ee : t !== $55d4f6cb7ddbea62$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $55d4f6cb7ddbea62$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $55d4f6cb7ddbea62$var$H extends $55d4f6cb7ddbea62$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $55d4f6cb7ddbea62$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $55d4f6cb7ddbea62$var$I extends $55d4f6cb7ddbea62$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $55d4f6cb7ddbea62$export$45b790e32b2810ee);
    }
}
class $55d4f6cb7ddbea62$var$L extends $55d4f6cb7ddbea62$var$k {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $55d4f6cb7ddbea62$var$S(this, t, i, 0) ?? $55d4f6cb7ddbea62$export$45b790e32b2810ee) === $55d4f6cb7ddbea62$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $55d4f6cb7ddbea62$export$45b790e32b2810ee && s !== $55d4f6cb7ddbea62$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $55d4f6cb7ddbea62$export$45b790e32b2810ee && (s === $55d4f6cb7ddbea62$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $55d4f6cb7ddbea62$var$z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $55d4f6cb7ddbea62$var$S(this, t);
    }
}
const $55d4f6cb7ddbea62$export$8613d1ca9052b22e = {
    M: $55d4f6cb7ddbea62$var$e,
    P: $55d4f6cb7ddbea62$var$h,
    A: $55d4f6cb7ddbea62$var$o,
    C: 1,
    L: $55d4f6cb7ddbea62$var$V,
    R: $55d4f6cb7ddbea62$var$M,
    D: $55d4f6cb7ddbea62$var$u,
    V: $55d4f6cb7ddbea62$var$S,
    I: $55d4f6cb7ddbea62$var$R,
    H: $55d4f6cb7ddbea62$var$k,
    N: $55d4f6cb7ddbea62$var$I,
    U: $55d4f6cb7ddbea62$var$L,
    B: $55d4f6cb7ddbea62$var$H,
    F: $55d4f6cb7ddbea62$var$z
}, $55d4f6cb7ddbea62$var$j = $55d4f6cb7ddbea62$var$t.litHtmlPolyfillSupport;
$55d4f6cb7ddbea62$var$j?.($55d4f6cb7ddbea62$var$N, $55d4f6cb7ddbea62$var$R), ($55d4f6cb7ddbea62$var$t.litHtmlVersions ??= []).push("3.3.1");
const $55d4f6cb7ddbea62$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $55d4f6cb7ddbea62$var$R(i.insertBefore($55d4f6cb7ddbea62$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $23e72313714efa3c$var$s = globalThis;
class $23e72313714efa3c$export$3f2f9f5909897157 extends (0, $220e83d71314010a$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const r = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $55d4f6cb7ddbea62$export$b3890eb0ae9dca99)(r, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $55d4f6cb7ddbea62$export$9c068ae9cc5db4e8;
    }
}
$23e72313714efa3c$export$3f2f9f5909897157._$litElement$ = !0, $23e72313714efa3c$export$3f2f9f5909897157["finalized"] = !0, $23e72313714efa3c$var$s.litElementHydrateSupport?.({
    LitElement: $23e72313714efa3c$export$3f2f9f5909897157
});
const $23e72313714efa3c$var$o = $23e72313714efa3c$var$s.litElementPolyfillSupport;
$23e72313714efa3c$var$o?.({
    LitElement: $23e72313714efa3c$export$3f2f9f5909897157
});
const $23e72313714efa3c$export$f5c524615a7708d6 = {
    _$AK: (t, e, r)=>{
        t._$AK(e, r);
    },
    _$AL: (t)=>t._$AL
};
($23e72313714efa3c$var$s.litElementVersions ??= []).push("4.2.1");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $9e623adca87f3a47$export$6acf61af03e62db = !1;




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $5c30ea4b08dcd69f$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0936708d16581d69$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $220e83d71314010a$export$7312b35fbf521afb),
    reflect: !1,
    hasChanged: (0, $220e83d71314010a$export$53a6892c50694894)
}, $0936708d16581d69$export$8d623b1670eb40f4 = (t = $0936708d16581d69$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), "setter" === n && ((t = Object.create(t)).wrapped = !0), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.C(o, void 0, t, e), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $0936708d16581d69$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $0936708d16581d69$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $5c87cbdc1d7bbe2a$export$ca000e230c0caa3e(r) {
    return (0, $0936708d16581d69$export$d541bacb2bda4494)({
        ...r,
        state: !0,
        attribute: !1
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $ff0480c4bad933eb$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $ea55cdfd67d0b78a$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $8d592e0ae133699b$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $ea55cdfd67d0b78a$export$51987bb50e1f6752)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $ea55cdfd67d0b78a$export$51987bb50e1f6752)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $9965d2609e5deb5d$var$e;
function $9965d2609e5deb5d$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $ea55cdfd67d0b78a$export$51987bb50e1f6752)(n, o, {
            get () {
                return (this.renderRoot ?? ($9965d2609e5deb5d$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $d2c86078d7066c37$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $ea55cdfd67d0b78a$export$51987bb50e1f6752)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $3d8a3282c8d293e2$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $ea55cdfd67d0b78a$export$51987bb50e1f6752)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $a1e9cd8288b34889$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $ea55cdfd67d0b78a$export$51987bb50e1f6752)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}




// src/styles/component/host.css
var $0dc107042b3cd150$var$host_default = ":host {\n  box-sizing: border-box !important;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit !important;\n}\n\n[hidden] {\n  display: none !important;\n}\n";
// src/internal/webawesome-element.ts
var $0dc107042b3cd150$var$_hasRecordedInitialProperties;
var $0dc107042b3cd150$export$1c2340e2bfaed5f9 = class extends (0, $23e72313714efa3c$export$3f2f9f5909897157) {
    constructor(){
        super();
        (0, $15471b8b0c071016$export$addf369becd23283)(this, $0dc107042b3cd150$var$_hasRecordedInitialProperties, false);
        this.initialReflectedProperties = /* @__PURE__ */ new Map();
        this.didSSR = (0, $9e623adca87f3a47$export$6acf61af03e62db) || Boolean(this.shadowRoot);
        /**
     * Methods for setting and checking custom states.
     */ this.customStates = {
            /** Adds or removes the specified custom state. */ set: (customState, active)=>{
                if (!Boolean(this.internals?.states)) return;
                if (active) this.internals.states.add(customState);
                else this.internals.states.delete(customState);
            },
            /** Determines whether or not the element currently has the specified state. */ has: (customState)=>{
                if (!Boolean(this.internals?.states)) return false;
                return this.internals.states.has(customState);
            }
        };
        try {
            this.internals = this.attachInternals();
        } catch  {
            console.error("Element internals are not supported in your browser. Consider using a polyfill");
        }
        this.customStates.set("wa-defined", true);
        let Self = this.constructor;
        for (let [property2, spec] of Self.elementProperties)if (spec.default === "inherit" && spec.initial !== void 0 && typeof property2 === "string") this.customStates.set(`initial-${property2}-${spec.initial}`, true);
    }
    /**
   * Override the default styles property to fetch and convert string CSS files. Components can override this behavior
   * by setting their own `static styles = []` property.
   */ static get styles() {
        const styles = Array.isArray(this.css) ? this.css : this.css ? [
            this.css
        ] : [];
        return [
            $0dc107042b3cd150$var$host_default,
            ...styles
        ].map((style)=>typeof style === "string" ? (0, $fc3e06c5d1c8927b$export$8d80f9cac07cdb3)(style) : style);
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (!(0, $15471b8b0c071016$export$18a094aefa070634)(this, $0dc107042b3cd150$var$_hasRecordedInitialProperties)) {
            this.constructor.elementProperties.forEach((obj, prop)=>{
                if (obj.reflect && this[prop] != null) this.initialReflectedProperties.set(prop, this[prop]);
            });
            (0, $15471b8b0c071016$export$42432efe6614d3b4)(this, $0dc107042b3cd150$var$_hasRecordedInitialProperties, true);
        }
        super.attributeChangedCallback(name, oldValue, newValue);
    }
    willUpdate(changedProperties) {
        super.willUpdate(changedProperties);
        this.initialReflectedProperties.forEach((value, prop)=>{
            if (changedProperties.has(prop) && this[prop] == null) this[prop] = value;
        });
    }
    firstUpdated(changedProperties) {
        super.firstUpdated(changedProperties);
        if (this.didSSR) this.shadowRoot?.querySelectorAll("slot").forEach((slotElement)=>{
            slotElement.dispatchEvent(new Event("slotchange", {
                bubbles: true,
                composed: false,
                cancelable: false
            }));
        });
    }
    update(changedProperties) {
        try {
            super.update(changedProperties);
        } catch (e) {
            if (this.didSSR && !this.hasUpdated) {
                const event = new Event("lit-hydration-error", {
                    bubbles: true,
                    composed: true,
                    cancelable: false
                });
                event.error = e;
                this.dispatchEvent(event);
            }
            throw e;
        }
    }
    /**
   * Given a native event, this function cancels it and dispatches it again from the host element using the desired
   * event options.
   */ relayNativeEvent(event, eventOptions) {
        event.stopImmediatePropagation();
        this.dispatchEvent(new event.constructor(event.type, {
            ...event,
            ...eventOptions
        }));
    }
};
$0dc107042b3cd150$var$_hasRecordedInitialProperties = new WeakMap();
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $0dc107042b3cd150$export$1c2340e2bfaed5f9.prototype, "dir", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $0dc107042b3cd150$export$1c2340e2bfaed5f9.prototype, "lang", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        attribute: "did-ssr"
    })
], $0dc107042b3cd150$export$1c2340e2bfaed5f9.prototype, "didSSR", 2);






/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $7dbbd8e1869887f0$var$t } = (0, $55d4f6cb7ddbea62$export$8613d1ca9052b22e), $7dbbd8e1869887f0$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $7dbbd8e1869887f0$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2,
    MATHML: 3
}, $7dbbd8e1869887f0$export$6b6d145ec2a44ca9 = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, $7dbbd8e1869887f0$export$6a0e8de894d2fcca = (o)=>null != o?._$litType$?.h, $7dbbd8e1869887f0$export$2f448fec17d50a3e = (o)=>void 0 !== o?._$litDirective$, $7dbbd8e1869887f0$export$f28e31de6a6eaf32 = (o)=>o?._$litDirective$, $7dbbd8e1869887f0$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $7dbbd8e1869887f0$var$r = ()=>document.createComment(""), $7dbbd8e1869887f0$export$291b2338ad9b0b30 = (o, i, n)=>{
    const e = o._$AA.parentNode, l = void 0 === i ? o._$AB : i._$AA;
    if (void 0 === n) {
        const i = e.insertBefore($7dbbd8e1869887f0$var$r(), l), d = e.insertBefore($7dbbd8e1869887f0$var$r(), l);
        n = new $7dbbd8e1869887f0$var$t(i, d, o, o.options);
    } else {
        const t = n._$AB.nextSibling, i = n._$AM, d = i !== o;
        if (d) {
            let t;
            n._$AQ?.(o), n._$AM = o, void 0 !== n._$AP && (t = o._$AU) !== i._$AU && n._$AP(t);
        }
        if (t !== l || d) {
            let o = n._$AA;
            for(; o !== t;){
                const t = o.nextSibling;
                e.insertBefore(o, l), o = t;
            }
        }
    }
    return n;
}, $7dbbd8e1869887f0$export$cb8bf9562088e9f4 = (o, t, i = o)=>(o._$AI(t, i), o), $7dbbd8e1869887f0$var$u = {}, $7dbbd8e1869887f0$export$ea70d9dd5965b1c8 = (o, t = $7dbbd8e1869887f0$var$u)=>o._$AH = t, $7dbbd8e1869887f0$export$59e9bce518cde500 = (o)=>o._$AH, $7dbbd8e1869887f0$export$3133b3144bbba267 = (o)=>{
    o._$AR(), o._$AA.remove();
}, $7dbbd8e1869887f0$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};




// src/events/error.ts
var $92752f68e5670b3c$export$70537e1409e8a4d5 = class extends Event {
    constructor(){
        super("wa-error", {
            bubbles: true,
            cancelable: false,
            composed: true
        });
    }
};
// src/components/icon/icon.css
var $92752f68e5670b3c$var$icon_default = ":host {\n  --primary-color: currentColor;\n  --primary-opacity: 1;\n  --secondary-color: currentColor;\n  --secondary-opacity: 0.4;\n\n  display: inline-flex;\n  box-sizing: content-box !important;\n  width: auto;\n  height: 1em;\n}\n\nsvg {\n  display: inline-block;\n  width: auto;\n  height: inherit;\n  fill: currentColor;\n\n  .fa-primary {\n    color: var(--primary-color);\n    opacity: var(--primary-opacity);\n  }\n\n  .fa-secondary {\n    color: var(--secondary-color);\n    opacity: var(--secondary-opacity);\n  }\n}\n\n:host([fixed-width]) {\n  width: 1em;\n  justify-content: center;\n}\n";
// src/components/icon/icon.ts
var $92752f68e5670b3c$var$CACHEABLE_ERROR = Symbol();
var $92752f68e5670b3c$var$RETRYABLE_ERROR = Symbol();
var $92752f68e5670b3c$var$parser;
var $92752f68e5670b3c$var$iconCache = /* @__PURE__ */ new Map();
var $92752f68e5670b3c$export$f48cd026bf8fe08 = class extends (0, $0dc107042b3cd150$export$1c2340e2bfaed5f9) {
    constructor(){
        super(...arguments);
        this.svg = null;
        this.label = "";
        this.library = "default";
    }
    connectedCallback() {
        super.connectedCallback();
        (0, $47014c79790cb258$export$da63f424a7208010)(this);
    }
    firstUpdated(changedProperties) {
        super.firstUpdated(changedProperties);
        this.setIcon();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        (0, $47014c79790cb258$export$9e46b25ecab82f0b)(this);
    }
    getIconSource() {
        const library = (0, $47014c79790cb258$export$be026de5111f322b)(this.library);
        const family = this.family || (0, $47014c79790cb258$export$8c069b61c9cfc554)();
        if (this.name && library) return {
            url: library.resolver(this.name, family, this.variant),
            fromLibrary: true
        };
        return {
            url: this.src,
            fromLibrary: false
        };
    }
    /** Given a URL, this function returns the resulting SVG element or an appropriate error symbol. */ async resolveIcon(url, library) {
        let fileData;
        if (library?.spriteSheet) {
            if (!this.hasUpdated) await this.updateComplete;
            this.svg = (0, $55d4f6cb7ddbea62$export$c0bb0b647f701bb5)`<svg part="svg">
        <use part="use" href="${url}"></use>
      </svg>`;
            await this.updateComplete;
            const svg = this.shadowRoot.querySelector("[part='svg']");
            if (typeof library.mutator === "function") library.mutator(svg);
            return this.svg;
        }
        try {
            fileData = await fetch(url, {
                mode: "cors"
            });
            if (!fileData.ok) return fileData.status === 410 ? $92752f68e5670b3c$var$CACHEABLE_ERROR : $92752f68e5670b3c$var$RETRYABLE_ERROR;
        } catch  {
            return $92752f68e5670b3c$var$RETRYABLE_ERROR;
        }
        try {
            const div = document.createElement("div");
            div.innerHTML = await fileData.text();
            const svg = div.firstElementChild;
            if (svg?.tagName?.toLowerCase() !== "svg") return $92752f68e5670b3c$var$CACHEABLE_ERROR;
            if (!$92752f68e5670b3c$var$parser) $92752f68e5670b3c$var$parser = new DOMParser();
            const doc = $92752f68e5670b3c$var$parser.parseFromString(svg.outerHTML, "text/html");
            const svgEl = doc.body.querySelector("svg");
            if (!svgEl) return $92752f68e5670b3c$var$CACHEABLE_ERROR;
            svgEl.part.add("svg");
            return document.adoptNode(svgEl);
        } catch  {
            return $92752f68e5670b3c$var$CACHEABLE_ERROR;
        }
    }
    handleLabelChange() {
        const hasLabel = typeof this.label === "string" && this.label.length > 0;
        if (hasLabel) {
            this.setAttribute("role", "img");
            this.setAttribute("aria-label", this.label);
            this.removeAttribute("aria-hidden");
        } else {
            this.removeAttribute("role");
            this.removeAttribute("aria-label");
            this.setAttribute("aria-hidden", "true");
        }
    }
    async setIcon() {
        const { url: url, fromLibrary: fromLibrary } = this.getIconSource();
        const library = fromLibrary ? (0, $47014c79790cb258$export$be026de5111f322b)(this.library) : void 0;
        if (!url) {
            this.svg = null;
            return;
        }
        let iconResolver = $92752f68e5670b3c$var$iconCache.get(url);
        if (!iconResolver) {
            iconResolver = this.resolveIcon(url, library);
            $92752f68e5670b3c$var$iconCache.set(url, iconResolver);
        }
        const svg = await iconResolver;
        if (svg === $92752f68e5670b3c$var$RETRYABLE_ERROR) $92752f68e5670b3c$var$iconCache.delete(url);
        if (url !== this.getIconSource().url) return;
        if ((0, $7dbbd8e1869887f0$export$6b6d145ec2a44ca9)(svg)) {
            this.svg = svg;
            return;
        }
        switch(svg){
            case $92752f68e5670b3c$var$RETRYABLE_ERROR:
            case $92752f68e5670b3c$var$CACHEABLE_ERROR:
                this.svg = null;
                this.dispatchEvent(new $92752f68e5670b3c$export$70537e1409e8a4d5());
                break;
            default:
                this.svg = svg.cloneNode(true);
                library?.mutator?.(this.svg);
                this.dispatchEvent(new (0, $0b694c174441a21f$export$93d315c41534ba24)());
        }
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        const library = (0, $47014c79790cb258$export$be026de5111f322b)(this.library);
        const svg = this.shadowRoot?.querySelector("svg");
        if (svg) library?.mutator?.(svg);
    }
    render() {
        if (this.hasUpdated) return this.svg;
        return (0, $55d4f6cb7ddbea62$export$c0bb0b647f701bb5)`<svg part="svg" fill="currentColor" width="16" height="16"></svg>`;
    }
};
$92752f68e5670b3c$export$f48cd026bf8fe08.css = $92752f68e5670b3c$var$icon_default;
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $5c87cbdc1d7bbe2a$export$ca000e230c0caa3e)()
], $92752f68e5670b3c$export$f48cd026bf8fe08.prototype, "svg", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $92752f68e5670b3c$export$f48cd026bf8fe08.prototype, "name", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $92752f68e5670b3c$export$f48cd026bf8fe08.prototype, "family", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $92752f68e5670b3c$export$f48cd026bf8fe08.prototype, "variant", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        attribute: "fixed-width",
        type: Boolean,
        reflect: true
    })
], $92752f68e5670b3c$export$f48cd026bf8fe08.prototype, "fixedWidth", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $92752f68e5670b3c$export$f48cd026bf8fe08.prototype, "src", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $92752f68e5670b3c$export$f48cd026bf8fe08.prototype, "label", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $92752f68e5670b3c$export$f48cd026bf8fe08.prototype, "library", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $613ce7b9f4894054$export$3db5d71bdb2d5499)("label")
], $92752f68e5670b3c$export$f48cd026bf8fe08.prototype, "handleLabelChange", 1);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $613ce7b9f4894054$export$3db5d71bdb2d5499)([
        "family",
        "name",
        "library",
        "variant",
        "src"
    ])
], $92752f68e5670b3c$export$f48cd026bf8fe08.prototype, "setIcon", 1);
$92752f68e5670b3c$export$f48cd026bf8fe08 = (0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $5c30ea4b08dcd69f$export$da64fc29f17f9d0e)("wa-icon")
], $92752f68e5670b3c$export$f48cd026bf8fe08);







// src/components/avatar/avatar.css
var $4862a8589606e610$var$avatar_default = ":host {\n  --size: 3rem;\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  width: var(--size);\n  height: var(--size);\n  color: var(--wa-color-neutral-on-normal);\n  font: inherit;\n  font-size: calc(var(--size) * 0.4);\n  vertical-align: middle;\n  background-color: var(--wa-color-neutral-fill-normal);\n  border-radius: var(--wa-border-radius-circle);\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n:host([shape='square']) {\n  border-radius: 0;\n}\n\n:host([shape='rounded']) {\n  border-radius: var(--wa-border-radius-m);\n}\n\n.icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.initials {\n  line-height: 1;\n  text-transform: uppercase;\n}\n\n.image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  overflow: hidden;\n  border-radius: inherit;\n}\n";
// src/components/avatar/avatar.ts
var $4862a8589606e610$export$87fc0569d7f5fbfc = class extends (0, $0dc107042b3cd150$export$1c2340e2bfaed5f9) {
    constructor(){
        super(...arguments);
        this.hasError = false;
        this.image = "";
        this.label = "";
        this.initials = "";
        this.loading = "eager";
        this.shape = "circle";
    }
    handleImageChange() {
        this.hasError = false;
    }
    handleImageLoadError() {
        this.hasError = true;
        this.dispatchEvent(new (0, $92752f68e5670b3c$export$70537e1409e8a4d5)());
    }
    render() {
        const avatarWithImage = (0, $55d4f6cb7ddbea62$export$c0bb0b647f701bb5)`
      <img
        part="image"
        class="image"
        src="${this.image}"
        loading="${this.loading}"
        role="img"
        aria-label=${this.label}
        @error="${this.handleImageLoadError}"
      />
    `;
        let avatarWithoutImage = (0, $55d4f6cb7ddbea62$export$c0bb0b647f701bb5)``;
        if (this.initials) avatarWithoutImage = (0, $55d4f6cb7ddbea62$export$c0bb0b647f701bb5)`<div part="initials" class="initials" role="img" aria-label=${this.label}>
        ${this.initials}
      </div>`;
        else avatarWithoutImage = (0, $55d4f6cb7ddbea62$export$c0bb0b647f701bb5)`
        <slot name="icon" part="icon" class="icon" role="img" aria-label=${this.label}>
          <wa-icon name="user" library="system" variant="solid"></wa-icon>
        </slot>
      `;
        return (0, $55d4f6cb7ddbea62$export$c0bb0b647f701bb5)` ${this.image && !this.hasError ? avatarWithImage : avatarWithoutImage} `;
    }
};
$4862a8589606e610$export$87fc0569d7f5fbfc.css = $4862a8589606e610$var$avatar_default;
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $5c87cbdc1d7bbe2a$export$ca000e230c0caa3e)()
], $4862a8589606e610$export$87fc0569d7f5fbfc.prototype, "hasError", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $4862a8589606e610$export$87fc0569d7f5fbfc.prototype, "image", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $4862a8589606e610$export$87fc0569d7f5fbfc.prototype, "label", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $4862a8589606e610$export$87fc0569d7f5fbfc.prototype, "initials", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $4862a8589606e610$export$87fc0569d7f5fbfc.prototype, "loading", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        reflect: true
    })
], $4862a8589606e610$export$87fc0569d7f5fbfc.prototype, "shape", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $613ce7b9f4894054$export$3db5d71bdb2d5499)("image")
], $4862a8589606e610$export$87fc0569d7f5fbfc.prototype, "handleImageChange", 1);
$4862a8589606e610$export$87fc0569d7f5fbfc = (0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $5c30ea4b08dcd69f$export$da64fc29f17f9d0e)("wa-avatar")
], $4862a8589606e610$export$87fc0569d7f5fbfc);












// src/events/reposition.ts
var $7a5d85f04153a817$export$cb5897e98f7d0fac = class extends Event {
    constructor(){
        super("wa-reposition", {
            bubbles: true,
            cancelable: false,
            composed: true
        });
    }
};


// src/translations/en.ts
const $de542d486a632eef$var$connectedElements = new Set();
const $de542d486a632eef$var$translations = new Map();
let $de542d486a632eef$var$fallback;
let $de542d486a632eef$var$documentDirection = 'ltr';
let $de542d486a632eef$var$documentLanguage = 'en';
const $de542d486a632eef$var$isClient = typeof MutationObserver !== "undefined" && typeof document !== "undefined" && typeof document.documentElement !== "undefined";
if ($de542d486a632eef$var$isClient) {
    const documentElementObserver = new MutationObserver($de542d486a632eef$export$722fbec263ad908a);
    $de542d486a632eef$var$documentDirection = document.documentElement.dir || 'ltr';
    $de542d486a632eef$var$documentLanguage = document.documentElement.lang || navigator.language;
    documentElementObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: [
            'dir',
            'lang'
        ]
    });
}
function $de542d486a632eef$export$2332cb3ce32cc839(...translation) {
    translation.map((t)=>{
        const code = t.$code.toLowerCase();
        if ($de542d486a632eef$var$translations.has(code)) $de542d486a632eef$var$translations.set(code, Object.assign(Object.assign({}, $de542d486a632eef$var$translations.get(code)), t));
        else $de542d486a632eef$var$translations.set(code, t);
        if (!$de542d486a632eef$var$fallback) $de542d486a632eef$var$fallback = t;
    });
    $de542d486a632eef$export$722fbec263ad908a();
}
function $de542d486a632eef$export$722fbec263ad908a() {
    if ($de542d486a632eef$var$isClient) {
        $de542d486a632eef$var$documentDirection = document.documentElement.dir || 'ltr';
        $de542d486a632eef$var$documentLanguage = document.documentElement.lang || navigator.language;
    }
    [
        ...$de542d486a632eef$var$connectedElements.keys()
    ].map((el)=>{
        if (typeof el.requestUpdate === 'function') el.requestUpdate();
    });
}
class $de542d486a632eef$export$b1a2fed5bb41b893 {
    constructor(host){
        this.host = host;
        this.host.addController(this);
    }
    hostConnected() {
        $de542d486a632eef$var$connectedElements.add(this.host);
    }
    hostDisconnected() {
        $de542d486a632eef$var$connectedElements.delete(this.host);
    }
    dir() {
        return `${this.host.dir || $de542d486a632eef$var$documentDirection}`.toLowerCase();
    }
    lang() {
        return `${this.host.lang || $de542d486a632eef$var$documentLanguage}`.toLowerCase();
    }
    getTranslationData(lang) {
        var _a, _b;
        const locale = new Intl.Locale(lang.replace(/_/g, '-'));
        const language = locale === null || locale === void 0 ? void 0 : locale.language.toLowerCase();
        const region = (_b = (_a = locale === null || locale === void 0 ? void 0 : locale.region) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '';
        const primary = $de542d486a632eef$var$translations.get(`${language}-${region}`);
        const secondary = $de542d486a632eef$var$translations.get(language);
        return {
            locale: locale,
            language: language,
            region: region,
            primary: primary,
            secondary: secondary
        };
    }
    exists(key, options) {
        var _a;
        const { primary: primary, secondary: secondary } = this.getTranslationData((_a = options.lang) !== null && _a !== void 0 ? _a : this.lang());
        options = Object.assign({
            includeFallback: false
        }, options);
        if (primary && primary[key] || secondary && secondary[key] || options.includeFallback && $de542d486a632eef$var$fallback && $de542d486a632eef$var$fallback[key]) return true;
        return false;
    }
    term(key, ...args) {
        const { primary: primary, secondary: secondary } = this.getTranslationData(this.lang());
        let term;
        if (primary && primary[key]) term = primary[key];
        else if (secondary && secondary[key]) term = secondary[key];
        else if ($de542d486a632eef$var$fallback && $de542d486a632eef$var$fallback[key]) term = $de542d486a632eef$var$fallback[key];
        else {
            console.error(`No translation found for: ${String(key)}`);
            return String(key);
        }
        if (typeof term === 'function') return term(...args);
        return term;
    }
    date(dateToFormat, options) {
        dateToFormat = new Date(dateToFormat);
        return new Intl.DateTimeFormat(this.lang(), options).format(dateToFormat);
    }
    number(numberToFormat, options) {
        numberToFormat = Number(numberToFormat);
        return isNaN(numberToFormat) ? '' : new Intl.NumberFormat(this.lang(), options).format(numberToFormat);
    }
    relativeTime(value, unit, options) {
        return new Intl.RelativeTimeFormat(this.lang(), options).format(value, unit);
    }
}


var $1fc6d6bc0ac09d07$var$translation = {
    $code: "en",
    $name: "English",
    $dir: "ltr",
    carousel: "Carousel",
    clearEntry: "Clear entry",
    close: "Close",
    copied: "Copied",
    copy: "Copy",
    currentValue: "Current value",
    error: "Error",
    goToSlide: (slide, count)=>`Go to slide ${slide} of ${count}`,
    hidePassword: "Hide password",
    loading: "Loading",
    nextSlide: "Next slide",
    numOptionsSelected: (num)=>{
        if (num === 0) return "No options selected";
        if (num === 1) return "1 option selected";
        return `${num} options selected`;
    },
    pauseAnimation: "Pause animation",
    playAnimation: "Play animation",
    previousSlide: "Previous slide",
    progress: "Progress",
    remove: "Remove",
    resize: "Resize",
    scrollableRegion: "Scrollable region",
    scrollToEnd: "Scroll to end",
    scrollToStart: "Scroll to start",
    selectAColorFromTheScreen: "Select a color from the screen",
    showPassword: "Show password",
    slideNum: (slide)=>`Slide ${slide}`,
    toggleColorFormat: "Toggle color format",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out"
};
(0, $de542d486a632eef$export$2332cb3ce32cc839)($1fc6d6bc0ac09d07$var$translation);
var $1fc6d6bc0ac09d07$export$802b895dc4aecf21 = $1fc6d6bc0ac09d07$var$translation;



var $1fdb33ee03a3e3e4$export$b1a2fed5bb41b893 = class extends (0, $de542d486a632eef$export$b1a2fed5bb41b893) {
};
(0, $de542d486a632eef$export$2332cb3ce32cc839)((0, $1fc6d6bc0ac09d07$export$802b895dc4aecf21));




/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $f3d5a22901917d2b$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $f3d5a22901917d2b$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $f3d5a22901917d2b$export$803cd8101b6c182b = /*#__PURE__*/ $f3d5a22901917d2b$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $f3d5a22901917d2b$export$27b07d8a310ed8b5[0], side + "-" + $f3d5a22901917d2b$export$27b07d8a310ed8b5[1]), []);
const $f3d5a22901917d2b$export$96ec731ed4dcb222 = Math.min;
const $f3d5a22901917d2b$export$8960430cfd85939f = Math.max;
const $f3d5a22901917d2b$export$2077e0241d6afd3c = Math.round;
const $f3d5a22901917d2b$export$a3fe094919f356fd = Math.floor;
const $f3d5a22901917d2b$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $f3d5a22901917d2b$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $f3d5a22901917d2b$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $f3d5a22901917d2b$export$7d15b64cf5a3a4c4(start, value, end) {
    return $f3d5a22901917d2b$export$8960430cfd85939f(start, $f3d5a22901917d2b$export$96ec731ed4dcb222(value, end));
}
function $f3d5a22901917d2b$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $f3d5a22901917d2b$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $f3d5a22901917d2b$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $f3d5a22901917d2b$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $f3d5a22901917d2b$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
const $f3d5a22901917d2b$var$yAxisSides = /*#__PURE__*/ new Set([
    'top',
    'bottom'
]);
function $f3d5a22901917d2b$export$f28e8f882010718a(placement) {
    return $f3d5a22901917d2b$var$yAxisSides.has($f3d5a22901917d2b$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $f3d5a22901917d2b$export$2b57e0052a6d6d4c(placement) {
    return $f3d5a22901917d2b$export$8a000a963141ac32($f3d5a22901917d2b$export$f28e8f882010718a(placement));
}
function $f3d5a22901917d2b$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $f3d5a22901917d2b$export$f0989780f32bfcda(placement);
    const alignmentAxis = $f3d5a22901917d2b$export$2b57e0052a6d6d4c(placement);
    const length = $f3d5a22901917d2b$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $f3d5a22901917d2b$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $f3d5a22901917d2b$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $f3d5a22901917d2b$export$496432a3699e50b1(placement) {
    const oppositePlacement = $f3d5a22901917d2b$export$9c5e28bad23365fa(placement);
    return [
        $f3d5a22901917d2b$export$2b182c584985588b(placement),
        oppositePlacement,
        $f3d5a22901917d2b$export$2b182c584985588b(oppositePlacement)
    ];
}
function $f3d5a22901917d2b$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$f3d5a22901917d2b$var$oppositeAlignmentMap[alignment]);
}
const $f3d5a22901917d2b$var$lrPlacement = [
    'left',
    'right'
];
const $f3d5a22901917d2b$var$rlPlacement = [
    'right',
    'left'
];
const $f3d5a22901917d2b$var$tbPlacement = [
    'top',
    'bottom'
];
const $f3d5a22901917d2b$var$btPlacement = [
    'bottom',
    'top'
];
function $f3d5a22901917d2b$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $f3d5a22901917d2b$var$rlPlacement : $f3d5a22901917d2b$var$lrPlacement;
            return isStart ? $f3d5a22901917d2b$var$lrPlacement : $f3d5a22901917d2b$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $f3d5a22901917d2b$var$tbPlacement : $f3d5a22901917d2b$var$btPlacement;
        default:
            return [];
    }
}
function $f3d5a22901917d2b$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $f3d5a22901917d2b$export$f0989780f32bfcda(placement);
    let list = $f3d5a22901917d2b$var$getSideList($f3d5a22901917d2b$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($f3d5a22901917d2b$export$2b182c584985588b));
    }
    return list;
}
function $f3d5a22901917d2b$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$f3d5a22901917d2b$var$oppositeSideMap[side]);
}
function $f3d5a22901917d2b$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $f3d5a22901917d2b$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $f3d5a22901917d2b$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $f3d5a22901917d2b$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $9154911abd72ae9f$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $f3d5a22901917d2b$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $f3d5a22901917d2b$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $f3d5a22901917d2b$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $f3d5a22901917d2b$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $9154911abd72ae9f$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $9154911abd72ae9f$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $9154911abd72ae9f$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $9154911abd72ae9f$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $f3d5a22901917d2b$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $f3d5a22901917d2b$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $f3d5a22901917d2b$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9154911abd72ae9f$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $f3d5a22901917d2b$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $f3d5a22901917d2b$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $f3d5a22901917d2b$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $f3d5a22901917d2b$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $f3d5a22901917d2b$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $9154911abd72ae9f$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $f3d5a22901917d2b$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $f3d5a22901917d2b$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $f3d5a22901917d2b$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $f3d5a22901917d2b$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9154911abd72ae9f$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $f3d5a22901917d2b$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $f3d5a22901917d2b$export$803cd8101b6c182b) ? $9154911abd72ae9f$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $9154911abd72ae9f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $f3d5a22901917d2b$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $f3d5a22901917d2b$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $f3d5a22901917d2b$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9154911abd72ae9f$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $f3d5a22901917d2b$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $f3d5a22901917d2b$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $f3d5a22901917d2b$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $f3d5a22901917d2b$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $9154911abd72ae9f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $f3d5a22901917d2b$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $f3d5a22901917d2b$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $f3d5a22901917d2b$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $f3d5a22901917d2b$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $9154911abd72ae9f$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $9154911abd72ae9f$var$isAnySideFullyClipped(overflow) {
    return (0, $f3d5a22901917d2b$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $9154911abd72ae9f$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $9154911abd72ae9f$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $9154911abd72ae9f$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $9154911abd72ae9f$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $9154911abd72ae9f$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $9154911abd72ae9f$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $9154911abd72ae9f$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $9154911abd72ae9f$var$getBoundingRect(rects) {
    const minX = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $9154911abd72ae9f$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $f3d5a22901917d2b$export$ee05aea0aeecbad4)($9154911abd72ae9f$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $9154911abd72ae9f$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $9154911abd72ae9f$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $f3d5a22901917d2b$export$ee05aea0aeecbad4)($9154911abd72ae9f$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $f3d5a22901917d2b$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $f3d5a22901917d2b$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $9154911abd72ae9f$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $9154911abd72ae9f$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $f3d5a22901917d2b$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $f3d5a22901917d2b$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $9154911abd72ae9f$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $9154911abd72ae9f$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $9154911abd72ae9f$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9154911abd72ae9f$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $9154911abd72ae9f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $f3d5a22901917d2b$export$f28e8f882010718a)((0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $f3d5a22901917d2b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $f3d5a22901917d2b$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $f3d5a22901917d2b$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9154911abd72ae9f$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $f3d5a22901917d2b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $f3d5a22901917d2b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $9154911abd72ae9f$var$originSides.has((0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $9154911abd72ae9f$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
            const overflow = await $9154911abd72ae9f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $f3d5a22901917d2b$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $f3d5a22901917d2b$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $f3d5a22901917d2b$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $f3d5a22901917d2b$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $dd40b91ca1c84530$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $dd40b91ca1c84530$export$651544f548703224(node) {
    if ($dd40b91ca1c84530$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $dd40b91ca1c84530$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $dd40b91ca1c84530$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($dd40b91ca1c84530$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $dd40b91ca1c84530$export$8ee0fc9ee280b4ee(value) {
    if (!$dd40b91ca1c84530$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $dd40b91ca1c84530$export$38b2d434cce3ea22(value).Node;
}
function $dd40b91ca1c84530$export$45a5e7f76e0caa8d(value) {
    if (!$dd40b91ca1c84530$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $dd40b91ca1c84530$export$38b2d434cce3ea22(value).Element;
}
function $dd40b91ca1c84530$export$1b3bfaa9684536aa(value) {
    if (!$dd40b91ca1c84530$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $dd40b91ca1c84530$export$38b2d434cce3ea22(value).HTMLElement;
}
function $dd40b91ca1c84530$export$af51f0f06c0f328a(value) {
    if (!$dd40b91ca1c84530$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $dd40b91ca1c84530$export$38b2d434cce3ea22(value).ShadowRoot;
}
const $dd40b91ca1c84530$var$invalidOverflowDisplayValues = /*#__PURE__*/ new Set([
    'inline',
    'contents'
]);
function $dd40b91ca1c84530$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $dd40b91ca1c84530$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !$dd40b91ca1c84530$var$invalidOverflowDisplayValues.has(display);
}
const $dd40b91ca1c84530$var$tableElements = /*#__PURE__*/ new Set([
    'table',
    'td',
    'th'
]);
function $dd40b91ca1c84530$export$71535ffaa902797f(element) {
    return $dd40b91ca1c84530$var$tableElements.has($dd40b91ca1c84530$export$651544f548703224(element));
}
const $dd40b91ca1c84530$var$topLayerSelectors = [
    ':popover-open',
    ':modal'
];
function $dd40b91ca1c84530$export$89e651af02346cd4(element) {
    return $dd40b91ca1c84530$var$topLayerSelectors.some((selector)=>{
        try {
            return element.matches(selector);
        } catch (_e) {
            return false;
        }
    });
}
const $dd40b91ca1c84530$var$transformProperties = [
    'transform',
    'translate',
    'scale',
    'rotate',
    'perspective'
];
const $dd40b91ca1c84530$var$willChangeValues = [
    'transform',
    'translate',
    'scale',
    'rotate',
    'perspective',
    'filter'
];
const $dd40b91ca1c84530$var$containValues = [
    'paint',
    'layout',
    'strict',
    'content'
];
function $dd40b91ca1c84530$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $dd40b91ca1c84530$export$78551043582a6a98();
    const css = $dd40b91ca1c84530$export$45a5e7f76e0caa8d(elementOrCss) ? $dd40b91ca1c84530$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $dd40b91ca1c84530$var$transformProperties.some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || $dd40b91ca1c84530$var$willChangeValues.some((value)=>(css.willChange || '').includes(value)) || $dd40b91ca1c84530$var$containValues.some((value)=>(css.contain || '').includes(value));
}
function $dd40b91ca1c84530$export$940d8225183e1404(element) {
    let currentNode = $dd40b91ca1c84530$export$4e12058fc4d51d56(element);
    while($dd40b91ca1c84530$export$1b3bfaa9684536aa(currentNode) && !$dd40b91ca1c84530$export$d1162fb0b6d4cd51(currentNode)){
        if ($dd40b91ca1c84530$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($dd40b91ca1c84530$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $dd40b91ca1c84530$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $dd40b91ca1c84530$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
const $dd40b91ca1c84530$var$lastTraversableNodeNames = /*#__PURE__*/ new Set([
    'html',
    'body',
    '#document'
]);
function $dd40b91ca1c84530$export$d1162fb0b6d4cd51(node) {
    return $dd40b91ca1c84530$var$lastTraversableNodeNames.has($dd40b91ca1c84530$export$651544f548703224(node));
}
function $dd40b91ca1c84530$export$3735103072e4a80(element) {
    return $dd40b91ca1c84530$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $dd40b91ca1c84530$export$dc8fc79fa2800137(element) {
    if ($dd40b91ca1c84530$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $dd40b91ca1c84530$export$4e12058fc4d51d56(node) {
    if ($dd40b91ca1c84530$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $dd40b91ca1c84530$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $dd40b91ca1c84530$export$e495491855dc5418(node);
    return $dd40b91ca1c84530$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $dd40b91ca1c84530$export$7cd01a57c8ca906c(node) {
    const parentNode = $dd40b91ca1c84530$export$4e12058fc4d51d56(node);
    if ($dd40b91ca1c84530$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($dd40b91ca1c84530$export$1b3bfaa9684536aa(parentNode) && $dd40b91ca1c84530$export$989e911fa9af580a(parentNode)) return parentNode;
    return $dd40b91ca1c84530$export$7cd01a57c8ca906c(parentNode);
}
function $dd40b91ca1c84530$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $dd40b91ca1c84530$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $dd40b91ca1c84530$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $dd40b91ca1c84530$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $dd40b91ca1c84530$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $dd40b91ca1c84530$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $dd40b91ca1c84530$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $dd40b91ca1c84530$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $5cf54089b7e75f55$var$getCssDimensions(element) {
    const css = (0, $dd40b91ca1c84530$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $f3d5a22901917d2b$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $f3d5a22901917d2b$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $5cf54089b7e75f55$var$unwrapElement(element) {
    return !(0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $5cf54089b7e75f55$var$getScale(element) {
    const domElement = $5cf54089b7e75f55$var$unwrapElement(element);
    if (!(0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(domElement)) return (0, $f3d5a22901917d2b$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $5cf54089b7e75f55$var$getCssDimensions(domElement);
    let x = ($ ? (0, $f3d5a22901917d2b$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $f3d5a22901917d2b$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $5cf54089b7e75f55$var$noOffsets = /*#__PURE__*/ (0, $f3d5a22901917d2b$export$a397704b5e280835)(0);
function $5cf54089b7e75f55$var$getVisualOffsets(element) {
    const win = (0, $dd40b91ca1c84530$export$38b2d434cce3ea22)(element);
    if (!(0, $dd40b91ca1c84530$export$78551043582a6a98)() || !win.visualViewport) return $5cf54089b7e75f55$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $5cf54089b7e75f55$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $dd40b91ca1c84530$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $5cf54089b7e75f55$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $5cf54089b7e75f55$var$unwrapElement(element);
    let scale = (0, $f3d5a22901917d2b$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(offsetParent)) scale = $5cf54089b7e75f55$var$getScale(offsetParent);
        } else scale = $5cf54089b7e75f55$var$getScale(element);
    }
    const visualOffsets = $5cf54089b7e75f55$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $5cf54089b7e75f55$var$getVisualOffsets(domElement) : (0, $f3d5a22901917d2b$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $dd40b91ca1c84530$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $dd40b91ca1c84530$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $dd40b91ca1c84530$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $5cf54089b7e75f55$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $dd40b91ca1c84530$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $dd40b91ca1c84530$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $dd40b91ca1c84530$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $f3d5a22901917d2b$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $5cf54089b7e75f55$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $dd40b91ca1c84530$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $5cf54089b7e75f55$var$getBoundingClientRect((0, $dd40b91ca1c84530$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $5cf54089b7e75f55$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $5cf54089b7e75f55$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $5cf54089b7e75f55$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $dd40b91ca1c84530$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $dd40b91ca1c84530$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $f3d5a22901917d2b$export$a397704b5e280835)(1);
    const offsets = (0, $f3d5a22901917d2b$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $dd40b91ca1c84530$export$651544f548703224)(offsetParent) !== 'body' || (0, $dd40b91ca1c84530$export$989e911fa9af580a)(documentElement)) scroll = (0, $dd40b91ca1c84530$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $5cf54089b7e75f55$var$getBoundingClientRect(offsetParent);
            scale = $5cf54089b7e75f55$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $5cf54089b7e75f55$var$getHTMLOffset(documentElement, scroll) : (0, $f3d5a22901917d2b$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $5cf54089b7e75f55$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $5cf54089b7e75f55$var$getDocumentRect(element) {
    const html = (0, $dd40b91ca1c84530$export$e495491855dc5418)(element);
    const scroll = (0, $dd40b91ca1c84530$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $5cf54089b7e75f55$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $dd40b91ca1c84530$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $f3d5a22901917d2b$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $5cf54089b7e75f55$var$SCROLLBAR_MAX = 25;
function $5cf54089b7e75f55$var$getViewportRect(element, strategy) {
    const win = (0, $dd40b91ca1c84530$export$38b2d434cce3ea22)(element);
    const html = (0, $dd40b91ca1c84530$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $dd40b91ca1c84530$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $5cf54089b7e75f55$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $5cf54089b7e75f55$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $5cf54089b7e75f55$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
const $5cf54089b7e75f55$var$absoluteOrFixed = /*#__PURE__*/ new Set([
    'absolute',
    'fixed'
]);
// Returns the inner client rect, subtracting scrollbars if present.
function $5cf54089b7e75f55$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $5cf54089b7e75f55$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(element) ? $5cf54089b7e75f55$var$getScale(element) : (0, $f3d5a22901917d2b$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $5cf54089b7e75f55$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $5cf54089b7e75f55$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $5cf54089b7e75f55$var$getDocumentRect((0, $dd40b91ca1c84530$export$e495491855dc5418)(element));
    else if ((0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $5cf54089b7e75f55$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $5cf54089b7e75f55$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $f3d5a22901917d2b$export$ee05aea0aeecbad4)(rect);
}
function $5cf54089b7e75f55$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $dd40b91ca1c84530$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(parentNode) || (0, $dd40b91ca1c84530$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $dd40b91ca1c84530$export$3735103072e4a80)(parentNode).position === 'fixed' || $5cf54089b7e75f55$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $5cf54089b7e75f55$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $dd40b91ca1c84530$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(el) && (0, $dd40b91ca1c84530$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $dd40b91ca1c84530$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $dd40b91ca1c84530$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(currentNode) && !(0, $dd40b91ca1c84530$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $dd40b91ca1c84530$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $dd40b91ca1c84530$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && $5cf54089b7e75f55$var$absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || (0, $dd40b91ca1c84530$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $5cf54089b7e75f55$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $dd40b91ca1c84530$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $5cf54089b7e75f55$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $dd40b91ca1c84530$export$89e651af02346cd4)(element) ? [] : $5cf54089b7e75f55$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $5cf54089b7e75f55$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $5cf54089b7e75f55$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $5cf54089b7e75f55$var$getDimensions(element) {
    const { width: width, height: height } = $5cf54089b7e75f55$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $5cf54089b7e75f55$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $dd40b91ca1c84530$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $5cf54089b7e75f55$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $f3d5a22901917d2b$export$a397704b5e280835)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $5cf54089b7e75f55$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $dd40b91ca1c84530$export$651544f548703224)(offsetParent) !== 'body' || (0, $dd40b91ca1c84530$export$989e911fa9af580a)(documentElement)) scroll = (0, $dd40b91ca1c84530$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $5cf54089b7e75f55$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $5cf54089b7e75f55$var$getHTMLOffset(documentElement, scroll) : (0, $f3d5a22901917d2b$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $5cf54089b7e75f55$var$isStaticPositioned(element) {
    return (0, $dd40b91ca1c84530$export$3735103072e4a80)(element).position === 'static';
}
function $5cf54089b7e75f55$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(element) || (0, $dd40b91ca1c84530$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $dd40b91ca1c84530$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $5cf54089b7e75f55$var$getOffsetParent(element, polyfill) {
    const win = (0, $dd40b91ca1c84530$export$38b2d434cce3ea22)(element);
    if ((0, $dd40b91ca1c84530$export$89e651af02346cd4)(element)) return win;
    if (!(0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $dd40b91ca1c84530$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $dd40b91ca1c84530$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$5cf54089b7e75f55$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $dd40b91ca1c84530$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $5cf54089b7e75f55$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $dd40b91ca1c84530$export$71535ffaa902797f)(offsetParent) && $5cf54089b7e75f55$var$isStaticPositioned(offsetParent))offsetParent = $5cf54089b7e75f55$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $dd40b91ca1c84530$export$d1162fb0b6d4cd51)(offsetParent) && $5cf54089b7e75f55$var$isStaticPositioned(offsetParent) && !(0, $dd40b91ca1c84530$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $dd40b91ca1c84530$export$940d8225183e1404)(element) || win;
}
const $5cf54089b7e75f55$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $5cf54089b7e75f55$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $5cf54089b7e75f55$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $5cf54089b7e75f55$var$isRTL(element) {
    return (0, $dd40b91ca1c84530$export$3735103072e4a80)(element).direction === 'rtl';
}
const $5cf54089b7e75f55$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $5cf54089b7e75f55$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $dd40b91ca1c84530$export$e495491855dc5418,
    getClippingRect: $5cf54089b7e75f55$var$getClippingRect,
    getOffsetParent: $5cf54089b7e75f55$var$getOffsetParent,
    getElementRects: $5cf54089b7e75f55$var$getElementRects,
    getClientRects: $5cf54089b7e75f55$var$getClientRects,
    getDimensions: $5cf54089b7e75f55$var$getDimensions,
    getScale: $5cf54089b7e75f55$var$getScale,
    isElement: $dd40b91ca1c84530$export$45a5e7f76e0caa8d,
    isRTL: $5cf54089b7e75f55$var$isRTL
};
function $5cf54089b7e75f55$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $5cf54089b7e75f55$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $dd40b91ca1c84530$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $f3d5a22901917d2b$export$a3fe094919f356fd)(top);
        const insetRight = (0, $f3d5a22901917d2b$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $f3d5a22901917d2b$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $f3d5a22901917d2b$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $f3d5a22901917d2b$export$8960430cfd85939f)(0, (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$5cf54089b7e75f55$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $5cf54089b7e75f55$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $5cf54089b7e75f55$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $dd40b91ca1c84530$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $dd40b91ca1c84530$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $5cf54089b7e75f55$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $5cf54089b7e75f55$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $5cf54089b7e75f55$var$getBoundingClientRect(reference);
        if (prevRefRect && !$5cf54089b7e75f55$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $5cf54089b7e75f55$export$37b6bde19b108ecc = (0, $9154911abd72ae9f$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $5cf54089b7e75f55$export$cc800923e997bb8 = (0, $9154911abd72ae9f$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $5cf54089b7e75f55$export$91fb6ecbd551914 = (0, $9154911abd72ae9f$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $5cf54089b7e75f55$export$fba63a578e423eb = (0, $9154911abd72ae9f$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $5cf54089b7e75f55$export$8a83211c878a3f1f = (0, $9154911abd72ae9f$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $5cf54089b7e75f55$export$346677f925de839c = (0, $9154911abd72ae9f$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $5cf54089b7e75f55$export$fe8985bb6374093c = (0, $9154911abd72ae9f$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $5cf54089b7e75f55$export$f2120bbfa5450bd2 = (0, $9154911abd72ae9f$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $5cf54089b7e75f55$export$18c8ad048e32c7d5 = (0, $9154911abd72ae9f$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $5cf54089b7e75f55$export$7bf07e38f3dc4b69 = (0, $9154911abd72ae9f$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $5cf54089b7e75f55$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $5cf54089b7e75f55$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $9154911abd72ae9f$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



function $4205371b0d03eadb$export$759f2a42fd33dfde(t) {
    return $4205371b0d03eadb$var$i(t);
}
function $4205371b0d03eadb$export$9051df5ff5b6ece8(t) {
    return $4205371b0d03eadb$var$f(t, "offsetTop");
}
function $4205371b0d03eadb$export$4ad6bc00a859a01c(t) {
    return $4205371b0d03eadb$var$f(t, "offsetLeft");
}
function $4205371b0d03eadb$var$r(t) {
    return t.assignedSlot ? t.assignedSlot : t.parentNode instanceof ShadowRoot ? t.parentNode.host : t.parentNode;
}
function $4205371b0d03eadb$var$i(e) {
    for(let t = e; t; t = $4205371b0d03eadb$var$r(t))if (t instanceof Element && "none" === getComputedStyle(t).display) return null;
    for(let n = $4205371b0d03eadb$var$r(e); n; n = $4205371b0d03eadb$var$r(n)){
        if (!(n instanceof Element)) continue;
        const e = getComputedStyle(n);
        if ("contents" !== e.display) {
            if ("static" !== e.position || (0, $dd40b91ca1c84530$export$d6c4e8150c35fed1)(e)) return n;
            if ("BODY" === n.tagName) return n;
        }
    }
    return null;
}
function $4205371b0d03eadb$var$f(t, e) {
    let n = t[e], o = $4205371b0d03eadb$var$i(t);
    const r = function(t) {
        const e = new Set;
        let n = t.getRootNode();
        for(; n;)e.add(n), n = n.parentNode ? n.parentNode.getRootNode() : null;
        return e;
    }(t);
    for(; o && !r.has(o.getRootNode());)n -= o[e], o = $4205371b0d03eadb$var$i(o);
    return n;
}





/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $44ceb53f9bbed706$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $44ceb53f9bbed706$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $44ceb53f9bbed706$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $af14a7d4f9968de8$export$56cc687933817664 = (0, $44ceb53f9bbed706$export$99b43ad1ed32e735)(class extends (0, $44ceb53f9bbed706$export$befdefbdce210f91) {
    constructor(t){
        if (super(t), t.type !== (0, $44ceb53f9bbed706$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || t.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((s)=>t[s]).join(" ") + " ";
    }
    update(s, [i]) {
        if (void 0 === this.st) {
            this.st = new Set, void 0 !== s.strings && (this.nt = new Set(s.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in i)i[t] && !this.nt?.has(t) && this.st.add(t);
            return this.render(i);
        }
        const r = s.element.classList;
        for (const t of this.st)t in i || (r.remove(t), this.st.delete(t));
        for(const t in i){
            const s = !!i[t];
            s === this.st.has(t) || this.nt?.has(t) || (s ? (r.add(t), this.st.add(t)) : (r.remove(t), this.st.delete(t)));
        }
        return 0, $55d4f6cb7ddbea62$export$9c068ae9cc5db4e8;
    }
});




// src/components/popup/popup.css
var $5b036c82d07b4713$var$popup_default = ":host {\n  --arrow-color: black;\n  --arrow-size: var(--wa-tooltip-arrow-size);\n  --show-duration: 100ms;\n  --hide-duration: 100ms;\n\n  /*\n     * These properties are computed to account for the arrow's dimensions after being rotated 45\xBA. The constant\n     * 0.7071 is derived from sin(45), which is the diagonal size of the arrow's container after rotating.\n     */\n  --arrow-size-diagonal: calc(var(--arrow-size) * 0.7071);\n  --arrow-padding-offset: calc(var(--arrow-size-diagonal) - var(--arrow-size));\n\n  display: contents;\n}\n\n.popup {\n  position: absolute;\n  isolation: isolate;\n  max-width: var(--auto-size-available-width, none);\n  max-height: var(--auto-size-available-height, none);\n\n  /* Clear UA styles for [popover] */\n  :where(&) {\n    inset: unset;\n    padding: unset;\n    margin: unset;\n    width: unset;\n    height: unset;\n    color: unset;\n    background: unset;\n    border: unset;\n    overflow: unset;\n  }\n}\n\n.popup-fixed {\n  position: fixed;\n}\n\n.popup:not(.popup-active) {\n  display: none;\n}\n\n.arrow {\n  position: absolute;\n  width: calc(var(--arrow-size-diagonal) * 2);\n  height: calc(var(--arrow-size-diagonal) * 2);\n  rotate: 45deg;\n  background: var(--arrow-color);\n  z-index: 3;\n}\n\n:host([data-current-placement~='left']) .arrow {\n  rotate: -45deg;\n}\n\n:host([data-current-placement~='right']) .arrow {\n  rotate: 135deg;\n}\n\n:host([data-current-placement~='bottom']) .arrow {\n  rotate: 225deg;\n}\n\n/* Hover bridge */\n.popup-hover-bridge:not(.popup-hover-bridge-visible) {\n  display: none;\n}\n\n.popup-hover-bridge {\n  position: fixed;\n  z-index: 899;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  clip-path: polygon(\n    var(--hover-bridge-top-left-x, 0) var(--hover-bridge-top-left-y, 0),\n    var(--hover-bridge-top-right-x, 0) var(--hover-bridge-top-right-y, 0),\n    var(--hover-bridge-bottom-right-x, 0) var(--hover-bridge-bottom-right-y, 0),\n    var(--hover-bridge-bottom-left-x, 0) var(--hover-bridge-bottom-left-y, 0)\n  );\n}\n\n/* Built-in animations */\n.show {\n  animation: show var(--show-duration) ease;\n}\n\n.hide {\n  animation: show var(--hide-duration) ease reverse;\n}\n\n@keyframes show {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.show-with-scale {\n  animation: show-with-scale var(--show-duration) ease;\n}\n\n.hide-with-scale {\n  animation: show-with-scale var(--hide-duration) ease reverse;\n}\n\n@keyframes show-with-scale {\n  from {\n    opacity: 0;\n    scale: 0.8;\n  }\n  to {\n    opacity: 1;\n    scale: 1;\n  }\n}\n";
// src/components/popup/popup.ts
function $5b036c82d07b4713$var$isVirtualElement(e) {
    return e !== null && typeof e === "object" && "getBoundingClientRect" in e && ("contextElement" in e ? e instanceof Element : true);
}
var $5b036c82d07b4713$var$SUPPORTS_POPOVER = globalThis?.HTMLElement?.prototype.hasOwnProperty("popover");
var $5b036c82d07b4713$export$f99b847ea5a1ff19 = class extends (0, $0dc107042b3cd150$export$1c2340e2bfaed5f9) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $1fdb33ee03a3e3e4$export$b1a2fed5bb41b893)(this);
        this.active = false;
        this.placement = "top";
        this.boundary = "viewport";
        this.distance = 0;
        this.skidding = 0;
        this.arrow = false;
        this.arrowPlacement = "anchor";
        this.arrowPadding = 10;
        this.flip = false;
        this.flipFallbackPlacements = "";
        this.flipFallbackStrategy = "best-fit";
        this.flipPadding = 0;
        this.shift = false;
        this.shiftPadding = 0;
        this.autoSizePadding = 0;
        this.hoverBridge = false;
        this.updateHoverBridge = ()=>{
            if (this.hoverBridge && this.anchorEl) {
                const anchorRect = this.anchorEl.getBoundingClientRect();
                const popupRect = this.popup.getBoundingClientRect();
                const isVertical = this.placement.includes("top") || this.placement.includes("bottom");
                let topLeftX = 0;
                let topLeftY = 0;
                let topRightX = 0;
                let topRightY = 0;
                let bottomLeftX = 0;
                let bottomLeftY = 0;
                let bottomRightX = 0;
                let bottomRightY = 0;
                if (isVertical) {
                    if (anchorRect.top < popupRect.top) {
                        topLeftX = anchorRect.left;
                        topLeftY = anchorRect.bottom;
                        topRightX = anchorRect.right;
                        topRightY = anchorRect.bottom;
                        bottomLeftX = popupRect.left;
                        bottomLeftY = popupRect.top;
                        bottomRightX = popupRect.right;
                        bottomRightY = popupRect.top;
                    } else {
                        topLeftX = popupRect.left;
                        topLeftY = popupRect.bottom;
                        topRightX = popupRect.right;
                        topRightY = popupRect.bottom;
                        bottomLeftX = anchorRect.left;
                        bottomLeftY = anchorRect.top;
                        bottomRightX = anchorRect.right;
                        bottomRightY = anchorRect.top;
                    }
                } else if (anchorRect.left < popupRect.left) {
                    topLeftX = anchorRect.right;
                    topLeftY = anchorRect.top;
                    topRightX = popupRect.left;
                    topRightY = popupRect.top;
                    bottomLeftX = anchorRect.right;
                    bottomLeftY = anchorRect.bottom;
                    bottomRightX = popupRect.left;
                    bottomRightY = popupRect.bottom;
                } else {
                    topLeftX = popupRect.right;
                    topLeftY = popupRect.top;
                    topRightX = anchorRect.left;
                    topRightY = anchorRect.top;
                    bottomLeftX = popupRect.right;
                    bottomLeftY = popupRect.bottom;
                    bottomRightX = anchorRect.left;
                    bottomRightY = anchorRect.bottom;
                }
                this.style.setProperty("--hover-bridge-top-left-x", `${topLeftX}px`);
                this.style.setProperty("--hover-bridge-top-left-y", `${topLeftY}px`);
                this.style.setProperty("--hover-bridge-top-right-x", `${topRightX}px`);
                this.style.setProperty("--hover-bridge-top-right-y", `${topRightY}px`);
                this.style.setProperty("--hover-bridge-bottom-left-x", `${bottomLeftX}px`);
                this.style.setProperty("--hover-bridge-bottom-left-y", `${bottomLeftY}px`);
                this.style.setProperty("--hover-bridge-bottom-right-x", `${bottomRightX}px`);
                this.style.setProperty("--hover-bridge-bottom-right-y", `${bottomRightY}px`);
            }
        };
    }
    async connectedCallback() {
        super.connectedCallback();
        await this.updateComplete;
        this.start();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.stop();
    }
    async updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has("active")) {
            if (this.active) this.start();
            else this.stop();
        }
        if (changedProperties.has("anchor")) this.handleAnchorChange();
        if (this.active) {
            await this.updateComplete;
            this.reposition();
        }
    }
    async handleAnchorChange() {
        await this.stop();
        if (this.anchor && typeof this.anchor === "string") {
            const root = this.getRootNode();
            this.anchorEl = root.getElementById(this.anchor);
        } else if (this.anchor instanceof Element || $5b036c82d07b4713$var$isVirtualElement(this.anchor)) this.anchorEl = this.anchor;
        else this.anchorEl = this.querySelector('[slot="anchor"]');
        if (this.anchorEl instanceof HTMLSlotElement) this.anchorEl = this.anchorEl.assignedElements({
            flatten: true
        })[0];
        if (this.anchorEl) this.start();
    }
    start() {
        if (!this.anchorEl || !this.active) return;
        this.popup.showPopover?.();
        this.cleanup = (0, $5cf54089b7e75f55$export$deee3a793edee05f)(this.anchorEl, this.popup, ()=>{
            this.reposition();
        });
    }
    async stop() {
        return new Promise((resolve)=>{
            this.popup.hidePopover?.();
            if (this.cleanup) {
                this.cleanup();
                this.cleanup = void 0;
                this.removeAttribute("data-current-placement");
                this.style.removeProperty("--auto-size-available-width");
                this.style.removeProperty("--auto-size-available-height");
                requestAnimationFrame(()=>resolve());
            } else resolve();
        });
    }
    /** Forces the popup to recalculate and reposition itself. */ reposition() {
        if (!this.active || !this.anchorEl) return;
        const middleware = [
            // The offset middleware goes first
            (0, $5cf54089b7e75f55$export$cc800923e997bb8)({
                mainAxis: this.distance,
                crossAxis: this.skidding
            })
        ];
        if (this.sync) middleware.push((0, $5cf54089b7e75f55$export$346677f925de839c)({
            apply: ({ rects: rects })=>{
                const syncWidth = this.sync === "width" || this.sync === "both";
                const syncHeight = this.sync === "height" || this.sync === "both";
                this.popup.style.width = syncWidth ? `${rects.reference.width}px` : "";
                this.popup.style.height = syncHeight ? `${rects.reference.height}px` : "";
            }
        }));
        else {
            this.popup.style.width = "";
            this.popup.style.height = "";
        }
        let defaultBoundary;
        if ($5b036c82d07b4713$var$SUPPORTS_POPOVER && !$5b036c82d07b4713$var$isVirtualElement(this.anchor) && this.boundary === "scroll") defaultBoundary = (0, $dd40b91ca1c84530$export$3b57c1601291186b)(this.anchorEl).filter((el)=>el instanceof Element);
        if (this.flip) middleware.push((0, $5cf54089b7e75f55$export$8a83211c878a3f1f)({
            boundary: this.flipBoundary || defaultBoundary,
            // @ts-expect-error - We're converting a string attribute to an array here
            fallbackPlacements: this.flipFallbackPlacements,
            fallbackStrategy: this.flipFallbackStrategy === "best-fit" ? "bestFit" : "initialPlacement",
            padding: this.flipPadding
        }));
        if (this.shift) middleware.push((0, $5cf54089b7e75f55$export$fba63a578e423eb)({
            boundary: this.shiftBoundary || defaultBoundary,
            padding: this.shiftPadding
        }));
        if (this.autoSize) middleware.push((0, $5cf54089b7e75f55$export$346677f925de839c)({
            boundary: this.autoSizeBoundary || defaultBoundary,
            padding: this.autoSizePadding,
            apply: ({ availableWidth: availableWidth, availableHeight: availableHeight })=>{
                if (this.autoSize === "vertical" || this.autoSize === "both") this.style.setProperty("--auto-size-available-height", `${availableHeight}px`);
                else this.style.removeProperty("--auto-size-available-height");
                if (this.autoSize === "horizontal" || this.autoSize === "both") this.style.setProperty("--auto-size-available-width", `${availableWidth}px`);
                else this.style.removeProperty("--auto-size-available-width");
            }
        }));
        else {
            this.style.removeProperty("--auto-size-available-width");
            this.style.removeProperty("--auto-size-available-height");
        }
        if (this.arrow) middleware.push((0, $5cf54089b7e75f55$export$f2120bbfa5450bd2)({
            element: this.arrowEl,
            padding: this.arrowPadding
        }));
        const getOffsetParent = $5b036c82d07b4713$var$SUPPORTS_POPOVER ? (element)=>(0, $5cf54089b7e75f55$export$722a64dea1b767dc).getOffsetParent(element, (0, $4205371b0d03eadb$export$759f2a42fd33dfde)) : (0, $5cf54089b7e75f55$export$722a64dea1b767dc).getOffsetParent;
        (0, $5cf54089b7e75f55$export$48a53dcb22e581d0)(this.anchorEl, this.popup, {
            placement: this.placement,
            middleware: middleware,
            strategy: $5b036c82d07b4713$var$SUPPORTS_POPOVER ? "absolute" : "fixed",
            platform: {
                ...(0, $5cf54089b7e75f55$export$722a64dea1b767dc),
                getOffsetParent: getOffsetParent
            }
        }).then(({ x: x, y: y, middlewareData: middlewareData, placement: placement })=>{
            const isRtl = this.localize.dir() === "rtl";
            const staticSide = {
                top: "bottom",
                right: "left",
                bottom: "top",
                left: "right"
            }[placement.split("-")[0]];
            this.setAttribute("data-current-placement", placement);
            Object.assign(this.popup.style, {
                left: `${x}px`,
                top: `${y}px`
            });
            if (this.arrow) {
                const arrowX = middlewareData.arrow.x;
                const arrowY = middlewareData.arrow.y;
                let top = "";
                let right = "";
                let bottom = "";
                let left = "";
                if (this.arrowPlacement === "start") {
                    const value = typeof arrowX === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
                    top = typeof arrowY === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
                    right = isRtl ? value : "";
                    left = isRtl ? "" : value;
                } else if (this.arrowPlacement === "end") {
                    const value = typeof arrowX === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
                    right = isRtl ? "" : value;
                    left = isRtl ? value : "";
                    bottom = typeof arrowY === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
                } else if (this.arrowPlacement === "center") {
                    left = typeof arrowX === "number" ? `calc(50% - var(--arrow-size-diagonal))` : "";
                    top = typeof arrowY === "number" ? `calc(50% - var(--arrow-size-diagonal))` : "";
                } else {
                    left = typeof arrowX === "number" ? `${arrowX}px` : "";
                    top = typeof arrowY === "number" ? `${arrowY}px` : "";
                }
                Object.assign(this.arrowEl.style, {
                    top: top,
                    right: right,
                    bottom: bottom,
                    left: left,
                    [staticSide]: "calc(var(--arrow-size-diagonal) * -1)"
                });
            }
        });
        requestAnimationFrame(()=>this.updateHoverBridge());
        this.dispatchEvent(new (0, $7a5d85f04153a817$export$cb5897e98f7d0fac)());
    }
    render() {
        return (0, $55d4f6cb7ddbea62$export$c0bb0b647f701bb5)`
      <slot name="anchor" @slotchange=${this.handleAnchorChange}></slot>

      <span
        part="hover-bridge"
        class=${(0, $af14a7d4f9968de8$export$56cc687933817664)({
            "popup-hover-bridge": true,
            "popup-hover-bridge-visible": this.hoverBridge && this.active
        })}
      ></span>

      <div
        popover="manual"
        part="popup"
        class=${(0, $af14a7d4f9968de8$export$56cc687933817664)({
            popup: true,
            "popup-active": this.active,
            "popup-fixed": !$5b036c82d07b4713$var$SUPPORTS_POPOVER,
            "popup-has-arrow": this.arrow
        })}
      >
        <slot></slot>
        ${this.arrow ? (0, $55d4f6cb7ddbea62$export$c0bb0b647f701bb5)`<div part="arrow" class="arrow" role="presentation"></div>` : ""}
      </div>
    `;
    }
};
$5b036c82d07b4713$export$f99b847ea5a1ff19.css = $5b036c82d07b4713$var$popup_default;
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $8d592e0ae133699b$export$2fa187e846a241c4)(".popup")
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "popup", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $8d592e0ae133699b$export$2fa187e846a241c4)(".arrow")
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "arrowEl", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "anchor", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "active", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        reflect: true
    })
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "placement", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "boundary", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        type: Number
    })
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "distance", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        type: Number
    })
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "skidding", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        type: Boolean
    })
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "arrow", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        attribute: "arrow-placement"
    })
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "arrowPlacement", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        attribute: "arrow-padding",
        type: Number
    })
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "arrowPadding", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        type: Boolean
    })
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "flip", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        attribute: "flip-fallback-placements",
        converter: {
            fromAttribute: (value)=>{
                return value.split(" ").map((p)=>p.trim()).filter((p)=>p !== "");
            },
            toAttribute: (value)=>{
                return value.join(" ");
            }
        }
    })
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "flipFallbackPlacements", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        attribute: "flip-fallback-strategy"
    })
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "flipFallbackStrategy", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        type: Object
    })
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "flipBoundary", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        attribute: "flip-padding",
        type: Number
    })
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "flipPadding", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        type: Boolean
    })
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "shift", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        type: Object
    })
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "shiftBoundary", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        attribute: "shift-padding",
        type: Number
    })
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "shiftPadding", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        attribute: "auto-size"
    })
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "autoSize", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "sync", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        type: Object
    })
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "autoSizeBoundary", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        attribute: "auto-size-padding",
        type: Number
    })
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "autoSizePadding", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        attribute: "hover-bridge",
        type: Boolean
    })
], $5b036c82d07b4713$export$f99b847ea5a1ff19.prototype, "hoverBridge", 2);
$5b036c82d07b4713$export$f99b847ea5a1ff19 = (0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $5c30ea4b08dcd69f$export$da64fc29f17f9d0e)("wa-popup")
], $5b036c82d07b4713$export$f99b847ea5a1ff19);


// src/events/after-hide.ts
var $e379104b7460941d$export$7b1e7adde2f1dd6c = class extends Event {
    constructor(){
        super("wa-after-hide", {
            bubbles: true,
            cancelable: false,
            composed: true
        });
    }
};
// src/events/after-show.ts
var $e379104b7460941d$export$b9e1539da35189ca = class extends Event {
    constructor(){
        super("wa-after-show", {
            bubbles: true,
            cancelable: false,
            composed: true
        });
    }
};
// src/events/hide.ts
var $e379104b7460941d$export$e4267f9b469eac96 = class extends Event {
    constructor(detail){
        super("wa-hide", {
            bubbles: true,
            cancelable: true,
            composed: true
        });
        this.detail = detail;
    }
};
// src/events/show.ts
var $e379104b7460941d$export$dd0bb25790ab4015 = class extends Event {
    constructor(){
        super("wa-show", {
            bubbles: true,
            cancelable: true,
            composed: true
        });
    }
};


// src/internal/math.ts
/* @ts-self-types="./index.d.ts" */ const $e7016a9af9b25e86$export$2b646eea95309f00 = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';


let $cf399e049a9c4d34$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $cf399e049a9c4d34$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log2(alphabet.length - 1)) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = '';
        while(true){
            let bytes = getRandom(step);
            let j = step | 0;
            while(j--){
                id += alphabet[bytes[j] & mask] || '';
                if (id.length >= size) return id;
            }
        }
    };
};
let $cf399e049a9c4d34$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$cf399e049a9c4d34$export$a5cee9e955a615e5(alphabet, size | 0, $cf399e049a9c4d34$export$4385e60b38654f68);
let $cf399e049a9c4d34$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let bytes = crypto.getRandomValues(new Uint8Array(size |= 0));
    while(size--)id += (0, $e7016a9af9b25e86$export$2b646eea95309f00)[bytes[size] & 63];
    return id;
};


function $1b81ca7d644fbda9$export$7d15b64cf5a3a4c4(value, min, max) {
    const noNegativeZero = (n)=>Object.is(n, -0) ? 0 : n;
    if (value < min) return noNegativeZero(min);
    if (value > max) return noNegativeZero(max);
    return noNegativeZero(value);
}
function $1b81ca7d644fbda9$export$8b15d37bc3f197d4(prefix = "") {
    return `${prefix}${(0, $cf399e049a9c4d34$export$ac4959f4f1338dfc)()}`;
}


// src/internal/event.ts
function $f3785d62168e3ed0$export$6608ab6fe9313967(el, eventName) {
    return new Promise((resolve)=>{
        function done(event) {
            if (event.target === el) {
                el.removeEventListener(eventName, done);
                resolve();
            }
        }
        el.addEventListener(eventName, done);
    });
}
function $f3785d62168e3ed0$export$2562999169740ceb(event) {
    if (event.target instanceof Node) switch(event.target.nodeType){
        case Node.TEXT_NODE:
        case Node.COMMENT_NODE:
            return event.target.parentNode;
        case Node.ELEMENT_NODE:
            return event.target;
    }
    return null;
}


// src/internal/animate.ts
async function $6e7851876bce8a11$export$e3607ec2d7a891c4(el, keyframes, options) {
    return el.animate(keyframes, options).finished.catch(()=>{});
}
function $6e7851876bce8a11$export$b1934f85a9394732(el, className) {
    return new Promise((resolve)=>{
        const controller = new AbortController();
        const { signal: signal } = controller;
        if (el.classList.contains(className)) return;
        el.classList.remove(className);
        el.classList.add(className);
        let onEnd = ()=>{
            el.classList.remove(className);
            resolve();
            controller.abort();
        };
        el.addEventListener("animationend", onEnd, {
            once: true,
            signal: signal
        });
        el.addEventListener("animationcancel", onEnd, {
            once: true,
            signal: signal
        });
    });
}
function $6e7851876bce8a11$export$ecae829bb3747ea6(duration) {
    duration = duration.toString().toLowerCase();
    if (duration.indexOf("ms") > -1) return parseFloat(duration) || 0;
    if (duration.indexOf("s") > -1) return (parseFloat(duration) || 0) * 1e3;
    return parseFloat(duration) || 0;
}
function $6e7851876bce8a11$export$ff7706047246b98b() {
    const query = window.matchMedia("(prefers-reduced-motion: reduce)");
    return query.matches;
}








// src/components/popover/popover.css
var $1a7bc88fc7d2316d$var$popover_default = ":host {\n  --arrow-size: 0.375rem;\n  --max-width: 25rem;\n  --show-duration: 100ms;\n  --hide-duration: 100ms;\n\n  /* Internal calculated properties */\n  --arrow-diagonal-size: calc((var(--arrow-size) * sin(45deg)));\n\n  display: contents;\n\n  /** Defaults for inherited CSS properties */\n  font-size: var(--wa-font-size-m);\n  line-height: var(--wa-line-height-normal);\n  text-align: start;\n  white-space: normal;\n}\n\n/* The native dialog element */\n.dialog {\n  display: none;\n  position: fixed;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: transparent;\n  overflow: visible;\n  pointer-events: none;\n\n  &:focus {\n    outline: none;\n  }\n\n  &[open] {\n    display: block;\n  }\n}\n\n/* The <wa-popup> element */\n.popover {\n  --arrow-size: inherit;\n  --show-duration: inherit;\n  --hide-duration: inherit;\n\n  pointer-events: auto;\n\n  &::part(arrow) {\n    background-color: var(--wa-color-surface-default);\n    border-top: none;\n    border-left: none;\n    border-bottom: solid var(--wa-panel-border-width) var(--wa-color-surface-border);\n    border-right: solid var(--wa-panel-border-width) var(--wa-color-surface-border);\n    box-shadow: none;\n  }\n}\n\n.popover[placement^='top']::part(popup) {\n  transform-origin: bottom;\n}\n\n.popover[placement^='bottom']::part(popup) {\n  transform-origin: top;\n}\n\n.popover[placement^='left']::part(popup) {\n  transform-origin: right;\n}\n\n.popover[placement^='right']::part(popup) {\n  transform-origin: left;\n}\n\n/* Body */\n.body {\n  display: flex;\n  flex-direction: column;\n  width: max-content;\n  max-width: var(--max-width);\n  padding: var(--wa-space-l);\n  background-color: var(--wa-color-surface-default);\n  border: var(--wa-panel-border-width) solid var(--wa-color-surface-border);\n  border-radius: var(--wa-panel-border-radius);\n  border-style: var(--wa-panel-border-style);\n  box-shadow: var(--wa-shadow-l);\n  color: var(--wa-color-text-normal);\n  user-select: none;\n  -webkit-user-select: none;\n}\n";
// src/components/popover/popover.ts
var $1a7bc88fc7d2316d$var$openPopovers = /* @__PURE__ */ new Set();
var $1a7bc88fc7d2316d$export$13c69eaf2b073ae7 = class extends (0, $0dc107042b3cd150$export$1c2340e2bfaed5f9) {
    constructor(){
        super(...arguments);
        this.anchor = null;
        this.placement = "top";
        this.open = false;
        this.distance = 8;
        this.skidding = 0;
        this.for = null;
        this.withoutArrow = false;
        this.eventController = new AbortController();
        this.handleAnchorClick = ()=>{
            this.open = !this.open;
        };
        this.handleBodyClick = (event)=>{
            const target = event.target;
            const button = target.closest('[data-popover="close"]');
            if (button) {
                event.stopPropagation();
                this.open = false;
            }
        };
        this.handleDocumentKeyDown = (event)=>{
            if (event.key === "Escape") {
                event.preventDefault();
                this.open = false;
                if (this.anchor && typeof this.anchor.focus === "function") this.anchor.focus();
            }
        };
        this.handleDocumentClick = (event)=>{
            const target = event.target;
            if (this.anchor && event.composedPath().includes(this.anchor)) return;
            if (target.closest("wa-popover") !== this) this.open = false;
        };
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.id) this.id = (0, $1b81ca7d644fbda9$export$8b15d37bc3f197d4)("wa-popover-");
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener("keydown", this.handleDocumentKeyDown);
        this.eventController.abort();
    }
    firstUpdated() {
        if (this.open) {
            this.dialog.show();
            this.popup.active = true;
            this.popup.reposition();
        }
    }
    updated(changedProperties) {
        if (changedProperties.has("open")) this.customStates.set("open", this.open);
    }
    async handleOpenChange() {
        if (this.open) {
            const waShowEvent = new (0, $e379104b7460941d$export$dd0bb25790ab4015)();
            this.dispatchEvent(waShowEvent);
            if (waShowEvent.defaultPrevented) {
                this.open = false;
                return;
            }
            $1a7bc88fc7d2316d$var$openPopovers.forEach((popover)=>popover.open = false);
            document.addEventListener("keydown", this.handleDocumentKeyDown, {
                signal: this.eventController.signal
            });
            document.addEventListener("click", this.handleDocumentClick, {
                signal: this.eventController.signal
            });
            this.dialog.show();
            this.popup.active = true;
            $1a7bc88fc7d2316d$var$openPopovers.add(this);
            requestAnimationFrame(()=>{
                const elementToFocus = this.querySelector("[autofocus]");
                if (elementToFocus && typeof elementToFocus.focus === "function") elementToFocus.focus();
                else this.dialog.focus();
            });
            await (0, $6e7851876bce8a11$export$b1934f85a9394732)(this.popup.popup, "show-with-scale");
            this.popup.reposition();
            this.dispatchEvent(new (0, $e379104b7460941d$export$b9e1539da35189ca)());
        } else {
            const waHideEvent = new (0, $e379104b7460941d$export$e4267f9b469eac96)();
            this.dispatchEvent(waHideEvent);
            if (waHideEvent.defaultPrevented) {
                this.open = true;
                return;
            }
            document.removeEventListener("keydown", this.handleDocumentKeyDown);
            document.removeEventListener("click", this.handleDocumentClick);
            $1a7bc88fc7d2316d$var$openPopovers.delete(this);
            await (0, $6e7851876bce8a11$export$b1934f85a9394732)(this.popup.popup, "hide-with-scale");
            this.popup.active = false;
            this.dialog.close();
            this.dispatchEvent(new (0, $e379104b7460941d$export$7b1e7adde2f1dd6c)());
        }
    }
    handleForChange() {
        const rootNode = this.getRootNode();
        if (!rootNode) return;
        const newAnchor = this.for ? rootNode.querySelector(`#${this.for}`) : null;
        const oldAnchor = this.anchor;
        if (newAnchor === oldAnchor) return;
        const { signal: signal } = this.eventController;
        if (newAnchor) newAnchor.addEventListener("click", this.handleAnchorClick, {
            signal: signal
        });
        if (oldAnchor) oldAnchor.removeEventListener("click", this.handleAnchorClick);
        this.anchor = newAnchor;
        if (this.for && !newAnchor) console.warn(`A popover was assigned to an element with an ID of "${this.for}" but the element could not be found.`, this);
    }
    async handleOptionsChange() {
        if (this.hasUpdated) {
            await this.updateComplete;
            this.popup.reposition();
        }
    }
    /** Shows the popover. */ async show() {
        if (this.open) return void 0;
        this.open = true;
        return (0, $f3785d62168e3ed0$export$6608ab6fe9313967)(this, "wa-after-show");
    }
    /** Hides the popover. */ async hide() {
        if (!this.open) return void 0;
        this.open = false;
        return (0, $f3785d62168e3ed0$export$6608ab6fe9313967)(this, "wa-after-hide");
    }
    render() {
        return (0, $55d4f6cb7ddbea62$export$c0bb0b647f701bb5)`
      <dialog part="dialog" class="dialog">
        <wa-popup
          part="popup"
          exportparts="
            popup:popup__popup,
            arrow:popup__arrow
          "
          class=${(0, $af14a7d4f9968de8$export$56cc687933817664)({
            popover: true,
            "popover-open": this.open
        })}
          placement=${this.placement}
          distance=${this.distance}
          skidding=${this.skidding}
          flip
          shift
          ?arrow=${!this.withoutArrow}
          .anchor=${this.anchor}
        >
          <div part="body" class="body" @click=${this.handleBodyClick}>
            <slot></slot>
          </div>
        </wa-popup>
      </dialog>
    `;
    }
};
$1a7bc88fc7d2316d$export$13c69eaf2b073ae7.css = $1a7bc88fc7d2316d$var$popover_default;
$1a7bc88fc7d2316d$export$13c69eaf2b073ae7.dependencies = {
    "wa-popup": (0, $5b036c82d07b4713$export$f99b847ea5a1ff19)
};
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $8d592e0ae133699b$export$2fa187e846a241c4)("dialog")
], $1a7bc88fc7d2316d$export$13c69eaf2b073ae7.prototype, "dialog", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $8d592e0ae133699b$export$2fa187e846a241c4)(".body")
], $1a7bc88fc7d2316d$export$13c69eaf2b073ae7.prototype, "body", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $8d592e0ae133699b$export$2fa187e846a241c4)("wa-popup")
], $1a7bc88fc7d2316d$export$13c69eaf2b073ae7.prototype, "popup", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $5c87cbdc1d7bbe2a$export$ca000e230c0caa3e)()
], $1a7bc88fc7d2316d$export$13c69eaf2b073ae7.prototype, "anchor", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $1a7bc88fc7d2316d$export$13c69eaf2b073ae7.prototype, "placement", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $1a7bc88fc7d2316d$export$13c69eaf2b073ae7.prototype, "open", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        type: Number
    })
], $1a7bc88fc7d2316d$export$13c69eaf2b073ae7.prototype, "distance", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        type: Number
    })
], $1a7bc88fc7d2316d$export$13c69eaf2b073ae7.prototype, "skidding", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $1a7bc88fc7d2316d$export$13c69eaf2b073ae7.prototype, "for", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        attribute: "without-arrow",
        type: Boolean,
        reflect: true
    })
], $1a7bc88fc7d2316d$export$13c69eaf2b073ae7.prototype, "withoutArrow", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $613ce7b9f4894054$export$3db5d71bdb2d5499)("open", {
        waitUntilFirstUpdate: true
    })
], $1a7bc88fc7d2316d$export$13c69eaf2b073ae7.prototype, "handleOpenChange", 1);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $613ce7b9f4894054$export$3db5d71bdb2d5499)("for")
], $1a7bc88fc7d2316d$export$13c69eaf2b073ae7.prototype, "handleForChange", 1);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $613ce7b9f4894054$export$3db5d71bdb2d5499)([
        "distance",
        "placement",
        "skidding"
    ])
], $1a7bc88fc7d2316d$export$13c69eaf2b073ae7.prototype, "handleOptionsChange", 1);
$1a7bc88fc7d2316d$export$13c69eaf2b073ae7 = (0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $5c30ea4b08dcd69f$export$da64fc29f17f9d0e)("wa-popover")
], $1a7bc88fc7d2316d$export$13c69eaf2b073ae7);




















// src/components/spinner/spinner.css
var $882a4b32bd1d3d58$var$spinner_default = ":host {\n  --track-width: 2px;\n  --track-color: var(--wa-color-neutral-fill-normal);\n  --indicator-color: var(--wa-color-brand-fill-loud);\n  --speed: 2s;\n\n  /* Resizing a spinner element using anything but font-size will break the animation because the animation uses em units.\n   Therefore, if a spinner is used in a flex container without `flex: none` applied, the spinner can grow/shrink and\n   break the animation. The use of `flex: none` on the host element prevents this by always having the spinner sized\n   according to its actual dimensions.\n  */\n  flex: none;\n  display: inline-flex;\n  width: 1em;\n  height: 1em;\n}\n\nsvg {\n  width: 100%;\n  height: 100%;\n  aspect-ratio: 1;\n  animation: spin var(--speed) linear infinite;\n}\n\n.track {\n  stroke: var(--track-color);\n}\n\n.indicator {\n  stroke: var(--indicator-color);\n  stroke-dasharray: 75, 100;\n  stroke-dashoffset: -5;\n  animation: dash 1.5s ease-in-out infinite;\n  stroke-linecap: round;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes dash {\n  0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -35;\n  }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -124;\n  }\n}\n";
// src/components/spinner/spinner.ts
var $882a4b32bd1d3d58$export$7c9c940b7822a46a = class extends (0, $0dc107042b3cd150$export$1c2340e2bfaed5f9) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $1fdb33ee03a3e3e4$export$b1a2fed5bb41b893)(this);
    }
    render() {
        return (0, $55d4f6cb7ddbea62$export$c0bb0b647f701bb5)`
      <svg
        part="base"
        role="progressbar"
        aria-label=${this.localize.term("loading")}
        fill="none"
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle class="track" cx="25" cy="25" r="20" fill="none" stroke-width="5" />
        <circle class="indicator" cx="25" cy="25" r="20" fill="none" stroke-width="5" />
      </svg>
    `;
    }
};
$882a4b32bd1d3d58$export$7c9c940b7822a46a.css = $882a4b32bd1d3d58$var$spinner_default;
$882a4b32bd1d3d58$export$7c9c940b7822a46a = (0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $5c30ea4b08dcd69f$export$da64fc29f17f9d0e)("wa-spinner")
], $882a4b32bd1d3d58$export$7c9c940b7822a46a);








// src/internal/offset.ts
function $ffc02feaa0ef5a22$var$getOffset(element, parent) {
    return {
        top: Math.round(element.getBoundingClientRect().top - parent.getBoundingClientRect().top),
        left: Math.round(element.getBoundingClientRect().left - parent.getBoundingClientRect().left)
    };
}
// src/internal/scroll.ts
var $ffc02feaa0ef5a22$var$locks = /* @__PURE__ */ new Set();
function $ffc02feaa0ef5a22$var$getScrollbarWidth() {
    const documentWidth = document.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}
function $ffc02feaa0ef5a22$var$getExistingBodyPadding() {
    const padding = Number(getComputedStyle(document.body).paddingRight.replace(/px/, ""));
    if (isNaN(padding) || !padding) return 0;
    return padding;
}
function $ffc02feaa0ef5a22$export$5f4bd35c67f2403d(lockingEl) {
    $ffc02feaa0ef5a22$var$locks.add(lockingEl);
    if (!document.documentElement.classList.contains("wa-scroll-lock")) {
        const scrollbarWidth = $ffc02feaa0ef5a22$var$getScrollbarWidth() + $ffc02feaa0ef5a22$var$getExistingBodyPadding();
        let scrollbarGutterProperty = getComputedStyle(document.documentElement).scrollbarGutter;
        if (!scrollbarGutterProperty || scrollbarGutterProperty === "auto") scrollbarGutterProperty = "stable";
        if (scrollbarWidth < 2) scrollbarGutterProperty = "";
        document.documentElement.style.setProperty("--wa-scroll-lock-gutter", scrollbarGutterProperty);
        document.documentElement.classList.add("wa-scroll-lock");
        document.documentElement.style.setProperty("--wa-scroll-lock-size", `${scrollbarWidth}px`);
    }
}
function $ffc02feaa0ef5a22$export$7475b4759872c980(lockingEl) {
    $ffc02feaa0ef5a22$var$locks.delete(lockingEl);
    if ($ffc02feaa0ef5a22$var$locks.size === 0) {
        document.documentElement.classList.remove("wa-scroll-lock");
        document.documentElement.style.removeProperty("--wa-scroll-lock-size");
    }
}
function $ffc02feaa0ef5a22$export$53a0910f038337bd(element, container, direction = "vertical", behavior = "smooth") {
    const offset = $ffc02feaa0ef5a22$var$getOffset(element, container);
    const offsetTop = offset.top + container.scrollTop;
    const offsetLeft = offset.left + container.scrollLeft;
    const minX = container.scrollLeft;
    const maxX = container.scrollLeft + container.offsetWidth;
    const minY = container.scrollTop;
    const maxY = container.scrollTop + container.offsetHeight;
    if (direction === "horizontal" || direction === "both") {
        if (offsetLeft < minX) container.scrollTo({
            left: offsetLeft,
            behavior: behavior
        });
        else if (offsetLeft + element.clientWidth > maxX) container.scrollTo({
            left: offsetLeft - container.offsetWidth + element.clientWidth,
            behavior: behavior
        });
    }
    if (direction === "vertical" || direction === "both") {
        if (offsetTop < minY) container.scrollTo({
            top: offsetTop,
            behavior: behavior
        });
        else if (offsetTop + element.clientHeight > maxY) container.scrollTo({
            top: offsetTop - container.offsetHeight + element.clientHeight,
            behavior: behavior
        });
    }
}









// src/events/tab-hide.ts
var $265a1541aff99367$var$WaTabHideEvent = class extends Event {
    constructor(detail){
        super("wa-tab-hide", {
            bubbles: true,
            cancelable: false,
            composed: true
        });
        this.detail = detail;
    }
};
// src/events/tab-show.ts
var $265a1541aff99367$var$WaTabShowEvent = class extends Event {
    constructor(detail){
        super("wa-tab-show", {
            bubbles: true,
            cancelable: false,
            composed: true
        });
        this.detail = detail;
    }
};
// src/components/tab-group/tab-group.css
var $265a1541aff99367$var$tab_group_default = ":host {\n  --indicator-color: var(--wa-color-brand-fill-loud);\n  --track-color: var(--wa-color-neutral-fill-normal);\n  --track-width: 0.125rem;\n\n  display: block;\n}\n\n.tab-group {\n  display: flex;\n  border-radius: 0;\n}\n\n.tabs {\n  display: flex;\n  position: relative;\n}\n\n.indicator {\n  position: absolute;\n}\n\n.tab-group-has-scroll-controls .nav-container {\n  position: relative;\n  padding: 0 1.5em;\n}\n\n.body {\n  display: block;\n  overflow: auto;\n}\n\n.scroll-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 1.5em;\n}\n\n.scroll-button-start {\n  inset-inline-start: 0;\n}\n\n.scroll-button-end {\n  inset-inline-end: 0;\n}\n\n/*\n   * Top\n   */\n\n.tab-group-top {\n  flex-direction: column;\n}\n\n.tab-group-top .nav-container {\n  order: 1;\n}\n\n.tab-group-top .nav {\n  display: flex;\n  overflow-x: auto;\n\n  /* Hide scrollbar in Firefox */\n  scrollbar-width: none;\n}\n\n/* Hide scrollbar in Chrome/Safari */\n.tab-group-top .nav::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.tab-group-top .tabs {\n  flex: 1 1 auto;\n  position: relative;\n  flex-direction: row;\n  border-bottom: solid var(--track-width) var(--track-color);\n}\n\n.tab-group-top .indicator {\n  bottom: calc(-1 * var(--track-width));\n  border-bottom: solid var(--track-width) var(--indicator-color);\n}\n\n.tab-group-top .body {\n  order: 2;\n}\n\n.tab-group-top ::slotted(wa-tab[active]) {\n  border-block-end: solid var(--track-width) var(--indicator-color);\n  margin-block-end: calc(-1 * var(--track-width));\n}\n\n.tab-group-top ::slotted(wa-tab-panel) {\n  --padding: var(--wa-space-xl) 0;\n}\n\n/*\n   * Bottom\n   */\n\n.tab-group-bottom {\n  flex-direction: column;\n}\n\n.tab-group-bottom .nav-container {\n  order: 2;\n}\n\n.tab-group-bottom .nav {\n  display: flex;\n  overflow-x: auto;\n\n  /* Hide scrollbar in Firefox */\n  scrollbar-width: none;\n}\n\n/* Hide scrollbar in Chrome/Safari */\n.tab-group-bottom .nav::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.tab-group-bottom .tabs {\n  flex: 1 1 auto;\n  position: relative;\n  flex-direction: row;\n  border-top: solid var(--track-width) var(--track-color);\n}\n\n.tab-group-bottom .indicator {\n  top: calc(-1 * var(--track-width));\n  border-top: solid var(--track-width) var(--indicator-color);\n}\n\n.tab-group-bottom .body {\n  order: 1;\n}\n\n.tab-group-bottom ::slotted(wa-tab[active]) {\n  border-block-start: solid var(--track-width) var(--indicator-color);\n  margin-block-start: calc(-1 * var(--track-width));\n}\n\n.tab-group-bottom ::slotted(wa-tab-panel) {\n  --padding: var(--wa-space-xl) 0;\n}\n\n/*\n   * Start\n   */\n\n.tab-group-start {\n  flex-direction: row;\n}\n\n.tab-group-start .nav-container {\n  order: 1;\n}\n\n.tab-group-start .tabs {\n  flex: 0 0 auto;\n  flex-direction: column;\n  border-inline-end: solid var(--track-width) var(--track-color);\n}\n\n.tab-group-start .indicator {\n  inset-inline-end: calc(-1 * var(--track-width));\n  border-right: solid var(--track-width) var(--indicator-color);\n}\n\n.tab-group-start .body {\n  flex: 1 1 auto;\n  order: 2;\n}\n\n.tab-group-start ::slotted(wa-tab[active]) {\n  border-inline-end: solid var(--track-width) var(--indicator-color);\n  margin-inline-end: calc(-1 * var(--track-width));\n}\n\n.tab-group-start ::slotted(wa-tab-panel) {\n  --padding: 0 var(--wa-space-xl);\n}\n\n/*\n   * End\n   */\n\n.tab-group-end {\n  flex-direction: row;\n}\n\n.tab-group-end .nav-container {\n  order: 2;\n}\n\n.tab-group-end .tabs {\n  flex: 0 0 auto;\n  flex-direction: column;\n  border-left: solid var(--track-width) var(--track-color);\n}\n\n.tab-group-end .indicator {\n  inset-inline-start: calc(-1 * var(--track-width));\n  border-inline-start: solid var(--track-width) var(--indicator-color);\n}\n\n.tab-group-end .body {\n  flex: 1 1 auto;\n  order: 1;\n}\n\n.tab-group-end ::slotted(wa-tab[active]) {\n  border-inline-start: solid var(--track-width) var(--indicator-color);\n  margin-inline-start: calc(-1 * var(--track-width));\n}\n\n.tab-group-end ::slotted(wa-tab-panel) {\n  --padding: 0 var(--wa-space-xl);\n}\n";
// src/components/tab-group/tab-group.ts
var $265a1541aff99367$export$15db6f24a746b7e3 = class extends (0, $0dc107042b3cd150$export$1c2340e2bfaed5f9) {
    constructor(){
        super(...arguments);
        this.tabs = [];
        this.focusableTabs = [];
        this.panels = [];
        this.localize = new (0, $1fdb33ee03a3e3e4$export$b1a2fed5bb41b893)(this);
        this.hasScrollControls = false;
        this.active = "";
        this.placement = "top";
        this.activation = "auto";
        this.withoutScrollControls = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.resizeObserver = new ResizeObserver(()=>{
            this.updateScrollControls();
        });
        this.mutationObserver = new MutationObserver((mutations)=>{
            if (mutations.some((m)=>![
                    "aria-labelledby",
                    "aria-controls"
                ].includes(m.attributeName))) setTimeout(()=>this.setAriaLabels());
            const relevantMutations = mutations.filter((m)=>{
                const target = m.target;
                return target.closest("wa-tab-group") === this;
            });
            if (relevantMutations.some((m)=>m.attributeName === "disabled")) this.syncTabsAndPanels();
            else if (relevantMutations.some((m)=>m.attributeName === "active")) {
                const tabs = relevantMutations.filter((m)=>m.attributeName === "active" && m.target.tagName.toLowerCase() === "wa-tab").map((m)=>m.target);
                const newActiveTab = tabs.find((tab)=>tab.active);
                if (newActiveTab && newActiveTab.closest("wa-tab-group") === this) this.setActiveTab(newActiveTab);
            }
        });
        this.updateComplete.then(()=>{
            this.syncTabsAndPanels();
            this.mutationObserver.observe(this, {
                attributes: true,
                childList: true,
                subtree: true
            });
            this.resizeObserver.observe(this.nav);
            const intersectionObserver = new IntersectionObserver((entries, observer)=>{
                if (entries[0].intersectionRatio > 0) {
                    this.setAriaLabels();
                    if (this.active) {
                        const tab = this.tabs.find((t)=>t.panel === this.active);
                        if (tab) this.setActiveTab(tab);
                    } else this.setActiveTab(this.getActiveTab() ?? this.tabs[0], {
                        emitEvents: false
                    });
                    observer.unobserve(entries[0].target);
                }
            });
            intersectionObserver.observe(this.tabGroup);
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.mutationObserver?.disconnect();
        if (this.nav) this.resizeObserver?.unobserve(this.nav);
    }
    getAllTabs() {
        const slot = this.shadowRoot.querySelector('slot[name="nav"]');
        return [
            ...slot.assignedElements()
        ].filter((el)=>{
            return el.tagName.toLowerCase() === "wa-tab";
        });
    }
    getAllPanels() {
        return [
            ...this.body.assignedElements()
        ].filter((el)=>el.tagName.toLowerCase() === "wa-tab-panel");
    }
    getActiveTab() {
        return this.tabs.find((el)=>el.active);
    }
    handleClick(event) {
        const target = event.target;
        const tab = target.closest("wa-tab");
        const tabGroup = tab?.closest("wa-tab-group");
        if (tabGroup !== this) return;
        if (tab !== null) this.setActiveTab(tab, {
            scrollBehavior: "smooth"
        });
    }
    handleKeyDown(event) {
        const target = event.target;
        const tab = target.closest("wa-tab");
        const tabGroup = tab?.closest("wa-tab-group");
        if (tabGroup !== this) return;
        if ([
            "Enter",
            " "
        ].includes(event.key)) {
            if (tab !== null) {
                this.setActiveTab(tab, {
                    scrollBehavior: "smooth"
                });
                event.preventDefault();
            }
            return;
        }
        if ([
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown",
            "Home",
            "End"
        ].includes(event.key)) {
            const activeEl = this.tabs.find((t)=>t.matches(":focus"));
            const isRtl = this.localize.dir() === "rtl";
            let nextTab = null;
            if (activeEl?.tagName.toLowerCase() === "wa-tab") {
                if (event.key === "Home") nextTab = this.focusableTabs[0];
                else if (event.key === "End") nextTab = this.focusableTabs[this.focusableTabs.length - 1];
                else if ([
                    "top",
                    "bottom"
                ].includes(this.placement) && event.key === (isRtl ? "ArrowRight" : "ArrowLeft") || [
                    "start",
                    "end"
                ].includes(this.placement) && event.key === "ArrowUp") {
                    const currentIndex = this.tabs.findIndex((el)=>el === activeEl);
                    nextTab = this.findNextFocusableTab(currentIndex, "backward");
                } else if ([
                    "top",
                    "bottom"
                ].includes(this.placement) && event.key === (isRtl ? "ArrowLeft" : "ArrowRight") || [
                    "start",
                    "end"
                ].includes(this.placement) && event.key === "ArrowDown") {
                    const currentIndex = this.tabs.findIndex((el)=>el === activeEl);
                    nextTab = this.findNextFocusableTab(currentIndex, "forward");
                }
                if (!nextTab) return;
                nextTab.tabIndex = 0;
                nextTab.focus({
                    preventScroll: true
                });
                if (this.activation === "auto") this.setActiveTab(nextTab, {
                    scrollBehavior: "smooth"
                });
                else this.tabs.forEach((tabEl)=>{
                    tabEl.tabIndex = tabEl === nextTab ? 0 : -1;
                });
                if ([
                    "top",
                    "bottom"
                ].includes(this.placement)) (0, $ffc02feaa0ef5a22$export$53a0910f038337bd)(nextTab, this.nav, "horizontal");
                event.preventDefault();
            }
        }
    }
    findNextFocusableTab(currentIndex, direction) {
        let nextTab = null;
        const iterator = direction === "forward" ? 1 : -1;
        let nextIndex = currentIndex + iterator;
        while(currentIndex < this.tabs.length){
            nextTab = this.tabs[nextIndex] || null;
            if (nextTab === null) {
                if (direction === "forward") nextTab = this.focusableTabs[0];
                else nextTab = this.focusableTabs[this.focusableTabs.length - 1];
                break;
            }
            if (!nextTab.disabled) break;
            nextIndex += iterator;
        }
        return nextTab;
    }
    handleScrollToStart() {
        this.nav.scroll({
            left: this.localize.dir() === "rtl" ? this.nav.scrollLeft + this.nav.clientWidth : this.nav.scrollLeft - this.nav.clientWidth,
            behavior: "smooth"
        });
    }
    handleScrollToEnd() {
        this.nav.scroll({
            left: this.localize.dir() === "rtl" ? this.nav.scrollLeft - this.nav.clientWidth : this.nav.scrollLeft + this.nav.clientWidth,
            behavior: "smooth"
        });
    }
    setActiveTab(tab, options) {
        options = {
            emitEvents: true,
            scrollBehavior: "auto",
            ...options
        };
        if (tab.closest("wa-tab-group") !== this) return;
        if (tab !== this.activeTab && !tab.disabled) {
            const previousTab = this.activeTab;
            this.active = tab.panel;
            this.activeTab = tab;
            this.tabs.forEach((el)=>{
                el.active = el === this.activeTab;
                el.tabIndex = el === this.activeTab ? 0 : -1;
            });
            this.panels.forEach((el)=>el.active = el.name === this.activeTab?.panel);
            if ([
                "top",
                "bottom"
            ].includes(this.placement)) (0, $ffc02feaa0ef5a22$export$53a0910f038337bd)(this.activeTab, this.nav, "horizontal", options.scrollBehavior);
            if (options.emitEvents) {
                if (previousTab) this.dispatchEvent(new $265a1541aff99367$var$WaTabHideEvent({
                    name: previousTab.panel
                }));
                this.dispatchEvent(new $265a1541aff99367$var$WaTabShowEvent({
                    name: this.activeTab.panel
                }));
            }
        }
    }
    setAriaLabels() {
        this.tabs.forEach((tab)=>{
            const panel = this.panels.find((el)=>el.name === tab.panel);
            if (panel) {
                tab.setAttribute("aria-controls", panel.getAttribute("id"));
                panel.setAttribute("aria-labelledby", tab.getAttribute("id"));
            }
        });
    }
    // This stores tabs and panels so we can refer to a cache instead of calling querySelectorAll() multiple times.
    syncTabsAndPanels() {
        this.tabs = this.getAllTabs();
        this.focusableTabs = this.tabs.filter((el)=>!el.disabled);
        this.panels = this.getAllPanels();
        this.updateComplete.then(()=>this.updateScrollControls());
    }
    updateActiveTab() {
        const tab = this.tabs.find((el)=>el.panel === this.active);
        if (tab) this.setActiveTab(tab, {
            scrollBehavior: "smooth"
        });
    }
    updateScrollControls() {
        if (this.withoutScrollControls) this.hasScrollControls = false;
        else this.hasScrollControls = [
            "top",
            "bottom"
        ].includes(this.placement) && this.nav.scrollWidth > this.nav.clientWidth + 1;
    }
    render() {
        const isRtl = this.hasUpdated ? this.localize.dir() === "rtl" : this.dir === "rtl";
        return (0, $55d4f6cb7ddbea62$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class=${(0, $af14a7d4f9968de8$export$56cc687933817664)({
            "tab-group": true,
            "tab-group-top": this.placement === "top",
            "tab-group-bottom": this.placement === "bottom",
            "tab-group-start": this.placement === "start",
            "tab-group-end": this.placement === "end",
            "tab-group-has-scroll-controls": this.hasScrollControls
        })}
        @click=${this.handleClick}
        @keydown=${this.handleKeyDown}
      >
        <div class="nav-container" part="nav">
          ${this.hasScrollControls ? (0, $55d4f6cb7ddbea62$export$c0bb0b647f701bb5)`
                <wa-button
                  part="scroll-button scroll-button-start"
                  exportparts="base:scroll-button__base"
                  class="scroll-button scroll-button-start"
                  appearance="plain"
                  @click=${this.handleScrollToStart}
                >
                  <wa-icon
                    name=${isRtl ? "chevron-right" : "chevron-left"}
                    library="system"
                    variant="solid"
                    label=${this.localize.term("scrollToStart")}
                  ></wa-icon>
                </wa-button>
              ` : ""}

          <!-- We have a focus listener because in Firefox (and soon to be Chrome) overflow containers are focusable. -->
          <div class="nav" @focus=${()=>this.activeTab?.focus({
                preventScroll: true
            })}>
            <div part="tabs" class="tabs" role="tablist">
              <slot name="nav" @slotchange=${this.syncTabsAndPanels}></slot>
            </div>
          </div>

          ${this.hasScrollControls ? (0, $55d4f6cb7ddbea62$export$c0bb0b647f701bb5)`
                <wa-button
                  part="scroll-button scroll-button-end"
                  class="scroll-button scroll-button-end"
                  exportparts="base:scroll-button__base"
                  appearance="plain"
                  @click=${this.handleScrollToEnd}
                >
                  <wa-icon
                    name=${isRtl ? "chevron-left" : "chevron-right"}
                    library="system"
                    variant="solid"
                    label=${this.localize.term("scrollToEnd")}
                  ></wa-icon>
                </wa-button>
              ` : ""}
        </div>

        <slot part="body" class="body" @slotchange=${this.syncTabsAndPanels}></slot>
      </div>
    `;
    }
};
$265a1541aff99367$export$15db6f24a746b7e3.css = $265a1541aff99367$var$tab_group_default;
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $8d592e0ae133699b$export$2fa187e846a241c4)(".tab-group")
], $265a1541aff99367$export$15db6f24a746b7e3.prototype, "tabGroup", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $8d592e0ae133699b$export$2fa187e846a241c4)(".body")
], $265a1541aff99367$export$15db6f24a746b7e3.prototype, "body", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $8d592e0ae133699b$export$2fa187e846a241c4)(".nav")
], $265a1541aff99367$export$15db6f24a746b7e3.prototype, "nav", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $5c87cbdc1d7bbe2a$export$ca000e230c0caa3e)()
], $265a1541aff99367$export$15db6f24a746b7e3.prototype, "hasScrollControls", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        reflect: true
    })
], $265a1541aff99367$export$15db6f24a746b7e3.prototype, "active", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $265a1541aff99367$export$15db6f24a746b7e3.prototype, "placement", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $265a1541aff99367$export$15db6f24a746b7e3.prototype, "activation", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        attribute: "without-scroll-controls",
        type: Boolean
    })
], $265a1541aff99367$export$15db6f24a746b7e3.prototype, "withoutScrollControls", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $613ce7b9f4894054$export$3db5d71bdb2d5499)("active")
], $265a1541aff99367$export$15db6f24a746b7e3.prototype, "updateActiveTab", 1);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $613ce7b9f4894054$export$3db5d71bdb2d5499)("withoutScrollControls", {
        waitUntilFirstUpdate: true
    })
], $265a1541aff99367$export$15db6f24a746b7e3.prototype, "updateScrollControls", 1);
$265a1541aff99367$export$15db6f24a746b7e3 = (0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $5c30ea4b08dcd69f$export$da64fc29f17f9d0e)("wa-tab-group")
], $265a1541aff99367$export$15db6f24a746b7e3);








// src/components/tab/tab.css
var $ae7f12f6149f1246$var$tab_default = ":host {\n  display: inline-block;\n  color: var(--wa-color-neutral-on-quiet);\n  font-weight: var(--wa-font-weight-action);\n}\n\n.tab {\n  display: inline-flex;\n  align-items: center;\n  font: inherit;\n  padding: 1em 1.5em;\n  white-space: nowrap;\n  user-select: none;\n  -webkit-user-select: none;\n  cursor: pointer;\n  transition: color var(--wa-transition-fast) var(--wa-transition-easing);\n\n  ::slotted(wa-icon:first-child) {\n    margin-inline-end: 0.5em;\n  }\n\n  ::slotted(wa-icon:last-child) {\n    margin-inline-start: 0.5em;\n  }\n}\n\n@media (hover: hover) {\n  :host(:hover:not([disabled])) .tab {\n    color: currentColor;\n  }\n}\n\n:host(:focus) {\n  outline: transparent;\n}\n\n:host(:focus-visible) .tab {\n  outline: var(--wa-focus-ring);\n  outline-offset: calc(-1 * var(--wa-border-width-l) - var(--wa-focus-ring-offset));\n}\n\n:host([active]:not([disabled])) {\n  color: var(--wa-color-brand-on-quiet);\n}\n\n:host([disabled]) .tab {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n@media (forced-colors: active) {\n  :host([active]:not([disabled])) {\n    outline: solid 1px transparent;\n    outline-offset: -3px;\n  }\n}\n";
// src/components/tab/tab.ts
var $ae7f12f6149f1246$var$id = 0;
var $ae7f12f6149f1246$export$ed95101505bdabce = class extends (0, $0dc107042b3cd150$export$1c2340e2bfaed5f9) {
    constructor(){
        super(...arguments);
        this.attrId = ++$ae7f12f6149f1246$var$id;
        this.componentId = `wa-tab-${this.attrId}`;
        this.panel = "";
        this.active = false;
        this.disabled = false;
        this.tabIndex = 0;
    }
    connectedCallback() {
        this.slot || (this.slot = "nav");
        super.connectedCallback();
        this.setAttribute("role", "tab");
    }
    handleActiveChange() {
        this.setAttribute("aria-selected", this.active ? "true" : "false");
    }
    handleDisabledChange() {
        this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
        if (this.disabled && !this.active) this.tabIndex = -1;
        else this.tabIndex = 0;
    }
    render() {
        this.id = this.id?.length > 0 ? this.id : this.componentId;
        return (0, $55d4f6cb7ddbea62$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class=${(0, $af14a7d4f9968de8$export$56cc687933817664)({
            tab: true,
            "tab-active": this.active
        })}
      >
        <slot></slot>
      </div>
    `;
    }
};
$ae7f12f6149f1246$export$ed95101505bdabce.css = $ae7f12f6149f1246$var$tab_default;
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $8d592e0ae133699b$export$2fa187e846a241c4)(".tab")
], $ae7f12f6149f1246$export$ed95101505bdabce.prototype, "tab", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        reflect: true
    })
], $ae7f12f6149f1246$export$ed95101505bdabce.prototype, "panel", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $ae7f12f6149f1246$export$ed95101505bdabce.prototype, "active", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $ae7f12f6149f1246$export$ed95101505bdabce.prototype, "disabled", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        type: Number,
        reflect: true
    })
], $ae7f12f6149f1246$export$ed95101505bdabce.prototype, "tabIndex", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $613ce7b9f4894054$export$3db5d71bdb2d5499)("active")
], $ae7f12f6149f1246$export$ed95101505bdabce.prototype, "handleActiveChange", 1);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $613ce7b9f4894054$export$3db5d71bdb2d5499)("disabled")
], $ae7f12f6149f1246$export$ed95101505bdabce.prototype, "handleDisabledChange", 1);
$ae7f12f6149f1246$export$ed95101505bdabce = (0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $5c30ea4b08dcd69f$export$da64fc29f17f9d0e)("wa-tab")
], $ae7f12f6149f1246$export$ed95101505bdabce);








// src/components/tab-panel/tab-panel.css
var $4127f4988228e634$var$tab_panel_default = ":host {\n  --padding: 0;\n\n  display: none;\n}\n\n:host([active]) {\n  display: block;\n}\n\n.tab-panel {\n  display: block;\n  padding: var(--padding);\n}\n";
// src/components/tab-panel/tab-panel.ts
var $4127f4988228e634$var$id = 0;
var $4127f4988228e634$export$716bbc700c6d5c8a = class extends (0, $0dc107042b3cd150$export$1c2340e2bfaed5f9) {
    constructor(){
        super(...arguments);
        this.attrId = ++$4127f4988228e634$var$id;
        this.componentId = `wa-tab-panel-${this.attrId}`;
        this.name = "";
        this.active = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.id = this.id.length > 0 ? this.id : this.componentId;
        this.setAttribute("role", "tabpanel");
    }
    handleActiveChange() {
        this.setAttribute("aria-hidden", this.active ? "false" : "true");
    }
    render() {
        return (0, $55d4f6cb7ddbea62$export$c0bb0b647f701bb5)`
      <slot
        part="base"
        class=${(0, $af14a7d4f9968de8$export$56cc687933817664)({
            "tab-panel": true,
            "tab-panel-active": this.active
        })}
      ></slot>
    `;
    }
};
$4127f4988228e634$export$716bbc700c6d5c8a.css = $4127f4988228e634$var$tab_panel_default;
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        reflect: true
    })
], $4127f4988228e634$export$716bbc700c6d5c8a.prototype, "name", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $4127f4988228e634$export$716bbc700c6d5c8a.prototype, "active", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $613ce7b9f4894054$export$3db5d71bdb2d5499)("active")
], $4127f4988228e634$export$716bbc700c6d5c8a.prototype, "handleActiveChange", 1);
$4127f4988228e634$export$716bbc700c6d5c8a = (0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $5c30ea4b08dcd69f$export$da64fc29f17f9d0e)("wa-tab-panel")
], $4127f4988228e634$export$716bbc700c6d5c8a);



// src/internal/validators/mirror-validator.ts
var $4a596452329e274a$export$c07432db7b838f29 = ()=>{
    return {
        checkValidity (element) {
            const formControl = element.input;
            const validity = {
                message: "",
                isValid: true,
                invalidKeys: []
            };
            if (!formControl) return validity;
            let isValid = true;
            if ("checkValidity" in formControl) isValid = formControl.checkValidity();
            if (isValid) return validity;
            validity.isValid = false;
            if ("validationMessage" in formControl) validity.message = formControl.validationMessage;
            if (!("validity" in formControl)) {
                validity.invalidKeys.push("customError");
                return validity;
            }
            for(const key in formControl.validity){
                if (key === "valid") continue;
                const checkedKey = key;
                if (formControl.validity[checkedKey]) validity.invalidKeys.push(checkedKey);
            }
            return validity;
        }
    };
};






// src/events/invalid.ts
var $c9d26002e9bf9408$export$dfa7d77f35d3c066 = class extends Event {
    constructor(){
        super("wa-invalid", {
            bubbles: true,
            cancelable: false,
            composed: true
        });
    }
};
// src/internal/validators/custom-error-validator.ts
var $c9d26002e9bf9408$var$CustomErrorValidator = ()=>{
    return {
        observedAttributes: [
            "custom-error"
        ],
        checkValidity (element) {
            const validity = {
                message: "",
                isValid: true,
                invalidKeys: []
            };
            if (element.customError) {
                validity.message = element.customError;
                validity.isValid = false;
                validity.invalidKeys = [
                    "customError"
                ];
            }
            return validity;
        }
    };
};
// src/internal/webawesome-form-associated-element.ts
var $c9d26002e9bf9408$export$8f4cbae1a5641ee6 = class extends (0, $0dc107042b3cd150$export$1c2340e2bfaed5f9) {
    constructor(){
        super();
        this.name = null;
        this.disabled = false;
        this.required = false;
        this.assumeInteractionOn = [
            "input"
        ];
        this.validators = [];
        this.valueHasChanged = false;
        this.hasInteracted = false;
        this.customError = null;
        this.emittedEvents = [];
        this.emitInvalid = (e)=>{
            if (e.target !== this) return;
            this.hasInteracted = true;
            this.dispatchEvent(new $c9d26002e9bf9408$export$dfa7d77f35d3c066());
        };
        this.handleInteraction = (event)=>{
            const emittedEvents = this.emittedEvents;
            if (!emittedEvents.includes(event.type)) emittedEvents.push(event.type);
            if (emittedEvents.length === this.assumeInteractionOn?.length) this.hasInteracted = true;
        };
        if (!(0, $9e623adca87f3a47$export$6acf61af03e62db)) this.addEventListener("invalid", this.emitInvalid);
    }
    /**
   * Validators are static because they have `observedAttributes`, essentially attributes to "watch"
   * for changes. Whenever these attributes change, we want to be notified and update the validator.
   */ static get validators() {
        return [
            $c9d26002e9bf9408$var$CustomErrorValidator()
        ];
    }
    // Append all Validator "observedAttributes" into the "observedAttributes" so they can run.
    static get observedAttributes() {
        const parentAttrs = new Set(super.observedAttributes || []);
        for (const validator of this.validators){
            if (!validator.observedAttributes) continue;
            for (const attr of validator.observedAttributes)parentAttrs.add(attr);
        }
        return [
            ...parentAttrs
        ];
    }
    connectedCallback() {
        super.connectedCallback();
        this.updateValidity();
        this.assumeInteractionOn.forEach((event)=>{
            this.addEventListener(event, this.handleInteraction);
        });
    }
    firstUpdated(...args) {
        super.firstUpdated(...args);
        this.updateValidity();
    }
    willUpdate(changedProperties) {
        if (!(0, $9e623adca87f3a47$export$6acf61af03e62db) && changedProperties.has("customError")) {
            if (!this.customError) this.customError = null;
            this.setCustomValidity(this.customError || "");
        }
        if (changedProperties.has("value") || changedProperties.has("disabled")) {
            const value = this.value;
            if (Array.isArray(value)) {
                if (this.name) {
                    const formData = new FormData();
                    for (const val of value)formData.append(this.name, val);
                    this.setValue(formData, formData);
                }
            } else this.setValue(value, value);
        }
        if (changedProperties.has("disabled")) {
            this.customStates.set("disabled", this.disabled);
            if (this.hasAttribute("disabled") || !(0, $9e623adca87f3a47$export$6acf61af03e62db) && !this.matches(":disabled")) this.toggleAttribute("disabled", this.disabled);
        }
        this.updateValidity();
        super.willUpdate(changedProperties);
    }
    get labels() {
        return this.internals.labels;
    }
    getForm() {
        return this.internals.form;
    }
    get validity() {
        return this.internals.validity;
    }
    // Not sure if this supports `novalidate`. Will need to test.
    get willValidate() {
        return this.internals.willValidate;
    }
    get validationMessage() {
        return this.internals.validationMessage;
    }
    checkValidity() {
        this.updateValidity();
        return this.internals.checkValidity();
    }
    reportValidity() {
        this.updateValidity();
        this.hasInteracted = true;
        return this.internals.reportValidity();
    }
    /**
   * Override this to change where constraint validation popups are anchored.
   */ get validationTarget() {
        return this.input || void 0;
    }
    setValidity(...args) {
        const flags = args[0];
        const message = args[1];
        let anchor = args[2];
        if (!anchor) anchor = this.validationTarget;
        this.internals.setValidity(flags, message, anchor || void 0);
        this.requestUpdate("validity");
        this.setCustomStates();
    }
    setCustomStates() {
        const required = Boolean(this.required);
        const isValid = this.internals.validity.valid;
        const hasInteracted = this.hasInteracted;
        this.customStates.set("required", required);
        this.customStates.set("optional", !required);
        this.customStates.set("invalid", !isValid);
        this.customStates.set("valid", isValid);
        this.customStates.set("user-invalid", !isValid && hasInteracted);
        this.customStates.set("user-valid", isValid && hasInteracted);
    }
    /**
   * Do not use this when creating a "Validator". This is intended for end users of components.
   * We track manually defined custom errors so we don't clear them on accident in our validators.
   *
   */ setCustomValidity(message) {
        if (!message) {
            this.customError = null;
            this.setValidity({});
            return;
        }
        this.customError = message;
        this.setValidity({
            customError: true
        }, message, this.validationTarget);
    }
    formResetCallback() {
        this.resetValidity();
        this.hasInteracted = false;
        this.valueHasChanged = false;
        this.emittedEvents = [];
        this.updateValidity();
    }
    formDisabledCallback(isDisabled) {
        this.disabled = isDisabled;
        this.updateValidity();
    }
    /**
   * Called when the browser is trying to restore element’s state to state in which case reason is "restore", or when
   * the browser is trying to fulfill autofill on behalf of user in which case reason is "autocomplete". In the case of
   * "restore", state is a string, File, or FormData object previously set as the second argument to setFormValue.
   */ formStateRestoreCallback(state, reason) {
        this.value = state;
        if (reason === "restore") this.resetValidity();
        this.updateValidity();
    }
    setValue(...args) {
        const [value, state] = args;
        this.internals.setFormValue(value, state);
    }
    get allValidators() {
        const staticValidators = this.constructor.validators || [];
        const validators = this.validators || [];
        return [
            ...staticValidators,
            ...validators
        ];
    }
    /**
   * Reset validity is a way of removing manual custom errors and native validation.
   */ resetValidity() {
        this.setCustomValidity("");
        this.setValidity({});
    }
    updateValidity() {
        if (this.disabled || this.hasAttribute("disabled") || !this.willValidate) {
            this.resetValidity();
            return;
        }
        const validators = this.allValidators;
        if (!validators?.length) return;
        const flags = {
            // Don't trust custom errors from the Browser. Safari breaks the spec.
            customError: Boolean(this.customError)
        };
        const formControl = this.validationTarget || this.input || void 0;
        let finalMessage = "";
        for (const validator of validators){
            const { isValid: isValid, message: message, invalidKeys: invalidKeys } = validator.checkValidity(this);
            if (isValid) continue;
            if (!finalMessage) finalMessage = message;
            if (invalidKeys?.length >= 0) invalidKeys.forEach((str)=>flags[str] = true);
        }
        if (!finalMessage) finalMessage = this.validationMessage;
        this.setValidity(flags, finalMessage, formControl);
    }
};
$c9d26002e9bf9408$export$8f4cbae1a5641ee6.formAssociated = true;
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        reflect: true
    })
], $c9d26002e9bf9408$export$8f4cbae1a5641ee6.prototype, "name", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        type: Boolean
    })
], $c9d26002e9bf9408$export$8f4cbae1a5641ee6.prototype, "disabled", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        state: true,
        attribute: false
    })
], $c9d26002e9bf9408$export$8f4cbae1a5641ee6.prototype, "valueHasChanged", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        state: true,
        attribute: false
    })
], $c9d26002e9bf9408$export$8f4cbae1a5641ee6.prototype, "hasInteracted", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        attribute: "custom-error",
        reflect: true
    })
], $c9d26002e9bf9408$export$8f4cbae1a5641ee6.prototype, "customError", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        attribute: false,
        state: true,
        type: Object
    })
], $c9d26002e9bf9408$export$8f4cbae1a5641ee6.prototype, "validity", 1);


// src/internal/slot.ts
var $afd8d05c36b1b057$export$34f6a5ffaa663541 = class {
    constructor(host, ...slotNames){
        this.slotNames = [];
        this.handleSlotChange = (event)=>{
            const slot = event.target;
            if (this.slotNames.includes("[default]") && !slot.name || slot.name && this.slotNames.includes(slot.name)) this.host.requestUpdate();
        };
        (this.host = host).addController(this);
        this.slotNames = slotNames;
    }
    hasDefaultSlot() {
        return [
            ...this.host.childNodes
        ].some((node)=>{
            if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== "") return true;
            if (node.nodeType === Node.ELEMENT_NODE) {
                const el = node;
                const tagName = el.tagName.toLowerCase();
                if (tagName === "wa-visually-hidden") return false;
                if (!el.hasAttribute("slot")) return true;
            }
            return false;
        });
    }
    hasNamedSlot(name) {
        return this.host.querySelector(`:scope > [slot="${name}"]`) !== null;
    }
    test(slotName) {
        return slotName === "[default]" ? this.hasDefaultSlot() : this.hasNamedSlot(slotName);
    }
    hostConnected() {
        this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange);
    }
    hostDisconnected() {
        this.host.shadowRoot.removeEventListener("slotchange", this.handleSlotChange);
    }
};


// src/styles/utilities/size.css
var $2f34fecdc74059af$export$967e797b0e4e2bc1 = "@layer wa-utilities {\n  :host([size='small']),\n  .wa-size-s {\n    font-size: var(--wa-font-size-s);\n  }\n\n  :host([size='medium']),\n  .wa-size-m {\n    font-size: var(--wa-font-size-m);\n  }\n\n  :host([size='large']),\n  .wa-size-l {\n    font-size: var(--wa-font-size-l);\n  }\n}\n";




// src/styles/utilities/variants.css
var $2a150f02384becb1$export$fabe5f4c0ec71ef3 = "@layer wa-utilities {\n  :where(:root),\n  .wa-neutral,\n  :host([variant='neutral']) {\n    --wa-color-fill-loud: var(--wa-color-neutral-fill-loud);\n    --wa-color-fill-normal: var(--wa-color-neutral-fill-normal);\n    --wa-color-fill-quiet: var(--wa-color-neutral-fill-quiet);\n    --wa-color-border-loud: var(--wa-color-neutral-border-loud);\n    --wa-color-border-normal: var(--wa-color-neutral-border-normal);\n    --wa-color-border-quiet: var(--wa-color-neutral-border-quiet);\n    --wa-color-on-loud: var(--wa-color-neutral-on-loud);\n    --wa-color-on-normal: var(--wa-color-neutral-on-normal);\n    --wa-color-on-quiet: var(--wa-color-neutral-on-quiet);\n  }\n\n  .wa-brand,\n  :host([variant='brand']) {\n    --wa-color-fill-loud: var(--wa-color-brand-fill-loud);\n    --wa-color-fill-normal: var(--wa-color-brand-fill-normal);\n    --wa-color-fill-quiet: var(--wa-color-brand-fill-quiet);\n    --wa-color-border-loud: var(--wa-color-brand-border-loud);\n    --wa-color-border-normal: var(--wa-color-brand-border-normal);\n    --wa-color-border-quiet: var(--wa-color-brand-border-quiet);\n    --wa-color-on-loud: var(--wa-color-brand-on-loud);\n    --wa-color-on-normal: var(--wa-color-brand-on-normal);\n    --wa-color-on-quiet: var(--wa-color-brand-on-quiet);\n  }\n\n  .wa-success,\n  :host([variant='success']) {\n    --wa-color-fill-loud: var(--wa-color-success-fill-loud);\n    --wa-color-fill-normal: var(--wa-color-success-fill-normal);\n    --wa-color-fill-quiet: var(--wa-color-success-fill-quiet);\n    --wa-color-border-loud: var(--wa-color-success-border-loud);\n    --wa-color-border-normal: var(--wa-color-success-border-normal);\n    --wa-color-border-quiet: var(--wa-color-success-border-quiet);\n    --wa-color-on-loud: var(--wa-color-success-on-loud);\n    --wa-color-on-normal: var(--wa-color-success-on-normal);\n    --wa-color-on-quiet: var(--wa-color-success-on-quiet);\n  }\n\n  .wa-warning,\n  :host([variant='warning']) {\n    --wa-color-fill-loud: var(--wa-color-warning-fill-loud);\n    --wa-color-fill-normal: var(--wa-color-warning-fill-normal);\n    --wa-color-fill-quiet: var(--wa-color-warning-fill-quiet);\n    --wa-color-border-loud: var(--wa-color-warning-border-loud);\n    --wa-color-border-normal: var(--wa-color-warning-border-normal);\n    --wa-color-border-quiet: var(--wa-color-warning-border-quiet);\n    --wa-color-on-loud: var(--wa-color-warning-on-loud);\n    --wa-color-on-normal: var(--wa-color-warning-on-normal);\n    --wa-color-on-quiet: var(--wa-color-warning-on-quiet);\n  }\n\n  .wa-danger,\n  :host([variant='danger']) {\n    --wa-color-fill-loud: var(--wa-color-danger-fill-loud);\n    --wa-color-fill-normal: var(--wa-color-danger-fill-normal);\n    --wa-color-fill-quiet: var(--wa-color-danger-fill-quiet);\n    --wa-color-border-loud: var(--wa-color-danger-border-loud);\n    --wa-color-border-normal: var(--wa-color-danger-border-normal);\n    --wa-color-border-quiet: var(--wa-color-danger-border-quiet);\n    --wa-color-on-loud: var(--wa-color-danger-on-loud);\n    --wa-color-on-normal: var(--wa-color-danger-on-normal);\n    --wa-color-on-quiet: var(--wa-color-danger-on-quiet);\n  }\n}\n";






/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $59a77c34f33be81e$export$f68dd208b5df064d = (o)=>o ?? (0, $55d4f6cb7ddbea62$export$45b790e32b2810ee);





/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $1c2359b027715450$var$a = Symbol.for(""), $1c2359b027715450$var$o = (t)=>{
    if (t?.r === $1c2359b027715450$var$a) return t?._$litStatic$;
}, $1c2359b027715450$export$4b395f4b8c9b548e = (t)=>({
        _$litStatic$: t,
        r: $1c2359b027715450$var$a
    }), $1c2359b027715450$export$c8ec6e1ec9fefcb0 = (t, ...r)=>({
        _$litStatic$: r.reduce((r, e, a)=>r + ((t)=>{
                if (void 0 !== t._$litStatic$) return t._$litStatic$;
                throw Error(`Value passed to 'literal' function must be a 'literal' result: ${t}. Use 'unsafeStatic' to pass non-literal values, but\n            take care to ensure page security.`);
            })(e) + t[a + 1], t[0]),
        r: $1c2359b027715450$var$a
    }), $1c2359b027715450$var$l = new Map, $1c2359b027715450$export$878791788f808fc0 = (t)=>(r, ...e)=>{
        const a = e.length;
        let s, i;
        const n = [], u = [];
        let c, $ = 0, f = !1;
        for(; $ < a;){
            for(c = r[$]; $ < a && void 0 !== (i = e[$], s = $1c2359b027715450$var$o(i));)c += s + r[++$], f = !0;
            $ !== a && u.push(i), n.push(c), $++;
        }
        if ($ === a && n.push(r[a]), f) {
            const t = n.join("$$lit$$");
            void 0 === (r = $1c2359b027715450$var$l.get(t)) && (n.raw = n, $1c2359b027715450$var$l.set(t, r = n)), e = u;
        }
        return t(r, ...e);
    }, $1c2359b027715450$export$c0bb0b647f701bb5 = $1c2359b027715450$export$878791788f808fc0((0, $55d4f6cb7ddbea62$export$c0bb0b647f701bb5)), $1c2359b027715450$export$7ed1367e7fa1ad68 = $1c2359b027715450$export$878791788f808fc0((0, $55d4f6cb7ddbea62$export$7ed1367e7fa1ad68)), $1c2359b027715450$export$47d5b44d225be5b4 = $1c2359b027715450$export$878791788f808fc0((0, $55d4f6cb7ddbea62$export$47d5b44d225be5b4));




// src/components/button/button.css
var $d15cc5d4e46a425c$var$button_default = "@layer wa-component {\n  :host {\n    display: inline-block;\n    position: relative;\n  }\n}\n\n.button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  user-select: none;\n  -webkit-user-select: none;\n  white-space: nowrap;\n  vertical-align: middle;\n  transition-property: background, border, box-shadow, color;\n  transition-duration: var(--wa-transition-fast);\n  transition-timing-function: var(--wa-transition-easing);\n  cursor: pointer;\n  padding: 0 var(--wa-form-control-padding-inline);\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: var(--wa-font-weight-action);\n  line-height: calc(var(--wa-form-control-height) - var(--border-width) * 2);\n  height: var(--wa-form-control-height);\n  width: 100%;\n\n  background-color: var(--wa-color-fill-loud, var(--wa-color-neutral-fill-loud));\n  border-color: transparent;\n  color: var(--wa-color-on-loud, var(--wa-color-neutral-on-loud));\n  border-radius: var(--wa-form-control-border-radius);\n  border-style: var(--wa-border-style);\n  border-width: var(--wa-border-width-s);\n}\n\n/* Appearance modifiers */\n:host([appearance~='plain']) {\n  .button {\n    color: var(--wa-color-on-quiet, var(--wa-color-neutral-on-quiet));\n    background-color: transparent;\n    border-color: transparent;\n  }\n  @media (hover: hover) {\n    .button:not(.disabled):not(.loading):hover {\n      color: var(--wa-color-on-quiet, var(--wa-color-neutral-on-quiet));\n      background-color: var(--wa-color-fill-quiet, var(--wa-color-neutral-fill-quiet));\n    }\n  }\n  .button:not(.disabled):not(.loading):active {\n    color: var(--wa-color-on-quiet, var(--wa-color-neutral-on-quiet));\n    background-color: color-mix(\n      in oklab,\n      var(--wa-color-fill-quiet, var(--wa-color-neutral-fill-quiet)),\n      var(--wa-color-mix-active)\n    );\n  }\n}\n\n:host([appearance~='outlined']) {\n  .button {\n    color: var(--wa-color-on-quiet, var(--wa-color-neutral-on-quiet));\n    background-color: transparent;\n    border-color: var(--wa-color-border-loud, var(--wa-color-neutral-border-loud));\n  }\n  @media (hover: hover) {\n    .button:not(.disabled):not(.loading):hover {\n      color: var(--wa-color-on-quiet, var(--wa-color-neutral-on-quiet));\n      background-color: var(--wa-color-fill-quiet, var(--wa-color-neutral-fill-quiet));\n    }\n  }\n  .button:not(.disabled):not(.loading):active {\n    color: var(--wa-color-on-quiet, var(--wa-color-neutral-on-quiet));\n    background-color: color-mix(\n      in oklab,\n      var(--wa-color-fill-quiet, var(--wa-color-neutral-fill-quiet)),\n      var(--wa-color-mix-active)\n    );\n  }\n}\n\n:host([appearance~='filled']) {\n  .button {\n    color: var(--wa-color-on-normal, var(--wa-color-neutral-on-normal));\n    background-color: var(--wa-color-fill-normal, var(--wa-color-neutral-fill-normal));\n    border-color: transparent;\n  }\n  @media (hover: hover) {\n    .button:not(.disabled):not(.loading):hover {\n      color: var(--wa-color-on-normal, var(--wa-color-neutral-on-normal));\n      background-color: color-mix(\n        in oklab,\n        var(--wa-color-fill-normal, var(--wa-color-neutral-fill-normal)),\n        var(--wa-color-mix-hover)\n      );\n    }\n  }\n  .button:not(.disabled):not(.loading):active {\n    color: var(--wa-color-on-normal, var(--wa-color-neutral-on-normal));\n    background-color: color-mix(\n      in oklab,\n      var(--wa-color-fill-normal, var(--wa-color-neutral-fill-normal)),\n      var(--wa-color-mix-active)\n    );\n  }\n}\n\n:host([appearance~='filled'][appearance~='outlined']) .button {\n  border-color: var(--wa-color-border-normal, var(--wa-color-neutral-border-normal));\n}\n\n:host([appearance~='accent']) {\n  .button {\n    color: var(--wa-color-on-loud, var(--wa-color-neutral-on-loud));\n    background-color: var(--wa-color-fill-loud, var(--wa-color-neutral-fill-loud));\n    border-color: transparent;\n  }\n  @media (hover: hover) {\n    .button:not(.disabled):not(.loading):hover {\n      background-color: color-mix(\n        in oklab,\n        var(--wa-color-fill-loud, var(--wa-color-neutral-fill-loud)),\n        var(--wa-color-mix-hover)\n      );\n    }\n  }\n  .button:not(.disabled):not(.loading):active {\n    background-color: color-mix(\n      in oklab,\n      var(--wa-color-fill-loud, var(--wa-color-neutral-fill-loud)),\n      var(--wa-color-mix-active)\n    );\n  }\n}\n\n/* Focus states */\n.button:focus {\n  outline: none;\n}\n\n.button:focus-visible {\n  outline: var(--wa-focus-ring);\n  outline-offset: var(--wa-focus-ring-offset);\n}\n\n/* Disabled state */\n.button.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* When disabled, prevent mouse events from bubbling up from children */\n.button.disabled * {\n  pointer-events: none;\n}\n\n/* Keep it last so Safari doesn't stop parsing this block */\n.button::-moz-focus-inner {\n  border: 0;\n}\n\n/* Icon buttons */\n.button.is-icon-button {\n  outline-offset: 2px;\n  width: var(--wa-form-control-height);\n  aspect-ratio: 1;\n}\n\n/* Pill modifier */\n:host([pill]) .button {\n  border-radius: var(--wa-border-radius-pill);\n}\n\n/*\n * Label\n */\n\n.start,\n.end {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  pointer-events: none;\n}\n\n.label {\n  display: flex;\n}\n\n.label::slotted(wa-icon) {\n  align-self: center;\n}\n\n/*\n * Caret modifier\n */\n\nwa-icon[part~='caret'] {\n  display: flex;\n  align-self: center;\n  align-items: center;\n\n  &::part(svg) {\n    width: 0.875em;\n    height: 0.875em;\n  }\n\n  .button:has(&) .end {\n    display: none;\n  }\n}\n\n/*\n * Loading modifier\n */\n\n.loading {\n  position: relative;\n  cursor: wait;\n\n  .start,\n  .label,\n  .end,\n  .caret {\n    visibility: hidden;\n  }\n\n  wa-spinner {\n    --indicator-color: currentColor;\n    --track-color: color-mix(in oklab, currentColor, transparent 90%);\n\n    position: absolute;\n    font-size: 1em;\n    height: 1em;\n    width: 1em;\n    top: calc(50% - 0.5em);\n    left: calc(50% - 0.5em);\n  }\n}\n\n/*\n * Badges\n */\n\nbutton ::slotted(wa-badge) {\n  border-color: var(--wa-color-surface-default);\n  position: absolute;\n  inset-block-start: 0;\n  inset-inline-end: 0;\n  translate: 50% -50%;\n  pointer-events: none;\n}\n\n:host(:dir(rtl)) ::slotted(wa-badge) {\n  translate: -50% -50%;\n}\n\n/*\n* Button spacing\n*/\n\nslot[name='start']::slotted(*) {\n  margin-inline-end: 0.75em;\n}\n\nslot[name='end']::slotted(*),\n.button:not(.visually-hidden-label) [part~='caret'] {\n  margin-inline-start: 0.75em;\n}\n\n/*\n * Button group border radius modifications\n */\n\n/* Remove border radius from all grouped buttons by default */\n:host(.wa-button-group__button) .button {\n  border-radius: 0;\n}\n\n/* Horizontal orientation */\n:host(.wa-button-group__horizontal.wa-button-group__button-first) .button {\n  border-start-start-radius: var(--wa-form-control-border-radius);\n  border-end-start-radius: var(--wa-form-control-border-radius);\n}\n\n:host(.wa-button-group__horizontal.wa-button-group__button-last) .button {\n  border-start-end-radius: var(--wa-form-control-border-radius);\n  border-end-end-radius: var(--wa-form-control-border-radius);\n}\n\n/* Vertical orientation */\n:host(.wa-button-group__vertical) {\n  flex: 1 1 auto;\n}\n\n:host(.wa-button-group__vertical) .button {\n  width: 100%;\n  justify-content: start;\n}\n\n:host(.wa-button-group__vertical.wa-button-group__button-first) .button {\n  border-start-start-radius: var(--wa-form-control-border-radius);\n  border-start-end-radius: var(--wa-form-control-border-radius);\n}\n\n:host(.wa-button-group__vertical.wa-button-group__button-last) .button {\n  border-end-start-radius: var(--wa-form-control-border-radius);\n  border-end-end-radius: var(--wa-form-control-border-radius);\n}\n\n/* Handle pill modifier for button groups */\n:host([pill].wa-button-group__horizontal.wa-button-group__button-first) .button {\n  border-start-start-radius: var(--wa-border-radius-pill);\n  border-end-start-radius: var(--wa-border-radius-pill);\n}\n\n:host([pill].wa-button-group__horizontal.wa-button-group__button-last) .button {\n  border-start-end-radius: var(--wa-border-radius-pill);\n  border-end-end-radius: var(--wa-border-radius-pill);\n}\n\n:host([pill].wa-button-group__vertical.wa-button-group__button-first) .button {\n  border-start-start-radius: var(--wa-border-radius-pill);\n  border-start-end-radius: var(--wa-border-radius-pill);\n}\n\n:host([pill].wa-button-group__vertical.wa-button-group__button-last) .button {\n  border-end-start-radius: var(--wa-border-radius-pill);\n  border-end-end-radius: var(--wa-border-radius-pill);\n}\n";
// src/components/button/button.ts
var $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c = class extends (0, $c9d26002e9bf9408$export$8f4cbae1a5641ee6) {
    constructor(){
        super(...arguments);
        this.assumeInteractionOn = [
            "click"
        ];
        this.hasSlotController = new (0, $afd8d05c36b1b057$export$34f6a5ffaa663541)(this, "[default]", "start", "end");
        this.localize = new (0, $1fdb33ee03a3e3e4$export$b1a2fed5bb41b893)(this);
        this.invalid = false;
        this.isIconButton = false;
        this.title = "";
        this.variant = "neutral";
        this.appearance = "accent";
        this.size = "medium";
        this.withCaret = false;
        this.disabled = false;
        this.loading = false;
        this.pill = false;
        this.type = "button";
        this.form = null;
    }
    static get validators() {
        return [
            ...super.validators,
            (0, $4a596452329e274a$export$c07432db7b838f29)()
        ];
    }
    constructLightDOMButton() {
        const button = document.createElement("button");
        button.type = this.type;
        button.style.position = "absolute";
        button.style.width = "0";
        button.style.height = "0";
        button.style.clipPath = "inset(50%)";
        button.style.overflow = "hidden";
        button.style.whiteSpace = "nowrap";
        if (this.name) button.name = this.name;
        button.value = this.value || "";
        [
            "form",
            "formaction",
            "formenctype",
            "formmethod",
            "formnovalidate",
            "formtarget"
        ].forEach((attr)=>{
            if (this.hasAttribute(attr)) button.setAttribute(attr, this.getAttribute(attr));
        });
        return button;
    }
    handleClick() {
        const form = this.getForm();
        if (!form) return;
        const lightDOMButton = this.constructLightDOMButton();
        this.parentElement?.append(lightDOMButton);
        lightDOMButton.click();
        lightDOMButton.remove();
    }
    handleInvalid() {
        this.dispatchEvent(new (0, $c9d26002e9bf9408$export$dfa7d77f35d3c066)());
    }
    handleLabelSlotChange() {
        const nodes = this.labelSlot.assignedNodes({
            flatten: true
        });
        let hasIconLabel = false;
        let hasIcon = false;
        let text = "";
        [
            ...nodes
        ].forEach((node)=>{
            if (node.nodeType === Node.ELEMENT_NODE && node.localName === "wa-icon") {
                hasIcon = true;
                if (!hasIconLabel) hasIconLabel = node.hasAttribute("label");
            }
            if (node.nodeType === Node.TEXT_NODE) text += node.textContent;
        });
        this.isIconButton = text.trim() === "" && hasIcon;
        if (this.isIconButton && !hasIconLabel) console.warn('Icon buttons must have a label for screen readers. Add <wa-icon label="..."> to remove this warning.', this);
    }
    isButton() {
        return this.href ? false : true;
    }
    isLink() {
        return this.href ? true : false;
    }
    handleDisabledChange() {
        this.updateValidity();
    }
    // eslint-disable-next-line
    setValue(..._args) {}
    /** Simulates a click on the button. */ click() {
        this.button.click();
    }
    /** Sets focus on the button. */ focus(options) {
        this.button.focus(options);
    }
    /** Removes focus from the button. */ blur() {
        this.button.blur();
    }
    render() {
        const isLink = this.isLink();
        const tag = isLink ? (0, $1c2359b027715450$export$c8ec6e1ec9fefcb0)`a` : (0, $1c2359b027715450$export$c8ec6e1ec9fefcb0)`button`;
        return (0, $1c2359b027715450$export$c0bb0b647f701bb5)`
      <${tag}
        part="base"
        class=${(0, $af14a7d4f9968de8$export$56cc687933817664)({
            button: true,
            caret: this.withCaret,
            disabled: this.disabled,
            loading: this.loading,
            rtl: this.localize.dir() === "rtl",
            "has-label": this.hasSlotController.test("[default]"),
            "has-start": this.hasSlotController.test("start"),
            "has-end": this.hasSlotController.test("end"),
            "is-icon-button": this.isIconButton
        })}
        ?disabled=${(0, $59a77c34f33be81e$export$f68dd208b5df064d)(isLink ? void 0 : this.disabled)}
        type=${(0, $59a77c34f33be81e$export$f68dd208b5df064d)(isLink ? void 0 : this.type)}
        title=${this.title}
        name=${(0, $59a77c34f33be81e$export$f68dd208b5df064d)(isLink ? void 0 : this.name)}
        value=${(0, $59a77c34f33be81e$export$f68dd208b5df064d)(isLink ? void 0 : this.value)}
        href=${(0, $59a77c34f33be81e$export$f68dd208b5df064d)(isLink ? this.href : void 0)}
        target=${(0, $59a77c34f33be81e$export$f68dd208b5df064d)(isLink ? this.target : void 0)}
        download=${(0, $59a77c34f33be81e$export$f68dd208b5df064d)(isLink ? this.download : void 0)}
        rel=${(0, $59a77c34f33be81e$export$f68dd208b5df064d)(isLink && this.rel ? this.rel : void 0)}
        role=${(0, $59a77c34f33be81e$export$f68dd208b5df064d)(isLink ? void 0 : "button")}
        aria-disabled=${this.disabled ? "true" : "false"}
        tabindex=${this.disabled ? "-1" : "0"}
        @invalid=${this.isButton() ? this.handleInvalid : null}
        @click=${this.handleClick}
      >
        <slot name="start" part="start" class="start"></slot>
        <slot part="label" class="label" @slotchange=${this.handleLabelSlotChange}></slot>
        <slot name="end" part="end" class="end"></slot>
        ${this.withCaret ? (0, $1c2359b027715450$export$c0bb0b647f701bb5)`
                <wa-icon part="caret" class="caret" library="system" name="chevron-down" variant="solid"></wa-icon>
              ` : ""}
        ${this.loading ? (0, $1c2359b027715450$export$c0bb0b647f701bb5)`<wa-spinner part="spinner"></wa-spinner>` : ""}
      </${tag}>
    `;
    }
};
$d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.css = [
    $d15cc5d4e46a425c$var$button_default,
    (0, $2a150f02384becb1$export$fabe5f4c0ec71ef3),
    (0, $2f34fecdc74059af$export$967e797b0e4e2bc1)
];
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $8d592e0ae133699b$export$2fa187e846a241c4)(".button")
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "button", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $8d592e0ae133699b$export$2fa187e846a241c4)("slot:not([name])")
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "labelSlot", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $5c87cbdc1d7bbe2a$export$ca000e230c0caa3e)()
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "invalid", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $5c87cbdc1d7bbe2a$export$ca000e230c0caa3e)()
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "isIconButton", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "title", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        reflect: true
    })
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "variant", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        reflect: true
    })
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "appearance", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        reflect: true
    })
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "size", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        attribute: "with-caret",
        type: Boolean,
        reflect: true
    })
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "withCaret", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        type: Boolean
    })
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "disabled", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "loading", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "pill", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "type", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        reflect: true
    })
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "name", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        reflect: true
    })
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "value", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        reflect: true
    })
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "href", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "target", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "rel", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)()
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "download", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        reflect: true
    })
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "form", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        attribute: "formaction"
    })
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "formAction", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        attribute: "formenctype"
    })
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "formEnctype", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        attribute: "formmethod"
    })
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "formMethod", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        attribute: "formnovalidate",
        type: Boolean
    })
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "formNoValidate", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $0936708d16581d69$export$d541bacb2bda4494)({
        attribute: "formtarget"
    })
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "formTarget", 2);
(0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $613ce7b9f4894054$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c.prototype, "handleDisabledChange", 1);
$d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c = (0, $15471b8b0c071016$export$85c93885f16e8446)([
    (0, $5c30ea4b08dcd69f$export$da64fc29f17f9d0e)("wa-button")
], $d15cc5d4e46a425c$export$2b1bb5b82bf1ca5c);






















const $1f0dc3b9307be026$var$STORAGE_SESSION_TOKEN = "session-token";
const $1f0dc3b9307be026$var$baseUrl = window.location.origin;
const $1f0dc3b9307be026$var$sessionToken = localStorage.getItem($1f0dc3b9307be026$var$STORAGE_SESSION_TOKEN);
const $1f0dc3b9307be026$var$app = $434810d243e219c9$export$889ea624f2cb2c57({
    baseUrl: $1f0dc3b9307be026$var$baseUrl,
    sessionToken: $1f0dc3b9307be026$var$sessionToken,
    node: document.getElementById("application")
});
const $1f0dc3b9307be026$var$authn = $8e3c12a99884957c$export$18298bb220d85216({
    server: "https://accounts.google.com",
    clientId: $b19a5f61ff992ce5$exports.authn.clientId
});
$1f0dc3b9307be026$var$app.persistSessionToken.subscribe((sessionToken)=>{
    localStorage.setItem($1f0dc3b9307be026$var$STORAGE_SESSION_TOKEN, sessionToken);
});
$1f0dc3b9307be026$var$app.requestLogin.subscribe(async ({ redirectUri: redirectUri, nonce: nonce })=>{
    $8e3c12a99884957c$export$596d806903d1f59e($1f0dc3b9307be026$var$authn, {
        redirectUri: redirectUri,
        nonce: nonce
    });
});
$1f0dc3b9307be026$var$app.requestLoginCallbackProcessing.subscribe(async ()=>{
    const id_token = await $8e3c12a99884957c$export$875757f72547b5f3();
    $1f0dc3b9307be026$var$app.reportLoginReceived(id_token);
});
$1f0dc3b9307be026$var$app.requestLogout.subscribe(()=>{
    localStorage.clear($1f0dc3b9307be026$var$STORAGE_SESSION_TOKEN);
});


//# sourceMappingURL=frontend-elm.a85a7d78.js.map
